function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
  if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _async_to_generator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _class_call_check(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _create_class(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _to_consumable_array(arr) {
  return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
  "@swc/helpers - typeof";

  return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
  var f,
    y,
    t,
    g,
    _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    };
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment IconFragment on Icon {\n    id\n    title\n    token\n    description\n    size\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment EGDSBasicPillFragment on EGDSBasicPill {\n    accessibility\n    disabled\n    name\n    primary\n    selected\n    selectedText\n    value\n    icon {\n      ...IconFragment\n    }\n    selectAnalytics {\n      ...AnalyticsFragment\n    }\n    deselectAnalytics {\n      ...AnalyticsFragment\n    }\n  }\n\n  fragment AnalyticsFragment on ClientSideAnalytics {\n    linkName\n    referrerId\n  }\n\n  ", "\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment EGDSBasicRemovablePillFragment on EGDSBasicRemovablePill {\n    primary\n    name\n    accessibility\n    id\n    removeAnalytics {\n      referrerId\n      linkName\n    }\n    value\n  }\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment EGDSBasicTriggerPillFragment on EGDSBasicTriggerPill {\n    id\n    disabled\n    primary\n    selected\n    icon {\n      ...IconFragment\n    }\n    selectAnalytics {\n      ...AnalyticsFragment\n    }\n    deselectAnalytics {\n      ...AnalyticsFragment\n    }\n    accessibility\n  }\n\n  fragment AnalyticsFragment on ClientSideAnalytics {\n    linkName\n    referrerId\n  }\n\n  ", "\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment EGDSPillFragment on EGDSPill {\n    __typename\n\n    ...EGDSBasicPillFragment\n    ...EGDSBasicTriggerPillFragment\n    ...EGDSBasicRemovablePillFragment\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment EGDSSearchFormSelectActionFragment on EGDSSearchFormSelectAction {\n    analytics {\n      linkName\n      referrerId\n    }\n\n    options {\n      label\n      selected\n      value\n    }\n  }\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment EGDSSearchFormInputFieldFragment on EGDSSearchFormInputField {\n    egdsElementId\n    value\n    label\n    placeholder\n    leftIcon {\n      ...IconFragment\n    }\n    action {\n      ...EGDSSearchFormSelectActionFragment\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment PackagesSearchFormSelectionFragment on PackagesSearchFormSelection {\n    car {\n      ...EGDSPillFragment\n    }\n    flight {\n      ...EGDSPillFragment\n    }\n    stay {\n      ...EGDSPillFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  query PackagesOptionsQuery(\n    $context: ContextInput!\n    $packageSearchCriteria: PackageSearchCriteriaInput!\n    $packageType: PackageType\n    $includePackageType: Boolean = false\n  ) {\n    searchForm(context: $context) {\n      packages(packageSearchCriteria: $packageSearchCriteria, packageType: $packageType) {\n        __typename\n        ... on PackagesSearchForm {\n          packageSelection @include(if: $includePackageType) {\n            ...PackagesSearchFormSelectionFragment\n          }\n          directFlightsOnly {\n            ...EGDSPillFragment\n          }\n        }\n        elements {\n          ...EGDSSearchFormInputFieldFragment\n        }\n      }\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _tagged_template_literal(["\n  fragment NoSelectionMessageFragment on UIEmptyState {\n    body\n    heading\n    icon {\n      ...IconFragment\n    }\n  }\n  ", "\n"]);
  _templateObject9 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject10() {
  var data = _tagged_template_literal(["\n  fragment EGDSErrorSummaryFragment on EGDSErrorSummary {\n    egdsElementId\n    goToErrorLinkText\n    goToFirstErrorLinkText\n    heading\n    body {\n      text\n    }\n    analytics {\n      linkName\n      referrerId\n    }\n    impressionAnalytics {\n      linkName\n      referrerId\n    }\n    headingTemplate {\n      ... on EGDSCardinalLocalizedText {\n        models {\n          key\n          source\n        }\n        templates {\n          category\n          template\n        }\n      }\n    }\n  }\n"]);
  _templateObject10 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject11() {
  var data = _tagged_template_literal(["\n  fragment EGDSButtonFragment on EGDSButton {\n    primary\n    disabled\n    accessibility\n    icon {\n      id\n      description\n      token\n      title\n    }\n    analytics {\n      linkName\n      referrerId\n    }\n    action {\n      accessibility\n    }\n  }\n"]);
  _templateObject11 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject12() {
  var data = _tagged_template_literal(["\n  fragment EGDSSearchFormButtonFragment on EGDSSearchFormButton {\n    egdsElementId\n    ...EGDSButtonFragment\n    onClick {\n      ...EGDSSubmitSearchFormActionFragment\n    }\n  }\n\n  fragment EGDSSubmitSearchFormActionFragment on EGDSSubmitSearchFormAction {\n    analytics {\n      linkName\n      referrerId\n    }\n  }\n  ", "\n"]);
  _templateObject12 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject13() {
  var data = _tagged_template_literal(["\n  fragment EGDSDatePickerFlexibilityCalendarContentFragment on EGDSDatePickerFlexibilityCalendarContent {\n    __typename\n    flexibleDateOptions {\n      ...EGDSBasicPillFragment\n    }\n    formElementId\n    title {\n      text\n      accessibility\n    }\n  }\n  ", "\n"]);
  _templateObject13 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject14() {
  var data = _tagged_template_literal(["\n  fragment EGDSBasicTabsFragment on EGDSBasicTabs {\n    __typename\n    egdsElementId\n    selectedTabId\n    tabs {\n      ... on EGDSBasicTab {\n        __typename\n        accessibility\n        clickAnalytics {\n          linkName\n          referrerId\n        }\n        label\n        tabId\n      }\n    }\n  }\n"]);
  _templateObject14 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject15() {
  var data = _tagged_template_literal(["\n  fragment EGDSToggleButtonFragment on EGDSToggleButton {\n    __typename\n    egdsElementId\n    primary\n    subText\n    name\n    selectedAnalytics {\n      linkName\n      referrerId\n    }\n    unselectedAnalytics {\n      linkName\n      referrerId\n    }\n    icon {\n      ... on Icon {\n        id\n        size\n      }\n    }\n    selected\n    disabled\n  }\n"]);
  _templateObject15 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject16() {
  var data = _tagged_template_literal(["\n  fragment EGDSToggleButtonGroupFragment on EGDSToggleButtonGroup {\n    __typename\n    options {\n      ...EGDSToggleButtonFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject16 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject17() {
  var data = _tagged_template_literal(["\n  fragment EGDSDatePickerFlexibleMonthsFragment on EGDSDatePickerFlexibleMonths {\n    heading\n    subHeading\n    options {\n      ...EGDSToggleButtonGroupFragment\n    }\n  }\n  ", "\n"]);
  _templateObject17 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject18() {
  var data = _tagged_template_literal(["\n  fragment EGDSBasicCheckBoxFragment on EGDSBasicCheckBox {\n    egdsElementId\n    description\n    enabled\n    checkedAnalytics {\n      linkName\n      referrerId\n    }\n    uncheckedAnalytics {\n      linkName\n      referrerId\n    }\n    label {\n      text\n    }\n    name\n    required\n    state\n  }\n"]);
  _templateObject18 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject19() {
  var data = _tagged_template_literal(["\n  fragment EGDSCheckBoxFragment on EGDSCheckBox {\n    __typename\n\n    ...EGDSBasicCheckBoxFragment\n  }\n\n  ", "\n"]);
  _templateObject19 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject20() {
  var data = _tagged_template_literal(["\n  fragment EGDSDatePickerFlexibleNightsFragment on EGDSDatePickerFlexibleNights {\n    heading\n    includeWeekend {\n      ...EGDSCheckBoxFragment\n    }\n    options {\n      ...EGDSPillFragment\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject20 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject21() {
  var data = _tagged_template_literal(["\n  fragment EGDSDatePickerFlexibilityDatesContentFragment on EGDSDatePickerFlexibilityDatesContent {\n    __typename\n    nightsSelection {\n      ...EGDSDatePickerFlexibleNightsFragment\n    }\n    monthsSelection {\n      ...EGDSDatePickerFlexibleMonthsFragment\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject21 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject22() {
  var data = _tagged_template_literal(["\n  fragment EGDSDatePickerFlexibilityContentFragment on EGDSDatePickerFlexibilityContent {\n    __typename\n    calendarContent {\n      ...EGDSDatePickerFlexibilityCalendarContentFragment\n    }\n    contentSelector {\n      ...EGDSBasicTabsFragment\n    }\n    flexibleDatesContent {\n      ...EGDSDatePickerFlexibilityDatesContentFragment\n    }\n    flexibilityLabel {\n      templates {\n        template\n        category\n      }\n      models {\n        key\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject22 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject23() {
  var data = _tagged_template_literal(["\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    linkName\n    referrerId\n  }\n"]);
  _templateObject23 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject24() {
  var data = _tagged_template_literal(["\n  fragment MarkFragment on Mark {\n    description\n    id\n  }\n"]);
  _templateObject24 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject25() {
  var data = _tagged_template_literal(["\n  fragment UIGraphicFragment on UIGraphic {\n    ... on Icon {\n      ...IconFragment\n    }\n\n    ... on Mark {\n      ...MarkFragment\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject25 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject26() {
  var data = _tagged_template_literal(["\n  fragment EGDSGraphicTextFragment on EGDSGraphicText {\n    accessibility\n    text\n    graphic {\n      ...UIGraphicFragment\n    }\n    trailingGraphics {\n      ...UIGraphicFragment\n    }\n  }\n  ", "\n"]);
  _templateObject26 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject27() {
  var data = _tagged_template_literal(["\n  query FlightsPriceCalendar(\n    $context: ContextInput!\n    $flightsSearchContext: FlightsSearchContextInput!\n    $journeyCriteria: [FlightsJourneyCriteriaInput!]!\n    $queryState: FlightsQueryState\n    $searchFilterValuesList: [FlightsSearchFilterValuesInput!]\n    $searchPreferences: FlightsSearchPreferencesInput\n  ) {\n    flightsPriceCalendar(\n      context: $context\n      flightsSearchContext: $flightsSearchContext\n      journeyCriteria: $journeyCriteria\n      queryState: $queryState\n      searchFilterValuesList: $searchFilterValuesList\n      searchPreferences: $searchPreferences\n    ) {\n      alertText {\n        ...EGDSGraphicTextFragment\n      }\n      disclaimerText\n      coverageAnalytics {\n        linkName\n        referrerId\n      }\n      calendarPrices {\n        date\n        label\n        selectAnalytics {\n          ...ClientSideAnalyticsFragment\n        }\n        theme\n        weight\n      }\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject27 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject28() {
  var data = _tagged_template_literal(["\n  fragment EGDSDateRangePickerFragment on EGDSDateRangePicker {\n    buttonText\n    buttonTextTemplate {\n      ... on EGDSCardinalLocalizedText {\n        text\n        models {\n          key\n          source\n          __typename\n        }\n        templates {\n          category\n          template\n          __typename\n        }\n        __typename\n      }\n    }\n    clearButtonText\n    firstDayOfWeek\n    maxNumberOfDaysSelected\n    sameDaySelectionAllowed\n    selectedStartDate {\n      ...DateFragment\n    }\n    startDatePlaceholderText\n    selectedEndDate {\n      ...DateFragment\n    }\n    endDatePlaceholderText\n    validDaysLowerBoundInclusive {\n      ...DateFragment\n    }\n    validDaysUpperBoundInclusive {\n      ...DateFragment\n    }\n    submitButtonAnalytics {\n      linkName\n      referrerId\n    }\n    nextButtonAnalytics {\n      linkName\n      referrerId\n    }\n    previousButtonAnalytics {\n      linkName\n      referrerId\n    }\n    startDateButtonAnalytics {\n      linkName\n      referrerId\n    }\n    endDateButtonAnalytics {\n      linkName\n      referrerId\n    }\n    clearDatesButtonAnalytics {\n      linkName\n      referrerId\n    }\n    showClearDatesButton\n\n    flexibleDateContent {\n      ...EGDSDatePickerFlexibilityContentFragment\n    }\n  }\n\n  fragment DateFragment on Date {\n    day\n    month\n    year\n  }\n\n  ", "\n"]);
  _templateObject28 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject29() {
  var data = _tagged_template_literal(["\n  fragment EGDSSingleDatePickerFragment on EGDSSingleDatePicker {\n    buttonText\n    selectedStartDate {\n      ...DateFragment\n    }\n    validDaysLowerBoundInclusive {\n      ...DateFragment\n    }\n    validDaysUpperBoundInclusive {\n      ...DateFragment\n    }\n    submitButtonAnalytics {\n      linkName\n      referrerId\n    }\n    startDateButtonAnalytics {\n      linkName\n      referrerId\n    }\n    firstDayOfWeek\n  }\n\n  fragment DateFragment on Date {\n    day\n    month\n    year\n  }\n"]);
  _templateObject29 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject30() {
  var data = _tagged_template_literal(["\n  fragment EGDSSearchFormDatePickerFieldFragment on EGDSSearchFormDatePickerField {\n    egdsElementId\n    label\n    labelTemplate {\n      ... on EGDSBasicLocalizedText {\n        text\n      }\n    }\n    placeholder\n    errorMessage\n    validations {\n      ... on EGDSMaxLengthInputValidation {\n        errorMessage\n      }\n    }\n    action {\n      ...EGDSOpenDatePickerActionFragment\n    }\n  }\n\n  fragment EGDSOpenDatePickerActionFragment on EGDSOpenDatePickerAction {\n    accessibility\n    analytics {\n      linkName\n      referrerId\n    }\n    datePicker {\n      ...EGDSDateRangePickerFragment\n      ...EGDSSingleDatePickerFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject30 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject31() {
  var data = _tagged_template_literal(["\n  fragment EGDSSearchFormLocationFieldFragment on EGDSSearchFormLocationField {\n    __typename\n    egdsElementId\n    label\n    placeholder\n    value\n    errorMessage\n    regionId\n    required\n    leftIcon {\n      title\n    }\n    action {\n      ...OpenTypeaheadActionFragment\n    }\n    closeAnalytics {\n      linkName\n      referrerId\n    }\n    changeAnalytics {\n      linkName\n      referrerId\n    }\n    multiLocations {\n      text\n      value\n    }\n    validations {\n      ... on EGDSInputValidation {\n        errorMessage\n        __typename\n      }\n    }\n    debounceRate\n  }\n\n  fragment OpenTypeaheadActionFragment on OpenTypeaheadAction {\n    accessibility\n    analytics {\n      linkName\n      referrerId\n    }\n    info {\n      ...TypeaheadInfoFragment\n    }\n    emptyResultsPlaceholder\n    categorize\n    allowExactMatch\n    listTitle\n    selectedItemHeading\n    clearAllText\n    dismissButtonText\n  }\n\n  fragment TypeaheadInfoFragment on TypeaheadInfo {\n    client\n    drivable\n    isDestination\n    lineOfBusiness\n    maxNumberOfResults\n    packageType\n    personalize\n    regionType\n    typeaheadFeatures\n    isMultiLocation\n    domain\n    regionId\n    showCurrentLocation\n    subLob\n    expUserId\n    trending\n  }\n"]);
  _templateObject31 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject32() {
  var data = _tagged_template_literal(["\n  fragment EGDSSecondaryButtonFragment on UISecondaryButton {\n    egdsElementId\n    ...EGDSButtonFragment\n  }\n\n  ", "\n"]);
  _templateObject32 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject33() {
  var data = _tagged_template_literal(["\n  fragment EGDSSearchFormLocationsFieldFragment on EGDSSearchFormLocationsField {\n    egdsElementId\n    origin {\n      ...EGDSSearchFormLocationFieldFragment\n    }\n    destination {\n      ...EGDSSearchFormLocationFieldFragment\n    }\n    horizontalSwapper {\n      ...EGDSSecondaryButtonFragment\n    }\n    verticalSwapper {\n      ...EGDSSecondaryButtonFragment\n    }\n    validations {\n      ... on EGDSInputValidation {\n        errorMessage\n      }\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject33 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject34() {
  var data = _tagged_template_literal(["\n  fragment EGDSPrimaryButtonFragment on UIPrimaryButton {\n    egdsElementId\n    ...EGDSButtonFragment\n  }\n\n  ", "\n"]);
  _templateObject34 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject35() {
  var data = _tagged_template_literal(["\n  fragment EGDSTertiaryButtonFragment on UITertiaryButton {\n    egdsElementId\n    ...EGDSButtonFragment\n  }\n\n  ", "\n"]);
  _templateObject35 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject36() {
  var data = _tagged_template_literal(["\n  fragment EGDSBasicOptionFragment on EGDSBasicOption {\n    label\n    value\n    egdsElementId\n    changeAnalytics {\n      linkName\n      referrerId\n    }\n  }\n"]);
  _templateObject36 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject37() {
  var data = _tagged_template_literal(["\n  fragment EGDSTravelerChildAgeSelectFragment on EGDSTravelerChildAgeSelect {\n    labelTemplate {\n      ... on EGDSBasicLocalizedText {\n        models {\n          key\n          source\n        }\n        template\n      }\n    }\n    options {\n      ...EGDSBasicOptionFragment\n    }\n    egdsElementId\n    value\n  }\n\n  ", "\n"]);
  _templateObject37 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject38() {
  var data = _tagged_template_literal(["\n  fragment TemplateModelFragment on TemplateModel {\n    key\n    source\n  }\n"]);
  _templateObject38 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject39() {
  var data = _tagged_template_literal(["\n  fragment EGDSBasicLocalizedTextFragment on EGDSBasicLocalizedText {\n    template\n    models {\n      ...TemplateModelFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject39 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject40() {
  var data = _tagged_template_literal(["\n  fragment EGDSCardinalLocalizedTextFragment on EGDSCardinalLocalizedText {\n    egdsElementId\n    text\n    models {\n      ...TemplateModelFragment\n    }\n    templates {\n      ...CardinalTemplateFragment\n    }\n  }\n\n  fragment CardinalTemplateFragment on CardinalTemplate {\n    template\n    category\n  }\n\n  ", "\n"]);
  _templateObject40 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject41() {
  var data = _tagged_template_literal(["\n  fragment EGDSCompositeLocalizedTextFragment on EGDSCompositeLocalizedText {\n    egdsElementId\n    text\n    template\n    models {\n      ...CompositeLocalizedTextModelFragment\n    }\n  }\n\n  fragment CompositeLocalizedTextModelFragment on CompositeLocalizedTextModel {\n    key\n    models {\n      ...EGDSTemplateModelsFragment\n    }\n  }\n\n  fragment EGDSTemplateModelsFragment on EGDSTemplateModels {\n    models {\n      ...TemplateModelFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject41 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject42() {
  var data = _tagged_template_literal(["\n  fragment EGDSLocalizedTextFragment on EGDSLocalizedText {\n    ...EGDSBasicLocalizedTextFragment\n    ...EGDSCardinalLocalizedTextFragment\n    ...EGDSCompositeLocalizedTextFragment\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject42 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject43() {
  var data = _tagged_template_literal(["\n  fragment EGDSTravelerStepInputFragment on EGDSStepInput {\n    ... on EGDSTravelerStepInput {\n      decreaseAnalytics {\n        linkName\n        referrerId\n      }\n      increaseAnalytics {\n        linkName\n        referrerId\n      }\n      decreaseText\n      decreaseTextTemplate {\n        ...EGDSBasicLocalizedTextFragment\n      }\n      increaseText\n      increaseTextTemplate {\n        ...EGDSBasicLocalizedTextFragment\n      }\n      egdsElementId\n    }\n    label\n    max\n    min\n    step\n    subLabel\n    value\n  }\n\n  ", "\n"]);
  _templateObject43 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject44() {
  var data = _tagged_template_literal(["\n  fragment EGDSTravelerChildrenFragment on EGDSTraveler {\n    count {\n      ...EGDSTravelerStepInputFragment\n    }\n    ... on EGDSBasicTraveler {\n      type\n    }\n    ... on EGDSTravelerChildren {\n      ages {\n        ...EGDSTravelerChildAgeSelectFragment\n      }\n      ageTemplate {\n        ...EGDSTravelerChildAgeSelectFragment\n      }\n    }\n    ... on EGDSTravelerInfant {\n      ages {\n        ...EGDSTravelerChildAgeSelectFragment\n      }\n      ageTemplate {\n        ...EGDSTravelerChildAgeSelectFragment\n      }\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject44 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject45() {
  var data = _tagged_template_literal(["\n  fragment EGDSTravelersFragment on EGDSTravelers {\n    adults {\n      ...EGDSTravelerStepInputFragment\n    }\n    children {\n      ...EGDSTravelerChildrenFragment\n    }\n    infantsInSeat {\n      ...EGDSTravelerChildrenFragment\n    }\n    infantsOnLap {\n      ...EGDSTravelerChildrenFragment\n    }\n    pets {\n      ...EGDSBasicCheckBoxFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject45 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject46() {
  var data = _tagged_template_literal(["\n  fragment EGDSBasicTravelerSelectorFragment on EGDSBasicTravelerSelector {\n    closeButton {\n      ...EGDSPrimaryButtonFragment\n      ...EGDSTertiaryButtonFragment\n    }\n    doneButton {\n      ...EGDSPrimaryButtonFragment\n    }\n    title\n    travelers {\n      ...EGDSTravelersFragment\n    }\n    validations {\n      ... on EGDSTravelersInputValidation {\n        errorMessage\n        maxCount\n        type\n        infantsInSeatPerAdult\n        errorSummary {\n          ...EGDSErrorSummaryFragment\n        }\n      }\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject46 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject47() {
  var data = _tagged_template_literal(["\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    text\n    egdsElementId\n    action {\n      accessibility\n      target\n      resource {\n        value\n      }\n      analytics {\n        linkName\n        referrerId\n      }\n    }\n    icon {\n      id\n    }\n    iconPosition\n  }\n"]);
  _templateObject47 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject48() {
  var data = _tagged_template_literal(["\n  fragment EGDSTravelerInfantSeatSelectFragment on EGDSTravelerInfantSeatSelection {\n    airlineAgeRule {\n      ...EGDSStandardLinkFragment\n    }\n    groupName\n    labelTemplate {\n      ... on EGDSCardinalLocalizedText {\n        text\n        models {\n          key\n          source\n        }\n        templates {\n          category\n          template\n        }\n      }\n    }\n    options {\n      label\n      value\n    }\n    selected\n  }\n  ", "\n"]);
  _templateObject48 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject49() {
  var data = _tagged_template_literal(["\n  fragment EGDSTravelerSelectorRoomFragment on EGDSTravelerSelectorRoom {\n    label {\n      ... on EGDSBasicLocalizedText {\n        models {\n          key\n          source\n        }\n        template\n      }\n    }\n    adults {\n      ...EGDSTravelerStepInputFragment\n    }\n    children {\n      ...EGDSTravelerChildrenFragment\n    }\n    infants {\n      ...EGDSTravelerChildrenFragment\n    }\n    removeRoomButton {\n      ...EGDSTertiaryButtonFragment\n    }\n    removeRoomAnnouncement\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject49 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject50() {
  var data = _tagged_template_literal(["\n  fragment EGDSRoomsTravelerSelectorFragment on EGDSRoomsTravelerSelector {\n    addAnotherRoomButton {\n      ...EGDSTertiaryButtonFragment\n    }\n    closeButton {\n      ...EGDSPrimaryButtonFragment\n      ...EGDSTertiaryButtonFragment\n    }\n    doneButton {\n      ...EGDSPrimaryButtonFragment\n    }\n    infantSeatSelection {\n      ...EGDSTravelerInfantSeatSelectFragment\n    }\n    maxRoomCount\n    rooms {\n      ...EGDSTravelerSelectorRoomFragment\n    }\n    title\n    validations {\n      ... on EGDSTravelersInputValidation {\n        errorMessage\n        maxCount\n        type\n        infantsInSeatPerAdult\n        errorSummary {\n          ...EGDSErrorSummaryFragment\n        }\n      }\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject50 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject51() {
  var data = _tagged_template_literal(["\n  fragment EGDSSearchFormTravelersFieldFragment on EGDSSearchFormTravelersField {\n    action {\n      ... on EGDSOpenTravelerSelectorAction {\n        analytics {\n          linkName\n          referrerId\n        }\n        travelerSelector {\n          ...EGDSBasicTravelerSelectorFragment\n          ...EGDSRoomsTravelerSelectorFragment\n        }\n        accessibility\n      }\n    }\n    label\n    labelTemplate {\n      ... on EGDSCardinalLocalizedText {\n        models {\n          key\n          source\n        }\n        templates {\n          category\n          template\n        }\n        secondaryTemplates {\n          category\n          template\n        }\n        text\n      }\n      ... on EGDSCompositeLocalizedText {\n        models {\n          key\n          models {\n            ... on EGDSCardinalLocalizedText {\n              models {\n                key\n                source\n              }\n              templates {\n                category\n                template\n              }\n            }\n          }\n        }\n        template\n        text\n      }\n    }\n    leftIcon {\n      id\n    }\n    readOnly\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject51 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject52() {
  var data = _tagged_template_literal(["\n  fragment EGDSSearchPlaybackFragment on EGDSSearchPlayback {\n    primary {\n      text\n    }\n    primaryTemplate {\n      ... on EGDSBasicLocalizedText {\n        text\n      }\n    }\n    secondaries {\n      ... on EGDSPlainText {\n        text\n        accessibility\n      }\n      ... on EGDSBasicLocalizedText {\n        text\n        template\n        accessibilityTemplate\n        models {\n          key\n          source\n        }\n        egdsElementId\n      }\n      ... on EGDSCardinalLocalizedText {\n        text\n        accessibilityText\n        egdsElementId\n        models {\n          key\n          source\n        }\n        templates {\n          category\n          template\n        }\n      }\n    }\n    showAction {\n      ... on EGDSShowSearchFormAction {\n        accessibility\n        analytics {\n          linkName\n          referrerId\n        }\n        icon {\n          id\n          size\n        }\n        resource {\n          value\n        }\n      }\n    }\n    hideButton {\n      ...EGDSTertiaryButtonFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject52 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject53() {
  var data = _tagged_template_literal(["\n  fragment SearchFormMessagingSheetFragment on EGDSSheet {\n    closeAccessibility\n    closeAnalytics {\n      referrerId\n      linkName\n    }\n    sheetTypes {\n      ... on EGDSSheetTypePerViewSize {\n        sheetType\n        viewSize\n      }\n    }\n  }\n"]);
  _templateObject53 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject54() {
  var data = _tagged_template_literal(["\n  fragment MoreInfoTriggerFragment on EGDSMoreInfoTrigger {\n    text\n    icon {\n      ...IconFragment\n    }\n    triggerAction {\n      accessibility\n      text\n      analytics {\n        referrerId\n        linkName\n      }\n      sheet {\n        ...SearchFormMessagingSheetFragment\n      }\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject54 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject55() {
  var data = _tagged_template_literal(["\n  fragment SearchFormMessagingFragment on SearchFormMessaging {\n    text {\n      template\n      replacementTexts\n    }\n    icon {\n      ...IconFragment\n    }\n    moreInfoTrigger {\n      ...MoreInfoTriggerFragment\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject55 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject56() {
  var data = _tagged_template_literal(["\n  fragment SearchFormPartialStayFragment on SearchFormPartialStay {\n    __typename\n    addPartialStay {\n      ...EGDSCheckBoxFragment\n      __typename\n    }\n    dates {\n      ...EGDSSearchFormDatePickerFieldFragment\n      __typename\n    }\n    errorMessage\n  }\n  ", "\n  ", "\n"]);
  _templateObject56 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject57() {
  var data = _tagged_template_literal(["\n  fragment SearchLocationFragment on SearchLocation {\n    __typename\n    analytics {\n      open\n      close\n      itemSelected\n      recommendationsPresented\n      recommendationSelected\n    }\n  }\n"]);
  _templateObject57 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject58() {
  var data = _tagged_template_literal(["\n  fragment MultiPackagesSearchFormFragment on PackagesSearchForm {\n    actionURL\n    errorSummary {\n      ...EGDSErrorSummaryFragment\n    }\n    elements {\n      __typename\n      ...EGDSSearchFormLocationFieldFragment\n      ...EGDSSearchFormLocationsFieldFragment\n      ...EGDSSearchFormDatePickerFieldFragment\n      ...EGDSSearchFormTravelersFieldFragment\n      ...EGDSSearchFormInputFieldFragment\n    }\n    search {\n      ...EGDSSearchFormButtonFragment\n    }\n    valuePropMessage {\n      ...SearchFormMessagingFragment\n    }\n    directFlightsOnly {\n      ...EGDSPillFragment\n    }\n    playback @include(if: $includePlayback) {\n      ...EGDSSearchPlaybackFragment\n    }\n    partialStay {\n      ...SearchFormPartialStayFragment\n    }\n    searchLocation {\n      ...SearchLocationFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject58 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject59() {
  var data = _tagged_template_literal(["\n  fragment PrebundlesSearchFormFragment on PackagesSearchForm {\n    playback @include(if: $includePlayback) {\n      ...EGDSSearchPlaybackFragment\n    }\n    errorSummary {\n      ...EGDSErrorSummaryFragment\n    }\n    elements {\n      __typename\n      ...EGDSSearchFormLocationFieldFragment\n      ...EGDSSearchFormDatePickerFieldFragment\n      ...EGDSSearchFormTravelersFieldFragment\n    }\n    search {\n      ...EGDSSearchFormButtonFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject59 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject60() {
  var data = _tagged_template_literal(["\n  query PackagesSearchFormQuery(\n    $context: ContextInput!\n    $packageSearchCriteria: PackageSearchCriteriaInput!\n    $packageShoppingCriteria: ProductShoppingCriteriaInput\n    $includePlayback: Boolean = false\n    $packageType: PackageType\n  ) {\n    searchForm(context: $context) {\n      packages(packageSearchCriteria: $packageSearchCriteria, packageShoppingCriteria: $packageShoppingCriteria, packageType: $packageType) {\n        ...PrebundlesSearchFormFragment\n        ...MultiPackagesSearchFormFragment\n        ... on PackagesSearchForm {\n          packageSelection {\n            noSelectionMessage {\n              ...NoSelectionMessageFragment\n            }\n          }\n        }\n      }\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject60 = function _templateObject() {
    return data;
  };
  return data;
}
var __defProp = Object.defineProperty;
var __defNormalProp = function (obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __publicField = function (obj, key, value) {
  __defNormalProp(obj, (typeof key === "undefined" ? "undefined" : _type_of(key)) !== "symbol" ? key + "" : key, value);
  return value;
};
// src/components/packages-search-form/search-form.tsx
import React71 from "react";
import { SearchFormReflectionProvider } from "@shared-ui/retail-search-tools-reflection-provider";
// ../internal/src/components/form/sticky-search-form.tsx
import React from "react";
import { ViewRow } from "@egds/react-search-experience";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkSticky } from "uitk-react-sticky";
import { UitkToolbar } from "uitk-react-toolbar";
var StickySearchForm = function (props) {
  var _React_useState = _sliced_to_array(React.useState(false), 2),
    sticky = _React_useState[0],
    setSticky = _React_useState[1];
  var children = props.children;
  return /* @__PURE__ */React.createElement(UitkSticky, {
    zIndex: 500,
    onFixed: function (isFixed) {
      setSticky(isFixed);
    }
  }, /* @__PURE__ */React.createElement(UitkToolbar, {
    elevation: sticky ? "floating" : "default",
    toolbarType: sticky ? "standard" : "transparent"
  }, /* @__PURE__ */React.createElement(ViewRow, {
    layout: "fullwidth",
    canvasTheme: sticky ? "primary" : "none",
    paddedViewRow: false
  }, /* @__PURE__ */React.createElement(UitkSpacing, {
    padding: {
      block: "four",
      inline: "three"
    }
  }, /* @__PURE__ */React.createElement("div", {
    "data-stid": "sticky-search-form"
  }, children)))), !sticky && /* @__PURE__ */React.createElement(UitkSpacing, {
    padding: "six"
  }, /* @__PURE__ */React.createElement("div", null)));
};
// src/components/packages-search-form/search-form.tsx
import { ViewMedium as ViewMedium13, Viewport as Viewport15, ViewSmall as ViewSmall13 } from "@shared-ui/viewport-context";
// src/__generated__/types.ts
var PackageType = /* @__PURE__ */function (PackageType2) {
  PackageType2["FLIGHT_CAR"] = "FLIGHT_CAR";
  PackageType2["FLIGHT_HOTEL"] = "FLIGHT_HOTEL";
  PackageType2["FLIGHT_HOTEL_CAR"] = "FLIGHT_HOTEL_CAR";
  PackageType2["HOTEL_ACTIVITY"] = "HOTEL_ACTIVITY";
  PackageType2["HOTEL_CAR"] = "HOTEL_CAR";
  return PackageType2;
}(PackageType || {});
// src/components/package-options.tsx
import React10 from "react";
import { gql as gql9, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
// ../internal/src/components/common/egds-pill/egds-pill.tsx
import React6 from "react";
import { gql as gql5 } from "@apollo/client";
// ../internal/src/components/common/egds-pill/egds-basic-pill.tsx
import React3, { useRef } from "react";
import { gql as gql2 } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { useFormCallback } from "uitk-react-form";
import { UitkPill } from "uitk-react-pill";
import { Level, liveAnnounce } from "uitk-react-utils";
// ../internal/src/components/common/icon.tsx
import React2 from "react";
import { gql } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
var __Fragment = gql(_templateObject());
var _obj;
var iconSizeMap = (_obj = {}, _define_property(_obj, "EXTRA_SMALL" /* EXTRA_SMALL */, UitkIconSize.EXTRA_SMALL), _define_property(_obj, "SMALL" /* SMALL */, UitkIconSize.SMALL), _define_property(_obj, "MEDIUM" /* MEDIUM */, UitkIconSize.MEDIUM), _define_property(_obj, "MEDIUM_LARGE" /* MEDIUM_LARGE */, UitkIconSize.MEDIUM), _define_property(_obj, "LARGE" /* LARGE */, UitkIconSize.LARGE), _define_property(_obj, "XLARGE" /* XLARGE */, UitkIconSize.XLARGE), _obj);
var Icon = function (props) {
  var data = props.data;
  var id = data.id,
    title = data.title,
    description = data.description,
    size = data.size;
  var iconSize = iconSizeMap[size !== null && size !== void 0 ? size : "LARGE"];
  return /* @__PURE__ */React2.createElement(UitkIcon, {
    id: id,
    name: id,
    title: title !== null && title !== void 0 ? title : description,
    description: description,
    size: iconSize
  });
};
Icon.displayName = "Icon";
Icon.fragment = __Fragment;
// ../internal/src/components/common/egds-pill/egds-basic-pill.tsx
var EGDS_BASIC_PILL_PREFIX = "EGDSBasicPill";
var __Fragment2 = gql2(_templateObject1(), Icon.fragment);
var EGDSBasicPill = function (props) {
  var data = props.data,
    onChange = props.onChange,
    triggerPill = props.triggerPill,
    onClick = props.onClick,
    active = props.active;
  var accessibility = data.accessibility,
    name = data.name,
    primary = data.primary,
    selected = data.selected,
    value = data.value,
    disabled = data.disabled,
    icon = data.icon,
    selectAnalytics = data.selectAnalytics,
    deselectAnalytics = data.deselectAnalytics,
    selectedText = data.selectedText;
  var clickTracker = useClickTracker();
  var id = name !== null && name !== void 0 ? name : "egds-basic-pill";
  var _React3_useState = _sliced_to_array(React3.useState(selected), 2),
    checked = _React3_useState[0],
    setCheckState = _React3_useState[1];
  var pillRef = useRef(false);
  var onPillSelectText = selectedText || primary;
  var handleOnChange = useFormCallback(id, function (event) {
    var _event_currentTarget = event.currentTarget,
      newSelection = _event_currentTarget.checked;
    setCheckState(newSelection);
    if (!pillRef.current) {
      pillRef.current = true;
    }
    if (onChange) {
      onChange(event);
    }
    if (selectAnalytics && newSelection) {
      var linkName = selectAnalytics.linkName,
        referrerId = selectAnalytics.referrerId;
      clickTracker(referrerId, linkName);
      return event;
    }
    if (deselectAnalytics && !newSelection) {
      var linkName1 = deselectAnalytics.linkName,
        referrerId1 = deselectAnalytics.referrerId;
      clickTracker(referrerId1, linkName1);
    }
    return event;
  });
  var handleOnClick = function () {
    if (onClick) {
      onClick();
    }
  };
  React3.useEffect(function () {
    if (pillRef.current) {
      liveAnnounce(accessibility !== null && accessibility !== void 0 ? accessibility : void 0, Level.POLITE);
    }
  }, [accessibility]);
  React3.useEffect(function () {
    setCheckState(selected);
  }, [selected]);
  return /* @__PURE__ */React3.createElement(UitkPill, {
    checked: checked,
    active: active,
    disabled: disabled,
    icon: (icon === null || icon === void 0 ? void 0 : icon.__typename) === "Icon" ? icon.token : "",
    id: id,
    name: "".concat(EGDS_BASIC_PILL_PREFIX, "-").concat(name),
    onChange: handleOnChange,
    value: value !== null && value !== void 0 ? value : "",
    altText: accessibility !== null && accessibility !== void 0 ? accessibility : "",
    triggerPill: triggerPill,
    onClick: handleOnClick
  }, checked ? onPillSelectText : primary);
};
EGDSBasicPill.displayName = "EGDSBasicPill";
EGDSBasicPill.fragment = _object_spread_props(_object_spread({}, __Fragment2), {
  __typename: "EGDSBasicPill"
});
// ../internal/src/components/common/egds-pill/egds-basic-removable-pill.tsx
import React4 from "react";
import { gql as gql3 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkRemovablePill } from "uitk-react-pill";
var __Fragment3 = gql3(_templateObject2());
var EGDSBasicRemovablePill = function (param) {
  var data = param.data,
    onClick = param.onClick;
  var id = data.id,
    primary = data.primary,
    accessibility = data.accessibility,
    removeAnalytics = data.removeAnalytics,
    name = data.name,
    value = data.value;
  var _ref;
  var title = (_ref = id !== null && id !== void 0 ? id : name) !== null && _ref !== void 0 ? _ref : "egds-basic-removable-pill";
  var clickTracker = useClickTracker2();
  var handleOnClick = function (event) {
    if (onClick) {
      onClick({
        event: event,
        id: id !== null && id !== void 0 ? id : ""
      });
    }
    if (removeAnalytics) {
      var referrerId = removeAnalytics.referrerId,
        linkName = removeAnalytics.linkName;
      clickTracker(referrerId, linkName);
    }
  };
  return /* @__PURE__ */React4.createElement("div", null, /* @__PURE__ */React4.createElement(UitkRemovablePill, {
    id: title,
    onClick: handleOnClick,
    a11yRemoveText: accessibility || ""
  }, primary), /* @__PURE__ */React4.createElement("input", {
    type: "hidden",
    name: name !== null && name !== void 0 ? name : "",
    value: value !== null && value !== void 0 ? value : ""
  }));
};
EGDSBasicRemovablePill.displayName = "EGDSBasicRemovablePill";
EGDSBasicRemovablePill.fragment = __Fragment3;
// ../internal/src/components/common/egds-pill/egds-basic-trigger-pill.tsx
import React5 from "react";
import { gql as gql4 } from "@apollo/client";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { useFormCallback as useFormCallback2 } from "uitk-react-form";
import { UitkPill as UitkPill2 } from "uitk-react-pill";
var EGDS_BASIC_TRIGGER_PILL_PREFIX = "EGDSBasicTriggerPill";
var __Fragment4 = gql4(_templateObject3(), Icon.fragment);
var EGDSBasicTriggerPill = function (props) {
  var data = props.data,
    onChange = props.onChange,
    triggerPill = props.triggerPill,
    onClick = props.onClick,
    domRef = props.domRef,
    active = props.active;
  var id = data.id,
    primary = data.primary,
    selected = data.selected,
    disabled = data.disabled,
    icon = data.icon,
    selectAnalytics = data.selectAnalytics,
    deselectAnalytics = data.deselectAnalytics,
    accessibility = data.accessibility;
  var clickTracker = useClickTracker3();
  var name = id !== null && id !== void 0 ? id : "egds-basic-pill";
  var _React5_useState = _sliced_to_array(React5.useState(active || selected), 2),
    checked = _React5_useState[0],
    check = _React5_useState[1];
  React5.useEffect(function () {
    check(active !== null && active !== void 0 ? active : false);
  }, [active]);
  var handleOnClick = useFormCallback2(name, function (event) {
    check(!checked);
    if (onChange) {
      onChange(event);
    }
    if (onClick) {
      onClick();
    }
    if (selectAnalytics && checked) {
      var linkName = selectAnalytics.linkName,
        referrerId = selectAnalytics.referrerId;
      clickTracker(referrerId, linkName);
      return event;
    }
    if (deselectAnalytics && !checked) {
      var linkName1 = deselectAnalytics.linkName,
        referrerId1 = deselectAnalytics.referrerId;
      clickTracker(referrerId1, linkName1);
    }
    return event;
  });
  return /* @__PURE__ */React5.createElement(UitkPill2, {
    checked: checked,
    active: checked,
    selected: selected,
    disabled: disabled,
    icon: (icon === null || icon === void 0 ? void 0 : icon.__typename) === "Icon" ? icon.token : "",
    id: name,
    name: "".concat(EGDS_BASIC_TRIGGER_PILL_PREFIX, "-").concat(name),
    triggerPill: triggerPill,
    onClick: handleOnClick,
    altText: accessibility !== null && accessibility !== void 0 ? accessibility : "",
    domRef: domRef
  }, primary);
};
EGDSBasicTriggerPill.displayName = "EGDSBasicTriggerPillFragment";
EGDSBasicTriggerPill.fragment = __Fragment4;
// ../internal/src/components/common/egds-pill/egds-pill.tsx
var __Fragment5 = gql5(_templateObject4(), EGDSBasicPill.fragment, EGDSBasicTriggerPill.fragment, EGDSBasicRemovablePill.fragment);
var EGDSPill = function (props) {
  var data = props.data;
  switch (data.__typename) {
    case "EGDSBasicPill":
      return /* @__PURE__ */React6.createElement(EGDSBasicPill, _object_spread_props(_object_spread({}, props), {
        data: data
      }));
    case "EGDSBasicTriggerPill":
      return /* @__PURE__ */React6.createElement(EGDSBasicTriggerPill, _object_spread_props(_object_spread({}, props), {
        data: data
      }));
    case "EGDSBasicRemovablePill":
      return /* @__PURE__ */React6.createElement(EGDSBasicRemovablePill, _object_spread_props(_object_spread({}, props), {
        data: data
      }));
    default:
      return null;
  }
};
EGDSPill.displayName = "EGDSPill";
EGDSPill.fragment = __Fragment5;
// ../internal/src/components/form/egds-search-form-input-field/egds-search-form-input-field.tsx
import React8 from "react";
import { gql as gql7 } from "@apollo/client";
// ../internal/src/components/form/egds-search-form-input-field/egds-search-form-input-field-with-selection.tsx
import React7 from "react";
import { gql as gql6 } from "@apollo/client";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
import { useFormCallback as useFormCallback3 } from "uitk-react-form";
import { UitkSelect } from "uitk-react-input";
import { PositionType, UitkMenu, UitkMenuContainer, UitkMenuList, UitkMenuTrigger } from "uitk-react-menu";
import { UitkPill as UitkPill3 } from "uitk-react-pill";
// ../internal/src/utils/trigger-input-change-event.ts
var triggerInputChangeEvent = function (value, handler, inputType) {
  var event = new CustomEvent("change");
  var input = document.createElement("input");
  if (inputType) {
    input.type = inputType;
  }
  input.value = value;
  var changeListener = function (inputEvent) {
    handler(inputEvent);
  };
  input.addEventListener("change", changeListener);
  input.dispatchEvent(event);
  input.removeEventListener("change", changeListener);
};
// ../internal/src/components/form/egds-search-form-input-field/egds-search-form-input-field-with-selection.tsx
var __Fragment6 = gql6(_templateObject5());
var DISPLAY_NAME = "EGDSSearchFormInputFieldWithSelection";
var INPUT_FIELD__WITH_SELECTION_PREFIX = "".concat(DISPLAY_NAME);
var EGDSSearchFormInputFieldWithSelection = function (param) {
  var data = param.data,
    trigger = param.trigger,
    triggerType = param.triggerType;
  var egdsElementId = trigger.egdsElementId,
    leftIcon = trigger.leftIcon,
    label = trigger.label;
  var analytics = data.analytics,
    options = data.options;
  var track = useClickTracker4();
  var _React7_useState = _sliced_to_array(React7.useState(false), 2),
    isOpen = _React7_useState[0],
    displayToggle = _React7_useState[1];
  var _React7_useState1 = _sliced_to_array(React7.useState(options.findIndex(function (option) {
      return option.selected;
    })), 2),
    selectedOptionIndex = _React7_useState1[0],
    setSelectedOptionIndex = _React7_useState1[1];
  var _options_find;
  var _ref = (_options_find = options.find(function (_, index) {
      return index === selectedOptionIndex;
    })) !== null && _options_find !== void 0 ? _options_find : trigger,
    currentDisplayValue = _ref.label,
    currentValue = _ref.value;
  var _React7_useState2 = _sliced_to_array(React7.useState(currentValue !== null && currentValue !== void 0 ? currentValue : ""), 2),
    selectValue = _React7_useState2[0],
    onSelectValueChange = _React7_useState2[1];
  var fakeInputRef = React7.createRef();
  var selectInputRef = React7.createRef();
  var pillButtonRef = React7.createRef();
  var defaultMenuItemAttributes = {
    attributes: {
      role: "menuitemradio",
      tabindex: 0
    },
    className: "uitk-list-item"
  };
  var INPUT_NAME = "".concat(INPUT_FIELD__WITH_SELECTION_PREFIX, "-").concat(egdsElementId);
  var inputFieldWithSelectionFormCallback = useFormCallback3(INPUT_NAME, function (event) {
    return event;
  });
  var handleTriggerClick = React7.useCallback(function (isMenu) {
    if (isMenu) {
      displayToggle(function (prevState) {
        return !prevState;
      });
    }
    var referrerId = analytics.referrerId,
      linkName = analytics.linkName;
    track(referrerId, linkName);
  }, [analytics, track]);
  var handleMenuDismiss = function () {
    displayToggle(false);
  };
  var handleSelectChange = useFormCallback3(INPUT_NAME, function (event) {
    onSelectValueChange(event.target.value);
    return event;
  });
  var handleMenuItemSelect = function (newIndex, event) {
    var _fakeInputRef_current, _pillButtonRef_current;
    setSelectedOptionIndex(newIndex);
    displayToggle(false);
    triggerInputChangeEvent(options[newIndex].value, inputFieldWithSelectionFormCallback);
    fakeInputRef === null || fakeInputRef === void 0 ? void 0 : (_fakeInputRef_current = fakeInputRef.current) === null || _fakeInputRef_current === void 0 ? void 0 : _fakeInputRef_current.focus();
    (_pillButtonRef_current = pillButtonRef.current) === null || _pillButtonRef_current === void 0 ? void 0 : _pillButtonRef_current.focus();
    event.preventDefault();
  };
  var menuItems = options.map(function (option, index) {
    var optionLabel = option.label,
      value = option.value;
    return _object_spread_props(_object_spread({}, defaultMenuItemAttributes), {
      label: optionLabel,
      id: value,
      onClick: function (event) {
        return handleMenuItemSelect(index, event);
      },
      selected: selectedOptionIndex === index
    });
  });
  var _leftIcon_id;
  var selectorTrigger = /* @__PURE__ */React7.createElement(UitkSelect, {
    name: INPUT_NAME,
    label: label !== null && label !== void 0 ? label : "",
    icon: (_leftIcon_id = leftIcon === null || leftIcon === void 0 ? void 0 : leftIcon.id) !== null && _leftIcon_id !== void 0 ? _leftIcon_id : "",
    domRef: selectInputRef,
    onChange: handleSelectChange,
    "aria-label": label !== null && label !== void 0 ? label : ""
  }, options.map(function (param) {
    var optionLabel = param.label,
      value = param.value;
    return /* @__PURE__ */React7.createElement("option", {
      key: value,
      label: optionLabel,
      value: value
    }, value);
  }));
  var _ref1;
  var pillTrigger = /* @__PURE__ */React7.createElement(UitkPill3, {
    name: INPUT_NAME,
    id: egdsElementId,
    triggerPill: true,
    selected: true,
    toggleState: isOpen,
    onClick: function () {
      return handleTriggerClick(true);
    },
    domRef: pillButtonRef
  }, (_ref1 = currentDisplayValue !== label ? currentDisplayValue : currentValue) !== null && _ref1 !== void 0 ? _ref1 : "");
  return /* @__PURE__ */React7.createElement(React7.Fragment, null, triggerType === "pill" /* PILL */ && /* @__PURE__ */React7.createElement(UitkMenu, {
    id: "".concat(egdsElementId, "_menu"),
    isOpen: isOpen,
    onDismiss: handleMenuDismiss,
    disableBodyClickHandler: false
  }, /* @__PURE__ */React7.createElement(UitkMenuTrigger, null, pillTrigger), /* @__PURE__ */React7.createElement(UitkMenuContainer, {
    position: PositionType.LEFT
  }, /* @__PURE__ */React7.createElement(UitkMenuList, {
    items: menuItems
  }))), triggerType === "selector" /* SELECTOR */ && selectorTrigger, /* @__PURE__ */React7.createElement("input", {
    type: "hidden",
    "data-testid": INPUT_NAME,
    name: INPUT_NAME,
    value: triggerType === "selector" /* SELECTOR */ ? selectValue : currentValue !== null && currentValue !== void 0 ? currentValue : ""
  }));
};
EGDSSearchFormInputFieldWithSelection.displayName = DISPLAY_NAME;
EGDSSearchFormInputFieldWithSelection.fragment = __Fragment6;
// ../internal/src/components/form/egds-search-form-input-field/egds-search-form-input-field.tsx
var __Fragment7 = gql7(_templateObject6(), Icon.fragment, EGDSSearchFormInputFieldWithSelection.fragment);
var EGDSSearchFormInputField = function (param) {
  var data = param.data,
    triggerType = param.triggerType;
  var _data_action;
  switch ((_data_action = data.action) === null || _data_action === void 0 ? void 0 : _data_action.__typename) {
    case "EGDSSearchFormSelectAction":
      if (triggerType) {
        return /* @__PURE__ */React8.createElement(EGDSSearchFormInputFieldWithSelection, {
          data: data.action,
          trigger: data,
          triggerType: triggerType
        });
      }
      return null;
    default:
      return null;
  }
};
EGDSSearchFormInputField.displayName = "EGDSSearchFormInputField";
EGDSSearchFormInputField.fragment = __Fragment7;
// src/components/package-options.tsx
import { UitkForm } from "uitk-react-form";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLineSkeleton } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
// src/util/fallback-options-data.ts
var cabin = {
  egdsElementId: "cabin_class",
  value: "COACH",
  label: "Cabin class",
  placeholder: "Economy",
  leftIcon: {
    id: "airline_seat_recline_extra",
    title: null,
    token: "icon__airline_seat_recline_extra",
    description: "airline_seat_recline_extra",
    size: null,
    __typename: "Icon"
  },
  action: {
    analytics: {
      linkName: "Open Cabin Class Selector",
      referrerId: "Web.package.cabin.class.selector.open",
      __typename: "ClientSideAnalytics"
    },
    options: [{
      label: "Economy",
      selected: true,
      value: "COACH",
      __typename: "EGDSBasicOption"
    }, {
      label: "Premium economy",
      selected: false,
      value: "ECONOMY_PREMIUM",
      __typename: "EGDSBasicOption"
    }, {
      label: "Business class",
      selected: false,
      value: "BUSINESS",
      __typename: "EGDSBasicOption"
    }, {
      label: "First class",
      selected: false,
      value: "FIRST_CLASS",
      __typename: "EGDSBasicOption"
    }],
    __typename: "EGDSSearchFormSelectAction"
  },
  __typename: "EGDSSearchFormInputField"
};
var car = function (selected) {
  return {
    __typename: "EGDSBasicPill",
    accessibility: null,
    disabled: false,
    name: "package-type-selector-car",
    primary: "Car",
    selected: selected,
    selectedText: "Car added",
    value: null,
    icon: null,
    selectAnalytics: {
      linkName: "Packages - Pill selected or deselected",
      referrerId: "Web.package.selection.car.selected",
      __typename: "ClientSideAnalytics"
    },
    deselectAnalytics: {
      linkName: "Packages - Pill selected or deselected",
      referrerId: "Web.package.selection.car.deselected",
      __typename: "ClientSideAnalytics"
    }
  };
};
var flight = function (selected) {
  return {
    __typename: "EGDSBasicPill",
    accessibility: null,
    disabled: false,
    name: "package-type-selector-flight",
    primary: "Flight",
    selected: selected,
    selectedText: "Flight added",
    value: null,
    icon: null,
    selectAnalytics: {
      linkName: "Packages - Pill selected or deselected",
      referrerId: "Web.package.selection.flight.selected",
      __typename: "ClientSideAnalytics"
    },
    deselectAnalytics: {
      linkName: "Packages - Pill selected or deselected",
      referrerId: "Web.package.selection.flight.deselected",
      __typename: "ClientSideAnalytics"
    }
  };
};
var stay = function (selected) {
  return {
    __typename: "EGDSBasicPill",
    accessibility: null,
    disabled: false,
    name: "package-type-selector-stay",
    primary: "Stay",
    selected: selected,
    selectedText: "Stay added",
    value: null,
    icon: null,
    selectAnalytics: {
      linkName: "Packages - Pill selected or deselected",
      referrerId: "Web.package.selection.stay.selected",
      __typename: "ClientSideAnalytics"
    },
    deselectAnalytics: {
      linkName: "Packages - Pill selected or deselected",
      referrerId: "Web.package.selection.stay.deselected",
      __typename: "ClientSideAnalytics"
    }
  };
};
var defaultElements = [{
  __typename: "EGDSSearchFormLocationsField"
}, {
  __typename: "EGDSSearchFormDatePickerField"
}, {
  __typename: "EGDSSearchFormTravelersField"
}];
var packageSelectionMap = /* @__PURE__ */new Map([["FLIGHT_HOTEL" /* FLIGHT_HOTEL */, {
  car: car(false),
  flight: flight(true),
  stay: stay(true),
  __typename: "PackagesSearchFormSelection"
}], ["FLIGHT_CAR" /* FLIGHT_CAR */, {
  car: car(true),
  flight: flight(true),
  stay: stay(false),
  __typename: "PackagesSearchFormSelection"
}], ["FLIGHT_HOTEL_CAR" /* FLIGHT_HOTEL_CAR */, {
  car: car(true),
  flight: flight(true),
  stay: stay(true),
  __typename: "PackagesSearchFormSelection"
}], ["HOTEL_CAR" /* HOTEL_CAR */, {
  car: car(true),
  flight: flight(false),
  stay: stay(true),
  __typename: "PackagesSearchFormSelection"
}]]);
var getFallbackOptionsData = function (packageType, includePackageSelection) {
  var packageSelection2 = null;
  var elements = _to_consumable_array(defaultElements);
  if (includePackageSelection && packageType) {
    packageSelection2 = packageSelectionMap.get(packageType) || null;
  }
  if (packageType && packageType !== "HOTEL_CAR" /* HOTEL_CAR */) {
    elements = _to_consumable_array(defaultElements).concat([cabin]);
  }
  return {
    searchForm: {
      packages: {
        __typename: "PackagesSearchForm",
        packageSelection: packageSelection2,
        elements: elements,
        directFlightsOnly: null
      },
      __typename: "SearchFormResults"
    }
  };
};
// src/components/__private/package-selection.tsx
import React9 from "react";
import { gql as gql8 } from "@apollo/client";
var listOfLineOfBusiness = ["stay", "flight", "car"];
var packages = [{
  stay: true,
  flight: true,
  car: true,
  type: "FLIGHT_HOTEL_CAR" /* FLIGHT_HOTEL_CAR */
}, {
  stay: true,
  flight: true,
  car: false,
  type: "FLIGHT_HOTEL" /* FLIGHT_HOTEL */
}, {
  stay: false,
  flight: true,
  car: true,
  type: "FLIGHT_CAR" /* FLIGHT_CAR */
}, {
  stay: true,
  flight: false,
  car: true,
  type: "HOTEL_CAR" /* HOTEL_CAR */
}];
var __Fragment8 = gql8(_templateObject7(), EGDSPill.fragment);
var PackagesSearchFormSelection = function (props) {
  var _packages_find;
  var data = props.data,
    onPackageTypeChange = props.onPackageTypeChange;
  var car2 = data.car,
    flight2 = data.flight,
    stay2 = data.stay;
  var initialState = {
    stay: !!(stay2 === null || stay2 === void 0 ? void 0 : stay2.selected),
    flight: !!(flight2 === null || flight2 === void 0 ? void 0 : flight2.selected),
    car: !!(car2 === null || car2 === void 0 ? void 0 : car2.selected)
  };
  var _packages_find_type;
  var _React9_useState = _sliced_to_array(React9.useState(_object_spread_props(_object_spread({}, initialState), {
      type: (_packages_find_type = (_packages_find = packages.find(function (pkg) {
        return listOfLineOfBusiness.every(function (lob) {
          return pkg[lob] === initialState[lob];
        });
      })) === null || _packages_find === void 0 ? void 0 : _packages_find.type) !== null && _packages_find_type !== void 0 ? _packages_find_type : null
    })), 2),
    setCurrentPackage = _React9_useState[1];
  var handlePillChange = function (event) {
    var _event_target = event.target,
      name = _event_target.name,
      checked = _event_target.checked;
    var pillNamePrefix = "package-type-selector-";
    var key = name.split(pillNamePrefix)[1];
    setCurrentPackage(function (prev) {
      var _packages_find;
      var newPackage = _object_spread_props(_object_spread({}, prev), _define_property({}, key, checked));
      var _packages_find_type;
      var type = (_packages_find_type = (_packages_find = packages.find(function (pkg) {
        return listOfLineOfBusiness.every(function (lob) {
          return pkg[lob] === newPackage[lob];
        });
      })) === null || _packages_find === void 0 ? void 0 : _packages_find.type) !== null && _packages_find_type !== void 0 ? _packages_find_type : null;
      onPackageTypeChange === null || onPackageTypeChange === void 0 ? void 0 : onPackageTypeChange(type);
      return _object_spread_props(_object_spread({}, newPackage), {
        type: type
      });
    });
  };
  if (!stay2 || !flight2) {
    return null;
  }
  var pills = car2 ? [stay2, flight2, car2] : [stay2, flight2];
  return /* @__PURE__ */React9.createElement(React9.Fragment, null, pills.map(function (pill) {
    return /* @__PURE__ */React9.createElement(EGDSPill, {
      key: pill.name,
      data: pill,
      onChange: handlePillChange
    });
  }));
};
PackagesSearchFormSelection.displayName = "PackagesSearchFormSelection";
PackagesSearchFormSelection.fragment = __Fragment8;
// src/components/package-options.tsx
var __Query = gql9(_templateObject8(), PackagesSearchFormSelection.fragment, EGDSSearchFormInputField.fragment, EGDSPill.fragment);
var PackagesOptions = function (props) {
  var _data_searchForm;
  var inputs = props.inputs,
    skipSsr = props.skipSsr,
    batchKey = props.batchKey,
    onFieldChange = props.onFieldChange,
    onCabinClassSelect = props.onCabinClassSelect,
    onPackageTypeChange = props.onPackageTypeChange,
    handleDirectFlightsOnlySwitch = props.handleDirectFlightsOnlySwitch,
    showCabinClass = props.showCabinClass,
    showDirectFlightsOnly = props.showDirectFlightsOnly,
    skipQuery = props.skipQuery;
  var includePackageType = inputs.includePackageType,
    packageType = inputs.packageType;
  var context = useBexApi().context;
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var _useQuery = useQuery(__Query, {
      context: {
        batchKey: batchKey
      },
      variables: variables,
      ssr: !skipSsr,
      skip: skipQuery
    }),
    currentData = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading,
    previousData = _useQuery.previousData;
  var data = previousData || currentData;
  React10.useEffect(function () {
    if (onCabinClassSelect) {
      var _cabinClassField_action;
      var cabinClassField = (data === null || data === void 0 ? void 0 : data.searchForm.packages.__typename) === "PackagesSearchForm" ? data.searchForm.packages.elements.find(function (element) {
        var _element_action;
        return element.__typename === "EGDSSearchFormInputField" && ((_element_action = element.action) === null || _element_action === void 0 ? void 0 : _element_action.__typename) === "EGDSSearchFormSelectAction";
      }) : null;
      if ((cabinClassField === null || cabinClassField === void 0 ? void 0 : cabinClassField.__typename) === "EGDSSearchFormInputField" && ((_cabinClassField_action = cabinClassField.action) === null || _cabinClassField_action === void 0 ? void 0 : _cabinClassField_action.__typename) === "EGDSSearchFormSelectAction") {
        var cabinClassFieldName = "".concat(INPUT_FIELD__WITH_SELECTION_PREFIX, "-").concat(cabinClassField.egdsElementId);
        var selectedOption = cabinClassField.action.options.find(function (option) {
          return option.selected;
        });
        var _selectedOption_value;
        onCabinClassSelect({
          name: cabinClassFieldName,
          value: (_selectedOption_value = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) !== null && _selectedOption_value !== void 0 ? _selectedOption_value : ""
        });
      }
    }
  }, [data === null || data === void 0 ? void 0 : data.searchForm, onCabinClassSelect]);
  if (loading && !data) {
    return /* @__PURE__ */React10.createElement(UitkSpacing2, {
      padding: {
        blockstart: "three",
        blockend: "three"
      }
    }, /* @__PURE__ */React10.createElement("div", null, /* @__PURE__ */React10.createElement(UitkLineSkeleton, {
      animation: true,
      type: "secondary"
    })));
  }
  if (error || !data) {
    data = getFallbackOptionsData(packageType, includePackageType);
  }
  if ((data === null || data === void 0 ? void 0 : (_data_searchForm = data.searchForm) === null || _data_searchForm === void 0 ? void 0 : _data_searchForm.packages.__typename) !== "PackagesSearchForm") {
    return null;
  }
  var elements = data.searchForm.packages.elements;
  var handleCabinClassChange = function (field) {
    onCabinClassSelect === null || onCabinClassSelect === void 0 ? void 0 : onCabinClassSelect(field);
  };
  var handleFieldChange = function (field, event) {
    onFieldChange === null || onFieldChange === void 0 ? void 0 : onFieldChange(field, event);
  };
  var onChangeDirectFlightsOnly = function (event) {
    handleDirectFlightsOnlySwitch === null || handleDirectFlightsOnlySwitch === void 0 ? void 0 : handleDirectFlightsOnlySwitch(event.target.checked);
  };
  var directFlightsOnly = data.searchForm.packages.directFlightsOnly;
  return /* @__PURE__ */React10.createElement(UitkSpacing2, {
    padding: {
      blockend: "three"
    }
  }, /* @__PURE__ */React10.createElement(UitkLayoutFlex, {
    space: "two",
    wrap: "wrap"
  }, includePackageType && data.searchForm.packages.packageSelection && /* @__PURE__ */React10.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */React10.createElement(UitkForm, {
    onFieldChange: handleFieldChange,
    "data-stid": "package-type-selector"
  }, /* @__PURE__ */React10.createElement(PackagesSearchFormSelection, _object_spread_props(_object_spread({}, props), {
    data: data.searchForm.packages.packageSelection,
    onPackageTypeChange: onPackageTypeChange
  })))), showCabinClass && /* @__PURE__ */React10.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */React10.createElement("div", null, /* @__PURE__ */React10.createElement(UitkForm, {
    onFieldChange: handleCabinClassChange
  }, elements.map(function (element, index) {
    return element.__typename === "EGDSSearchFormInputField" && /* @__PURE__ */React10.createElement(EGDSSearchFormInputField, {
      key: index,
      data: element,
      triggerType: "pill" /* PILL */
    });
  })))), directFlightsOnly && showDirectFlightsOnly && /* @__PURE__ */React10.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */React10.createElement("div", null, /* @__PURE__ */React10.createElement(EGDSPill, {
    data: directFlightsOnly,
    onChange: onChangeDirectFlightsOnly
  })))));
};
PackagesOptions.displayName = "sharedui-PackagesOptions";
// src/components/packages-search-form/packages-search-form.tsx
import React70 from "react";
import { gql as gql57, useQuery as useQuery2 } from "@apollo/client";
import { useBexApi as useBexApi6 } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker3 } from "@shared-ui/clickstream-analytics-context";
import { useLoggerEvents as useLoggerEvents2 } from "@shared-ui/logger-context";
// ../internal/src/components/common/fallback-indicator-wrapper.tsx
import React11 from "react";
import { EGDSBadgeStandard } from "@egds/react-core/badge";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
import { EGDSSpacing } from "@egds/react-core/spacing";
var developmentHostNames = ["localhost", "wwwexpediacom", "shared-ui.expedia.biz"];
var FallbackIndicatorWrapper = function (props) {
  var children = props.children;
  var isDevelopment = developmentHostNames.includes(window.location.hostname);
  return /* @__PURE__ */React11.createElement(React11.Fragment, null, isDevelopment && /* @__PURE__ */React11.createElement(EGDSSpacing, {
    margin: {
      blockend: "three"
    }
  }, /* @__PURE__ */React11.createElement(EGDSBadgeStandard, {
    theme: "warning",
    text: "Fallback is in use"
  }, /* @__PURE__ */React11.createElement(EGDSIcon, {
    size: EGDSIconSize.MEDIUM,
    name: "warning"
  }))), children);
};
FallbackIndicatorWrapper.displayName = "FallbackBadge";
// ../internal/src/components/form/form-skeleton.tsx
import React12 from "react";
import { UitkLineSkeleton as UitkLineSkeleton2 } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
var FormSkeleton = function (param) {
  var rows = param.rows;
  return /* @__PURE__ */React12.createElement(React12.Fragment, null, rows.map(function (param, index) {
    var type = param.type;
    return /* @__PURE__ */React12.createElement(UitkSpacing3, {
      key: index,
      padding: index === 0 ? void 0 : {
        blockstart: "three"
      }
    }, /* @__PURE__ */React12.createElement("div", null, /* @__PURE__ */React12.createElement(UitkLineSkeleton2, {
      animation: true,
      type: type
    })));
  }));
};
// src/components/packages-search-form/packages-search-form.tsx
import { ViewMedium as ViewMedium12, Viewport as Viewport14, ViewSmall as ViewSmall12 } from "@shared-ui/viewport-context";
// ../internal/src/utils/search-location-fallback-data.ts
var searchLocationFallback = {
  __typename: "SearchLocation",
  analytics: {
    __typename: "SearchLocationAnalytics",
    open: '{"metadata":{"packer_version":"1.0.1"},"events":{"search_location.opened":{"v1":{"event_data":{"event":{"event_name":"search_location.opened","event_version":"1.0.0","event_category":"Search","event_type":"Interaction"}}}}}}',
    close: '{"metadata":{"packer_version":"1.0.1"},"events":{"search_location.closed":{"v1":{"event_data":{"event":{"event_name":"search_location.closed","event_version":"1.0.0","event_category":"Search","event_type":"Interaction"}}}}}}',
    itemSelected: '{"metadata":{"packer_version":"1.0.1"},"events":{"search_location.selected":{"v1":{"event_data":{"event":{"event_name":"search_location.selected","event_version":"1.0.0","event_category":"Search","event_type":"Interaction"}}}}}}',
    recommendationsPresented: '{"metadata":{"packer_version":"1.0.1"},"events":{"recommendations_module.presented":{"v2":{"event_data":{"event":{"event_name":"recommendations_module.presented","event_version":"2.1.0","event_category":"Search","event_type":"Impression"}}}}}}',
    recommendationSelected: '{"metadata":{"packer_version":"1.0.1"},"events":{"recommendations_module.selected":{"v2":{"event_data":{"event":{"event_name":"recommendations_module.selected","event_version":"2.1.0","event_category":"Search","event_type":"Interaction"}}}}}}'
  }
};
// src/util/fallback-form-data.ts
var templateError = [{
  category: "ZERO" /* ZERO */,
  template: "Please correct the ${errorCount} errors to continue",
  __typename: "CardinalTemplate"
}, {
  category: "ONE" /* ONE */,
  template: "Please correct the error to continue",
  __typename: "CardinalTemplate"
}, {
  category: "TWO" /* TWO */,
  template: "Please correct the ${errorCount} errors to continue",
  __typename: "CardinalTemplate"
}, {
  category: "FEW" /* FEW */,
  template: "Please correct the ${errorCount} errors to continue",
  __typename: "CardinalTemplate"
}, {
  category: "MANY" /* MANY */,
  template: "Please correct the ${errorCount} errors to continue",
  __typename: "CardinalTemplate"
}, {
  category: "OTHER" /* OTHER */,
  template: "Please correct the ${errorCount} errors to continue",
  __typename: "CardinalTemplate"
}];
var templateTravelers = [{
  category: "ZERO" /* ZERO */,
  template: "${travelerCount} travelers",
  __typename: "CardinalTemplate"
}, {
  category: "ONE" /* ONE */,
  template: "${travelerCount} traveler",
  __typename: "CardinalTemplate"
}, {
  category: "TWO" /* TWO */,
  template: "${travelerCount} travelers",
  __typename: "CardinalTemplate"
}, {
  category: "FEW" /* FEW */,
  template: "${travelerCount} travelers",
  __typename: "CardinalTemplate"
}, {
  category: "MANY" /* MANY */,
  template: "${travelerCount} travelers",
  __typename: "CardinalTemplate"
}, {
  category: "OTHER" /* OTHER */,
  template: "${travelerCount} travelers",
  __typename: "CardinalTemplate"
}];
var templateRooms = [{
  category: "ZERO" /* ZERO */,
  template: "${roomCount} rooms",
  __typename: "CardinalTemplate"
}, {
  category: "ONE" /* ONE */,
  template: "${roomCount} room",
  __typename: "CardinalTemplate"
}, {
  category: "TWO" /* TWO */,
  template: "${roomCount} rooms",
  __typename: "CardinalTemplate"
}, {
  category: "FEW" /* FEW */,
  template: "${roomCount} rooms",
  __typename: "CardinalTemplate"
}, {
  category: "MANY" /* MANY */,
  template: "${roomCount} rooms",
  __typename: "CardinalTemplate"
}, {
  category: "OTHER" /* OTHER */,
  template: "${roomCount} rooms",
  __typename: "CardinalTemplate"
}];
var errorSummary = {
  egdsElementId: "search_form_error_summary",
  goToErrorLinkText: "Go to error",
  goToFirstErrorLinkText: "Go to first error",
  heading: "",
  body: null,
  analytics: {
    linkName: "Error summary link clicked",
    referrerId: "Web.Packages.Search.Error.Summary",
    __typename: "ClientSideAnalytics"
  },
  impressionAnalytics: {
    linkName: "Error summary displayed",
    referrerId: "Web.Packages.Search.Error.Summary.Displayed",
    __typename: "ClientSideImpressionEventAnalytics"
  },
  headingTemplate: {
    models: [{
      key: "errorCount",
      source: "errorCount",
      __typename: "TemplateModel"
    }],
    templates: templateError,
    __typename: "EGDSCardinalLocalizedText"
  },
  __typename: "EGDSErrorSummary"
};
var search = {
  egdsElementId: "search_button",
  primary: "Search",
  disabled: false,
  accessibility: "Search",
  icon: null,
  analytics: null,
  action: null,
  __typename: "EGDSSearchFormButton",
  onClick: {
    analytics: {
      linkName: "Search button clicked",
      referrerId: "Web.Packages.Search.Button.Clicked",
      __typename: "ClientSideAnalytics"
    },
    __typename: "EGDSSubmitSearchFormAction"
  }
};
var packageSelection = {
  noSelectionMessage: {
    body: "To start building your trip, choose two or more items",
    heading: "Please select two or more items",
    icon: {
      id: "search",
      title: null,
      token: "icon__search",
      description: "search",
      size: null,
      __typename: "Icon"
    },
    __typename: "UIEmptyState"
  },
  __typename: "PackagesSearchFormSelection"
};
var packageTypeSelector = /* @__PURE__ */new Map([["FLIGHT_CAR" /* FLIGHT_CAR */, "fc"], ["FLIGHT_HOTEL_CAR" /* FLIGHT_HOTEL_CAR */, "fhc"], ["FLIGHT_HOTEL" /* FLIGHT_HOTEL */, "fh"], ["HOTEL_CAR" /* HOTEL_CAR */, "hc"]]);
var destinationLocationField = function () {
  var packageType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "HOTEL_CAR" /* HOTEL_CAR */;
  return {
    __typename: "EGDSSearchFormLocationField",
    egdsElementId: "destination_select",
    label: "Going to",
    placeholder: "Going to",
    value: null,
    errorMessage: "Please select a destination",
    validations: [{
      errorMessage: "Please select a destination",
      __typename: "EGDSRequiredInputValidation"
    }],
    required: false,
    leftIcon: {
      title: null,
      __typename: "Icon"
    },
    action: {
      accessibility: null,
      analytics: {
        linkName: "Destination Selection",
        referrerId: "Web.package.destination.location.change",
        __typename: "ClientSideAnalytics"
      },
      info: {
        client: "Packages.Search",
        drivable: false,
        isDestination: true,
        lineOfBusiness: "PACKAGES",
        maxNumberOfResults: 8,
        packageType: packageTypeSelector[packageType] || "hc",
        personalize: true,
        regionType: 863,
        typeaheadFeatures: "ta_hierarchy|postal_code|google|consistent_display",
        isMultiLocation: null,
        domain: null,
        regionId: null,
        showCurrentLocation: null,
        __typename: "TypeaheadInfo",
        subLob: packageTypeSelector[packageType] || "hc",
        expUserId: "-1",
        trending: false
      },
      emptyResultsPlaceholder: "Search by city or airport",
      categorize: false,
      allowExactMatch: true,
      listTitle: false,
      selectedItemHeading: null,
      clearAllText: null,
      dismissButtonText: null,
      __typename: "OpenTypeaheadAction"
    },
    closeAnalytics: {
      linkName: "Destination Selection",
      referrerId: "Web.package.destination.location.close",
      __typename: "ClientSideAnalytics"
    },
    changeAnalytics: {
      linkName: "Destination change",
      referrerId: "Web.package.destination.location.change",
      __typename: "ClientSideAnalytics"
    },
    multiLocations: null,
    regionId: null,
    debounceRate: null
  };
};
var searchLocationsFields = function (packageType) {
  return {
    __typename: "EGDSSearchFormLocationsField",
    egdsElementId: "locations",
    origin: {
      __typename: "EGDSSearchFormLocationField",
      egdsElementId: "origin_select",
      label: "Leaving from",
      placeholder: "Leaving from",
      value: null,
      errorMessage: "Please select an origin",
      validations: [{
        errorMessage: "Please select an origin",
        __typename: "EGDSRequiredInputValidation"
      }],
      required: false,
      leftIcon: {
        title: null,
        __typename: "Icon"
      },
      action: {
        accessibility: null,
        analytics: {
          linkName: "Origin Selection",
          referrerId: "Web.package.origin.location.open",
          __typename: "ClientSideAnalytics"
        },
        info: {
          client: "Packages.Search",
          drivable: false,
          isDestination: false,
          lineOfBusiness: "PACKAGES",
          maxNumberOfResults: 8,
          packageType: packageTypeSelector.get(packageType) || "hc",
          personalize: true,
          regionType: 863,
          typeaheadFeatures: "ta_hierarchy|postal_code|google|consistent_display",
          isMultiLocation: null,
          domain: null,
          regionId: null,
          showCurrentLocation: null,
          __typename: "TypeaheadInfo",
          subLob: packageTypeSelector.get(packageType) || "hc",
          expUserId: "-1",
          trending: false
        },
        emptyResultsPlaceholder: "Search by city or airport",
        categorize: false,
        allowExactMatch: true,
        listTitle: false,
        selectedItemHeading: null,
        clearAllText: null,
        dismissButtonText: null,
        __typename: "OpenTypeaheadAction"
      },
      closeAnalytics: {
        linkName: "Origin Selection",
        referrerId: "Web.package.origin.location.close",
        __typename: "ClientSideAnalytics"
      },
      changeAnalytics: {
        linkName: "Origin change",
        referrerId: "Web.package.origin.location.change",
        __typename: "ClientSideAnalytics"
      },
      multiLocations: null,
      regionId: null,
      debounceRate: null
    },
    destination: destinationLocationField(packageType),
    horizontalSwapper: {
      egdsElementId: "location_swapper",
      primary: "",
      disabled: false,
      accessibility: "Swap origin and destination values",
      icon: {
        id: "",
        description: "swap_horiz",
        token: "",
        title: null,
        __typename: "Icon"
      },
      analytics: {
        linkName: "Swapper button clicked",
        referrerId: "package.locations.swapper.button.click",
        __typename: "ClientSideAnalytics"
      },
      action: null,
      __typename: "UISecondaryButton"
    },
    verticalSwapper: {
      egdsElementId: "location_swapper",
      primary: "",
      disabled: false,
      accessibility: "Swap origin and destination values",
      icon: {
        id: "",
        description: "swap_vert",
        token: "",
        title: null,
        __typename: "Icon"
      },
      analytics: {
        linkName: "Swapper button clicked",
        referrerId: "package.locations.swapper.button.click",
        __typename: "ClientSideAnalytics"
      },
      action: null,
      __typename: "UISecondaryButton"
    },
    validations: [{
      errorMessage: "Please make sure your departure and arrival cities are different",
      __typename: "EGDSSameValueInputValidation"
    }]
  };
};
var today = /* @__PURE__ */new Date();
var startDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 14);
var endDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + 1);
var validDaysUpperInclusive = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 332);
var validDaysLowerBoundInclusive = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 2);
var startDatePickerMonthValue = startDate.getMonth() + 1;
var endDatePickerMonthValue = endDate.getMonth() + 1;
var datePicker = {
  __typename: "EGDSSearchFormDatePickerField",
  egdsElementId: "date-range-select",
  label: "Dates",
  labelTemplate: null,
  placeholder: "Dates",
  errorMessage: null,
  validations: [{
    errorMessage: "Dates must be no more than 29 days apart",
    __typename: "EGDSMaxLengthInputValidation"
  }],
  action: {
    accessibility: null,
    analytics: {
      linkName: "Packages - Calendar Selection",
      referrerId: "Web.packages.calendar.selection",
      __typename: "ClientSideAnalytics"
    },
    datePicker: {
      flexibleDateContent: null,
      buttonText: "Done",
      buttonTextTemplate: null,
      clearButtonText: null,
      firstDayOfWeek: "SUN" /* SUN */,
      maxNumberOfDaysSelected: 29,
      sameDaySelectionAllowed: false,
      selectedStartDate: {
        day: startDate.getDate(),
        month: startDatePickerMonthValue,
        year: startDate.getFullYear(),
        __typename: "Date"
      },
      startDatePlaceholderText: "Check-in",
      selectedEndDate: {
        day: endDate.getDate(),
        month: endDatePickerMonthValue,
        year: endDate.getFullYear(),
        __typename: "Date"
      },
      endDatePlaceholderText: "Check-out",
      validDaysLowerBoundInclusive: {
        day: validDaysLowerBoundInclusive.getDate(),
        month: validDaysLowerBoundInclusive.getMonth(),
        year: validDaysLowerBoundInclusive.getFullYear(),
        __typename: "Date"
      },
      validDaysUpperBoundInclusive: {
        day: validDaysUpperInclusive.getDate(),
        month: validDaysUpperInclusive.getMonth(),
        year: validDaysUpperInclusive.getFullYear(),
        __typename: "Date"
      },
      submitButtonAnalytics: {
        linkName: "Packages - Calendar Submit",
        referrerId: "Web.packages.calendar.submit",
        __typename: "ClientSideAnalytics"
      },
      nextButtonAnalytics: {
        linkName: "Calendar next",
        referrerId: "Web.Packages.Calendar.Next.Month.Click",
        __typename: "ClientSideAnalytics"
      },
      previousButtonAnalytics: {
        linkName: "Calendar previous",
        referrerId: "Web.Packages.Calendar.Previous.Month.Click",
        __typename: "ClientSideAnalytics"
      },
      startDateButtonAnalytics: {
        linkName: "Packages - Calendar Start Date",
        referrerId: "Web.packages.calendar.start.date.click",
        __typename: "ClientSideAnalytics"
      },
      endDateButtonAnalytics: {
        linkName: "Packages - Calendar End Date",
        referrerId: "Web.packages.calendar.end.date.click",
        __typename: "ClientSideAnalytics"
      },
      clearDatesButtonAnalytics: null,
      showClearDatesButton: false,
      __typename: "EGDSDateRangePicker"
    },
    __typename: "EGDSOpenDatePickerAction"
  }
};
var cabinFormInput = {
  __typename: "EGDSSearchFormInputField",
  egdsElementId: "cabin_class",
  value: "COACH",
  label: "Cabin class",
  placeholder: "Economy",
  leftIcon: {
    id: "airline_seat_recline_extra",
    title: null,
    token: "icon__airline_seat_recline_extra",
    description: "airline_seat_recline_extra",
    size: null,
    __typename: "Icon"
  },
  action: {
    analytics: {
      linkName: "Open Cabin Class Selector",
      referrerId: "Web.package.cabin.class.selector.open",
      __typename: "ClientSideAnalytics"
    },
    options: [{
      label: "Economy",
      selected: true,
      value: "COACH",
      __typename: "EGDSBasicOption"
    }, {
      label: "Premium economy",
      selected: false,
      value: "ECONOMY_PREMIUM",
      __typename: "EGDSBasicOption"
    }, {
      label: "Business class",
      selected: false,
      value: "BUSINESS",
      __typename: "EGDSBasicOption"
    }, {
      label: "First class",
      selected: false,
      value: "FIRST_CLASS",
      __typename: "EGDSBasicOption"
    }],
    __typename: "EGDSSearchFormSelectAction"
  }
};
var infantValidations = [{
  errorMessage: "We allow up to 6 travelers per booking.",
  maxCount: 6,
  type: "MAX_TRAVELERS" /* MAX_TRAVELERS */,
  infantsInSeatPerAdult: null,
  errorSummary: {
    egdsElementId: "traveler_selector_error_summary",
    goToErrorLinkText: null,
    goToFirstErrorLinkText: null,
    heading: "We allow up to 6 travelers per booking.",
    body: null,
    analytics: null,
    impressionAnalytics: {
      linkName: "Error summary displayed",
      referrerId: "Web.Packages.Traveler.Error.Summary.Displayed",
      __typename: "ClientSideImpressionEventAnalytics"
    },
    headingTemplate: null,
    __typename: "EGDSErrorSummary"
  },
  __typename: "EGDSTravelersInputValidation"
}, {
  errorMessage: "There must be at least 1 traveler (age 12+) for each infant in a lap.",
  maxCount: null,
  type: "MANY_INFANT_ON_LAP" /* MANY_INFANT_ON_LAP */,
  infantsInSeatPerAdult: 2,
  errorSummary: {
    egdsElementId: "traveler_selector_error_summary",
    goToErrorLinkText: null,
    goToFirstErrorLinkText: null,
    heading: "There must be at least 1 traveler (age 12+) for each infant in a lap.",
    body: null,
    analytics: null,
    impressionAnalytics: {
      linkName: "Error summary displayed",
      referrerId: "Web.Packages.Traveler.Error.Summary.Displayed",
      __typename: "ClientSideImpressionEventAnalytics"
    },
    headingTemplate: null,
    __typename: "EGDSErrorSummary"
  },
  __typename: "EGDSTravelersInputValidation"
}, {
  errorMessage: "Provide the age of the child.",
  maxCount: null,
  type: "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */,
  infantsInSeatPerAdult: null,
  errorSummary: {
    egdsElementId: "traveler_selector_error_summary",
    goToErrorLinkText: "Go to error",
    goToFirstErrorLinkText: "Go to first error",
    heading: "",
    body: null,
    analytics: {
      linkName: "Error summary link clicked",
      referrerId: "Web.Packages.Traveler.Error.Summary",
      __typename: "ClientSideAnalytics"
    },
    impressionAnalytics: {
      linkName: "Error summary displayed",
      referrerId: "Web.Packages.Traveler.Error.Summary.Displayed",
      __typename: "ClientSideImpressionEventAnalytics"
    },
    headingTemplate: {
      models: [{
        key: "errorCount",
        source: "errorCount",
        __typename: "TemplateModel"
      }],
      templates: templateError,
      __typename: "EGDSCardinalLocalizedText"
    },
    __typename: "EGDSErrorSummary"
  },
  __typename: "EGDSTravelersInputValidation"
}, {
  errorMessage: "There must be at least 1 traveler (age 12+) for every 2 infants in a seat.",
  maxCount: null,
  type: "MANY_INFANT_IN_SEAT" /* MANY_INFANT_IN_SEAT */,
  infantsInSeatPerAdult: 2,
  errorSummary: {
    egdsElementId: "traveler_selector_error_summary",
    goToErrorLinkText: null,
    goToFirstErrorLinkText: null,
    heading: "There must be at least 1 traveler (age 12+) for every 2 infants in a seat.",
    body: null,
    analytics: null,
    impressionAnalytics: {
      linkName: "Error summary displayed",
      referrerId: "Web.Packages.Traveler.Error.Summary.Displayed",
      __typename: "ClientSideImpressionEventAnalytics"
    },
    headingTemplate: null,
    __typename: "EGDSErrorSummary"
  },
  __typename: "EGDSTravelersInputValidation"
}];
var ageOptions = function (value, label) {
  var labelOption = label || value;
  return {
    label: labelOption,
    value: value,
    egdsElementId: null,
    changeAnalytics: {
      linkName: "Travelers age update",
      referrerId: "Web.Packages.Traveler.Child.Update.Age.".concat(value),
      __typename: "ClientSideAnalytics"
    },
    __typename: "EGDSBasicOption"
  };
};
var flightHotelCarTravelSelector = {
  __typename: "EGDSSearchFormTravelersField",
  action: {
    analytics: {
      linkName: "Packages - Travelers Selection",
      referrerId: "Web.packages.travelers.selection",
      __typename: "ClientSideAnalytics"
    },
    travelerSelector: {
      addAnotherRoomButton: {
        egdsElementId: null,
        primary: "Add another room",
        disabled: false,
        accessibility: null,
        icon: null,
        analytics: {
          linkName: "Travelers add room",
          referrerId: "Web.Packages.Traveler.Add.Room",
          __typename: "ClientSideAnalytics"
        },
        action: null,
        __typename: "UITertiaryButton"
      },
      closeButton: {
        egdsElementId: null,
        primary: null,
        disabled: false,
        accessibility: null,
        icon: {
          id: "close",
          description: "",
          token: "icon__close",
          title: null,
          __typename: "Icon"
        },
        analytics: {
          linkName: "Travelers results not updated",
          referrerId: "Web.Packages.Traveler.Close",
          __typename: "ClientSideAnalytics"
        },
        action: null,
        __typename: "UITertiaryButton"
      },
      doneButton: {
        egdsElementId: null,
        primary: "Done",
        disabled: false,
        accessibility: null,
        icon: null,
        analytics: {
          linkName: "Travelers results updated",
          referrerId: "Web.Packages.Traveler.Done",
          __typename: "ClientSideAnalytics"
        },
        action: null,
        __typename: "UIPrimaryButton"
      },
      infantSeatSelection: {
        airlineAgeRule: {
          text: "Airline age rules",
          action: {
            accessibility: null,
            target: "INTERNAL" /* INTERNAL */,
            resource: {
              value: "https://www.expedia.com/p/info-main/h_fw_default%3Frhtx=HTX_FLTSRCH_RT%23travs",
              __typename: "HttpURI"
            },
            analytics: {
              linkName: "Packages - Airline Age Rules",
              referrerId: "Web.packages.airline.age.rules",
              __typename: "ClientSideAnalytics"
            },
            __typename: "UILinkAction"
          },
          icon: null,
          iconPosition: null,
          __typename: "EGDSStandardLink",
          egdsElementId: null
        },
        groupName: "InfantSeating",
        labelTemplate: {
          text: "Where will the infants sit?",
          models: [{
            key: "infantCount",
            source: "infantCount",
            __typename: "TemplateModel"
          }],
          templates: [{
            category: "ONE" /* ONE */,
            template: "Where will the infant sit?",
            __typename: "CardinalTemplate"
          }, {
            category: "OTHER" /* OTHER */,
            template: "Where will the infants sit?",
            __typename: "CardinalTemplate"
          }],
          __typename: "EGDSCardinalLocalizedText"
        },
        options: [{
          label: "On lap",
          value: "lap",
          __typename: "EGDSInfantSeatRadioButton"
        }, {
          label: "In seat",
          value: "seat",
          __typename: "EGDSInfantSeatRadioButton"
        }],
        selected: "lap",
        __typename: "EGDSTravelerInfantSeatSelection"
      },
      maxRoomCount: 6,
      rooms: [{
        label: {
          models: [{
            key: "roomNumber",
            source: "roomNumber",
            __typename: "TemplateModel"
          }],
          template: "Room ${roomNumber}",
          __typename: "EGDSBasicLocalizedText"
        },
        adults: {
          decreaseAnalytics: {
            linkName: "Packages - Step input decrease",
            referrerId: "Web.packages.step.input.decrease",
            __typename: "ClientSideAnalytics"
          },
          increaseAnalytics: {
            linkName: "Packages - Step input increase",
            referrerId: "Web.packages.step.input.increase",
            __typename: "ClientSideAnalytics"
          },
          decreaseText: "Decrease the number of adults in this room",
          decreaseTextTemplate: null,
          increaseText: "Increase the number of adults in this room",
          increaseTextTemplate: null,
          egdsElementId: null,
          __typename: "EGDSTravelerStepInput",
          label: "Adults",
          max: 6,
          min: 1,
          step: 1,
          subLabel: null,
          value: 2
        },
        children: {
          count: {
            decreaseAnalytics: {
              linkName: "Packages - Step input decrease",
              referrerId: "Web.packages.step.input.decrease",
              __typename: "ClientSideAnalytics"
            },
            increaseAnalytics: {
              linkName: "Packages - Step input increase",
              referrerId: "Web.packages.step.input.increase",
              __typename: "ClientSideAnalytics"
            },
            decreaseText: "Decrease the number of children in this room",
            decreaseTextTemplate: null,
            increaseText: "Increase the number of children in this room",
            increaseTextTemplate: null,
            egdsElementId: null,
            __typename: "EGDSTravelerStepInput",
            label: "Children",
            max: 5,
            min: 0,
            step: 1,
            subLabel: "Ages 2 to 17",
            value: 0
          },
          ages: [],
          ageTemplate: {
            labelTemplate: {
              models: [{
                key: "childNumber",
                source: "childNumber",
                __typename: "TemplateModel"
              }],
              template: "Child ${childNumber} age",
              __typename: "EGDSBasicLocalizedText"
            },
            options: [ageOptions("2"), ageOptions("3"), ageOptions("4"), ageOptions("5"), ageOptions("6"), ageOptions("7"), ageOptions("8"), ageOptions("9"), ageOptions("10"), ageOptions("11"), ageOptions("12"), ageOptions("13"), ageOptions("14"), ageOptions("15"), ageOptions("16"), ageOptions("17")],
            egdsElementId: null,
            value: null,
            __typename: "EGDSTravelerChildAgeSelect"
          },
          __typename: "EGDSTravelerChildren"
        },
        infants: {
          count: {
            decreaseAnalytics: {
              linkName: "Packages - Step input decrease",
              referrerId: "Web.packages.step.input.decrease",
              __typename: "ClientSideAnalytics"
            },
            increaseAnalytics: {
              linkName: "Packages - Step input increase",
              referrerId: "Web.packages.step.input.increase",
              __typename: "ClientSideAnalytics"
            },
            decreaseText: "Decrease the number of infants in this room",
            decreaseTextTemplate: null,
            increaseText: "Increase the number of infants in this room",
            increaseTextTemplate: null,
            egdsElementId: null,
            __typename: "EGDSTravelerStepInput",
            label: "Infants",
            max: 5,
            min: 0,
            step: 1,
            subLabel: "Younger than 2",
            value: 0
          },
          ages: [],
          ageTemplate: {
            labelTemplate: {
              models: [{
                key: "infantNumber",
                source: "infantNumber",
                __typename: "TemplateModel"
              }],
              template: "Infant ${infantNumber} age",
              __typename: "EGDSBasicLocalizedText"
            },
            options: [{
              label: "Under 1",
              value: "0",
              egdsElementId: null,
              changeAnalytics: null,
              __typename: "EGDSBasicOption"
            }, {
              label: "1",
              value: "1",
              egdsElementId: null,
              changeAnalytics: null,
              __typename: "EGDSBasicOption"
            }],
            egdsElementId: null,
            value: null,
            __typename: "EGDSTravelerChildAgeSelect"
          },
          __typename: "EGDSTravelerInfant"
        },
        removeRoomButton: {
          egdsElementId: null,
          primary: "Remove room",
          disabled: false,
          accessibility: null,
          icon: null,
          analytics: {
            linkName: "Packages.Traveler.Remove.Room",
            referrerId: "Web.Travelers remove room",
            __typename: "ClientSideAnalytics"
          },
          action: null,
          __typename: "UITertiaryButton"
        },
        removeRoomAnnouncement: "Room removed",
        __typename: "EGDSTravelerSelectorRoom"
      }],
      title: "Travelers",
      validations: infantValidations,
      __typename: "EGDSRoomsTravelerSelector"
    },
    accessibility: "expand to change the number of travelers",
    __typename: "EGDSOpenTravelerSelectorAction"
  },
  label: "Travelers",
  labelTemplate: {
    models: [{
      key: "rooms",
      models: {
        models: [{
          key: "roomCount",
          source: "roomCount",
          __typename: "TemplateModel"
        }],
        templates: templateRooms,
        __typename: "EGDSCardinalLocalizedText"
      },
      __typename: "CompositeLocalizedTextModel"
    }, {
      key: "travelers",
      models: {
        models: [{
          key: "travelerCount",
          source: "travelerCount",
          __typename: "TemplateModel"
        }],
        templates: templateTravelers,
        __typename: "EGDSCardinalLocalizedText"
      },
      __typename: "CompositeLocalizedTextModel"
    }],
    template: "${travelers}, ${rooms}",
    text: "2 travelers, 1 room",
    __typename: "EGDSCompositeLocalizedText"
  },
  leftIcon: {
    id: "person",
    __typename: "Icon"
  },
  readOnly: false
};
var flightCarTravelSelector = {
  __typename: "EGDSSearchFormTravelersField",
  action: {
    analytics: {
      linkName: "Packages - Travelers Selection",
      referrerId: "Web.packages.travelers.selection",
      __typename: "ClientSideAnalytics"
    },
    travelerSelector: {
      closeButton: {
        egdsElementId: null,
        primary: null,
        disabled: false,
        accessibility: null,
        icon: {
          id: "close",
          description: "",
          token: "icon__close",
          title: null,
          __typename: "Icon"
        },
        analytics: null,
        action: null,
        __typename: "UITertiaryButton"
      },
      doneButton: {
        egdsElementId: null,
        primary: "Done",
        disabled: false,
        accessibility: null,
        icon: null,
        analytics: null,
        action: null,
        __typename: "UIPrimaryButton"
      },
      title: "Travelers",
      travelers: {
        adults: {
          decreaseAnalytics: {
            linkName: "Packages - Step input decrease",
            referrerId: "Web.packages.step.input.decrease",
            __typename: "ClientSideAnalytics"
          },
          increaseAnalytics: {
            linkName: "Packages - Step input increase",
            referrerId: "Web.packages.step.input.increase",
            __typename: "ClientSideAnalytics"
          },
          decreaseText: "Decrease the number of adults",
          decreaseTextTemplate: null,
          increaseText: "Increase the number of adults",
          increaseTextTemplate: null,
          egdsElementId: null,
          __typename: "EGDSTravelerStepInput",
          label: "Adults",
          max: 6,
          min: 1,
          step: 1,
          subLabel: null,
          value: 2
        },
        children: {
          count: {
            decreaseAnalytics: {
              linkName: "Packages - Step input decrease",
              referrerId: "Web.packages.step.input.decrease",
              __typename: "ClientSideAnalytics"
            },
            increaseAnalytics: {
              linkName: "Packages - Step input increase",
              referrerId: "Web.packages.step.input.increase",
              __typename: "ClientSideAnalytics"
            },
            decreaseText: "Decrease the number of children",
            decreaseTextTemplate: null,
            increaseText: "Increase the number of children",
            increaseTextTemplate: null,
            egdsElementId: null,
            __typename: "EGDSTravelerStepInput",
            label: "Children",
            max: 5,
            min: 0,
            step: 1,
            subLabel: "Ages 2 to 17",
            value: 0
          },
          ages: [],
          ageTemplate: {
            labelTemplate: {
              models: [{
                key: "childNumber",
                source: "childNumber",
                __typename: "TemplateModel"
              }],
              template: "Child ${childNumber} age",
              __typename: "EGDSBasicLocalizedText"
            },
            options: [ageOptions("2"), ageOptions("3"), ageOptions("4"), ageOptions("5"), ageOptions("6"), ageOptions("7"), ageOptions("8"), ageOptions("9"), ageOptions("10"), ageOptions("11"), ageOptions("12"), ageOptions("13"), ageOptions("14"), ageOptions("15"), ageOptions("16"), ageOptions("17")],
            egdsElementId: null,
            value: null,
            __typename: "EGDSTravelerChildAgeSelect"
          },
          __typename: "EGDSTravelerChildren"
        },
        infantsInSeat: {
          count: {
            decreaseAnalytics: {
              linkName: "Packages - Step input decrease",
              referrerId: "Web.packages.step.input.decrease",
              __typename: "ClientSideAnalytics"
            },
            increaseAnalytics: {
              linkName: "Packages - Step input increase",
              referrerId: "Web.packages.step.input.increase",
              __typename: "ClientSideAnalytics"
            },
            decreaseText: "Decrease the number of infants",
            decreaseTextTemplate: null,
            increaseText: "Increase the number of infants",
            increaseTextTemplate: null,
            egdsElementId: null,
            __typename: "EGDSTravelerStepInput",
            label: "Infants in seat",
            max: 4,
            min: 0,
            step: 1,
            subLabel: "Younger than 2",
            value: 0
          },
          ages: [],
          ageTemplate: {
            labelTemplate: {
              models: [{
                key: "infantNumber",
                source: "infantNumber",
                __typename: "TemplateModel"
              }],
              template: "Infant ${infantNumber} age",
              __typename: "EGDSBasicLocalizedText"
            },
            options: [{
              label: "Under 1",
              value: "0",
              egdsElementId: null,
              changeAnalytics: null,
              __typename: "EGDSBasicOption"
            }, {
              label: "1",
              value: "1",
              egdsElementId: null,
              changeAnalytics: null,
              __typename: "EGDSBasicOption"
            }],
            egdsElementId: null,
            value: null,
            __typename: "EGDSTravelerChildAgeSelect"
          },
          __typename: "EGDSTravelerInfant"
        },
        infantsOnLap: {
          count: {
            decreaseAnalytics: {
              linkName: "Packages - Step input decrease",
              referrerId: "Web.packages.step.input.decrease",
              __typename: "ClientSideAnalytics"
            },
            increaseAnalytics: {
              linkName: "Packages - Step input increase",
              referrerId: "Web.packages.step.input.increase",
              __typename: "ClientSideAnalytics"
            },
            decreaseText: "Decrease the number of infants",
            decreaseTextTemplate: null,
            increaseText: "Increase the number of infants",
            increaseTextTemplate: null,
            egdsElementId: null,
            __typename: "EGDSTravelerStepInput",
            label: "Infants on lap",
            max: 3,
            min: 0,
            step: 1,
            subLabel: "Younger than 2",
            value: 0
          },
          ages: [],
          ageTemplate: {
            labelTemplate: {
              models: [{
                key: "infantNumber",
                source: "infantNumber",
                __typename: "TemplateModel"
              }],
              template: "Infant ${infantNumber} age",
              __typename: "EGDSBasicLocalizedText"
            },
            options: [{
              label: "Under 1",
              value: "0",
              egdsElementId: null,
              changeAnalytics: null,
              __typename: "EGDSBasicOption"
            }, {
              label: "1",
              value: "1",
              egdsElementId: null,
              changeAnalytics: null,
              __typename: "EGDSBasicOption"
            }],
            egdsElementId: null,
            value: null,
            __typename: "EGDSTravelerChildAgeSelect"
          },
          __typename: "EGDSTravelerInfant"
        },
        pets: null,
        __typename: "EGDSTravelers"
      },
      validations: infantValidations,
      __typename: "EGDSBasicTravelerSelector"
    },
    accessibility: "expand to change the number of travelers",
    __typename: "EGDSOpenTravelerSelectorAction"
  },
  label: "Travelers",
  labelTemplate: {
    models: [{
      key: "travelerCount",
      source: "travelerCount",
      __typename: "TemplateModel"
    }],
    templates: templateTravelers,
    secondaryTemplates: null,
    text: "2 travelers",
    __typename: "EGDSCardinalLocalizedText"
  },
  leftIcon: {
    id: "person",
    __typename: "Icon"
  },
  readOnly: false
};
var hotelCarTravelSelector = {
  __typename: "EGDSSearchFormTravelersField",
  action: {
    analytics: {
      linkName: "Packages - Travelers Selection",
      referrerId: "Web.packages.travelers.selection",
      __typename: "ClientSideAnalytics"
    },
    travelerSelector: {
      addAnotherRoomButton: {
        egdsElementId: null,
        primary: "Add another room",
        disabled: false,
        accessibility: null,
        icon: null,
        analytics: {
          linkName: "Travelers add room",
          referrerId: "Web.Packages.Traveler.Add.Room",
          __typename: "ClientSideAnalytics"
        },
        action: null,
        __typename: "UITertiaryButton"
      },
      closeButton: {
        egdsElementId: null,
        primary: null,
        disabled: false,
        accessibility: null,
        icon: {
          id: "close",
          description: "",
          token: "icon__close",
          title: null,
          __typename: "Icon"
        },
        analytics: {
          linkName: "Travelers results not updated",
          referrerId: "Web.Packages.Traveler.Close",
          __typename: "ClientSideAnalytics"
        },
        action: null,
        __typename: "UITertiaryButton"
      },
      doneButton: {
        egdsElementId: null,
        primary: "Done",
        disabled: false,
        accessibility: null,
        icon: null,
        analytics: {
          linkName: "Travelers results updated",
          referrerId: "Web.Packages.Traveler.Done",
          __typename: "ClientSideAnalytics"
        },
        action: null,
        __typename: "UIPrimaryButton"
      },
      infantSeatSelection: {
        airlineAgeRule: {
          text: "Airline age rules",
          action: {
            accessibility: null,
            target: "INTERNAL" /* INTERNAL */,
            resource: {
              value: "https://www.expedia.com/p/info-main/h_fw_default%3Frhtx=HTX_FLTSRCH_RT%23travs",
              __typename: "HttpURI"
            },
            analytics: {
              linkName: "Packages - Airline Age Rules",
              referrerId: "Web.packages.airline.age.rules",
              __typename: "ClientSideAnalytics"
            },
            __typename: "UILinkAction"
          },
          icon: null,
          iconPosition: null,
          __typename: "EGDSStandardLink",
          egdsElementId: null
        },
        groupName: "InfantSeating",
        labelTemplate: {
          text: "Where will the infants sit?",
          models: [{
            key: "infantCount",
            source: "infantCount",
            __typename: "TemplateModel"
          }],
          templates: [{
            category: "ONE" /* ONE */,
            template: "Where will the infant sit?",
            __typename: "CardinalTemplate"
          }, {
            category: "OTHER" /* OTHER */,
            template: "Where will the infants sit?",
            __typename: "CardinalTemplate"
          }],
          __typename: "EGDSCardinalLocalizedText"
        },
        options: [{
          label: "On lap",
          value: "lap",
          __typename: "EGDSInfantSeatRadioButton"
        }, {
          label: "In seat",
          value: "seat",
          __typename: "EGDSInfantSeatRadioButton"
        }],
        selected: "lap",
        __typename: "EGDSTravelerInfantSeatSelection"
      },
      maxRoomCount: 6,
      rooms: [{
        label: {
          models: [{
            key: "roomNumber",
            source: "roomNumber",
            __typename: "TemplateModel"
          }],
          template: "Room ${roomNumber}",
          __typename: "EGDSBasicLocalizedText"
        },
        adults: {
          decreaseAnalytics: {
            linkName: "Packages - Step input decrease",
            referrerId: "Web.packages.step.input.decrease",
            __typename: "ClientSideAnalytics"
          },
          increaseAnalytics: {
            linkName: "Packages - Step input increase",
            referrerId: "Web.packages.step.input.increase",
            __typename: "ClientSideAnalytics"
          },
          decreaseText: "Decrease the number of adults in this room",
          decreaseTextTemplate: null,
          increaseText: "Increase the number of adults in this room",
          increaseTextTemplate: null,
          egdsElementId: null,
          __typename: "EGDSTravelerStepInput",
          label: "Adults",
          max: 6,
          min: 1,
          step: 1,
          subLabel: null,
          value: 2
        },
        children: {
          count: {
            decreaseAnalytics: {
              linkName: "Packages - Step input decrease",
              referrerId: "Web.packages.step.input.decrease",
              __typename: "ClientSideAnalytics"
            },
            increaseAnalytics: {
              linkName: "Packages - Step input increase",
              referrerId: "Web.packages.step.input.increase",
              __typename: "ClientSideAnalytics"
            },
            decreaseText: "Decrease the number of children in this room",
            decreaseTextTemplate: null,
            increaseText: "Increase the number of children in this room",
            increaseTextTemplate: null,
            egdsElementId: null,
            __typename: "EGDSTravelerStepInput",
            label: "Children",
            max: 5,
            min: 0,
            step: 1,
            subLabel: "Ages 0 to 17",
            value: 0
          },
          ages: [],
          ageTemplate: {
            labelTemplate: {
              models: [{
                key: "childNumber",
                source: "childNumber",
                __typename: "TemplateModel"
              }],
              template: "Child ${childNumber} age",
              __typename: "EGDSBasicLocalizedText"
            },
            options: [ageOptions("0", "Under 1"), ageOptions("1"), ageOptions("2"), ageOptions("3"), ageOptions("4"), ageOptions("5"), ageOptions("6"), ageOptions("7"), ageOptions("8"), ageOptions("9"), ageOptions("10"), ageOptions("11"), ageOptions("12"), ageOptions("13"), ageOptions("14"), ageOptions("15"), ageOptions("16"), ageOptions("17")],
            egdsElementId: null,
            value: null,
            __typename: "EGDSTravelerChildAgeSelect"
          },
          __typename: "EGDSTravelerChildren"
        },
        infants: null,
        removeRoomButton: {
          egdsElementId: null,
          primary: "Remove room",
          disabled: false,
          accessibility: null,
          icon: null,
          analytics: {
            linkName: "Packages.Traveler.Remove.Room",
            referrerId: "Web.Travelers remove room",
            __typename: "ClientSideAnalytics"
          },
          action: null,
          __typename: "UITertiaryButton"
        },
        removeRoomAnnouncement: "Room removed",
        __typename: "EGDSTravelerSelectorRoom"
      }],
      title: "Travelers",
      validations: infantValidations,
      __typename: "EGDSRoomsTravelerSelector"
    },
    accessibility: "expand to change the number of travelers",
    __typename: "EGDSOpenTravelerSelectorAction"
  },
  label: "Travelers",
  labelTemplate: {
    models: [{
      key: "rooms",
      models: {
        models: [{
          key: "roomCount",
          source: "roomCount",
          __typename: "TemplateModel"
        }],
        templates: templateRooms,
        __typename: "EGDSCardinalLocalizedText"
      },
      __typename: "CompositeLocalizedTextModel"
    }, {
      key: "travelers",
      models: {
        models: [{
          key: "travelerCount",
          source: "travelerCount",
          __typename: "TemplateModel"
        }],
        templates: templateTravelers,
        __typename: "EGDSCardinalLocalizedText"
      },
      __typename: "CompositeLocalizedTextModel"
    }],
    template: "${travelers}, ${rooms}",
    text: "2 travelers, 1 room",
    __typename: "EGDSCompositeLocalizedText"
  },
  leftIcon: {
    id: "person",
    __typename: "Icon"
  },
  readOnly: false
};
var getFallbackData = function (packageType) {
  var elements = [];
  switch (packageType) {
    case "HOTEL_CAR" /* HOTEL_CAR */:
      elements = [destinationLocationField(), datePicker, hotelCarTravelSelector];
      break;
    case "FLIGHT_HOTEL_CAR" /* FLIGHT_HOTEL_CAR */:
    case "FLIGHT_HOTEL" /* FLIGHT_HOTEL */:
      elements = [searchLocationsFields(packageType), datePicker, flightHotelCarTravelSelector, cabinFormInput];
      break;
    case "FLIGHT_CAR" /* FLIGHT_CAR */:
      elements = [searchLocationsFields(packageType), datePicker, flightCarTravelSelector, cabinFormInput];
      break;
    default:
      break;
  }
  return {
    searchForm: {
      packages: {
        errorSummary: errorSummary,
        search: search,
        elements: elements,
        __typename: "PackagesSearchForm",
        actionURL: "/flexibleshopping",
        packageSelection: packageSelection,
        searchLocation: searchLocationFallback
      },
      __typename: "SearchFormResults"
    }
  };
};
// src/components/__private/no-selection-message.tsx
import React13 from "react";
import { gql as gql10 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
import { UitkHeading, UitkParagraph } from "uitk-react-text";
var __Fragment9 = gql10(_templateObject9(), Icon.fragment);
var NoSelectionMessage = function (props) {
  var data = props.data;
  var icon = data.icon,
    heading = data.heading,
    body = data.body;
  return /* @__PURE__ */React13.createElement(UitkSpacing4, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React13.createElement("div", null, /* @__PURE__ */React13.createElement(UitkLayoutFlex2, {
    direction: "column",
    alignItems: "center"
  }, /* @__PURE__ */React13.createElement(UitkLayoutFlexItem2, null, icon && /* @__PURE__ */React13.createElement(Icon, {
    data: icon
  })), /* @__PURE__ */React13.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */React13.createElement(UitkHeading, null, heading)), /* @__PURE__ */React13.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */React13.createElement(UitkParagraph, null, body)))));
};
NoSelectionMessage.displayName = "NoSelectionMessage";
NoSelectionMessage.fragment = __Fragment9;
// src/components/packages-search-form/client-events.ts
import { SystemEvent, SystemEventLevel } from "@shared-ui/logger-context";
var CLIENT_EVENTS = {
  /**
  * Pattern: `SEARCH_TOOLS_{LOB}_{COMPONENT}_{EVENT}`
  */
  SEARCH_TOOLS_PACKAGES_SEARCH_FORM_QUERY_FAILURE: new SystemEvent(SystemEventLevel.ERROR, "SEARCH_TOOLS_PACKAGES_SEARCH_FORM_QUERY_FAILURE")
};
var CLIENT_TRACKING_EVENTS = {
  /**
  * Pattern: `SEARCH_TOOLS_{LOB}_{COMPONENT}_{EVENT}`
  */
  SEARCH_TOOLS_PACKAGES_SEARCH_FORM_FALLBACK_IMPRESSION: {
    linkName: "Packages Search Form Fallback Presented",
    referrerId: "Web.Packages.Search.Form.Fallback.Presented"
  },
  /**
  * Event to track the presentation of the search form
  * This is temporary hardcoded directly as it is part of a PoC
  * Will be analyzed if required to create a new event in EGClickstream or continue tracking with UISPrime but driven via Experience API
  */
  SEARCH_TOOLS_PACKAGES_SEARCH_FORM_IMPRESSION: {
    linkName: "Packages Search Form Presented",
    referrerId: "Web.Packages.Search.Form.Presented"
  }
};
// src/components/packages-search-form/forms/multi-packages-search-form.tsx
import React68 from "react";
import { gql as gql55 } from "@apollo/client";
import { useExperiment as useExperiment3 } from "@shared-ui/experiment-context";
import { useLocalization as useLocalization5 } from "@shared-ui/localization-context";
// ../internal/src/components/common/egds-error-summary.tsx
import React14 from "react";
import { gql as gql11 } from "@apollo/client";
import { EGDSBanner } from "@egds/react-core/banner";
import { EGDSLink } from "@egds/react-core/link";
import { EGDSHeading, EGDSText } from "@egds/react-core/text";
import { Level as Level2, liveAnnounce as liveAnnounce2 } from "@egds/react-core/utils";
import { IntersectionTracker, useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/utils/format-localized-token-string.ts
function formatLocalizedTokenString(localizedString, token, value) {
  return localizedString.replace("${".concat(token, "}"), value);
}
// ../internal/src/components/common/egds-error-summary.tsx
var __Fragment10 = gql11(_templateObject10());
var EGDSErrorSummary = function (param) {
  var _param_errorCount = param.errorCount,
    errorCount = _param_errorCount === void 0 ? 0 : _param_errorCount,
    inputErrorRef = param.inputErrorRef,
    data = param.data;
  var clickTracker = useClickTracker5();
  var body = data.body,
    goToErrorLinkText = data.goToErrorLinkText,
    goToFirstErrorLinkText = data.goToFirstErrorLinkText,
    heading = data.heading,
    analytics = data.analytics,
    impressionAnalytics = data.impressionAnalytics,
    headingTemplate = data.headingTemplate;
  var hasNoErrors = errorCount === 0;
  var hasOneError = errorCount === 1;
  var linkRef = React14.createRef();
  React14.useEffect(function () {
    var _linkRef_current;
    liveAnnounce2(headingText, Level2.ASSERTIVE);
    (_linkRef_current = linkRef.current) === null || _linkRef_current === void 0 ? void 0 : _linkRef_current.focus();
  }, []);
  if (hasNoErrors) {
    return null;
  }
  var getLocalizedErrorHeading = function (errors) {
    if ((headingTemplate === null || headingTemplate === void 0 ? void 0 : headingTemplate.__typename) === "EGDSCardinalLocalizedText") {
      var headingTemplates = headingTemplate.templates.slice(1, 3);
      var key = hasOneError ? "" : headingTemplate.models[0].key;
      var template = hasOneError ? headingTemplates[0].template : headingTemplates[1].template;
      return formatLocalizedTokenString(template, key, errors.toString());
    }
    return "";
  };
  var linkText = hasOneError ? goToErrorLinkText : goToFirstErrorLinkText;
  var headingText = heading.trim() ? heading : getLocalizedErrorHeading(errorCount);
  var handleClick = function () {
    var _inputErrorRef_current;
    inputErrorRef === null || inputErrorRef === void 0 ? void 0 : (_inputErrorRef_current = inputErrorRef.current) === null || _inputErrorRef_current === void 0 ? void 0 : _inputErrorRef_current.focus();
    if (analytics) {
      var referrerId = analytics.referrerId,
        linkName = analytics.linkName;
      var id = hasOneError ? "".concat(referrerId, ".One.Error") : "".concat(referrerId, ".Many.Errors");
      clickTracker(id, linkName);
    }
  };
  var _impressionAnalytics_referrerId, _impressionAnalytics_linkName;
  return /* @__PURE__ */React14.createElement(IntersectionTracker, {
    referrerId: (_impressionAnalytics_referrerId = impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.referrerId) !== null && _impressionAnalytics_referrerId !== void 0 ? _impressionAnalytics_referrerId : "",
    linkName: (_impressionAnalytics_linkName = impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.linkName) !== null && _impressionAnalytics_linkName !== void 0 ? _impressionAnalytics_linkName : ""
  }, /* @__PURE__ */React14.createElement(EGDSBanner, {
    theme: "error"
  }, /* @__PURE__ */React14.createElement(EGDSHeading, {
    size: 7,
    "aria-level": 3
  }, headingText), body && /* @__PURE__ */React14.createElement(EGDSText, {
    size: 300
  }, body.text), linkText && /* @__PURE__ */React14.createElement(EGDSLink, {
    domRef: linkRef
  }, /* @__PURE__ */React14.createElement("button", {
    type: "button",
    onClick: handleClick
  }, linkText))));
};
EGDSErrorSummary.displayName = "EGDSErrorSummaryFragment";
EGDSErrorSummary.fragment = __Fragment10;
// ../internal/src/components/form/egds-search-form-button.tsx
import React15 from "react";
import { gql as gql13 } from "@apollo/client";
import { useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkButtonSize, UitkPrimaryButton } from "uitk-react-button";
import { UitkIcon as UitkIcon2 } from "uitk-react-icons";
// ../internal/src/components/common/button/egds-button-fragment.ts
import { gql as gql12 } from "@apollo/client";
var EGDSButtonFragment = gql12(_templateObject11());
// ../internal/src/components/form/egds-search-form-button.tsx
var __Fragment11 = gql13(_templateObject12(), EGDSButtonFragment);
var Button = function (param) {
  var children = param.children,
    submitButtonProps = param.submitButtonProps,
    primary = param.primary,
    _param_isFullWidth = param.isFullWidth,
    isFullWidth = _param_isFullWidth === void 0 ? false : _param_isFullWidth;
  return /* @__PURE__ */React15.createElement(UitkPrimaryButton, _object_spread_props(_object_spread({}, submitButtonProps), {
    size: UitkButtonSize.LARGE,
    "aria-label": primary !== null && primary !== void 0 ? primary : "",
    isFullWidth: isFullWidth
  }), children);
};
var EGDSSearchFormButton = function (param) {
  var data = param.data;
  var track = useClickTracker6();
  var egdsElementId = data.egdsElementId,
    primary = data.primary,
    disabled = data.disabled,
    action = data.onClick,
    icon = data.icon;
  var id = egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "search_form_submit_button";
  var handleClick = React15.useCallback(function () {
    if (action && action.__typename === "EGDSSubmitSearchFormAction") {
      var _action_analytics = action.analytics,
        referrerId = _action_analytics.referrerId,
        linkName = _action_analytics.linkName;
      track(referrerId, linkName);
    }
  }, [action, track]);
  var submitButtonProps = {
    id: id,
    disabled: disabled,
    onClick: handleClick,
    type: "submit"
  };
  var _icon_token, _icon_title;
  return /* @__PURE__ */React15.createElement(Viewport, null, /* @__PURE__ */React15.createElement(ViewSmall, null, /* @__PURE__ */React15.createElement(Button, {
    isFullWidth: true,
    submitButtonProps: submitButtonProps,
    primary: primary
  }, primary)), /* @__PURE__ */React15.createElement(ViewMedium, null, icon ? /* @__PURE__ */React15.createElement(Button, {
    submitButtonProps: submitButtonProps,
    primary: primary
  }, /* @__PURE__ */React15.createElement(UitkIcon2, {
    name: (_icon_token = icon === null || icon === void 0 ? void 0 : icon.token) !== null && _icon_token !== void 0 ? _icon_token : "search",
    title: (_icon_title = icon === null || icon === void 0 ? void 0 : icon.title) !== null && _icon_title !== void 0 ? _icon_title : "",
    id: icon === null || icon === void 0 ? void 0 : icon.id
  })) : /* @__PURE__ */React15.createElement(Button, {
    submitButtonProps: submitButtonProps,
    primary: primary
  }, primary)));
};
EGDSSearchFormButton.displayName = "EGDSSearchFormButton";
EGDSSearchFormButton.fragment = __Fragment11;
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-search-form-date-picker-field.tsx
import React37 from "react";
import { gql as gql31 } from "@apollo/client";
// ../internal/src/utils/search-form-date-selector.ts
import React16 from "react";
var dialogIdCounter = 0;
function useUniqueDialogId() {
  var dialogName = /* @__PURE__ */new Date().getTime();
  var uniqueId = dialogIdCounter;
  dialogIdCounter += 1;
  var dialogIdRef = React16.useRef("".concat(dialogName, "-").concat(uniqueId));
  return dialogIdRef.current;
}
var search_form_date_selector_default = useUniqueDialogId;
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-date-range-picker.tsx
import React35 from "react";
import { gql as gql29 } from "@apollo/client";
import { useClickTracker as useClickTracker11 } from "@shared-ui/clickstream-analytics-context";
import { useLocalization as useLocalization2 } from "@shared-ui/localization-context";
import { useSearchFormReflectionContext } from "@shared-ui/retail-search-tools-reflection-provider";
import { ViewMedium as ViewMedium2, Viewport as Viewport4, ViewSmall as ViewSmall4 } from "@shared-ui/viewport-context";
// ../internal/src/components/form/egds-search-form-date-picker-field/date-range-selector.tsx
import React29 from "react";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker10 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment } from "@shared-ui/experiment-context";
import { useLocalization } from "@shared-ui/localization-context";
import { defaultViewSizes as defaultViewSizes3, useMediaQueries as useMediaQueries3 } from "@shared-ui/viewport-context";
import { UitkDateSelector } from "uitk-react-date-selector";
import { useFormCallback as useFormCallback4 } from "uitk-react-form";
// ../internal/src/utils/search-form-playback-dates.ts
var getFormattedDates = function (value, localizationContext, dateTimes) {
  var formatDateString = localizationContext.formatDateString;
  var _value_split = _sliced_to_array(value.split(" - "), 2),
    startDate2 = _value_split[0],
    endDate2 = _value_split[1];
  if (startDate2 === "" || endDate2 === "") {
    return "";
  }
  var updatedStartDate = formatDateString(startDate2, {
    skeleton: "MMMd"
  });
  var updatedEndDate = formatDateString(endDate2, {
    skeleton: "MMMd"
  });
  if ((dateTimes === null || dateTimes === void 0 ? void 0 : dateTimes.start) && (dateTimes === null || dateTimes === void 0 ? void 0 : dateTimes.end)) {
    return "".concat(updatedStartDate, ", ").concat(dateTimes.start, " - ").concat(updatedEndDate, ", ").concat(dateTimes.end);
  }
  return "".concat(updatedStartDate, " - ").concat(updatedEndDate);
};
// ../internal/src/components/form/egds-search-form-date-picker-field/date-range-selector-day-template.tsx
import React18 from "react";
import { UitkDateNumber } from "uitk-react-calendar";
// ../internal/src/components/form/egds-search-form-date-picker-field/helpers.tsx
import React17 from "react";
import { DayName } from "uitk-react-date-picker";
// ../internal/src/utils/search-form-plural-category.tsx
var getPluralCategory = function (value) {
  if (value === 0) {
    return "ZERO" /* ZERO */;
  }
  if (value === 1) {
    return "ONE" /* ONE */;
  }
  if (value === 2) {
    return "TWO" /* TWO */;
  }
  if (value > 2 && value < 5) {
    return "FEW" /* FEW */;
  }
  if (value >= 5 && value < 10) {
    return "MANY" /* MANY */;
  }
  return "OTHER" /* OTHER */;
};
// ../internal/src/components/form/egds-search-form-date-picker-field/helpers.tsx
var TO_DAY_MULTIPLIER = 1e3 * 60 * 60 * 24;
var addMaxDateToToday = function (daysInAdvance) {
  var today2 = /* @__PURE__ */new Date();
  var daysInAdvanceInMiliseconds = daysInAdvance * TO_DAY_MULTIPLIER;
  var todayPlusDaysInAdvance = new Date(today2.getTime() + daysInAdvanceInMiliseconds);
  return todayPlusDaysInAdvance;
};
var convertFromMiliSecondsToDays = function (miliseconds) {
  return Math.ceil(miliseconds / 1e3 / 60 / 60 / 24);
};
var convertToDateObject = function (param) {
  var year = param.year,
    month = param.month,
    day = param.day;
  return new Date(year, month - 1, day);
};
var _obj1;
var EGDSDayNameMap = (_obj1 = {}, _define_property(_obj1, "SUN" /* SUN */, DayName.SUN), _define_property(_obj1, "MON" /* MON */, DayName.MON), _define_property(_obj1, "TUE" /* TUE */, DayName.TUE), _define_property(_obj1, "WED" /* WED */, DayName.WED), _define_property(_obj1, "THU" /* THU */, DayName.THU), _define_property(_obj1, "FRI" /* FRI */, DayName.FRI), _define_property(_obj1, "SAT" /* SAT */, DayName.SAT), _obj1);
var formatCardinalText = function (cardinalText, value) {
  var templateKey = "templates";
  var cardinalTemplate = cardinalText[templateKey].find(function (template) {
    return template.category === getPluralCategory(value);
  });
  if (!cardinalTemplate) {
    return "";
  }
  return formatLocalizedTokenString(cardinalTemplate.template, cardinalText.models[0].key, value.toString());
};
var EXACT_DATES_PREFIX = "0";
var isFlexibleOptionExactDates = function (flexibleOption) {
  var _flexibleOption_value;
  return !!(flexibleOption === null || flexibleOption === void 0 ? void 0 : (_flexibleOption_value = flexibleOption.value) === null || _flexibleOption_value === void 0 ? void 0 : _flexibleOption_value.startsWith(EXACT_DATES_PREFIX));
};
var isDateEnabled = function (day, validStartDate, validEndDate) {
  var dayDate = new Date(day.year, day.month, day.day);
  if (day.isPast) {
    return false;
  }
  if (validStartDate && validEndDate) {
    return dayDate >= validStartDate && dayDate <= validEndDate;
  }
  if (validStartDate && !validEndDate) {
    return dayDate >= validStartDate;
  }
  if (!validStartDate && validEndDate) {
    return dayDate <= validEndDate;
  }
  return true;
};
var isTodayDate = function (date) {
  var today2 = /* @__PURE__ */new Date();
  return today2.getDate() === date.getDate() && today2.getMonth() === date.getMonth() && today2.getFullYear() === date.getFullYear();
};
var getDateFromDateString = function (date) {
  return /* @__PURE__ */new Date("".concat(date, "T00:00:00"));
};
// ../internal/src/components/form/egds-search-form-date-picker-field/date-range-selector-day-template.tsx
var DateRangeSelectorDayTemplate = function (props) {
  var day = props.day,
    tmp = props.dayData,
    _ref = tmp === void 0 ? {} : tmp,
    validStartDate = _ref.validStartDate,
    validEndDate = _ref.validEndDate;
  var isDayDisabled = !isDateEnabled(day, validStartDate, validEndDate);
  var theme = React18.useMemo(function () {
    if (day.isPast) {
      return "muted";
    }
    if (day.isToday) {
      return "today";
    }
    return "default";
  }, [day.isPast, day.isToday]);
  return /* @__PURE__ */React18.createElement(UitkDateNumber, {
    theme: theme,
    disabled: isDayDisabled
  }, day.day);
};
var canClick = function (dayData, day) {
  return isDateEnabled(day, dayData.validStartDate, dayData.validEndDate);
};
var getAriaLabel = function (dayData, day, l10n) {
  var localeDateString = day.localeDateString;
  return !isDateEnabled(day, dayData.validStartDate, dayData.validEndDate) ? l10n.formatText("calendar.unavailable.a11yLabel", localeDateString) : localeDateString;
};
DateRangeSelectorDayTemplate.canClick = canClick;
DateRangeSelectorDayTemplate.canSpan = canClick;
DateRangeSelectorDayTemplate.getAriaLabel = getAriaLabel;
// ../internal/src/components/form/egds-search-form-date-picker-field/flexible-content/egds-date-picker-flexibility-calendar-content.tsx
import React19 from "react";
import { gql as gql14 } from "@apollo/client";
import { SingleSelectPillWrapper } from "@egds/react-search-experience";
import { UitkSpacing as UitkSpacing5 } from "uitk-react-spacing";
var __Fragment12 = gql14(_templateObject13(), EGDSBasicPill.fragment);
var DISPLAY_NAME2 = "EGDSDatePickerFlexibilityCalendarContent";
var FLEXIBILITY_CALENDAR_CONTENT_NAME_PREFIX = "".concat(DISPLAY_NAME2, "-SelectedOption");
var EGDSDatePickerFlexibilityCalendarContent = function (param) {
  var data = param.data,
    onSelect = param.onSelect,
    currentlySelectedPillValue = param.currentlySelectedPillValue,
    className = param.className;
  var handleSelectedPill = function (selectedPillValue) {
    onSelect(selectedPillValue);
  };
  var _data_flexibleDateOptions_map;
  var singleSelectOptions = (_data_flexibleDateOptions_map = data === null || data === void 0 ? void 0 : data.flexibleDateOptions.map(function (pillData) {
    var _pillData_primary, _pillData_value, _pillData_value1, _pillData_accessibility;
    return {
      selected: pillData.value === currentlySelectedPillValue,
      checked: pillData.value === currentlySelectedPillValue,
      text: (_pillData_primary = pillData.primary) !== null && _pillData_primary !== void 0 ? _pillData_primary : "",
      disabled: pillData.disabled,
      value: (_pillData_value = pillData.value) !== null && _pillData_value !== void 0 ? _pillData_value : "",
      id: (_pillData_value1 = pillData.value) !== null && _pillData_value1 !== void 0 ? _pillData_value1 : "",
      altText: (_pillData_accessibility = pillData.accessibility) !== null && _pillData_accessibility !== void 0 ? _pillData_accessibility : void 0
    };
  })) !== null && _data_flexibleDateOptions_map !== void 0 ? _data_flexibleDateOptions_map : [];
  return /* @__PURE__ */React19.createElement(UitkSpacing5, {
    margin: {
      medium: {
        inlinestart: "two",
        blockend: "three",
        blockstart: "one"
      },
      small: {
        inlinestart: "two",
        blockend: "three",
        blockstart: "one"
      }
    }
  }, /* @__PURE__ */React19.createElement("div", {
    className: className
  }, /* @__PURE__ */React19.createElement(SingleSelectPillWrapper, {
    data: singleSelectOptions,
    handleSelectedPill: handleSelectedPill
  })));
};
EGDSDatePickerFlexibilityCalendarContent.displayName = DISPLAY_NAME2;
EGDSDatePickerFlexibilityCalendarContent.fragment = __Fragment12;
// ../internal/src/components/form/egds-search-form-date-picker-field/flexible-content/egds-date-picker-flexibility-content.tsx
import React28 from "react";
import { gql as gql23 } from "@apollo/client";
import { EGDSScrollable } from "@egds/react-core/scrollable";
import { UitkTabsBackGroundColorType as UitkTabsBackGroundColorType2, UitkTabsType as UitkTabsType2 } from "uitk-react-tabs";
// ../internal/src/components/common/egds-basic-tabs/egds-basic-tabs.tsx
import React20, { useState } from "react";
import { gql as gql15 } from "@apollo/client";
import { useClickTracker as useClickTracker7 } from "@shared-ui/clickstream-analytics-context";
import { defaultViewSizes, useMediaQueries } from "@shared-ui/viewport-context";
import { UitkTab, UitkTabs, UitkTabsBackGroundColorType, UitkTabsType } from "uitk-react-tabs";
var __Fragment13 = gql15(_templateObject14());
var EGDSBasicTabs = function (param) {
  var data = param.data,
    onTabSelected = param.onTabSelected,
    backgroundColor = param.backgroundColor,
    tabsType = param.tabsType;
  var tabs = data.tabs,
    selectedTabId = data.selectedTabId;
  var clickTracker = useClickTracker7();
  var defaultTabSelected = 0;
  var initialSelectedTab = selectedTabId ? tabs.findIndex(function (tab) {
    return tab.__typename === "EGDSBasicTab" ? tab.tabId === selectedTabId : defaultTabSelected;
  }) : defaultTabSelected;
  var _useState = _sliced_to_array(useState(initialSelectedTab), 2),
    selectedTab = _useState[0],
    setSelectedTab = _useState[1];
  var viewportSize = useMediaQueries({
    viewSizes: defaultViewSizes
  });
  var isSmallViewportSize = viewportSize <= defaultViewSizes.SMALL;
  var trackTabOnClick = function (analytics) {
    if (analytics && (analytics === null || analytics === void 0 ? void 0 : analytics.__typename) === "ClientSideAnalytics") {
      var linkName = analytics.linkName,
        referrerId = analytics.referrerId;
      clickTracker(referrerId, linkName);
    }
  };
  var onTabSelect = function (selectedIndex) {
    setSelectedTab(selectedIndex);
    var tab = tabs[selectedIndex];
    if (tab.__typename === "EGDSBasicTab") {
      var clickAnalytics = tab.clickAnalytics,
        tabId = tab.tabId;
      trackTabOnClick(clickAnalytics);
      if (onTabSelected) {
        onTabSelected(tabId);
      }
    }
  };
  var defaultTabsType = isSmallViewportSize ? UitkTabsType.EQUAL_WIDTH : UitkTabsType.NATURAL;
  var tabProps = {
    selectedTab: selectedTab !== -1 ? selectedTab : defaultTabSelected,
    onTabSelect: onTabSelect,
    tabsType: tabsType !== null && tabsType !== void 0 ? tabsType : defaultTabsType,
    backgroundColor: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : UitkTabsBackGroundColorType.PRIMARY
  };
  return /* @__PURE__ */React20.createElement(UitkTabs, _object_spread({}, tabProps), tabs.map(function (tab) {
    var tabId = tab.__typename === "EGDSBasicTab" ? tab.tabId : "";
    var label = tab.__typename === "EGDSBasicTab" ? tab.label : "";
    return /* @__PURE__ */React20.createElement(UitkTab, {
      id: tabId,
      key: tabId,
      name: label,
      targetURI: "#EGDSBasicTabSearchForm_".concat(tabId)
    });
  }));
};
EGDSBasicTabs.fragment = __Fragment13;
EGDSBasicTabs.displayName = "EGDSBasicTabs";
// ../internal/src/components/form/egds-search-form-date-picker-field/flexible-content/egds-date-picker-flexibility-dates-content.tsx
import React27 from "react";
import { gql as gql22 } from "@apollo/client";
import { UitkSpacing as UitkSpacing6, UitkSpacingHr } from "uitk-react-spacing";
// ../internal/src/components/form/egds-search-form-date-picker-field/flexible-content/egds-date-picker-flexibility-months-section.tsx
import React23 from "react";
import { gql as gql18 } from "@apollo/client";
import { EGDSIcon as EGDSIcon2 } from "@egds/react-core/icons";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading2, EGDSSubheading, EGDSText as EGDSText2 } from "@egds/react-core/text";
import { defaultViewSizes as defaultViewSizes2, useMediaQueries as useMediaQueries2, ViewLarge, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
// ../internal/src/components/common/button/toggle/egds-toggle-button.tsx
import React21 from "react";
import { gql as gql16 } from "@apollo/client";
import { ButtonToggleCustomContent } from "@egds/react-search-experience";
import { useClickTracker as useClickTracker8 } from "@shared-ui/clickstream-analytics-context";
var __Fragment14 = gql16(_templateObject15());
var EGDSToggleButton = function (param) {
  var data = param.data,
    onChange = param.onChange,
    children = param.children,
    ariaLabel = param.ariaLabel;
  var primary = data.primary,
    subText = data.subText,
    disabled = data.disabled,
    selected = data.selected,
    name = data.name,
    selectedAnalytics = data.selectedAnalytics,
    unselectedAnalytics = data.unselectedAnalytics;
  var trackClick = useClickTracker8();
  var trackToggleButtonState = function (isStateSelected) {
    var state = isStateSelected ? selectedAnalytics : unselectedAnalytics;
    if ((state === null || state === void 0 ? void 0 : state.__typename) === "ClientSideAnalytics") {
      var linkName = state.linkName,
        referrerId = state.referrerId;
      trackClick(referrerId, linkName);
    }
  };
  var handleChange = function (event) {
    if (onChange) {
      onChange(event);
    }
    trackToggleButtonState(!selected);
  };
  return /* @__PURE__ */React21.createElement(ButtonToggleCustomContent, {
    id: name !== null && name !== void 0 ? name : "",
    disabled: disabled,
    name: name !== null && name !== void 0 ? name : "",
    checked: selected,
    onChange: handleChange,
    "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : "".concat(primary, " ").concat(subText)
  }, children);
};
EGDSToggleButton.displayName = "EGDSToggleButton";
EGDSToggleButton.fragment = __Fragment14;
// ../internal/src/components/common/button/toggle/egds-toggle-button-group.tsx
import React22 from "react";
import { gql as gql17 } from "@apollo/client";
import { UitkButtonToggleGroup } from "uitk-react-button-toggle";
var __Fragment15 = gql17(_templateObject16(), EGDSToggleButton.fragment);
var EGDSToggleButtonGroup = function (param) {
  var data = param.data;
  var options = data.options;
  var _React22_useState = _sliced_to_array(React22.useState(options), 2),
    buttons = _React22_useState[0],
    setButtons = _React22_useState[1];
  var handleChange = function (event) {
    setButtons(function (prevState) {
      return prevState.map(function (buttonToggleState) {
        return buttonToggleState.name === event.target.name ? _object_spread_props(_object_spread({}, buttonToggleState), {
          selected: !buttonToggleState.selected
        }) : buttonToggleState;
      });
    });
  };
  return /* @__PURE__ */React22.createElement(UitkButtonToggleGroup, {
    wrapButtons: true
  }, buttons.map(function (option, index) {
    return /* @__PURE__ */React22.createElement(EGDSToggleButton, {
      key: index,
      data: option,
      onChange: handleChange
    });
  }));
};
EGDSToggleButtonGroup.displayName = "EGDSToggleButtonGroup";
EGDSToggleButtonGroup.fragment = __Fragment15;
// ../internal/src/components/form/egds-search-form-date-picker-field/flexible-content/egds-date-picker-flexibility-months-section.tsx
var __Fragment16 = gql18(_templateObject17(), EGDSToggleButtonGroup.fragment);
var DISPLAY_NAME3 = "EGDSDatePickerFlexibleMonths";
var FLEXIBILITY_MONTHS_NAME_PREFIX = "".concat(DISPLAY_NAME3, "-Options");
var EGDSDatePickerFlexibleMonthButton = function (param) {
  var monthSelectionButton = param.monthSelectionButton,
    onMonthSelectionToggle = param.onMonthSelectionToggle;
  var icon = monthSelectionButton.icon,
    primary = monthSelectionButton.primary,
    subText = monthSelectionButton.subText;
  return /* @__PURE__ */React23.createElement(EGDSToggleButton, {
    data: monthSelectionButton,
    onChange: onMonthSelectionToggle,
    ariaLabel: "".concat(primary, " ").concat(subText)
  }, /* @__PURE__ */React23.createElement(EGDSLayoutFlex, {
    direction: "column",
    alignItems: "center",
    blockSize: "full_size",
    justifyContent: "center"
  }, icon && /* @__PURE__ */React23.createElement(EGDSIcon2, {
    name: (icon === null || icon === void 0 ? void 0 : icon.__typename) === "Icon" ? icon.id : ""
  }), primary && /* @__PURE__ */React23.createElement(EGDSText2, {
    size: 100,
    weight: "bold",
    spacing: "one"
  }, primary !== null && primary !== void 0 ? primary : ""), subText && /* @__PURE__ */React23.createElement(EGDSText2, {
    size: 100
  }, subText !== null && subText !== void 0 ? subText : "")));
};
var EGDSDatePickerFlexibleMonths = function (param) {
  var data = param.data,
    monthsSelectionToggleButtons = param.monthsSelectionToggleButtons,
    onMonthSelectionToggle = param.onMonthSelectionToggle;
  var heading = data.heading,
    subHeading = data.subHeading;
  var viewportSize = useMediaQueries2({
    viewSizes: defaultViewSizes2
  });
  var isMediumViewportSize = viewportSize <= defaultViewSizes2.MEDIUM;
  var isSmallViewportSize = viewportSize <= defaultViewSizes2.SMALL;
  var buttonToggleLayoutItemProps = {
    grow: 1,
    maxWidth: isSmallViewportSize || isMediumViewportSize ? void 0 : "twenty_four",
    minWidth: isSmallViewportSize || isMediumViewportSize ? "quarter_width" : void 0
  };
  return /* @__PURE__ */React23.createElement("div", null, /* @__PURE__ */React23.createElement(EGDSLayoutFlex, {
    alignItems: "center",
    direction: "column",
    space: "three"
  }, /* @__PURE__ */React23.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React23.createElement("div", null, /* @__PURE__ */React23.createElement(EGDSHeading2, {
    size: 6,
    align: "center"
  }, heading), /* @__PURE__ */React23.createElement(EGDSSubheading, null, subHeading)))), monthsSelectionToggleButtons && /* @__PURE__ */React23.createElement(Viewport2, null, /* @__PURE__ */React23.createElement(ViewSmall2, null, /* @__PURE__ */React23.createElement(EGDSSpacing2, {
    padding: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React23.createElement(EGDSLayoutFlex, {
    direction: "row",
    justifyContent: "space-around",
    wrap: "wrap",
    space: "three"
  }, monthsSelectionToggleButtons.options.map(function (option, index) {
    return /* @__PURE__ */React23.createElement(EGDSLayoutFlexItem, _object_spread_props(_object_spread({}, buttonToggleLayoutItemProps), {
      key: index
    }), /* @__PURE__ */React23.createElement("div", null, /* @__PURE__ */React23.createElement(EGDSDatePickerFlexibleMonthButton, {
      monthSelectionButton: option,
      onMonthSelectionToggle: onMonthSelectionToggle
    })));
  })))), /* @__PURE__ */React23.createElement(ViewLarge, null, /* @__PURE__ */React23.createElement(EGDSSpacing2, {
    padding: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React23.createElement(EGDSLayoutGrid, {
    columns: 6,
    space: "three"
  }, monthsSelectionToggleButtons.options.map(function (option, index) {
    return /* @__PURE__ */React23.createElement(EGDSLayoutGridItem, _object_spread_props(_object_spread({}, buttonToggleLayoutItemProps), {
      key: index
    }), /* @__PURE__ */React23.createElement("div", null, /* @__PURE__ */React23.createElement(EGDSDatePickerFlexibleMonthButton, {
      monthSelectionButton: option,
      onMonthSelectionToggle: onMonthSelectionToggle
    })));
  }))))));
};
EGDSDatePickerFlexibleMonths.displayName = DISPLAY_NAME3;
EGDSDatePickerFlexibleMonths.fragment = __Fragment16;
// ../internal/src/components/form/egds-search-form-date-picker-field/flexible-content/egds-date-picker-flexibility-nights-section.tsx
import React26 from "react";
import { gql as gql21 } from "@apollo/client";
import { SingleSelectPillWrapper as SingleSelectPillWrapper2 } from "@egds/react-search-experience";
import { UitkLayoutFlex as UitkLayoutFlex3, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "uitk-react-layout-flex";
import { UitkHeading as UitkHeading2 } from "uitk-react-text";
// ../internal/src/components/common/checkbox/egds-checkbox.tsx
import React25 from "react";
import { gql as gql20 } from "@apollo/client";
// ../internal/src/components/common/checkbox/egds-basic-checkbox.tsx
import React24 from "react";
import { gql as gql19 } from "@apollo/client";
import { useClickTracker as useClickTracker9 } from "@shared-ui/clickstream-analytics-context";
import { UitkCheckbox } from "uitk-react-checkbox";
var __Fragment17 = gql19(_templateObject18());
var EGDSBasicCheckBox = function (param) {
  var data = param.data,
    checked = param.checked,
    onChange = param.onChange;
  var egdsElementId = data.egdsElementId,
    description = data.description,
    enabled = data.enabled,
    name = data.name,
    required = data.required,
    label = data.label,
    checkedAnalytics = data.checkedAnalytics,
    uncheckedAnalytics = data.uncheckedAnalytics,
    state = data.state;
  var _React24_useState = _sliced_to_array(React24.useState(checked !== null && checked !== void 0 ? checked : state === "CHECKED" /* CHECKED */), 2),
    isChecked = _React24_useState[0],
    setIsChecked = _React24_useState[1];
  React24.useEffect(function () {
    setIsChecked(checked !== null && checked !== void 0 ? checked : state === "CHECKED" /* CHECKED */);
  }, [checked, state]);
  var track = useClickTracker9();
  var handleChange = React24.useCallback(function (event) {
    setIsChecked(event.currentTarget.checked);
    if (checkedAnalytics && !isChecked) {
      var referrerId = checkedAnalytics.referrerId,
        linkName = checkedAnalytics.linkName;
      track(referrerId, linkName);
    }
    if (uncheckedAnalytics && isChecked) {
      var referrerId1 = uncheckedAnalytics.referrerId,
        linkName1 = uncheckedAnalytics.linkName;
      track(referrerId1, linkName1);
    }
    onChange === null || onChange === void 0 ? void 0 : onChange(event);
  }, [checkedAnalytics, isChecked, onChange, track, uncheckedAnalytics]);
  return /* @__PURE__ */React24.createElement(UitkCheckbox, {
    id: egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "",
    checked: isChecked,
    description: description !== null && description !== void 0 ? description : void 0,
    disabled: !enabled,
    name: name !== null && name !== void 0 ? name : void 0,
    onChange: handleChange,
    required: required
  }, label === null || label === void 0 ? void 0 : label.text);
};
EGDSBasicCheckBox.displayName = "EGDSBasicCheckBoxFragment";
EGDSBasicCheckBox.fragment = _object_spread_props(_object_spread({}, __Fragment17), {
  __typename: "EGDSBasicCheckBox"
});
// ../internal/src/components/common/checkbox/egds-checkbox.tsx
var __Fragment18 = gql20(_templateObject19(), EGDSBasicCheckBox.fragment);
var EGDSCheckBox = function (param) {
  var data = param.data,
    onChange = param.onChange;
  switch (data.__typename) {
    case "EGDSBasicCheckBox":
      return /* @__PURE__ */React25.createElement(EGDSBasicCheckBox, {
        onChange: onChange,
        data: data
      });
    default:
      return null;
  }
};
EGDSCheckBox.displayName = "EGDSCheckBox";
EGDSCheckBox.fragment = __Fragment18;
// ../internal/src/components/form/egds-search-form-date-picker-field/flexible-content/egds-date-picker-flexibility-nights-section.tsx
var __Fragment19 = gql21(_templateObject20(), EGDSPill.fragment, EGDSCheckBox.fragment);
var DISPLAY_NAME4 = "EGDSDatePickerFlexibleNights";
var FLEXIBILITY_NIGHTS_OPTIONS_NAME_PREFIX = "".concat(DISPLAY_NAME4, "-Options");
var FLEXIBILITY_NIGHTS_WEEKEND_NAME_PREFIX = "".concat(DISPLAY_NAME4, "-Weekend");
var EGDSDatePickerFlexibleNights = function (param) {
  var data = param.data,
    onNightSelectionPillChange = param.onNightSelectionPillChange,
    nightsSelectionPills = param.nightsSelectionPills,
    onIncludeWeekendCheck = param.onIncludeWeekendCheck,
    includeWeekendCheckbox = param.includeWeekendCheckbox;
  var heading = data.heading;
  return /* @__PURE__ */React26.createElement("div", null, /* @__PURE__ */React26.createElement(UitkLayoutFlex3, {
    alignItems: "center",
    direction: "column",
    space: "three"
  }, /* @__PURE__ */React26.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */React26.createElement(UitkHeading2, {
    size: 6
  }, heading)), /* @__PURE__ */React26.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */React26.createElement(SingleSelectPillWrapper2, {
    data: nightsSelectionPills,
    handleSelectedPill: onNightSelectionPillChange
  }), ";"), includeWeekendCheckbox && /* @__PURE__ */React26.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */React26.createElement(EGDSCheckBox, {
    data: includeWeekendCheckbox,
    onChange: onIncludeWeekendCheck
  }))));
};
EGDSDatePickerFlexibleNights.displayName = DISPLAY_NAME4;
EGDSDatePickerFlexibleNights.fragment = __Fragment19;
// ../internal/src/components/form/egds-search-form-date-picker-field/flexible-content/egds-date-picker-flexibility-dates-content.tsx
var __Fragment20 = gql22(_templateObject21(), EGDSDatePickerFlexibleMonths.fragment, EGDSDatePickerFlexibleNights.fragment);
var DISPLAY_NAME5 = "EGDSDatePickerFlexibilityDatesContent";
var EGDSDatePickerFlexibilityDatesContent = function (param) {
  var data = param.data,
    className = param.className,
    onNightSelectionPillChange = param.onNightSelectionPillChange,
    nightsSelectionPills = param.nightsSelectionPills,
    onIncludeWeekendCheck = param.onIncludeWeekendCheck,
    includeWeekendCheckbox = param.includeWeekendCheckbox,
    monthsSelectionToggleButtons = param.monthsSelectionToggleButtons,
    onMonthSelectionToggle = param.onMonthSelectionToggle;
  var nightsSelection = data.nightsSelection,
    monthsSelection = data.monthsSelection;
  return /* @__PURE__ */React27.createElement(UitkSpacing6, {
    padding: "four"
  }, /* @__PURE__ */React27.createElement("div", {
    className: className
  }, nightsSelection && /* @__PURE__ */React27.createElement(EGDSDatePickerFlexibleNights, {
    data: nightsSelection,
    onNightSelectionPillChange: onNightSelectionPillChange,
    nightsSelectionPills: nightsSelectionPills,
    onIncludeWeekendCheck: onIncludeWeekendCheck,
    includeWeekendCheckbox: includeWeekendCheckbox
  }), /* @__PURE__ */React27.createElement(UitkSpacingHr, {
    blockMargin: "six"
  }), monthsSelection && /* @__PURE__ */React27.createElement(EGDSDatePickerFlexibleMonths, {
    data: monthsSelection,
    monthsSelectionToggleButtons: monthsSelectionToggleButtons,
    onMonthSelectionToggle: onMonthSelectionToggle
  })));
};
EGDSDatePickerFlexibilityDatesContent.displayName = DISPLAY_NAME5;
EGDSDatePickerFlexibilityDatesContent.fragment = __Fragment20;
// ../internal/src/components/form/egds-search-form-date-picker-field/flexible-content/egds-date-picker-flexibility-content.tsx
var __Fragment21 = gql23(_templateObject22(), EGDSBasicTabs.fragment, EGDSDatePickerFlexibilityCalendarContent.fragment, EGDSDatePickerFlexibilityDatesContent.fragment);
var DISPLAY_NAME6 = "EGDSDatePickerFlexibilityContent";
var EGDSDatePickerFlexibilityContent = function (param) {
  var data = param.data,
    children = param.children,
    className = param.className,
    onContentSelectorSelection = param.onContentSelectorSelection,
    onNightSelectionPillChange = param.onNightSelectionPillChange,
    nightsSelectionPills = param.nightsSelectionPills,
    onIncludeWeekendCheck = param.onIncludeWeekendCheck,
    includeWeekendCheckbox = param.includeWeekendCheckbox,
    monthsSelectionToggleButtons = param.monthsSelectionToggleButtons,
    onMonthSelectionToggle = param.onMonthSelectionToggle,
    contentSelector = param.contentSelector;
  var flexibleDatesContent = data.flexibleDatesContent;
  var activeTab = (contentSelector === null || contentSelector === void 0 ? void 0 : contentSelector.__typename) === "EGDSBasicTabs" ? contentSelector.selectedTabId : "";
  var defaultTabIds = {
    calendarTabId: "calendar-tab",
    flexibleTabId: "flexible-dates-tab"
  };
  var getTabIds = function () {
    if ((contentSelector === null || contentSelector === void 0 ? void 0 : contentSelector.__typename) === "EGDSBasicTabs") {
      var tabs = contentSelector.tabs;
      if (tabs[0].__typename === "EGDSBasicTab" && tabs[1].__typename === "EGDSBasicTab") {
        return {
          calendarTabId: tabs[0].tabId,
          flexibleTabId: tabs[1].tabId
        };
      }
      return defaultTabIds;
    }
    return defaultTabIds;
  };
  var _getTabIds = getTabIds(),
    calendarTabId = _getTabIds.calendarTabId,
    flexibleTabId = _getTabIds.flexibleTabId;
  return /* @__PURE__ */React28.createElement(EGDSScrollable, {
    direction: "vertical"
  }, /* @__PURE__ */React28.createElement("div", {
    className: className
  }, (contentSelector === null || contentSelector === void 0 ? void 0 : contentSelector.__typename) === "EGDSBasicTabs" && /* @__PURE__ */React28.createElement(EGDSBasicTabs, {
    data: contentSelector,
    onTabSelected: onContentSelectorSelection,
    backgroundColor: UitkTabsBackGroundColorType2.SECONDARY,
    tabsType: UitkTabsType2.EQUAL_WIDTH
  }), activeTab === calendarTabId && children, activeTab === flexibleTabId && flexibleDatesContent && /* @__PURE__ */React28.createElement(EGDSDatePickerFlexibilityDatesContent, {
    data: flexibleDatesContent,
    onNightSelectionPillChange: onNightSelectionPillChange,
    nightsSelectionPills: nightsSelectionPills,
    onIncludeWeekendCheck: onIncludeWeekendCheck,
    includeWeekendCheckbox: includeWeekendCheckbox,
    monthsSelectionToggleButtons: monthsSelectionToggleButtons,
    onMonthSelectionToggle: onMonthSelectionToggle
  })));
};
EGDSDatePickerFlexibilityContent.displayName = DISPLAY_NAME6;
EGDSDatePickerFlexibilityContent.fragment = __Fragment21;
// ../internal/src/components/form/egds-search-form-date-picker-field/date-range-selector.tsx
var DEFAULT_LOCALE = "en-US";
var TYPENAME_REFERENCE = "EGDSSearchFormDatePickerField";
var formatLocale = function (locale) {
  return locale.replace("_", "-");
};
var DIALOG_ACTIONS = {
  SUBMIT: "on_submit",
  CLOSE: "on_close"
};
var DateRangeSelector = function (props) {
  var _flexibleDateContent_calendarContent, _flexibleDateContent_flexibleDatesContent_nightsSelection, _flexibleDateContent_flexibleDatesContent, _flexibleDateContent_flexibleDatesContent_nightsSelection1, _flexibleDateContent_flexibleDatesContent1, _flexibleDateContent_flexibleDatesContent_nightsSelection2, _flexibleDateContent_flexibleDatesContent2, _flexibleDateContent_flexibleDatesContent_monthsSelection, _flexibleDateContent_flexibleDatesContent3, _flexibleDateContent_flexibleDatesContent_nightsSelection3, _flexibleDateContent_flexibleDatesContent4, _flexibleDateContent_flexibleDatesContent_nightsSelection4, _flexibleDateContent_flexibleDatesContent_nightsSelection5, _flexibleDateContent_flexibleDatesContent5, _flexibleDateContent_flexibleDatesContent_monthsSelection1, _flexibleDateContent_flexibleDatesContent6, _flexibleDateContent_calendarContent1;
  var autoOpen = props.autoOpen,
    startDate2 = props.startDate,
    endDate2 = props.endDate,
    enableSameDayDateRange = props.enableSameDayDateRange,
    buttonText = props.buttonText,
    clearButtonText = props.clearButtonText,
    startButtonLabel = props.inputLabel1,
    endStartButtonLabel = props.inputLabel2,
    allowClearDates = props.allowClearDates,
    validDaysLowerBoundInclusive2 = props.validDaysLowerBoundInclusive,
    validDaysUpperBoundInclusive = props.validDaysUpperBoundInclusive,
    skipQuery = props.skipQuery,
    typename = props.typename,
    startDateErrorMessage = props.errorMessage,
    labelTemplate = props.labelTemplate,
    buttonTextTemplate = props.buttonTextTemplate,
    onClearDates = props.onClearDates,
    onSelectEndDate = props.onSelectEndDate,
    onSelectStartDate = props.onSelectStartDate,
    onChangeEndDate = props.onChangeEndDate,
    onChangeStartDate = props.onChangeStartDate,
    onClose = props.onClose,
    onOpen = props.onOpen,
    setFieldRefByTypename = props.setFieldRefByTypename,
    onNextCalendarClick = props.onNextCalendarClick,
    onPreviousCalendarClick = props.onPreviousCalendarClick,
    flexibleDateContent = props.flexibleDateContent,
    flexibleContentConfig = props.flexibleContentConfig,
    dialogId = props.dialogId,
    startDateString = props.startDateString,
    endDateString = props.endDateString,
    showCalendar = props.showCalendar,
    toggleCalendar = props.toggleCalendar,
    showStartDateEndDateHiddenInputs = props.showStartDateEndDateHiddenInputs,
    tonightSameDayDateExperiment = props.tonightSameDayDateExperiment,
    input1Stid = props.input1Stid,
    popoverWidth = props.popoverWidth,
    onFlexibleTabSelection = props.onFlexibleTabSelection;
  var context = useBexApi2().context;
  var locale = context.locale ? formatLocale(context.locale) : DEFAULT_LOCALE;
  var clickTracker = useClickTracker10();
  var localizationContext = useLocalization();
  var formatDateString = localizationContext.formatDateString;
  var startDateRef = React29.useRef(null);
  var _useExperiment = useExperiment("Update_Date_Selector_Start_Date_Interaction" /* Update_Date_Selector_Start_Date_Interaction */),
    startInterationExposure = _useExperiment.exposure,
    startInteractionLog = _useExperiment.logExperiment;
  var _useExperiment1 = useExperiment("Date_Selector_Start_Date_Interaction_Hcom" /* Date_Selector_Start_Date_Interaction_Hcom */),
    startInterationExposureHcom = _useExperiment1.exposure,
    startInteractionLogHcom = _useExperiment1.logExperiment;
  var _useExperiment2 = useExperiment("Date_selector_start_date_interaction_Vrbo" /* Date_selector_start_date_interaction_Vrbo */),
    startInterationExposureVrbo = _useExperiment2.exposure,
    startInteractionLogVrbo = _useExperiment2.logExperiment;
  var getFormattedDateString = function (dateString, dateObject) {
    var dateStringFinal = dateString !== null && dateString !== void 0 ? dateString : dateObject ? convertToDateObject(dateObject) : "";
    if (dateStringFinal) {
      return formatDateString(dateStringFinal, {
        raw: "yyyy-MM-dd"
      });
    }
    return null;
  };
  if (autoOpen && onOpen) {
    startInteractionLog(startInterationExposure);
    startInteractionLogHcom(startInterationExposureHcom);
    startInteractionLogVrbo(startInterationExposureVrbo);
    onOpen();
  }
  var formattedStartDate = getFormattedDateString(startDateString, startDate2);
  var formattedEndDate = getFormattedDateString(endDateString, endDate2);
  var _React29_useState = _sliced_to_array(React29.useState(formattedStartDate), 2),
    prevCheckInDateString = _React29_useState[0],
    setPrevCheckInDateString = _React29_useState[1];
  var _React29_useState1 = _sliced_to_array(React29.useState(formattedEndDate), 2),
    prevCheckOutDateString = _React29_useState1[0],
    setPrevCheckOutDateString = _React29_useState1[1];
  var _React29_useState2 = _sliced_to_array(React29.useState(formattedStartDate), 2),
    checkInDateString = _React29_useState2[0],
    setCheckInDateString = _React29_useState2[1];
  var _React29_useState3 = _sliced_to_array(React29.useState(formattedEndDate), 2),
    checkOutDateString = _React29_useState3[0],
    setCheckOutDateString = _React29_useState3[1];
  var _React29_useState4 = _sliced_to_array(React29.useState(500), 2),
    daysBookableInAdvance = _React29_useState4[0],
    setDaysBookableInAdvance = _React29_useState4[1];
  var _React29_useState5 = _sliced_to_array(React29.useState(false), 2),
    shouldFireChangeEvent = _React29_useState5[0],
    setShouldFireChangeEvent = _React29_useState5[1];
  var allowToControlOpenStateFromOutside = typeof showCalendar === "boolean" && toggleCalendar;
  var _React29_useState6 = _sliced_to_array(React29.useState(allowToControlOpenStateFromOutside ? showCalendar : autoOpen !== null && autoOpen !== void 0 ? autoOpen : false), 2),
    initialOpenState = _React29_useState6[0],
    setInitialOpenState = _React29_useState6[1];
  var _React29_useState7 = _sliced_to_array(React29.useState(initialOpenState), 2),
    isCalendarOpen = _React29_useState7[0],
    setIsCalendarOpen = _React29_useState7[1];
  var _React29_useState8 = _sliced_to_array(React29.useState(false), 2),
    shouldCloseFireChangeEvent = _React29_useState8[0],
    setShouldCloseFireChangeEvent = _React29_useState8[1];
  var _React29_useState9 = _sliced_to_array(React29.useState((buttonTextTemplate === null || buttonTextTemplate === void 0 ? void 0 : buttonTextTemplate.__typename) === "EGDSCardinalLocalizedText" ? buttonTextTemplate.text : buttonText), 2),
    dynamicButtonText = _React29_useState9[0],
    setDynamicButtonText = _React29_useState9[1];
  var flexibleDateOptions = flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : (_flexibleDateContent_calendarContent = flexibleDateContent.calendarContent) === null || _flexibleDateContent_calendarContent === void 0 ? void 0 : _flexibleDateContent_calendarContent.flexibleDateOptions;
  var _flexibleDateOptions_find;
  var selectedFlexibleDateOptionsData = (_flexibleDateOptions_find = flexibleDateOptions === null || flexibleDateOptions === void 0 ? void 0 : flexibleDateOptions.find(function (option) {
    return checkInDateString && checkOutDateString ? option.selected : isFlexibleOptionExactDates(option);
  })) !== null && _flexibleDateOptions_find !== void 0 ? _flexibleDateOptions_find : null;
  var trailingTextForFlexibleDateOptions = (selectedFlexibleDateOptionsData === null || selectedFlexibleDateOptionsData === void 0 ? void 0 : selectedFlexibleDateOptionsData.primary) ? "(".concat(selectedFlexibleDateOptionsData.primary, ")") : void 0;
  var selectedCalendarPillState = {
    value: selectedFlexibleDateOptionsData === null || selectedFlexibleDateOptionsData === void 0 ? void 0 : selectedFlexibleDateOptionsData.value,
    hasValueChanged: false,
    trailingText: selectedFlexibleDateOptionsData && isFlexibleOptionExactDates(selectedFlexibleDateOptionsData) ? "" : trailingTextForFlexibleDateOptions
  };
  var _React29_useState10 = _sliced_to_array(React29.useState(selectedCalendarPillState), 2),
    selectedCalendarPill = _React29_useState10[0],
    setSelectedCalendarPill = _React29_useState10[1];
  var viewportSize = useMediaQueries3({
    viewSizes: defaultViewSizes3
  });
  var isLargeViewportSize = viewportSize >= defaultViewSizes3.LARGE;
  var _React29_useState11 = _sliced_to_array(React29.useState(flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : flexibleDateContent.contentSelector), 2),
    contentSelector = _React29_useState11[0],
    setContentSelector = _React29_useState11[1];
  var contentSelectorTabs = (contentSelector === null || contentSelector === void 0 ? void 0 : contentSelector.__typename) === "EGDSBasicTabs" ? contentSelector.tabs : null;
  var calendarTabId = contentSelectorTabs && contentSelectorTabs[0].__typename === "EGDSBasicTab" ? contentSelectorTabs[0].tabId : "calendar-tab";
  var isCalendarTab = (contentSelector === null || contentSelector === void 0 ? void 0 : contentSelector.__typename) === "EGDSBasicTabs" ? contentSelector.selectedTabId === calendarTabId : true;
  var _ref;
  var includeFlexibleDatesContent = (_ref = (flexibleContentConfig === null || flexibleContentConfig === void 0 ? void 0 : flexibleContentConfig.includeFlexibleDatesContent) && !isCalendarTab) !== null && _ref !== void 0 ? _ref : false;
  var _React29_useState12 = _sliced_to_array(React29.useState(), 2),
    prevFlexibleDatesState = _React29_useState12[0],
    setPrevFlexibleDatesState = _React29_useState12[1];
  var _React29_useState13 = _sliced_to_array(React29.useState(), 2),
    prevTabIdState = _React29_useState13[0],
    setPrevTabIdState = _React29_useState13[1];
  var _React29_useState14 = _sliced_to_array(React29.useState(), 2),
    flexibleLabel = _React29_useState14[0],
    setFlexibleLabel = _React29_useState14[1];
  var getDatesStringTonightLabelTeplate = function (startDateValue, endDateValue) {
    var labelTemplateText = labelTemplate === null || labelTemplate === void 0 ? void 0 : labelTemplate.text;
    var startDateKey = "${startDate}";
    var endDateKey = "${endDate}";
    if (!startDateValue || !endDateValue || startDateValue === "" || endDateValue === "") {
      return void 0;
    }
    if (!labelTemplateText || !labelTemplateText.includes(startDateKey) || !labelTemplateText.includes(endDateKey)) {
      return void 0;
    }
    var startDateObj = getDateFromDateString(startDateValue);
    var endDateObj = getDateFromDateString(endDateValue);
    if (!isTodayDate(startDateObj) || !tonightSameDayDateExperiment || tonightSameDayDateExperiment.exposure.bucket !== 1) {
      return void 0;
    }
    var updatedStartDate = formatDateString(startDateObj, {
      skeleton: "MMMd"
    });
    var updatedEndDate = formatDateString(endDateObj, {
      skeleton: "MMMd"
    });
    return labelTemplateText.replace(startDateKey, updatedStartDate).replace(endDateKey, updatedEndDate);
  };
  var _React29_useState15 = _sliced_to_array(React29.useState(getDatesStringTonightLabelTeplate(checkInDateString, checkOutDateString)), 2),
    ovewriteDatesValueString = _React29_useState15[0],
    setOvewriteDatesValueString = _React29_useState15[1];
  var handleSubmit = useFormCallback4(function () {
    var hasTrailingText = isCalendarTab && (flexibleContentConfig === null || flexibleContentConfig === void 0 ? void 0 : flexibleContentConfig.includeFlexibleCalendarContent) && selectedCalendarPill.trailingText;
    if (includeFlexibleDatesContent) {
      return "".concat(typename, "-Flexible");
    }
    if (ovewriteDatesValueString || hasTrailingText) {
      return "".concat(typename, "-TemplateValue");
    }
    return typename;
  }(), function (event) {
    return event;
  });
  var _React29_useState16 = _sliced_to_array(React29.useState(), 2),
    dialogActionsTracker = _React29_useState16[0],
    setDialogActionsTracker = _React29_useState16[1];
  React29.useEffect(function () {
    if ((dialogActionsTracker === null || dialogActionsTracker === void 0 ? void 0 : dialogActionsTracker.includes(DIALOG_ACTIONS.CLOSE)) && !(dialogActionsTracker === null || dialogActionsTracker === void 0 ? void 0 : dialogActionsTracker.includes(DIALOG_ACTIONS.SUBMIT)) && !isLargeViewportSize) {
      if (hasFlexibleDates) {
        resetContentSelector();
        resetFlexDateSelection();
      }
      resetCalendarValues();
    } else {
      setDialogActionsTracker(null);
    }
  }, [dialogActionsTracker]);
  React29.useEffect(function () {
    var _flexibleDateContent_flexibleDatesContent_monthsSelection, _flexibleDateContent_flexibleDatesContent, _flexibleDateContent_flexibleDatesContent_nightsSelection, _flexibleDateContent_flexibleDatesContent1;
    setPrevFlexibleDatesState({
      months: flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent = flexibleDateContent.flexibleDatesContent) === null || _flexibleDateContent_flexibleDatesContent === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent_monthsSelection = _flexibleDateContent_flexibleDatesContent.monthsSelection) === null || _flexibleDateContent_flexibleDatesContent_monthsSelection === void 0 ? void 0 : _flexibleDateContent_flexibleDatesContent_monthsSelection.options,
      nights: defaultNightsSelectionPills,
      weekend: flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent1 = flexibleDateContent.flexibleDatesContent) === null || _flexibleDateContent_flexibleDatesContent1 === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent_nightsSelection = _flexibleDateContent_flexibleDatesContent1.nightsSelection) === null || _flexibleDateContent_flexibleDatesContent_nightsSelection === void 0 ? void 0 : _flexibleDateContent_flexibleDatesContent_nightsSelection.includeWeekend
    });
    setPrevTabIdState((contentSelector === null || contentSelector === void 0 ? void 0 : contentSelector.__typename) === "EGDSBasicTabs" ? contentSelector.selectedTabId : calendarTabId);
  }, []);
  React29.useEffect(function () {
    if (shouldFireChangeEvent) {
      setShouldFireChangeEvent(false);
      var value = "";
      if (checkInDateString && checkOutDateString) {
        value = getInputTextValue();
        if (isTodayDate(getDateFromDateString(checkInDateString)) && tonightSameDayDateExperiment) {
          try {
            tonightSameDayDateExperiment.logExperiment(tonightSameDayDateExperiment.exposure);
          } catch (e) {}
        }
      }
      triggerInputChangeEvent(!isCalendarTab ? flexibleLabel !== null && flexibleLabel !== void 0 ? flexibleLabel : "" : value, handleSubmit);
    }
  }, [shouldFireChangeEvent]);
  React29.useEffect(function () {
    if (formattedStartDate) {
      setCheckInDateString(formattedStartDate);
      setPrevCheckInDateString(formattedStartDate);
    }
    if (formattedEndDate) {
      setCheckOutDateString(formattedEndDate);
      setPrevCheckOutDateString(formattedEndDate);
    }
    if (!formattedStartDate && !formattedEndDate) {
      setCheckInDateString("");
      setCheckOutDateString("");
    }
    if (validDaysUpperBoundInclusive) {
      var difference = convertToDateObject(validDaysUpperBoundInclusive).getTime() - /* @__PURE__ */new Date().getTime();
      setDaysBookableInAdvance(convertFromMiliSecondsToDays(difference));
    }
  }, [formattedEndDate, formattedStartDate, skipQuery, validDaysLowerBoundInclusive2, validDaysUpperBoundInclusive]);
  React29.useEffect(function () {
    if (!skipQuery && (selectedFlexibleDateOptionsData === null || selectedFlexibleDateOptionsData === void 0 ? void 0 : selectedFlexibleDateOptionsData.value) !== selectedCalendarPill.value) {
      setSelectedCalendarPill(selectedCalendarPillState);
    }
  }, [selectedFlexibleDateOptionsData, skipQuery]);
  React29.useEffect(function () {
    setFieldRefByTypename(TYPENAME_REFERENCE, startDateRef);
  }, []);
  var calendarHandlerOnScroll = React29.useCallback(function () {
    var _startDateRef_current;
    var distanceToTopOfViewportToClose = 20;
    var _startDateRef_current_getBoundingClientRect_top;
    if (initialOpenState && ((_startDateRef_current_getBoundingClientRect_top = startDateRef === null || startDateRef === void 0 ? void 0 : (_startDateRef_current = startDateRef.current) === null || _startDateRef_current === void 0 ? void 0 : _startDateRef_current.getBoundingClientRect().top) !== null && _startDateRef_current_getBoundingClientRect_top !== void 0 ? _startDateRef_current_getBoundingClientRect_top : distanceToTopOfViewportToClose) <= distanceToTopOfViewportToClose) {
      setInitialOpenState(false);
      document.body.click();
    }
  }, [initialOpenState]);
  React29.useEffect(function () {
    if (initialOpenState) {
      window.addEventListener("scroll", calendarHandlerOnScroll);
      return function () {
        return window.removeEventListener("scroll", calendarHandlerOnScroll);
      };
    }
  }, [initialOpenState, calendarHandlerOnScroll]);
  React29.useEffect(function () {
    if (allowToControlOpenStateFromOutside) {
      if (showCalendar && !isCalendarOpen) {
        var _startDateRef_current;
        (_startDateRef_current = startDateRef.current) === null || _startDateRef_current === void 0 ? void 0 : _startDateRef_current.click();
      } else if (!showCalendar && isCalendarOpen) {
        document.body.click();
      }
    }
  }, [showCalendar, toggleCalendar]);
  var resetCalendarValues = function () {
    setOvewriteDatesValueString(getDatesStringTonightLabelTeplate(prevCheckInDateString, prevCheckOutDateString));
    setCheckInDateString(prevCheckInDateString);
    setCheckOutDateString(prevCheckOutDateString);
  };
  var updateButtonSubmitText = function (newStartDate, newEndDate) {
    if ((buttonTextTemplate === null || buttonTextTemplate === void 0 ? void 0 : buttonTextTemplate.__typename) === "EGDSCardinalLocalizedText" && newStartDate && newEndDate) {
      var startDateInMiliSeconds = Number(new Date(newStartDate));
      var formateCurrentEndDate = newEndDate !== null && newEndDate !== void 0 ? newEndDate : "";
      var endDateInMiliSeconds = Number(new Date(formateCurrentEndDate));
      var durationOfDays = convertFromMiliSecondsToDays(endDateInMiliSeconds - startDateInMiliSeconds);
      setDynamicButtonText(formatCardinalText(buttonTextTemplate, durationOfDays));
    }
  };
  var onDateRangeChange = function (newStartDate, endDateParam) {
    var _nextTostartDate_toISOString;
    var newEndDate = endDateParam;
    setShouldFireChangeEvent(false);
    setShouldCloseFireChangeEvent(true);
    var hasStartDateChanged = newStartDate !== checkInDateString;
    if (hasStartDateChanged && newStartDate && checkOutDateString && getDateFromDateString(checkOutDateString) > getDateFromDateString(newStartDate) && (startInterationExposure.bucket === 1 || startInterationExposureHcom.bucket === 1 || startInterationExposureVrbo.bucket === 1)) {
      newEndDate = checkOutDateString;
    }
    if (!(newStartDate === null && checkInDateString !== null)) {
      setCheckInDateString(newStartDate);
    }
    if (newStartDate) {
      onChangeStartDate(newStartDate);
      onSelectStartDate();
    }
    if (!newStartDate) {
      setCheckInDateString("");
      onChangeStartDate("");
      onSelectStartDate();
    }
    var nextTostartDate = newStartDate && new Date(newStartDate);
    if (nextTostartDate) {
      nextTostartDate === null || nextTostartDate === void 0 ? void 0 : nextTostartDate.setDate(nextTostartDate.getDate() + 1);
    }
    var formatedDefaultEndDate = nextTostartDate === null || nextTostartDate === void 0 ? void 0 : (_nextTostartDate_toISOString = nextTostartDate.toISOString()) === null || _nextTostartDate_toISOString === void 0 ? void 0 : _nextTostartDate_toISOString.match(/[0-9]{4}-[0-9]{2}-[0-9]{2}/gi);
    if (newEndDate || (formatedDefaultEndDate === null || formatedDefaultEndDate === void 0 ? void 0 : formatedDefaultEndDate[0])) {
      var finalEndDate = newEndDate || (formatedDefaultEndDate === null || formatedDefaultEndDate === void 0 ? void 0 : formatedDefaultEndDate[0]) || null;
      setCheckOutDateString(finalEndDate);
      onSelectEndDate();
      onChangeEndDate(finalEndDate);
      updateButtonSubmitText(newStartDate, finalEndDate);
      setOvewriteDatesValueString(getDatesStringTonightLabelTeplate(newStartDate, finalEndDate));
    } else if (newStartDate) {
      setCheckInDateString(newStartDate);
    } else if (!newStartDate) {
      setCheckOutDateString("");
      onChangeEndDate("");
      setOvewriteDatesValueString(void 0);
      onSelectEndDate();
    }
  };
  var resetFlexibleDateContent = function () {
    var _flexibleDateOptions_find;
    var defaultFlexibleDateOptionValue = (_flexibleDateOptions_find = flexibleDateOptions === null || flexibleDateOptions === void 0 ? void 0 : flexibleDateOptions.find(function (pill) {
      return pill.value === "0_day";
    })) !== null && _flexibleDateOptions_find !== void 0 ? _flexibleDateOptions_find : null;
    if (defaultFlexibleDateOptionValue) {
      var value = defaultFlexibleDateOptionValue.value;
      setSelectedCalendarPill({
        value: value,
        trailingText: "",
        hasValueChanged: true
      });
    }
  };
  var onDateRangeClear = function () {
    setCheckInDateString(null);
    setCheckOutDateString(null);
    resetFlexibleDateContent();
    onClearDates();
  };
  var onOpenCB = function () {
    if (allowToControlOpenStateFromOutside) {
      toggleCalendar(true);
    }
    startInteractionLog(startInterationExposure);
    startInteractionLogHcom(startInterationExposureHcom);
    startInteractionLogVrbo(startInterationExposureVrbo);
    onOpen();
    setIsCalendarOpen(true);
    if (!isCalendarTab) {
      onFlexibleTabSelection === null || onFlexibleTabSelection === void 0 ? void 0 : onFlexibleTabSelection();
    }
  };
  var getFlexibleLabel = function () {
    var _flexibleDateContent_flexibilityLabel;
    var flexibilityLabels = flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : (_flexibleDateContent_flexibilityLabel = flexibleDateContent.flexibilityLabel) === null || _flexibleDateContent_flexibilityLabel === void 0 ? void 0 : _flexibleDateContent_flexibilityLabel.templates;
    var nightSelection = selectedFlexibleDatesNights === null || selectedFlexibleDatesNights === void 0 ? void 0 : selectedFlexibleDatesNights.text;
    var monthsSelection = selectedFlexibleDatesMonths === null || selectedFlexibleDatesMonths === void 0 ? void 0 : selectedFlexibleDatesMonths.map(function (month) {
      return month.shortMonthName;
    });
    var monthsSelected = monthsSelection && monthsSelection.length > 0;
    var labelIndex = monthsSelected && monthsSelection.length > 6 ? 5 : monthsSelection.length - 1;
    var templateLabel = monthsSelected && flexibilityLabels ? flexibilityLabels[labelIndex].template : "";
    var keyValues = monthsSelected ? [nightSelection].concat(_to_consumable_array(monthsSelection)) : [];
    var flexibleLocalizedLabel = templateLabel;
    keyValues.forEach(function (key, index) {
      var _flexibleDateContent_flexibilityLabel_models_index, _flexibleDateContent_flexibilityLabel;
      var modelKey = flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : (_flexibleDateContent_flexibilityLabel = flexibleDateContent.flexibilityLabel) === null || _flexibleDateContent_flexibilityLabel === void 0 ? void 0 : (_flexibleDateContent_flexibilityLabel_models_index = _flexibleDateContent_flexibilityLabel.models[index]) === null || _flexibleDateContent_flexibilityLabel_models_index === void 0 ? void 0 : _flexibleDateContent_flexibilityLabel_models_index.key;
      flexibleLocalizedLabel = formatLocalizedTokenString(flexibleLocalizedLabel, modelKey !== null && modelKey !== void 0 ? modelKey : "", key !== null && key !== void 0 ? key : "");
    });
    return flexibleLocalizedLabel;
  };
  React29.useEffect(function () {
    if (includeFlexibleDatesContent) {
      setFlexibleLabel(getFlexibleLabel);
    }
  }, []);
  var getInputTextValue = function () {
    var dates = "".concat(checkInDateString, " - ").concat(checkOutDateString);
    var preFormattedDates = getFormattedDates(dates, localizationContext);
    var trailingText = selectedCalendarPill.trailingText;
    if (trailingText && isCalendarTab && (flexibleContentConfig === null || flexibleContentConfig === void 0 ? void 0 : flexibleContentConfig.includeFlexibleCalendarContent)) {
      if (ovewriteDatesValueString) {
        return "".concat(ovewriteDatesValueString, " ").concat(trailingText);
      }
      return "".concat(preFormattedDates, " ").concat(trailingText);
    }
    return ovewriteDatesValueString !== null && ovewriteDatesValueString !== void 0 ? ovewriteDatesValueString : dates;
  };
  var resetFlexDateSelection = function () {
    if (prevFlexibleDatesState) {
      var months = prevFlexibleDatesState.months,
        nights = prevFlexibleDatesState.nights,
        weekend = prevFlexibleDatesState.weekend;
      if (months) {
        setMonthsSelectionToggleButtons(months);
      }
      if (nights) {
        setNightsSelectionPills(nights);
      }
      if (weekend) {
        setIncludeWeekendCheckbox(weekend);
      }
    }
  };
  var resetContentSelector = function () {
    setContentSelector(function (prevState) {
      if (prevState) {
        return _object_spread_props(_object_spread({}, prevState), {
          selectedTabId: prevTabIdState !== null && prevTabIdState !== void 0 ? prevTabIdState : (contentSelector === null || contentSelector === void 0 ? void 0 : contentSelector.__typename) === "EGDSBasicTabs" ? contentSelector.selectedTabId : ""
        });
      }
      return null;
    });
  };
  var getUpdatedFlexibleMonthsButtonDataWhenNoMonthsSelected = function () {
    if (monthsSelectionToggleButtons) {
      var options = monthsSelectionToggleButtons.options.map(function (option, index) {
        if (index === 0 || index === 1) {
          return _object_spread_props(_object_spread({}, option), {
            selected: !option.selected
          });
        }
        return option;
      });
      return _object_spread_props(_object_spread({}, monthsSelectionToggleButtons), {
        options: options
      });
    }
    return null;
  };
  var updateFlexibleDates = function () {
    if (includeFlexibleDatesContent) {
      var _prevFlexibleDatesState_weekend;
      var newFlexibleLabel = getFlexibleLabel();
      setFlexibleLabel(newFlexibleLabel);
      var _monthsSelectionToggleButtons_options_some;
      var areMonthsSelectionToggleButtonsSelected = (_monthsSelectionToggleButtons_options_some = monthsSelectionToggleButtons === null || monthsSelectionToggleButtons === void 0 ? void 0 : monthsSelectionToggleButtons.options.some(function (option) {
        return option.selected;
      })) !== null && _monthsSelectionToggleButtons_options_some !== void 0 ? _monthsSelectionToggleButtons_options_some : false;
      var firstTwoMonthsSelectedData = getUpdatedFlexibleMonthsButtonDataWhenNoMonthsSelected();
      if (!areMonthsSelectionToggleButtonsSelected && firstTwoMonthsSelectedData) {
        setMonthsSelectionToggleButtons(firstTwoMonthsSelectedData);
      }
      var monthsSelectedToggleButtons = areMonthsSelectionToggleButtonsSelected ? monthsSelectionToggleButtons : firstTwoMonthsSelectedData !== null && firstTwoMonthsSelectedData !== void 0 ? firstTwoMonthsSelectedData : monthsSelectionToggleButtons;
      var wasFlexibleDatesContentChanged = (prevFlexibleDatesState === null || prevFlexibleDatesState === void 0 ? void 0 : prevFlexibleDatesState.nights) !== nightsSelectionPills || (prevFlexibleDatesState === null || prevFlexibleDatesState === void 0 ? void 0 : (_prevFlexibleDatesState_weekend = prevFlexibleDatesState.weekend) === null || _prevFlexibleDatesState_weekend === void 0 ? void 0 : _prevFlexibleDatesState_weekend.state) !== (includeWeekendCheckbox === null || includeWeekendCheckbox === void 0 ? void 0 : includeWeekendCheckbox.state) || prevFlexibleDatesState.months !== monthsSelectedToggleButtons;
      setPrevFlexibleDatesState({
        months: monthsSelectedToggleButtons,
        nights: nightsSelectionPills,
        weekend: includeWeekendCheckbox
      });
      setShouldFireChangeEvent(wasFlexibleDatesContentChanged);
    }
    if (hasFlexibleDates) {
      var contentSelectorTabId = (contentSelector === null || contentSelector === void 0 ? void 0 : contentSelector.__typename) === "EGDSBasicTabs" ? contentSelector.selectedTabId : "";
      setPrevTabIdState(contentSelectorTabId);
      if (prevTabIdState !== contentSelectorTabId) {
        setShouldFireChangeEvent(true);
      }
    }
  };
  var onCloseCB = function () {
    if (allowToControlOpenStateFromOutside) {
      toggleCalendar(false);
    }
    if (!isLargeViewportSize) {
      setDialogActionsTracker(function (prevState) {
        if (prevState) {
          return _to_consumable_array(prevState).concat([DIALOG_ACTIONS.CLOSE]);
        }
        return [DIALOG_ACTIONS.CLOSE];
      });
    } else {
      updateFlexibleDates();
    }
    if (selectedCalendarPill.hasValueChanged && checkInDateString !== "" && checkOutDateString !== "") {
      setShouldFireChangeEvent(true);
      setSelectedCalendarPill(function (prevState) {
        return _object_spread_props(_object_spread({}, prevState), {
          hasValueChanged: false
        });
      });
    }
    if (shouldCloseFireChangeEvent) {
      setShouldFireChangeEvent(true);
      setShouldCloseFireChangeEvent(false);
    }
    onClose();
    setIsCalendarOpen(false);
  };
  var onSubmitCB = function (start, end) {
    if (!isLargeViewportSize && hasFlexibleDates) {
      setDialogActionsTracker([DIALOG_ACTIONS.SUBMIT]);
      updateFlexibleDates();
    }
    if (!startDate2 && !endDate2 && start && end) {
      setPrevCheckInDateString(start);
      setPrevCheckOutDateString(end);
      setShouldFireChangeEvent(true);
      return;
    }
    if (!start && !end) {
      resetFlexibleDateContent();
    }
    if ((formattedStartDate !== null && formattedStartDate !== void 0 ? formattedStartDate : "") !== start || (formattedEndDate !== null && formattedEndDate !== void 0 ? formattedEndDate : "") !== end) {
      setPrevCheckInDateString(start);
      setPrevCheckOutDateString(end);
      setShouldFireChangeEvent(true);
    }
  };
  var handleFlexibleContentOptionSelection = function (newValue) {
    if (flexibleDateOptions === null || flexibleDateOptions === void 0 ? void 0 : flexibleDateOptions.length) {
      var selectedOption = flexibleDateOptions.find(function (selected) {
        return selected.value === newValue;
      });
      if (selectedOption) {
        var selectAnalytics = selectedOption.selectAnalytics,
          value = selectedOption.value,
          primary = selectedOption.primary;
        var trailingText = isFlexibleOptionExactDates(selectedOption) ? "" : "(".concat(primary, ")");
        setSelectedCalendarPill(function (prevState) {
          var _flexibleDateOptions_find;
          var _flexibleDateOptions_find_deselectAnalytics;
          var prevOptionDeselectAnalytics = (_flexibleDateOptions_find_deselectAnalytics = (_flexibleDateOptions_find = flexibleDateOptions.find(function (selected) {
            return selected.value === prevState.value;
          })) === null || _flexibleDateOptions_find === void 0 ? void 0 : _flexibleDateOptions_find.deselectAnalytics) !== null && _flexibleDateOptions_find_deselectAnalytics !== void 0 ? _flexibleDateOptions_find_deselectAnalytics : null;
          if (prevOptionDeselectAnalytics) {
            clickTracker(prevOptionDeselectAnalytics.referrerId, prevOptionDeselectAnalytics.linkName);
          }
          return {
            value: value,
            trailingText: trailingText,
            prevValue: prevState.value,
            hasValueChanged: true
          };
        });
        if (selectAnalytics) {
          clickTracker(selectAnalytics.referrerId, selectAnalytics.linkName);
        }
      }
    }
  };
  var maxDate = React29.useMemo(function () {
    return validDaysUpperBoundInclusive ? convertToDateObject(validDaysUpperBoundInclusive) : addMaxDateToToday(daysBookableInAdvance);
  }, [daysBookableInAdvance, validDaysUpperBoundInclusive]);
  var minDate = React29.useMemo(function () {
    return validDaysLowerBoundInclusive2 ? convertToDateObject(validDaysLowerBoundInclusive2) : void 0;
  }, [validDaysLowerBoundInclusive2]);
  var dayData = React29.useMemo(function () {
    return {
      defaults: {
        validStartDate: minDate,
        validEndDate: maxDate
      }
    };
  }, [minDate, maxDate]);
  var DATE_SELECTOR_NAME_PREFIX = "EGDSDateRange-date-selector-trigger";
  var onContentSelectorSelection = function (tabId) {
    showStartDateEndDateHiddenInputs((contentSelector === null || contentSelector === void 0 ? void 0 : contentSelector.__typename) === "EGDSBasicTabs" ? tabId === calendarTabId : false);
    setContentSelector(function (prevState) {
      if (prevState) {
        return _object_spread_props(_object_spread({}, prevState), {
          selectedTabId: tabId
        });
      }
      return null;
    });
    if (tabId !== calendarTabId) {
      onFlexibleTabSelection === null || onFlexibleTabSelection === void 0 ? void 0 : onFlexibleTabSelection();
    }
  };
  var _flexibleDateContent_flexibleDatesContent_nightsSelection_includeWeekend;
  var _React29_useState17 = _sliced_to_array(React29.useState((_flexibleDateContent_flexibleDatesContent_nightsSelection_includeWeekend = flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent = flexibleDateContent.flexibleDatesContent) === null || _flexibleDateContent_flexibleDatesContent === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent_nightsSelection = _flexibleDateContent_flexibleDatesContent.nightsSelection) === null || _flexibleDateContent_flexibleDatesContent_nightsSelection === void 0 ? void 0 : _flexibleDateContent_flexibleDatesContent_nightsSelection.includeWeekend) !== null && _flexibleDateContent_flexibleDatesContent_nightsSelection_includeWeekend !== void 0 ? _flexibleDateContent_flexibleDatesContent_nightsSelection_includeWeekend : null), 2),
    includeWeekendCheckbox = _React29_useState17[0],
    setIncludeWeekendCheckbox = _React29_useState17[1];
  var _flexibleDateContent_flexibleDatesContent_nightsSelection_includeWeekend_state;
  var _React29_useState18 = _sliced_to_array(React29.useState((_flexibleDateContent_flexibleDatesContent_nightsSelection_includeWeekend_state = flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent1 = flexibleDateContent.flexibleDatesContent) === null || _flexibleDateContent_flexibleDatesContent1 === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent_nightsSelection1 = _flexibleDateContent_flexibleDatesContent1.nightsSelection) === null || _flexibleDateContent_flexibleDatesContent_nightsSelection1 === void 0 ? void 0 : _flexibleDateContent_flexibleDatesContent_nightsSelection1.includeWeekend.state) !== null && _flexibleDateContent_flexibleDatesContent_nightsSelection_includeWeekend_state !== void 0 ? _flexibleDateContent_flexibleDatesContent_nightsSelection_includeWeekend_state : "UNCHECKED" /* UNCHECKED */), 2),
    includeWeekendCheckboxNightsState = _React29_useState18[0],
    setIncludeWeekendCheckboxDaysState = _React29_useState18[1];
  var onIncludeWeekendCheck = function (event) {
    var newCheckboxState = event.target.checked ? "CHECKED" /* CHECKED */ : "UNCHECKED" /* UNCHECKED */;
    setIncludeWeekendCheckbox(function (prevState) {
      if (prevState != null) {
        var _nightsSelectionPills_find_value, _nightsSelectionPills_find;
        var areNightsSelected = nightsSelectionPills === null || nightsSelectionPills === void 0 ? void 0 : (_nightsSelectionPills_find = nightsSelectionPills.find(function (nights) {
          return nights.selected;
        })) === null || _nightsSelectionPills_find === void 0 ? void 0 : (_nightsSelectionPills_find_value = _nightsSelectionPills_find.value) === null || _nightsSelectionPills_find_value === void 0 ? void 0 : _nightsSelectionPills_find_value.includes("DAY");
        if (areNightsSelected) {
          setIncludeWeekendCheckboxDaysState(newCheckboxState);
        }
        return _object_spread_props(_object_spread({}, prevState), {
          state: newCheckboxState
        });
      }
      return null;
    });
  };
  var _flexibleDateContent_flexibleDatesContent_nightsSelection_options_map;
  var defaultNightsSelectionPills = (_flexibleDateContent_flexibleDatesContent_nightsSelection_options_map = flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent2 = flexibleDateContent.flexibleDatesContent) === null || _flexibleDateContent_flexibleDatesContent2 === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent_nightsSelection2 = _flexibleDateContent_flexibleDatesContent2.nightsSelection) === null || _flexibleDateContent_flexibleDatesContent_nightsSelection2 === void 0 ? void 0 : _flexibleDateContent_flexibleDatesContent_nightsSelection2.options.map(function (option) {
    var _option_primary, _option_value, _option_name;
    return {
      selected: option.selected,
      checked: false,
      text: (_option_primary = option.primary) !== null && _option_primary !== void 0 ? _option_primary : "",
      disabled: option.disabled,
      value: (_option_value = option.value) !== null && _option_value !== void 0 ? _option_value : "",
      id: (_option_name = option.name) !== null && _option_name !== void 0 ? _option_name : "",
      altText: ""
    };
  })) !== null && _flexibleDateContent_flexibleDatesContent_nightsSelection_options_map !== void 0 ? _flexibleDateContent_flexibleDatesContent_nightsSelection_options_map : [];
  var _React29_useState19 = _sliced_to_array(React29.useState(defaultNightsSelectionPills), 2),
    nightsSelectionPills = _React29_useState19[0],
    setNightsSelectionPills = _React29_useState19[1];
  var trackOnPillSelect = function (selectedPillValue) {
    var _flexibleDateContent_flexibleDatesContent_nightsSelection_options_index, _flexibleDateContent_flexibleDatesContent_nightsSelection, _flexibleDateContent_flexibleDatesContent;
    var index = nightsSelectionPills.findIndex(function (pill) {
      return pill.value === selectedPillValue;
    });
    var analytics = flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent = flexibleDateContent.flexibleDatesContent) === null || _flexibleDateContent_flexibleDatesContent === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent_nightsSelection = _flexibleDateContent_flexibleDatesContent.nightsSelection) === null || _flexibleDateContent_flexibleDatesContent_nightsSelection === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent_nightsSelection_options_index = _flexibleDateContent_flexibleDatesContent_nightsSelection.options[index]) === null || _flexibleDateContent_flexibleDatesContent_nightsSelection_options_index === void 0 ? void 0 : _flexibleDateContent_flexibleDatesContent_nightsSelection_options_index.selectAnalytics;
    if ((analytics === null || analytics === void 0 ? void 0 : analytics.linkName) && (analytics === null || analytics === void 0 ? void 0 : analytics.referrerId)) {
      clickTracker(analytics.referrerId, analytics.linkName);
    }
  };
  var onNightSelectionPillChange = function (selectedPillValue) {
    setNightsSelectionPills(function (prevState) {
      return prevState.map(function (option) {
        return option.value === selectedPillValue ? _object_spread_props(_object_spread({}, option), {
          selected: true
        }) : _object_spread_props(_object_spread({}, option), {
          selected: false
        });
      });
    });
    trackOnPillSelect(selectedPillValue);
    setIncludeWeekendCheckbox(function (prevState) {
      var _nightsSelectionPills_find;
      if (prevState === null) {
        return null;
      }
      if (selectedPillValue.includes("WEEK") || selectedPillValue.includes("6_DAY_LOWER,7_DAY_UPPER") || selectedPillValue.includes("MONTH")) {
        return _object_spread_props(_object_spread({}, prevState), {
          state: "CHECKED" /* CHECKED */,
          enabled: false
        });
      }
      var weekPreviousValue = nightsSelectionPills === null || nightsSelectionPills === void 0 ? void 0 : (_nightsSelectionPills_find = nightsSelectionPills.find(function (nights) {
        return nights.selected;
      })) === null || _nightsSelectionPills_find === void 0 ? void 0 : _nightsSelectionPills_find.value;
      var isWeekPreviousSelection = (weekPreviousValue === null || weekPreviousValue === void 0 ? void 0 : weekPreviousValue.includes("WEEK")) || (weekPreviousValue === null || weekPreviousValue === void 0 ? void 0 : weekPreviousValue.includes("6_DAY_LOWER,7_DAY_UPPER")) || (weekPreviousValue === null || weekPreviousValue === void 0 ? void 0 : weekPreviousValue.includes("MONTH"));
      if (selectedPillValue.includes("DAY") && isWeekPreviousSelection) {
        return _object_spread_props(_object_spread({}, prevState), {
          state: includeWeekendCheckboxNightsState,
          enabled: true
        });
      }
      return _object_spread_props(_object_spread({}, prevState), {
        enabled: true
      });
    });
  };
  var _flexibleDateContent_flexibleDatesContent_monthsSelection_options;
  var _React29_useState20 = _sliced_to_array(React29.useState((_flexibleDateContent_flexibleDatesContent_monthsSelection_options = flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent3 = flexibleDateContent.flexibleDatesContent) === null || _flexibleDateContent_flexibleDatesContent3 === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent_monthsSelection = _flexibleDateContent_flexibleDatesContent3.monthsSelection) === null || _flexibleDateContent_flexibleDatesContent_monthsSelection === void 0 ? void 0 : _flexibleDateContent_flexibleDatesContent_monthsSelection.options) !== null && _flexibleDateContent_flexibleDatesContent_monthsSelection_options !== void 0 ? _flexibleDateContent_flexibleDatesContent_monthsSelection_options : null), 2),
    monthsSelectionToggleButtons = _React29_useState20[0],
    setMonthsSelectionToggleButtons = _React29_useState20[1];
  var onMonthSelectionToggle = function (selectedButton) {
    setMonthsSelectionToggleButtons(function (prevState) {
      if (prevState) {
        var options = prevState.options.map(function (option) {
          if (option.name === selectedButton.target.name) {
            return _object_spread_props(_object_spread({}, option), {
              selected: !option.selected
            });
          }
          return option;
        });
        return _object_spread_props(_object_spread({}, prevState), {
          options: options
        });
      }
      return null;
    });
  };
  var getDateMonthStringAndShortName = function (selectedFlexibleMonths) {
    return selectedFlexibleMonths === null || selectedFlexibleMonths === void 0 ? void 0 : selectedFlexibleMonths.map(function (button) {
      var _button_name;
      var nameProperties = (_button_name = button.name) === null || _button_name === void 0 ? void 0 : _button_name.split("_");
      var _nameProperties_splice_join;
      var monthsDate = (_nameProperties_splice_join = nameProperties === null || nameProperties === void 0 ? void 0 : nameProperties.splice(nameProperties.length - 2, nameProperties.length).join("_")) !== null && _nameProperties_splice_join !== void 0 ? _nameProperties_splice_join : "";
      var shortMonthName = nameProperties ? nameProperties[nameProperties.length - 1] : "";
      return {
        shortMonthName: shortMonthName,
        monthsDate: monthsDate
      };
    }).filter(function (option) {
      return !!option.monthsDate && !!option.shortMonthName;
    });
  };
  var getSelectedFlexibleOptions = function () {
    var selectedFlexibleDatesNights2 = nightsSelectionPills.find(function (pill) {
      return pill.selected === true;
    });
    var defaultFlexibleMonths = monthsSelectionToggleButtons ? [monthsSelectionToggleButtons === null || monthsSelectionToggleButtons === void 0 ? void 0 : monthsSelectionToggleButtons.options[0], monthsSelectionToggleButtons === null || monthsSelectionToggleButtons === void 0 ? void 0 : monthsSelectionToggleButtons.options[1]] : [];
    var selectedFlexibleMonthsToggleButtons = monthsSelectionToggleButtons === null || monthsSelectionToggleButtons === void 0 ? void 0 : monthsSelectionToggleButtons.options.filter(function (option) {
      return option.selected;
    });
    var selectedFlexibleDatesMonths2 = getDateMonthStringAndShortName(selectedFlexibleMonthsToggleButtons && (selectedFlexibleMonthsToggleButtons === null || selectedFlexibleMonthsToggleButtons === void 0 ? void 0 : selectedFlexibleMonthsToggleButtons.length) > 0 ? selectedFlexibleMonthsToggleButtons : defaultFlexibleMonths);
    return {
      selectedFlexibleDatesNights: selectedFlexibleDatesNights2,
      selectedFlexibleDatesMonths: selectedFlexibleDatesMonths2
    };
  };
  var _ref1 = includeFlexibleDatesContent ? getSelectedFlexibleOptions() : {
      selectedFlexibleDatesNights: void 0,
      selectedFlexibleDatesMonths: []
    },
    selectedFlexibleDatesNights = _ref1.selectedFlexibleDatesNights,
    selectedFlexibleDatesMonths = _ref1.selectedFlexibleDatesMonths;
  var calendarWrapperProps = {
    data: flexibleDateContent,
    onNightSelectionPillChange: onNightSelectionPillChange,
    nightsSelectionPills: nightsSelectionPills,
    includeWeekendCheckbox: includeWeekendCheckbox,
    onIncludeWeekendCheck: onIncludeWeekendCheck,
    onMonthSelectionToggle: onMonthSelectionToggle,
    monthsSelectionToggleButtons: monthsSelectionToggleButtons,
    onContentSelectorSelection: onContentSelectorSelection,
    contentSelector: contentSelector
  };
  var calendarWrapper = (flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : flexibleDateContent.contentSelector) && (flexibleContentConfig === null || flexibleContentConfig === void 0 ? void 0 : flexibleContentConfig.includeFlexibleDatesContent) ? {
    component: EGDSDatePickerFlexibilityContent,
    props: calendarWrapperProps
  } : void 0;
  var alertTemplateComponent = (flexibleContentConfig === null || flexibleContentConfig === void 0 ? void 0 : flexibleContentConfig.includeFlexibleCalendarContent) && (flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : flexibleDateContent.calendarContent) ? EGDSDatePickerFlexibilityCalendarContent : void 0;
  var hasFlexibleDates = !!calendarWrapper;
  var hasFlexibleCalendarContent = flexibleContentConfig === null || flexibleContentConfig === void 0 ? void 0 : flexibleContentConfig.includeFlexibleCalendarContent;
  var alertTemplateDataClassName = (contentSelector === null || contentSelector === void 0 ? void 0 : contentSelector.__typename) === "EGDSBasicTabs" && isCalendarTab ? "" : "is-visually-hidden is-hidden";
  var _ref2, _selectedCalendarPill_trailingText;
  var dateSelectorProps = {
    inputName1: DATE_SELECTOR_NAME_PREFIX,
    input1Stid: input1Stid !== null && input1Stid !== void 0 ? input1Stid : "default",
    autoCloseOnSelection: false,
    allowClearDates: (_ref2 = allowClearDates && isCalendarTab) !== null && _ref2 !== void 0 ? _ref2 : false,
    clearButtonLabel: clearButtonText,
    dateFormatOptions: {
      month: "short",
      day: "numeric"
    },
    dayNameLength: "narrow",
    dayTemplateComponent: DateRangeSelectorDayTemplate,
    dayData: dayData,
    endDate: checkOutDateString,
    enableSameDayDateRange: enableSameDayDateRange,
    inputLabel1: startButtonLabel,
    inputLabel2: endStartButtonLabel,
    locale: locale,
    maxDate: maxDate,
    minDate: minDate,
    onDateRangeChange: onDateRangeChange,
    onDateRangeClear: onDateRangeClear,
    onClose: onCloseCB,
    onSubmit: onSubmitCB,
    onOpen: onOpenCB,
    invalidInput1: startDateErrorMessage,
    startDate: checkInDateString,
    submitButtonLabel: dynamicButtonText,
    useSingleTrigger: true,
    initialOpenState: initialOpenState,
    startDateRef: startDateRef,
    onNextClicked: onNextCalendarClick,
    onPrevClicked: onPreviousCalendarClick,
    handleShape: "circle",
    alertTemplateComponent: alertTemplateComponent,
    alertTemplateData: {
      data: flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : flexibleDateContent.calendarContent,
      onSelect: handleFlexibleContentOptionSelection,
      currentlySelectedPillValue: selectedCalendarPill.value,
      className: hasFlexibleDates ? alertTemplateDataClassName : ""
    },
    calendarWrapper: calendarWrapper,
    trailingText1: hasFlexibleCalendarContent && !includeFlexibleDatesContent ? (_selectedCalendarPill_trailingText = selectedCalendarPill.trailingText) !== null && _selectedCalendarPill_trailingText !== void 0 ? _selectedCalendarPill_trailingText : "" : void 0,
    dialogId: dialogId,
    inputValue1: includeFlexibleDatesContent ? flexibleLabel : ovewriteDatesValueString !== null && ovewriteDatesValueString !== void 0 ? ovewriteDatesValueString : void 0,
    popoverWidth: popoverWidth
  };
  var _selectedCalendarPill_value;
  return /* @__PURE__ */React29.createElement(React29.Fragment, null, /* @__PURE__ */React29.createElement(UitkDateSelector, _object_spread({}, dateSelectorProps)), (flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent4 = flexibleDateContent.flexibleDatesContent) === null || _flexibleDateContent_flexibleDatesContent4 === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent_nightsSelection3 = _flexibleDateContent_flexibleDatesContent4.nightsSelection) === null || _flexibleDateContent_flexibleDatesContent_nightsSelection3 === void 0 ? void 0 : _flexibleDateContent_flexibleDatesContent_nightsSelection3.includeWeekend) && (includeWeekendCheckbox === null || includeWeekendCheckbox === void 0 ? void 0 : includeWeekendCheckbox.state) === "CHECKED" /* CHECKED */ && hasFlexibleDates && !isCalendarTab && /* @__PURE__ */React29.createElement("input", {
    type: "hidden",
    "data-stid": FLEXIBILITY_NIGHTS_WEEKEND_NAME_PREFIX,
    name: "".concat(FLEXIBILITY_NIGHTS_WEEKEND_NAME_PREFIX, "-").concat((_flexibleDateContent_flexibleDatesContent_nightsSelection4 = flexibleDateContent.flexibleDatesContent.nightsSelection) === null || _flexibleDateContent_flexibleDatesContent_nightsSelection4 === void 0 ? void 0 : _flexibleDateContent_flexibleDatesContent_nightsSelection4.includeWeekend.name),
    value: "INCLUDE_WEEKEND"
  }), (flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent5 = flexibleDateContent.flexibleDatesContent) === null || _flexibleDateContent_flexibleDatesContent5 === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent_nightsSelection5 = _flexibleDateContent_flexibleDatesContent5.nightsSelection) === null || _flexibleDateContent_flexibleDatesContent_nightsSelection5 === void 0 ? void 0 : _flexibleDateContent_flexibleDatesContent_nightsSelection5.options) && selectedFlexibleDatesNights && hasFlexibleDates && !isCalendarTab && /* @__PURE__ */React29.createElement("input", {
    type: "hidden",
    "data-stid": FLEXIBILITY_NIGHTS_OPTIONS_NAME_PREFIX,
    name: "".concat(FLEXIBILITY_NIGHTS_OPTIONS_NAME_PREFIX, "-").concat(selectedFlexibleDatesNights.id),
    value: selectedFlexibleDatesNights.value
  }), (flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent6 = flexibleDateContent.flexibleDatesContent) === null || _flexibleDateContent_flexibleDatesContent6 === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent_monthsSelection1 = _flexibleDateContent_flexibleDatesContent6.monthsSelection) === null || _flexibleDateContent_flexibleDatesContent_monthsSelection1 === void 0 ? void 0 : _flexibleDateContent_flexibleDatesContent_monthsSelection1.options) && hasFlexibleDates && !isCalendarTab && /* @__PURE__ */React29.createElement("input", {
    type: "hidden",
    "data-stid": FLEXIBILITY_MONTHS_NAME_PREFIX,
    name: FLEXIBILITY_MONTHS_NAME_PREFIX,
    value: selectedFlexibleDatesMonths.map(function (month) {
      return month.monthsDate;
    }).join("/")
  }), (flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : flexibleDateContent.calendarContent) && hasFlexibleCalendarContent && isCalendarTab && /* @__PURE__ */React29.createElement("input", {
    type: "hidden",
    "data-stid": FLEXIBILITY_CALENDAR_CONTENT_NAME_PREFIX,
    name: "".concat(FLEXIBILITY_CALENDAR_CONTENT_NAME_PREFIX, "-").concat((_flexibleDateContent_calendarContent1 = flexibleDateContent.calendarContent) === null || _flexibleDateContent_calendarContent1 === void 0 ? void 0 : _flexibleDateContent_calendarContent1.formElementId),
    value: (_selectedCalendarPill_value = selectedCalendarPill.value) !== null && _selectedCalendarPill_value !== void 0 ? _selectedCalendarPill_value : ""
  }));
};
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-price-calendar/egds-price-calendar.tsx
import React34 from "react";
import { UitkDateSelector as UitkDateSelector2 } from "@egds/react-core/date-selector";
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-price-calendar/flights/query-utils.ts
import { useLazyQuery } from "@apollo/client";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-price-calendar/flights/flights-price-calendar-query.ts
import { gql as gql28 } from "@apollo/client";
// ../internal/src/components/common/client-side-analytics.ts
import { gql as gql24 } from "@apollo/client";
var clientSideAnalyticsFragment = gql24(_templateObject23());
// ../internal/src/components/common/egds-text/egds-graphic-text.tsx
import React32 from "react";
import { gql as gql27 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing3, UitkSpacing as UitkSpacing7 } from "@egds/react-core/spacing";
import { UitkText } from "@egds/react-core/text";
// ../internal/src/components/common/ui-graphic/ui-graphic.tsx
import React31 from "react";
import { gql as gql26 } from "@apollo/client";
// ../internal/src/components/common/ui-graphic/mark.tsx
import React30 from "react";
import { gql as gql25 } from "@apollo/client";
import { UitkMark } from "uitk-react-mark";
var fragment = gql25(_templateObject24());
var Mark = function (param) {
  var data = param.data,
    className = param.className;
  return /* @__PURE__ */React30.createElement(UitkMark, {
    className: className,
    description: data.description,
    id: data.id,
    name: data.id
  });
};
Mark.displayName = "Mark";
Mark.fragment = fragment;
// ../internal/src/components/common/ui-graphic/ui-graphic.tsx
var fragment2 = gql26(_templateObject25(), Icon.fragment, Mark.fragment);
var UIGraphic = function (param) {
  var data = param.data,
    markOptions = param.markOptions;
  switch (data.__typename) {
    case "Icon":
      return /* @__PURE__ */React31.createElement(Icon, {
        data: data
      });
    case "Mark":
      return /* @__PURE__ */React31.createElement(Mark, _object_spread({
        data: data
      }, markOptions));
    default:
      return null;
  }
};
UIGraphic.displayName = "UIGraphic";
UIGraphic.fragment = fragment2;
// ../internal/src/components/common/egds-text/egds-graphic-text.tsx
var fragment3 = gql27(_templateObject26(), UIGraphic.fragment);
var EGDSGraphicText = function (param) {
  var inline = param.inline,
    size = param.size,
    graphicSpacing = param.graphicSpacing,
    data = param.data;
  var accessibility = data.accessibility,
    text = data.text,
    graphic = data.graphic,
    trailingGraphics = data.trailingGraphics;
  var hasA11yContent = accessibility && accessibility.length > 0;
  var textContent = hasA11yContent ? /* @__PURE__ */React32.createElement(React32.Fragment, null, /* @__PURE__ */React32.createElement("span", {
    "aria-hidden": hasA11yContent
  }, text), /* @__PURE__ */React32.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility)) : text;
  return /* @__PURE__ */React32.createElement(UitkText, {
    inline: inline
  }, /* @__PURE__ */React32.createElement(EGDSSpacing3, {
    padding: graphicSpacing === null || graphicSpacing === void 0 ? void 0 : graphicSpacing.padding,
    margin: graphicSpacing === null || graphicSpacing === void 0 ? void 0 : graphicSpacing.margin
  }, /* @__PURE__ */React32.createElement(UIGraphic, {
    data: graphic
  })), /* @__PURE__ */React32.createElement(UitkSpacing7, {
    padding: {
      inline: "one"
    }
  }, /* @__PURE__ */React32.createElement(UitkText, {
    inline: true,
    size: size
  }, textContent)), trailingGraphics === null || trailingGraphics === void 0 ? void 0 : trailingGraphics.map(function (graphicItem, index) {
    return /* @__PURE__ */React32.createElement(UIGraphic, {
      data: graphicItem,
      key: "trailing-graphic-".concat(index)
    });
  }));
};
EGDSGraphicText.displayName = "EGDSGraphicText";
EGDSGraphicText.fragment = fragment3;
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-price-calendar/flights/flights-price-calendar-query.ts
var __FlightsPriceCalendarQuery = gql28(_templateObject27(), EGDSGraphicText.fragment, clientSideAnalyticsFragment);
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-price-calendar/flights/query-utils.ts
var useLazyFetchFlightsPriceCalendar = function (queryInputs) {
  var context = useBexApi3().context;
  return useLazyQuery(__FlightsPriceCalendarQuery, {
    ssr: false,
    fetchPolicy: "no-cache",
    variables: _object_spread({
      context: context
    }, queryInputs)
  });
};
var getODInputs = function (isOutbound, journeyCriteria) {
  if (isOutbound) {
    return {
      origin: journeyCriteria[0].origin,
      destination: journeyCriteria[0].destination
    };
  }
  return {
    origin: journeyCriteria[1].origin,
    destination: journeyCriteria[1].destination
  };
};
var getFlightsData = function (queryInputs) {
  var journeyCriteria = queryInputs.journeyCriteria,
    flightsSearchContext = queryInputs.flightsSearchContext;
  return getODInputs(flightsSearchContext.tripType === "ROUND_TRIP" /* ROUND_TRIP */, journeyCriteria);
};
var getFlightsPricesDayData = function (data) {
  var availabilityDayData = {
    defaults: {
      dateText: {
        textWeight: "bold",
        textTheme: null,
        textValue: null
      }
    }
  };
  if (data === null || data === void 0 ? void 0 : data.flightsPriceCalendar.calendarPrices) {
    data.flightsPriceCalendar.calendarPrices.forEach(function (dayPrice) {
      var dateCell = {
        dateText: {
          textWeight: dayPrice.theme,
          textTheme: dayPrice.weight,
          textValue: dayPrice.label
        }
      };
      availabilityDayData["".concat(dayPrice.date)] = dateCell;
    });
  }
  return availabilityDayData;
};
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-price-calendar/flights/calendar-content-message.tsx
import React33 from "react";
import { UitkLayoutFlex as UitkLayoutFlex4, UitkLayoutFlexItem as UitkLayoutFlexItem4 } from "@egds/react-core/layout-flex";
import { UitkSpacing as UitkSpacing8 } from "@egds/react-core/spacing";
import { UitkText as UitkText2 } from "@egds/react-core/text";
import { ViewLarge as ViewLarge2, Viewport as Viewport3, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
var calendarContentPropsSmall = {
  padding: {
    blockend: "three"
  }
};
var calendarContentProps = {
  padding: {
    blockend: "four"
  }
};
var CalendarContentMessage = function (param) {
  var data = param.data;
  return /* @__PURE__ */React33.createElement(UitkLayoutFlex4, {
    justifyContent: "center"
  }, /* @__PURE__ */React33.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */React33.createElement(Viewport3, null, /* @__PURE__ */React33.createElement(ViewSmall3, null, /* @__PURE__ */React33.createElement(UitkSpacing8, {
    padding: calendarContentPropsSmall.padding
  }, /* @__PURE__ */React33.createElement(UitkText2, {
    size: 200,
    weight: "regular"
  }, data))), /* @__PURE__ */React33.createElement(ViewLarge2, null, /* @__PURE__ */React33.createElement(UitkSpacing8, {
    padding: calendarContentProps.padding
  }, /* @__PURE__ */React33.createElement(UitkText2, {
    size: 200,
    weight: "regular"
  }, data))))));
};
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-price-calendar/use-price-calendar.ts
var getQueryFetcher = function (lobName) {
  switch (lobName) {
    case "flights":
      return useLazyFetchFlightsPriceCalendar;
  }
};
var getInputData = function (lobName) {
  switch (lobName) {
    case "flights":
      return getFlightsData;
  }
};
var usePriceCalendarFetcher = function (lobName, queryInputs) {
  var queryFetchFunction = getQueryFetcher(lobName);
  var _queryFetchFunction = _sliced_to_array(queryFetchFunction(queryInputs), 2),
    getPriceCalendarPricesLazy = _queryFetchFunction[0],
    _queryFetchFunction_ = _queryFetchFunction[1],
    data = _queryFetchFunction_.data,
    error = _queryFetchFunction_.error;
  var getQueryInputs = getInputData(lobName);
  var _getQueryInputs = getQueryInputs(queryInputs),
    origin = _getQueryInputs.origin,
    destination = _getQueryInputs.destination;
  return [getPriceCalendarPricesLazy, origin, destination];
};
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-price-calendar/egds-price-calendar.tsx
var EGDSPriceCalendar = function (param) {
  var lobName = param.lobName,
    queryInputs = param.queryInputs;
  var _usePriceCalendarFetcher = _sliced_to_array(usePriceCalendarFetcher(lobName, queryInputs), 3),
    fetchQuery = _usePriceCalendarFetcher[0],
    origin = _usePriceCalendarFetcher[1],
    destination = _usePriceCalendarFetcher[2];
  var _React34_useState = _sliced_to_array(React34.useState(null), 2),
    startDate2 = _React34_useState[0],
    setStartDate = _React34_useState[1];
  var _React34_useState1 = _sliced_to_array(React34.useState(null), 2),
    endDate2 = _React34_useState1[0],
    setEndDate = _React34_useState1[1];
  var _React34_useState2 = _sliced_to_array(React34.useState(void 0), 2),
    dayData = _React34_useState2[0],
    setDayData = _React34_useState2[1];
  var onOpen = function () {
    var _ref = _async_to_generator(function () {
      var data, prices;
      return _ts_generator(this, function (_state) {
        switch (_state.label) {
          case 0:
            return [4, fetchQuery()];
          case 1:
            data = _state.sent();
            switch (lobName) {
              case "flights":
                {
                  prices = getFlightsPricesDayData(data === null || data === void 0 ? void 0 : data.data);
                  setDayData(prices);
                  break;
                }
            }
            return [2];
        }
      });
    });
    return function onOpen() {
      return _ref.apply(this, arguments);
    };
  }();
  var onDateRangeChange = function (startDateString, endDateString) {
    setStartDate(startDateString);
    setEndDate(endDateString);
  };
  var dateSelectorProps = {
    locale: "en-US",
    isSingleDateSelection: false,
    useSingleTrigger: true,
    dayNameLength: "narrow",
    handleShape: "circle",
    startDate: startDate2,
    endDate: endDate2,
    dayData: dayData,
    onOpen: onOpen,
    onDateRangeChange: onDateRangeChange,
    dateFormatOptions: {
      month: "short",
      day: "numeric"
    },
    inputLabel1: "Date label 1",
    inputLabel2: "Date label 2",
    alertTemplateComponent: CalendarContentMessage,
    alertTemplateData: {
      data: "prices are shown as flightType in USD"
    }
  };
  return /* @__PURE__ */React34.createElement("div", {
    "data-testid": "egds_price_calendar"
  }, /* @__PURE__ */React34.createElement(UitkDateSelector2, _object_spread({}, dateSelectorProps)));
};
EGDSPriceCalendar.displayName = "EGDSPriceCalendar";
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-date-range-picker.tsx
var __Fragment22 = gql29(_templateObject28(), EGDSDatePickerFlexibilityContent.fragment);
var NIGHTS_FIELD_NAME = "EGDSDatePickerFlexibleNights";
var DISPLAY_NAME7 = "EGDSDateRangePicker";
var START_DATE_NAME_PREFIX = "".concat(DISPLAY_NAME7, "-StartDate");
var END_DATE_NAME_PREFIX = "".concat(DISPLAY_NAME7, "-EndDate");
var PARTIAL_STAY_START_DATE_NAME_PREFIX = "EGDSDateRangePartialStay-StartDate";
var PARTIAL_STAY_END_DATE_NAME_PREFIX = "EGDSDateRangePartialStay-EndDate";
var FLEXIBILITY_NIGHTS_PREFIX = "".concat(NIGHTS_FIELD_NAME, "-Options");
var FLEXIBILITY_WEEKEND_PREFIX = "".concat(NIGHTS_FIELD_NAME, "-Weekend");
var DATE_FORMAT = "yyyy-MM-dd";
var EGDSDateRangePicker = function (props) {
  var _flexibleDateContent_contentSelector, _flexibleDateContent_contentSelector1;
  var clickTracker = useClickTracker11();
  var data = props.data,
    analytics = props.analytics,
    egdsElementId = props.egdsElementId,
    label = props.label,
    overrideValidDaysUpperBoundInclusive = props.validDaysUpperBoundInclusive,
    skipReflection = props.skipReflection,
    onOpenDatesField = props.onOpenDatesField,
    updatePlaybackDates = props.updatePlaybackDates,
    lobName = props.lobName,
    enablePriceCalendar = props.enablePriceCalendar,
    priceCalendarInputs = props.priceCalendarInputs,
    popoverWidth = props.popoverWidth;
  var __typename = data.__typename,
    selectedStartDate = data.selectedStartDate,
    selectedEndDate = data.selectedEndDate,
    validDaysUpperBoundInclusive = data.validDaysUpperBoundInclusive,
    sameDaySelectionAllowed = data.sameDaySelectionAllowed,
    clearButtonText = data.clearButtonText,
    showClearDatesButton = data.showClearDatesButton,
    startDatePlaceholderText = data.startDatePlaceholderText,
    endDatePlaceholderText = data.endDatePlaceholderText,
    clearDatesButtonAnalytics = data.clearDatesButtonAnalytics,
    endDateButtonAnalytics = data.endDateButtonAnalytics,
    startDateButtonAnalytics = data.startDateButtonAnalytics,
    submitButtonAnalytics = data.submitButtonAnalytics,
    nextButtonAnalytics = data.nextButtonAnalytics,
    previousButtonAnalytics = data.previousButtonAnalytics,
    flexibleDateContent = data.flexibleDateContent;
  var _useSearchFormReflectionContext = useSearchFormReflectionContext(),
    state = _useSearchFormReflectionContext.state,
    dispatchReflectionAction = _useSearchFormReflectionContext.dispatch;
  var _state_dates;
  var _ref = (_state_dates = state.dates) !== null && _state_dates !== void 0 ? _state_dates : {},
    reflectionStartDate = _ref.start,
    reflectionEndDate = _ref.end;
  var formatDateString = useLocalization2().formatDateString;
  var defaultStartDate = selectedStartDate ? formatDateString(convertToDateObject(selectedStartDate), {
    raw: DATE_FORMAT
  }) : "";
  var defaultEndDate = selectedEndDate ? formatDateString(convertToDateObject(selectedEndDate), {
    raw: DATE_FORMAT
  }) : "";
  var _React35_useState = _sliced_to_array(React35.useState({
      startDate: defaultStartDate,
      endDate: defaultEndDate
    }), 2),
    dateState = _React35_useState[0],
    setDateState = _React35_useState[1];
  var contentSelectorTabs = (flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : (_flexibleDateContent_contentSelector = flexibleDateContent.contentSelector) === null || _flexibleDateContent_contentSelector === void 0 ? void 0 : _flexibleDateContent_contentSelector.__typename) === "EGDSBasicTabs" ? flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : flexibleDateContent.contentSelector.tabs : null;
  var calendarTabId = contentSelectorTabs && contentSelectorTabs[0].__typename === "EGDSBasicTab" ? contentSelectorTabs[0].tabId : "calendar-tab";
  var _React35_useState1 = _sliced_to_array(React35.useState((flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : (_flexibleDateContent_contentSelector1 = flexibleDateContent.contentSelector) === null || _flexibleDateContent_contentSelector1 === void 0 ? void 0 : _flexibleDateContent_contentSelector1.__typename) === "EGDSBasicTabs" ? (flexibleDateContent === null || flexibleDateContent === void 0 ? void 0 : flexibleDateContent.contentSelector.selectedTabId) === calendarTabId : true), 2),
    showHiddenInputs = _React35_useState1[0],
    setShowHiddenInputs = _React35_useState1[1];
  var onHandleHiddenInputsVisibility = function (visibleHiddenInputs) {
    return setShowHiddenInputs(visibleHiddenInputs);
  };
  var trackAction = function (action) {
    var _action_referrerId;
    var referrerId = (_action_referrerId = action === null || action === void 0 ? void 0 : action.referrerId) !== null && _action_referrerId !== void 0 ? _action_referrerId : "";
    var _action_linkName;
    var linkName = (_action_linkName = action === null || action === void 0 ? void 0 : action.linkName) !== null && _action_linkName !== void 0 ? _action_linkName : "";
    if (referrerId && linkName) {
      clickTracker(referrerId, linkName);
    }
  };
  var onClearDates = function () {
    return trackAction(clearDatesButtonAnalytics);
  };
  var onSelectEndDate = function () {
    return trackAction(endDateButtonAnalytics);
  };
  var onSelectStartDate = function () {
    return trackAction(startDateButtonAnalytics);
  };
  var onChangeStartDate = function (startDate2) {
    setDateState(function (prevState) {
      return _object_spread_props(_object_spread({}, prevState), {
        startDate: startDate2 !== null && startDate2 !== void 0 ? startDate2 : prevState.startDate
      });
    });
    if (updatePlaybackDates) {
      updatePlaybackDates(startDate2, true);
    }
  };
  var onChangeEndDate = function (endDate2) {
    setDateState(function (prevState) {
      if (!skipReflection) {
        dispatchReflectionAction({
          type: "UPDATE_DATES",
          end: endDate2,
          start: prevState.startDate
        });
      }
      if (updatePlaybackDates) {
        updatePlaybackDates(endDate2, false);
      }
      return _object_spread_props(_object_spread({}, prevState), {
        endDate: endDate2 !== null && endDate2 !== void 0 ? endDate2 : prevState.endDate
      });
    });
  };
  var onSubmit = function () {
    return trackAction(submitButtonAnalytics);
  };
  var onClose = function () {
    return trackAction(submitButtonAnalytics);
  };
  var onOpen = function () {
    onOpenDatesField === null || onOpenDatesField === void 0 ? void 0 : onOpenDatesField();
    trackAction(analytics);
  };
  var onNextCalendarClick = function () {
    return trackAction(nextButtonAnalytics);
  };
  var onPreviousCalendarClick = function () {
    return trackAction(previousButtonAnalytics);
  };
  var sharedDateRangeProps = _object_spread({
    onClearDates: onClearDates,
    onSelectEndDate: onSelectEndDate,
    onSelectStartDate: onSelectStartDate,
    onSubmit: onSubmit,
    onClose: onClose,
    onOpen: onOpen,
    onChangeStartDate: onChangeStartDate,
    onChangeEndDate: onChangeEndDate,
    onNextCalendarClick: onNextCalendarClick,
    onPreviousCalendarClick: onPreviousCalendarClick
  }, !skipReflection ? {
    startDateString: reflectionStartDate,
    endDateString: reflectionEndDate
  } : {});
  var dateRangeSelectorProps = _object_spread_props(_object_spread({}, props, data, sharedDateRangeProps), {
    typename: __typename,
    startDate: selectedStartDate,
    endDate: selectedEndDate,
    validDaysUpperBoundInclusive: overrideValidDaysUpperBoundInclusive !== null && overrideValidDaysUpperBoundInclusive !== void 0 ? overrideValidDaysUpperBoundInclusive : validDaysUpperBoundInclusive,
    enableSameDayDateRange: sameDaySelectionAllowed,
    clearButtonText: clearButtonText !== null && clearButtonText !== void 0 ? clearButtonText : "",
    inputLabel1: label !== null && label !== void 0 ? label : startDatePlaceholderText,
    inputLabel2: label !== null && label !== void 0 ? label : endDatePlaceholderText,
    allowClearDates: showClearDatesButton !== null && showClearDatesButton !== void 0 ? showClearDatesButton : false,
    showStartDateEndDateHiddenInputs: onHandleHiddenInputsVisibility
  });
  React35.useEffect(function () {
    if (!skipReflection) {
      setDateState(function (prevState) {
        return _object_spread({}, prevState, reflectionStartDate ? {
          startDate: reflectionStartDate
        } : {}, reflectionEndDate ? {
          endDate: reflectionEndDate
        } : {});
      });
    }
  }, [setDateState, reflectionStartDate, reflectionEndDate, skipReflection]);
  var verifyPriceCalendarInputs = React35.useCallback(function () {
    var _priceCalendarInputs_journeyCriteria;
    if (lobName === "flights" && priceCalendarInputs && ((_priceCalendarInputs_journeyCriteria = priceCalendarInputs.journeyCriteria) === null || _priceCalendarInputs_journeyCriteria === void 0 ? void 0 : _priceCalendarInputs_journeyCriteria.length) > 0) {
      return priceCalendarInputs;
    }
    return void 0;
  }, [lobName, priceCalendarInputs]);
  var verifiedPriceCalendarInputs = verifyPriceCalendarInputs();
  var _dateState_startDate, _dateState_endDate;
  return enablePriceCalendar && lobName && verifiedPriceCalendarInputs ? /* @__PURE__ */React35.createElement(EGDSPriceCalendar, {
    lobName: lobName,
    queryInputs: verifiedPriceCalendarInputs
  }) : /* @__PURE__ */React35.createElement(React35.Fragment, null, /* @__PURE__ */React35.createElement(Viewport4, null, /* @__PURE__ */React35.createElement(ViewSmall4, null, /* @__PURE__ */React35.createElement(DateRangeSelector, _object_spread_props(_object_spread({}, dateRangeSelectorProps), {
    autoOpen: false
  }))), /* @__PURE__ */React35.createElement(ViewMedium2, null, /* @__PURE__ */React35.createElement(DateRangeSelector, _object_spread_props(_object_spread({}, dateRangeSelectorProps), {
    popoverWidth: popoverWidth
  })))), showHiddenInputs && /* @__PURE__ */React35.createElement(React35.Fragment, null, /* @__PURE__ */React35.createElement("input", {
    type: "hidden",
    "data-stid": egdsElementId === "partial-stay-date-range-select" ? PARTIAL_STAY_START_DATE_NAME_PREFIX : START_DATE_NAME_PREFIX,
    name: "".concat(egdsElementId === "partial-stay-date-range-select" ? PARTIAL_STAY_START_DATE_NAME_PREFIX : START_DATE_NAME_PREFIX, "-").concat(egdsElementId),
    value: (_dateState_startDate = dateState.startDate) !== null && _dateState_startDate !== void 0 ? _dateState_startDate : ""
  }), /* @__PURE__ */React35.createElement("input", {
    type: "hidden",
    "data-stid": egdsElementId === "partial-stay-date-range-select" ? PARTIAL_STAY_END_DATE_NAME_PREFIX : END_DATE_NAME_PREFIX,
    name: "".concat(egdsElementId === "partial-stay-date-range-select" ? PARTIAL_STAY_END_DATE_NAME_PREFIX : END_DATE_NAME_PREFIX, "-").concat(egdsElementId),
    value: (_dateState_endDate = dateState.endDate) !== null && _dateState_endDate !== void 0 ? _dateState_endDate : ""
  })));
};
EGDSDateRangePicker.displayName = DISPLAY_NAME7;
EGDSDateRangePicker.fragment = __Fragment22;
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-single-date-picker.tsx
import React36 from "react";
import { gql as gql30 } from "@apollo/client";
import { useBexApi as useBexApi4 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker12 } from "@shared-ui/clickstream-analytics-context";
import { useLocalization as useLocalization3 } from "@shared-ui/localization-context";
import { useSearchFormReflectionContext as useSearchFormReflectionContext2 } from "@shared-ui/retail-search-tools-reflection-provider";
import { UitkDateSelector as UitkDateSelector3 } from "uitk-react-date-selector";
import { useFormCallback as useFormCallback5 } from "uitk-react-form";
var DISPLAY_NAME8 = "EGDSSingleDatePicker";
var DATE_NAME_PREFIX = "".concat(DISPLAY_NAME8, "-Date");
var DATE_FORMAT2 = "yyyy-MM-dd";
var __Fragment23 = gql30(_templateObject29());
var EGDSSingleDatePicker = function (param) {
  var analytics = param.analytics,
    data = param.data,
    egdsElementId = param.egdsElementId,
    label = param.label,
    setFieldRefByTypename = param.setFieldRefByTypename,
    errorMessage = param.errorMessage,
    index = param.index,
    showCalendar = param.showCalendar,
    toggleCalendar = param.toggleCalendar,
    autoOpen = param.autoOpen,
    dialogId = param.dialogId,
    skipReflection = param.skipReflection,
    updatePlaybackDates = param.updatePlaybackDates,
    totalLegs = param.totalLegs,
    input1Stid = param.input1Stid,
    lobName = param.lobName,
    enablePriceCalendar = param.enablePriceCalendar,
    priceCalendarInputs = param.priceCalendarInputs;
  var clickTracker = useClickTracker12();
  var __typename = data.__typename,
    buttonText = data.buttonText,
    selectedStartDate = data.selectedStartDate,
    validDaysLowerBoundInclusive2 = data.validDaysLowerBoundInclusive,
    validDaysUpperBoundInclusive = data.validDaysUpperBoundInclusive,
    startDateButtonAnalytics = data.startDateButtonAnalytics,
    submitButtonAnalytics = data.submitButtonAnalytics;
  var _useSearchFormReflectionContext2 = useSearchFormReflectionContext2(),
    state = _useSearchFormReflectionContext2.state,
    dispatchReflectionAction = _useSearchFormReflectionContext2.dispatch;
  var _state_dates;
  var _ref = (_state_dates = state.dates) !== null && _state_dates !== void 0 ? _state_dates : {},
    reflectionStartDate = _ref.start,
    reflectionEndDate = _ref.end;
  var formatDateString = useLocalization3().formatDateString;
  var _React36_useState = _sliced_to_array(React36.useState(autoOpen !== null && autoOpen !== void 0 ? autoOpen : false), 1),
    isDateSelectorOpen = _React36_useState[0];
  var today2 = /* @__PURE__ */new Date();
  var tomorrow = /* @__PURE__ */new Date();
  tomorrow.setDate(today2.getDate() + 1);
  var _React36_useState1 = _sliced_to_array(React36.useState(formatDateString(today2, {
      raw: DATE_FORMAT2
    })), 2),
    startDate2 = _React36_useState1[0],
    setStartDate = _React36_useState1[1];
  var _React36_useState2 = _sliced_to_array(React36.useState(formatDateString(today2, {
      raw: DATE_FORMAT2
    })), 2),
    validStartDate = _React36_useState2[0],
    setValidStartDate = _React36_useState2[1];
  var defaultDaysBookableInAdvance = 330;
  var _React36_useState3 = _sliced_to_array(React36.useState(defaultDaysBookableInAdvance), 2),
    daysBookableInAdvance = _React36_useState3[0],
    setDaysBookableInAdvance = _React36_useState3[1];
  var handleSubmit = useFormCallback5(function () {
    return "".concat(__typename);
  }(), function (event) {
    return event;
  });
  var _React36_useState4 = _sliced_to_array(React36.useState(false), 2),
    shouldFireChangeEvent = _React36_useState4[0],
    setShouldFireChangeEvent = _React36_useState4[1];
  var _React36_useState5 = _sliced_to_array(React36.useState(false), 2),
    shouldCloseFireChangeEvent = _React36_useState5[0],
    setShouldCloseFireChangeEvent = _React36_useState5[1];
  React36.useEffect(function () {
    var dateFormatOptions = {
      raw: DATE_FORMAT2
    };
    if (!skipReflection && reflectionStartDate) {
      setStartDate(reflectionStartDate);
    } else if (selectedStartDate) {
      setStartDate(formatDateString(convertToDateObject(selectedStartDate), dateFormatOptions));
    }
    if (validDaysLowerBoundInclusive2) {
      setValidStartDate(formatDateString(convertToDateObject(validDaysLowerBoundInclusive2), dateFormatOptions));
    }
    if (validDaysUpperBoundInclusive) {
      var difference = convertToDateObject(validDaysUpperBoundInclusive).getTime() - /* @__PURE__ */new Date().getTime();
      setDaysBookableInAdvance(convertFromMiliSecondsToDays(difference));
    }
  }, [formatDateString, selectedStartDate, validDaysLowerBoundInclusive2, validDaysUpperBoundInclusive, reflectionStartDate]);
  React36.useEffect(function () {
    if (shouldFireChangeEvent) {
      setShouldFireChangeEvent(false);
      var value = startDate2 ? "".concat(startDate2) : "";
      triggerInputChangeEvent(value, handleSubmit);
    }
  }, [shouldFireChangeEvent]);
  var hiddenInputNameSuffix = "".concat(egdsElementId).concat(Number.isInteger(index) ? "-".concat(index) : "");
  var context = useBexApi4().context;
  var DEFAULT_LOCALE2 = "en-US";
  var TYPENAME_REFERENCE2 = "EGDSSearchFormDatePickerField";
  var formatLocale2 = function (locale2) {
    return locale2.replace("_", "-");
  };
  var locale = context.locale ? formatLocale2(context.locale) : DEFAULT_LOCALE2;
  var startDateRef = React36.useRef(null);
  var trackAction = function (action) {
    var _action_referrerId;
    var referrerId = (_action_referrerId = action === null || action === void 0 ? void 0 : action.referrerId) !== null && _action_referrerId !== void 0 ? _action_referrerId : "";
    var _action_linkName;
    var linkName = (_action_linkName = action === null || action === void 0 ? void 0 : action.linkName) !== null && _action_linkName !== void 0 ? _action_linkName : "";
    if (referrerId && linkName) {
      clickTracker(referrerId, linkName);
    }
  };
  React36.useEffect(function () {
    setFieldRefByTypename(TYPENAME_REFERENCE2, startDateRef);
  }, []);
  var onDateChange = function (newStartDate) {
    setShouldFireChangeEvent(false);
    setShouldCloseFireChangeEvent(true);
    setStartDate(newStartDate);
    if (updatePlaybackDates && totalLegs && (index === 0 || index === totalLegs - 1)) {
      updatePlaybackDates(newStartDate, index === 0);
    }
    trackAction(startDateButtonAnalytics);
  };
  var onOpen = function () {
    return trackAction(analytics);
  };
  var onClose = function () {
    trackAction(submitButtonAnalytics);
    if (shouldCloseFireChangeEvent) {
      setShouldFireChangeEvent(true);
      setShouldCloseFireChangeEvent(false);
    }
  };
  var dateSelectorProps = {
    isSingleDateSelection: true,
    input1Stid: input1Stid !== null && input1Stid !== void 0 ? input1Stid : "default",
    startDate: startDate2,
    submitButtonLabel: buttonText,
    inputLabel1: label !== null && label !== void 0 ? label : void 0,
    maxDate: addMaxDateToToday(daysBookableInAdvance),
    autoCloseOnSelection: false,
    allowClearDates: false,
    dateFormatOptions: {
      month: "short",
      day: "numeric"
    },
    dayNameLength: "narrow",
    initialOpenState: isDateSelectorOpen,
    locale: locale,
    handleShape: "circle",
    invalidInput1: errorMessage,
    dialogId: dialogId,
    startDateRef: startDateRef,
    onDateRangeChange: onDateChange,
    onOpen: onOpen,
    onClose: onClose,
    endDate: null
  };
  var verifyPriceCalendarInputs = React36.useCallback(function () {
    var _priceCalendarInputs_journeyCriteria;
    if (lobName === "flights" && priceCalendarInputs && ((_priceCalendarInputs_journeyCriteria = priceCalendarInputs.journeyCriteria) === null || _priceCalendarInputs_journeyCriteria === void 0 ? void 0 : _priceCalendarInputs_journeyCriteria.length) > 0) {
      return priceCalendarInputs;
    }
    return void 0;
  }, [lobName, priceCalendarInputs]);
  var verifiedPriceCalendarInputs = verifyPriceCalendarInputs();
  return enablePriceCalendar && lobName && verifiedPriceCalendarInputs ? /* @__PURE__ */React36.createElement(EGDSPriceCalendar, {
    lobName: lobName,
    queryInputs: verifiedPriceCalendarInputs
  }) : /* @__PURE__ */React36.createElement(React36.Fragment, null, /* @__PURE__ */React36.createElement(UitkDateSelector3, _object_spread({}, dateSelectorProps)), /* @__PURE__ */React36.createElement("input", {
    type: "hidden",
    "data-stid": DATE_NAME_PREFIX,
    name: "".concat(DATE_NAME_PREFIX, "-").concat(hiddenInputNameSuffix),
    value: startDate2
  }));
};
EGDSSingleDatePicker.displayName = DISPLAY_NAME8;
EGDSSingleDatePicker.fragment = __Fragment23;
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-search-form-date-picker-field.tsx
var __Fragment24 = gql31(_templateObject30(), EGDSDateRangePicker.fragment, EGDSSingleDatePicker.fragment);
var EGDSSearchFormDatePickerField = function (props) {
  var setFieldRefByTypename = props.setFieldRefByTypename,
    fieldError = props.fieldError,
    data = props.data,
    dialogId = props.dialogId,
    validDaysUpperBoundInclusive = props.validDaysUpperBoundInclusive,
    overrideErrorMessage = props.overrideErrorMessage,
    priceCalendarProps = props.priceCalendarProps,
    popoverWidth = props.popoverWidth;
  var action = data.action,
    errorMessage = data.errorMessage,
    validations = data.validations;
  var _ref = priceCalendarProps !== null && priceCalendarProps !== void 0 ? priceCalendarProps : {},
    lobName = _ref.lobName,
    enablePriceCalendar = _ref.enablePriceCalendar,
    priceCalendarInputs = _ref.priceCalendarInputs;
  var dialogIdRef = search_form_date_selector_default();
  if ((action === null || action === void 0 ? void 0 : action.__typename) !== "EGDSOpenDatePickerAction") {
    return null;
  }
  var getErrorMessage = function (element) {
    var datePickerValidations = element.validations;
    if ((datePickerValidations === null || datePickerValidations === void 0 ? void 0 : datePickerValidations.sameDate) || (datePickerValidations === null || datePickerValidations === void 0 ? void 0 : datePickerValidations.endDateBeforeStartDate) || (datePickerValidations === null || datePickerValidations === void 0 ? void 0 : datePickerValidations.dateOutsideTripRange)) {
      var _ref;
      return (_ref = overrideErrorMessage !== null && overrideErrorMessage !== void 0 ? overrideErrorMessage : errorMessage) !== null && _ref !== void 0 ? _ref : "";
    }
    if ((datePickerValidations === null || datePickerValidations === void 0 ? void 0 : datePickerValidations.maxDate) && validations && validations[0].__typename === "EGDSMaxLengthInputValidation") {
      var _validations__errorMessage;
      return (_validations__errorMessage = validations[0].errorMessage) !== null && _validations__errorMessage !== void 0 ? _validations__errorMessage : "";
    }
    return "";
  };
  var errorText = fieldError ? getErrorMessage(fieldError) : "";
  var datePickerProps = _object_spread_props(_object_spread({}, props), {
    analytics: action.analytics,
    setFieldRefByTypename: setFieldRefByTypename,
    errorMessage: errorText,
    dialogId: dialogId || dialogIdRef
  });
  switch (action.datePicker.__typename) {
    case "EGDSDateRangePicker":
      return /* @__PURE__ */React37.createElement(EGDSDateRangePicker, _object_spread_props(_object_spread({}, data, datePickerProps), {
        data: action.datePicker,
        validDaysUpperBoundInclusive: validDaysUpperBoundInclusive,
        lobName: lobName,
        enablePriceCalendar: enablePriceCalendar,
        priceCalendarInputs: priceCalendarInputs,
        popoverWidth: popoverWidth
      }));
    case "EGDSSingleDatePicker":
      {
        return /* @__PURE__ */React37.createElement(EGDSSingleDatePicker, _object_spread_props(_object_spread({}, data, datePickerProps), {
          data: action.datePicker,
          lobName: lobName,
          enablePriceCalendar: enablePriceCalendar,
          priceCalendarInputs: priceCalendarInputs
        }));
      }
    default:
      return null;
  }
};
EGDSSearchFormDatePickerField.displayName = "EGDSSearchFormDatePickerField";
EGDSSearchFormDatePickerField.fragment = __Fragment24;
// ../internal/src/components/form/egds-search-form-location-field/egds-search-form-location-field.tsx
import React40 from "react";
import { gql as gql32 } from "@apollo/client";
import { ESSAdapter } from "@egds/react-search-experience";
import { useBexApi as useBexApi5 } from "@shared-ui/bex-api-context";
import { useExperiment as useExperiment2 } from "@shared-ui/experiment-context";
import { useGoogleMapsSdkVersion } from "@shared-ui/retail-map-google-maps-sdk-version-provider";
import { useFormCallback as useFormCallback6 } from "uitk-react-form";
// ../internal/src/components/form/search-location/search-location-event-tracking/utils/optional.tsx
var Optional = /*#__PURE__*/function () {
  "use strict";

  function _Optional(value) {
    _class_call_check(this, _Optional);
    __publicField(this, "value");
    this.value = value;
  }
  _create_class(_Optional, [{
    key: "get",
    value: function get() {
      if (this.isPresent()) {
        return this.value;
      }
      throw new Error("Exception while trying to get the value of an empty Optional");
    }
  }, {
    key: "isPresent",
    value: function isPresent() {
      return !_Optional.isEmpty(this.value);
    }
  }, {
    key: "isNotPresent",
    value: function isNotPresent() {
      return !this.isPresent();
    }
  }, {
    key: "orElse",
    value: function orElse(alt) {
      if (this.isPresent()) {
        return this.value;
      }
      return alt;
    }
  }], [{
    key: "of",
    value: function of(value) {
      if (_Optional.isEmpty(value)) {
        throw new Error("Optional.of doesn't accept undefined or null values. Use Optional.ofNullable instead");
      }
      return new _Optional(value);
    }
  }, {
    key: "ofNullable",
    value: function ofNullable(value) {
      return new _Optional(value);
    }
  }, {
    key: "empty",
    value: function empty() {
      return new _Optional(null);
    }
  }, {
    key: "isEmpty",
    value: function isEmpty(value) {
      return value === null || value === void 0 || typeof value === "undefined";
    }
  }]);
  return _Optional;
}();
// ../internal/src/components/form/search-location/search-location-event-tracking/system-event.tsx
var SystemEvent2 = /*#__PURE__*/function () {
  "use strict";

  function SystemEvent2(level, name) {
    _class_call_check(this, SystemEvent2);
    __publicField(this, "level");
    __publicField(this, "name");
    this.level = level;
    this.name = name;
  }
  _create_class(SystemEvent2, [{
    /**
    * Get a string value of this event safe for Splunk.
    */
    key: "toString",
    value: function toString() {
      return "SystemEvent(level=".concat(this.level.toString(), " name=").concat(this.name, ")");
    }
  }]);
  return SystemEvent2;
}();
// ../internal/src/components/form/search-location/search-location-event-tracking/utils/utils.tsx
var _Utils = /*#__PURE__*/function () {
  "use strict";

  function _Utils() {
    _class_call_check(this, _Utils);
  }
  _create_class(_Utils, null, [{
    key: "init",
    value: function init(clientLogger) {
      if (clientLogger && typeof clientLogger.getLoggerWithIdentifier === "function") {
        var logger = clientLogger.getLoggerWithIdentifier("uitk-react-typeahead");
        if (logger && typeof logger.logEvent === "function") {
          _Utils.logger = logger;
        }
      }
    }
  }, {
    key: "isOrigin",
    value: function isOrigin(domElementId) {
      var elementId = domElementId.toLowerCase();
      return elementId.indexOf("origin") > -1 || elementId.indexOf("from") > -1 || elementId.indexOf("departure") > -1 || elementId.indexOf("drop") > -1 || elementId.indexOf("home") > -1 || elementId.indexOf("loc2") > -1;
    }
  }, {
    key: "isDestination",
    value: function isDestination(domElementId) {
      var elementId = domElementId.toLowerCase();
      return elementId.indexOf("dest") > -1 || elementId.indexOf("to") > -1 || elementId.indexOf("arrival") > -1 || elementId.indexOf("near") > -1 || elementId.indexOf("pick") > -1 || elementId.indexOf("location") === 0;
    }
  }, {
    key: "getDomElement",
    value: function getDomElement() {
      var _document_querySelector;
      var element = (_document_querySelector = document.querySelector("#search-location-input-field")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.getElementsByTagName("input")[0];
      if (!element) {
        _Utils.logError({
          message: "Failed to retrieve data for the typeahead UI component"
        });
      }
      return element;
    }
  }, {
    key: "logError",
    value: function logError(error) {
      try {
        if (_Utils.logger) {
          var errorToLog = error.stack ? {
            message: error.message,
            stack: error.stack
          } : error;
          _Utils.logger.logEvent(new SystemEvent2("ERROR" /* ERROR */, "TypeaheadLoggingError"), errorToLog);
        }
      } catch (e) {
        console.error("unable to log errors from typeaheadCustom logger. Reason:".concat(e));
      }
    }
  }, {
    key: "getInputElementId",
    value: function getInputElementId(inputEl) {
      var id;
      if (inputEl) {
        id = inputEl.getAttribute("data-stid");
        if (!id) {
          _Utils.logError({
            message: "Failed to retrieve input element id from 'data-stid'"
          });
        }
      }
      return id || _Utils.UNKNOWN;
    }
  }, {
    key: "getSubLob",
    value: function getSubLob(lob, sublob) {
      var updatedSublob = sublob;
      if (!sublob) {
        var usp = new URLSearchParams(window.location.search);
        updatedSublob = usp.get("pwaSubLOB") || "";
      }
      updatedSublob = updatedSublob === null || updatedSublob === void 0 ? void 0 : updatedSublob.toLowerCase();
      switch (lob.toLowerCase()) {
        case "flights":
          switch (updatedSublob) {
            case "oneway":
              return "OW";
            case "multicity":
              return "MD";
            default:
              return "RT";
          }
        case "packages":
          switch (updatedSublob) {
            case "fhc":
              return "FHC";
            case "hc":
              return "HC";
            case "fc":
              return "FC";
            default:
              return "FH";
          }
        default:
          return "";
      }
    }
  }]);
  return _Utils;
}();
__publicField(_Utils, "UNKNOWN", "UNKNOWN");
__publicField(_Utils, "logger");
var Utils = _Utils;
// ../internal/src/components/form/search-location/search-location-event-tracking/recommendation-event.tsx
var EVENT_VERSION = "2.1.0";
var EVENT_CATEGORY = "Search";
var RECOMMENDATION_TITLE_DEFAULT = {
  ALTERNATE: "People also searched",
  POPULAR: "Popular destinations"
};
var RECOMMENDATION_CATEGORIES = ["POPULAR", "ALTERNATE"];
var RecommendationEvent = /*#__PURE__*/function () {
  "use strict";

  function RecommendationEvent() {
    _class_call_check(this, RecommendationEvent);
  }
  _create_class(RecommendationEvent, null, [{
    key: "getRecommendationSeenMessage",
    value: function getRecommendationSeenMessage(response, elementName) {
      var _response_sr;
      if ((response === null || response === void 0 ? void 0 : (_response_sr = response.sr) === null || _response_sr === void 0 ? void 0 : _response_sr.length) > 0) {
        var recommendedSuggestions = response.sr.filter(function (sr) {
          return RECOMMENDATION_CATEGORIES.includes(sr.category);
        });
        if (recommendedSuggestions && (recommendedSuggestions === null || recommendedSuggestions === void 0 ? void 0 : recommendedSuggestions.length) > 0) {
          return {
            event: {
              event_name: "recommendations_module.presented" /* SEEN */,
              event_type: "Impression" /* SEEN */,
              event_version: EVENT_VERSION,
              event_category: EVENT_CATEGORY,
              action_location: elementName
            },
            recommendation_module: {
              recommendation_title: this.getRecommendationTitle(recommendedSuggestions[0].category),
              eg_recommendation_response_id: this.getEgRecommendationResponseId(response.recId),
              recommendations: this.getRecommendations(recommendedSuggestions)
            }
          };
        }
      }
      return void 0;
    }
  }, {
    key: "getRecommendationClickedMessage",
    value: function getRecommendationClickedMessage(selected, response, elementName) {
      if (selected && RECOMMENDATION_CATEGORIES.includes(selected.category)) {
        var _response_sr;
        var rank = selected.index;
        if ((response === null || response === void 0 ? void 0 : (_response_sr = response.sr) === null || _response_sr === void 0 ? void 0 : _response_sr.length) > 0) {
          var recommendations = response.sr.filter(function (sr) {
            return sr.category === selected.category;
          });
          for (var i = 0; i < (recommendations === null || recommendations === void 0 ? void 0 : recommendations.length); i += 1) {
            var _recommendations_i_essId, _selected_essId;
            if (((_recommendations_i_essId = recommendations[i].essId) === null || _recommendations_i_essId === void 0 ? void 0 : _recommendations_i_essId.sourceId) === ((_selected_essId = selected.essId) === null || _selected_essId === void 0 ? void 0 : _selected_essId.sourceId)) {
              rank = i;
              break;
            }
          }
        }
        return {
          event: {
            event_name: "recommendations_module.selected" /* CLICK */,
            event_type: "Interaction" /* CLICK */,
            event_version: EVENT_VERSION,
            event_category: EVENT_CATEGORY,
            action_location: elementName
          },
          recommendation_module: {
            recommendation_title: this.getRecommendationTitle(selected.category),
            eg_recommendation_response_id: this.getEgRecommendationResponseId(response.recId),
            recommendations: this.getSelectedRecommendations(selected, rank)
          }
        };
      }
      return void 0;
    }
  }, {
    key: "getEgRecommendationResponseId",
    value: function getEgRecommendationResponseId(responseId) {
      if (responseId) {
        this.egRecommendationResponseId = responseId;
      }
      return this.egRecommendationResponseId;
    }
  }, {
    key: "getRecommendationTitle",
    value: function getRecommendationTitle(recommendationType) {
      if (!this.recommendationTitle) {
        this.recommendationTitle = RECOMMENDATION_TITLE_DEFAULT[recommendationType];
      }
      return this.recommendationTitle;
    }
  }, {
    key: "getRecommendations",
    value: function getRecommendations(results) {
      var _this = this;
      var recommendations = [];
      var trueIndex = 0;
      if (results && (results === null || results === void 0 ? void 0 : results.length) > 0) {
        results.forEach(function (resultItem) {
          recommendations.push(_this.getRecommendation(resultItem, trueIndex));
          trueIndex += 1;
        });
        recommendations.push();
      }
      return recommendations;
    }
  }, {
    key: "getSelectedRecommendations",
    value: function getSelectedRecommendations(result, rank) {
      var recommendations = [];
      if (result) {
        recommendations.push(this.getRecommendation(result, rank));
      }
      return recommendations;
    }
  }, {
    key: "getRecommendation",
    value: function getRecommendation(resultItem, rank) {
      var _resultItem_essId;
      return {
        recommendation_id: (_resultItem_essId = resultItem.essId) === null || _resultItem_essId === void 0 ? void 0 : _resultItem_essId.sourceId,
        recommendation_position: rank.toString(),
        presentation_details_recommendation_name: resultItem.regionNames.primaryDisplayName
      };
    }
  }]);
  return RecommendationEvent;
}();
__publicField(RecommendationEvent, "recommendationTitle");
__publicField(RecommendationEvent, "egRecommendationResponseId");
// ../internal/src/components/form/search-location/search-location-event-tracking/search-location-event.tsx
var EVENT_VERSION2 = "1.0.0";
var SearchLocationEvent = /*#__PURE__*/function () {
  "use strict";

  function SearchLocationEvent(session) {
    _class_call_check(this, SearchLocationEvent);
    __publicField(this, "session");
    this.session = session;
  }
  _create_class(SearchLocationEvent, [{
    key: "getOpenEventPayload",
    value: function getOpenEventPayload() {
      var _this_session_input;
      this.session.focusTime = performance.now();
      return {
        event: {
          event_name: "search_location.opened" /* OPEN */,
          event_type: "Interaction" /* INTERACTION */,
          event_version: EVENT_VERSION2,
          event_category: "Search",
          action_location: this.session.fieldName
        },
        search_request: {
          search_query: ((_this_session_input = this.session.input) === null || _this_session_input === void 0 ? void 0 : _this_session_input.value) || ""
        },
        typeahead: {
          search_field: this.getSearchField(this.session.fieldName),
          line_of_business: this.session.metadata.lob + this.getSublob(this.session.metadata.lob, this.session.metadata.subLob)
        }
      };
    }
  }, {
    key: "getCloseEventPayload",
    value: function getCloseEventPayload() {
      var _this_session_response_sr, _this_session_response, _this_session_query;
      return {
        event: {
          event_name: "search_location.closed" /* CLOSE */,
          event_type: "Interaction" /* INTERACTION */,
          event_version: EVENT_VERSION2,
          event_category: "Search",
          action_location: this.session.fieldName
        },
        search_request: {
          search_query: this.session.query === this.session.prefill ? "" : this.session.query || ""
        },
        typeahead: {
          search_field: this.getSearchField(this.session.fieldName),
          backspaces_count: this.session.noOfBackspaces,
          suggestion_list: ((_this_session_response = this.session.response) === null || _this_session_response === void 0 ? void 0 : (_this_session_response_sr = _this_session_response.sr) === null || _this_session_response_sr === void 0 ? void 0 : _this_session_response_sr.length) ? this.getSuggestionList(this.session.response.sr) : [],
          line_of_business: this.session.metadata.lob + this.getSublob(this.session.metadata.lob, this.session.metadata.subLob),
          typeahead_selection_bool: !!this.session.selected,
          focus_to_blur_time: this.calculateTimeSpendOnTypeaheadInput().toString(),
          characters_typed_count: (_this_session_query = this.session.query) === null || _this_session_query === void 0 ? void 0 : _this_session_query.length
        }
      };
    }
  }, {
    key: "getSelectEventPayload",
    value: function getSelectEventPayload(isCurrLoc) {
      var _this_session_selected, _this_session_response, _this_session_response_sr, _this_session_response1, _this_session_response_sr1, _this_session_response2, _this_session_response_sr2, _this_session_response3;
      if (isCurrLoc) {
        var _this_session_response4, _this_session_response_sr3, _this_session_response5, _this_session_response_sr4, _this_session_response6;
        var _this_session_response_rid, _this_session_response_sr_length;
        return {
          event: {
            event_name: "search_location.selected" /* SELECT */,
            event_type: "Interaction" /* INTERACTION */,
            event_version: EVENT_VERSION2,
            event_category: "Search",
            action_location: this.session.fieldName
          },
          search_request: {
            search_query: this.session.query === this.session.prefill ? "" : this.session.query || "",
            search_id: (_this_session_response_rid = (_this_session_response4 = this.session.response) === null || _this_session_response4 === void 0 ? void 0 : _this_session_response4.rid) !== null && _this_session_response_rid !== void 0 ? _this_session_response_rid : null
          },
          destination: {
            destination_full_name: "CurrentLocation",
            destination_geo_id: "",
            destination_type: "CurrentLocation" /* CURRENT_LOCATION */
          },
          typeahead: {
            search_field: this.getSearchField(this.session.fieldName),
            backspaces_count: this.session.noOfBackspaces,
            selection_depth: 1,
            suggestion_count: (_this_session_response_sr_length = (_this_session_response5 = this.session.response) === null || _this_session_response5 === void 0 ? void 0 : (_this_session_response_sr3 = _this_session_response5.sr) === null || _this_session_response_sr3 === void 0 ? void 0 : _this_session_response_sr3.length) !== null && _this_session_response_sr_length !== void 0 ? _this_session_response_sr_length : null,
            suggestion_type: "CurrentLocation" /* CURRENT_LOCATION */,
            suggestion_list: ((_this_session_response6 = this.session.response) === null || _this_session_response6 === void 0 ? void 0 : (_this_session_response_sr4 = _this_session_response6.sr) === null || _this_session_response_sr4 === void 0 ? void 0 : _this_session_response_sr4.length) ? this.getSuggestionList(this.session.response.sr) : [],
            line_of_business: this.session.metadata.lob + this.getSublob(this.session.metadata.lob, this.session.metadata.subLob)
          }
        };
      }
      var selectionDepth = null;
      if (((_this_session_selected = this.session.selected) === null || _this_session_selected === void 0 ? void 0 : _this_session_selected.displayType) === "CATEGORIZED") {
        selectionDepth = parseInt(this.session.selected.index, 10);
      } else if (this.session.selected) {
        selectionDepth = parseInt(this.session.selected.index, 10) + 1;
      }
      var _this_session_response_rid1, _this_session_response_sr_length1;
      return {
        event: {
          event_name: "search_location.selected" /* SELECT */,
          event_type: "Interaction" /* INTERACTION */,
          event_version: EVENT_VERSION2,
          event_category: "Search",
          action_location: this.session.fieldName
        },
        search_request: {
          search_query: this.session.query === this.session.prefill ? "" : this.session.query || "",
          search_id: (_this_session_response_rid1 = (_this_session_response = this.session.response) === null || _this_session_response === void 0 ? void 0 : _this_session_response.rid) !== null && _this_session_response_rid1 !== void 0 ? _this_session_response_rid1 : null
        },
        destination: this.session.selected ? this.getDestinationField() : null,
        typeahead: {
          search_field: this.getSearchField(this.session.fieldName),
          backspaces_count: this.session.noOfBackspaces,
          selection_depth: selectionDepth,
          suggestion_count: (_this_session_response_sr_length1 = (_this_session_response1 = this.session.response) === null || _this_session_response1 === void 0 ? void 0 : (_this_session_response_sr = _this_session_response1.sr) === null || _this_session_response_sr === void 0 ? void 0 : _this_session_response_sr.length) !== null && _this_session_response_sr_length1 !== void 0 ? _this_session_response_sr_length1 : null,
          suggestion_type: ((_this_session_response2 = this.session.response) === null || _this_session_response2 === void 0 ? void 0 : (_this_session_response_sr1 = _this_session_response2.sr) === null || _this_session_response_sr1 === void 0 ? void 0 : _this_session_response_sr1.length) ? this.getSuggestionType(this.session.response.sr[0].category) : null,
          suggestion_list: ((_this_session_response3 = this.session.response) === null || _this_session_response3 === void 0 ? void 0 : (_this_session_response_sr2 = _this_session_response3.sr) === null || _this_session_response_sr2 === void 0 ? void 0 : _this_session_response_sr2.length) ? this.getSuggestionList(this.session.response.sr) : [],
          line_of_business: this.session.metadata.lob + this.getSublob(this.session.metadata.lob, this.session.metadata.subLob)
        }
      };
    }
  }, {
    key: "getSearchField",
    value: function getSearchField(domElementId) {
      if (!domElementId) {
        return "UNKNOWN" /* UNKNOWN */;
      }
      if (Utils.isOrigin(domElementId)) {
        return "Origin" /* ORIGIN */;
      }
      if (Utils.isDestination(domElementId)) {
        return "Destination" /* DESTINATION */;
      }
      return "UNKNOWN" /* UNKNOWN */;
    }
  }, {
    key: "getDestinationField",
    value: function getDestinationField() {
      var _this_session_selected_regionNames;
      return {
        destination_full_name: (_this_session_selected_regionNames = this.session.selected.regionNames) === null || _this_session_selected_regionNames === void 0 ? void 0 : _this_session_selected_regionNames.lastSearchName,
        destination_geo_id: this.getSourceId(this.session.selected),
        destination_geo_system: this.getSourceSystem(this.session.selected),
        destination_type: this.session.selected.type
      };
    }
  }, {
    key: "getSourceId",
    value: function getSourceId(s) {
      var _s_essId;
      return s.sourceId || ((_s_essId = s.essId) === null || _s_essId === void 0 ? void 0 : _s_essId.sourceId) || s.hotelId || s.gaiaId || Utils.UNKNOWN;
    }
  }, {
    key: "getSourceSystem",
    value: function getSourceSystem(s) {
      var _s_essId;
      var sourceName = s.sourceName || ((_s_essId = s.essId) === null || _s_essId === void 0 ? void 0 : _s_essId.sourceName) || (s.hotelId ? "LCM" : s.gaiaId ? "GAI" : "");
      switch (sourceName) {
        case "GAI":
          return "GAIA" /* GAIA */;
        case "LCM":
          return "LCM" /* LCM */;
        case "GPA":
          return "GOOGLE" /* GOOGLE */;
        default:
          return sourceName || "UNKNOWN" /* UNKNOWN */;
      }
    }
  }, {
    key: "getSuggestionType",
    value: function getSuggestionType(category) {
      switch (category) {
        case "GOOGLEMAPS":
          return "Google" /* GOOGLE */;
        case "USERHISTORY":
          return "RecentHistory" /* RECENT_HISTORY */;
        case "ALTERNATE":
          return "Alternate" /* ALTERNATE */;
        case "POPULAR":
          return "Popular" /* POPULAR */;
        case "CURRENTLOCATION":
          return "CurrentLocation" /* CURRENT_LOCATION */;
        default:
          return "Normal" /* NORMAL */;
      }
    }
  }, {
    key: "getSuggestionList",
    value: function getSuggestionList(suggestions) {
      var _this = this;
      return suggestions.map(function (suggestion) {
        var _suggestion_hierarchyInfo_relation, _suggestion_hierarchyInfo;
        var suggId = {
          destination_geo_id: _this.getSourceId(suggestion),
          destination_geo_system: _this.getSourceSystem(suggestion),
          destination_type: _this.getDestinationType(suggestion.type),
          reason: ((_suggestion_hierarchyInfo = suggestion.hierarchyInfo) === null || _suggestion_hierarchyInfo === void 0 ? void 0 : (_suggestion_hierarchyInfo_relation = _suggestion_hierarchyInfo.relation) === null || _suggestion_hierarchyInfo_relation === void 0 ? void 0 : _suggestion_hierarchyInfo_relation.length) ? suggestion.hierarchyInfo.relation[0] : null
        };
        return suggId;
      });
    }
  }, {
    key: "getDestinationType",
    value: function getDestinationType(s) {
      switch (s) {
        case "MULTICITY":
          return "MULTI_CITY" /* MULTICITY */;
        case "MULTIREGION":
          return "REGION" /* REGION */;
        case "METROCODE":
          return "REGION" /* REGION */;
        case "TRAINSTATION":
          return "TRAIN_STATION" /* TRAIN_STATION */;
        case "METROSTATION":
          return "METRO_STATION" /* METRO_STATION */;
        case "PREMISE":
          return "LANDMARK" /* LANDMARK */;
        case "POI":
          return "LANDMARK" /* LANDMARK */;
        case "ADDRESS":
          return "LANDMARK" /* LANDMARK */;
        case "LISTING":
          return "HOTEL" /* HOTEL */;
        default:
          return s;
      }
    }
  }, {
    key: "getSublob",
    value: function getSublob(lob, sublob) {
      var updatedSublob = Utils.getSubLob(lob, sublob);
      return updatedSublob ? ".".concat(updatedSublob) : "";
    }
  }, {
    /*
    This method is used to calculate the time spent by user on typeahead input box
    It first calculate the timestamp and store it in case of blur event only.
    */
    key: "calculateTimeSpendOnTypeaheadInput",
    value: function calculateTimeSpendOnTypeaheadInput() {
      var focus = this.session.focusTime;
      return focus ? performance.now() - focus : -1;
    }
  }]);
  return SearchLocationEvent;
}();
// ../internal/src/components/form/search-location/search-location-event-tracking/search-location-event-tracker.tsx
var _SearchLocationEventTracker = /*#__PURE__*/function () {
  "use strict";

  function _SearchLocationEventTracker() {
    _class_call_check(this, _SearchLocationEventTracker);
    __publicField(this, "metadata");
    __publicField(this, "prevResponse");
    __publicField(this, "response");
    __publicField(this, "shownResponse");
    if (!_SearchLocationEventTracker.sessionStore) {
      this.initSessionStore();
    }
  }
  _create_class(_SearchLocationEventTracker, [{
    key: "initMetadata",
    value: function initMetadata(metadata) {
      this.metadata = metadata;
    }
  }, {
    key: "recordRequest",
    value: function recordRequest(query) {
      _SearchLocationEventTracker.sessionStore.query = query;
    }
  }, {
    key: "recordResponse",
    value: function recordResponse(response) {
      this.prevResponse = this.response;
      this.response = response;
    }
  }, {
    key: "getRecommendationPresentedPayload",
    value: function getRecommendationPresentedPayload(query) {
      var _this_response_q, _this_response, _this_prevResponse_q, _this_prevResponse;
      if ((_this_response = this.response) === null || _this_response === void 0 ? void 0 : (_this_response_q = _this_response.q) === null || _this_response_q === void 0 ? void 0 : _this_response_q.includes(query)) {
        this.shownResponse = this.response;
      } else if ((_this_prevResponse = this.prevResponse) === null || _this_prevResponse === void 0 ? void 0 : (_this_prevResponse_q = _this_prevResponse.q) === null || _this_prevResponse_q === void 0 ? void 0 : _this_prevResponse_q.includes(query)) {
        this.shownResponse = this.prevResponse;
      } else {
        return void 0;
      }
      _SearchLocationEventTracker.sessionStore.response = this.shownResponse;
      _SearchLocationEventTracker.sessionStore.selected = void 0;
      var recEventMessage = RecommendationEvent.getRecommendationSeenMessage(this.shownResponse, _SearchLocationEventTracker.sessionStore.fieldName || "");
      return recEventMessage;
    }
  }, {
    key: "getOpenEventPayload",
    value: function getOpenEventPayload(prefill) {
      this.initEventData();
      _SearchLocationEventTracker.sessionStore.prefill = prefill;
      return new SearchLocationEvent(_SearchLocationEventTracker.sessionStore).getOpenEventPayload();
    }
  }, {
    key: "getSelectEventPayloads",
    value: function getSelectEventPayloads(selected) {
      var updatedSelected = selected;
      if (this.shownResponse && updatedSelected) {
        if (updatedSelected.displayType === "CATEGORIZED") {
          updatedSelected.index += 1;
        }
        var isCurrLoc = (updatedSelected === null || updatedSelected === void 0 ? void 0 : updatedSelected.type) === "CURRENT_LOCATION";
        if (Optional.ofNullable(updatedSelected).isPresent() && this.essResponseIsNotEmpty()) {
          _SearchLocationEventTracker.sessionStore.selected = _SearchLocationEventTracker.sessionStore.response.sr[updatedSelected.index - 1];
        }
        var selectEvent = new SearchLocationEvent(_SearchLocationEventTracker.sessionStore).getSelectEventPayload(isCurrLoc);
        var recEvent = RecommendationEvent.getRecommendationClickedMessage(_SearchLocationEventTracker.sessionStore.selected, _SearchLocationEventTracker.sessionStore.response, _SearchLocationEventTracker.sessionStore.fieldName || "");
        this.resetResponse();
        return {
          selectPayload: selectEvent,
          recommendationSelectPayload: recEvent
        };
      }
      return void 0;
    }
  }, {
    key: "getCloseEventPayload",
    value: function getCloseEventPayload() {
      var _SearchLocationEventTracker_sessionStore_input;
      var closePayload = new SearchLocationEvent(_SearchLocationEventTracker.sessionStore).getCloseEventPayload();
      _SearchLocationEventTracker.sessionStore.noOfBackspaces = 0;
      (_SearchLocationEventTracker_sessionStore_input = _SearchLocationEventTracker.sessionStore.input) === null || _SearchLocationEventTracker_sessionStore_input === void 0 ? void 0 : _SearchLocationEventTracker_sessionStore_input.removeEventListener("keydown", this.keyDown);
      this.resetResponse();
      return closePayload;
    }
  }, {
    /** ********* Util methods ************/key: "essResponseIsNotEmpty",
    value: function essResponseIsNotEmpty() {
      var _SearchLocationEventTracker_sessionStore_response_sr, _SearchLocationEventTracker_sessionStore_response, _SearchLocationEventTracker_sessionStore;
      return ((_SearchLocationEventTracker_sessionStore = _SearchLocationEventTracker.sessionStore) === null || _SearchLocationEventTracker_sessionStore === void 0 ? void 0 : (_SearchLocationEventTracker_sessionStore_response = _SearchLocationEventTracker_sessionStore.response) === null || _SearchLocationEventTracker_sessionStore_response === void 0 ? void 0 : (_SearchLocationEventTracker_sessionStore_response_sr = _SearchLocationEventTracker_sessionStore_response.sr) === null || _SearchLocationEventTracker_sessionStore_response_sr === void 0 ? void 0 : _SearchLocationEventTracker_sessionStore_response_sr.length) > 0;
    }
  }, {
    key: "keyDown",
    value: function keyDown(event) {
      if (event.key && ["Delete", "Backspace"].indexOf(event.key) > -1 || event.keyCode && [8, 46].indexOf(event.keyCode) > -1) {
        _SearchLocationEventTracker.sessionStore.noOfBackspaces += 1;
      }
    }
  }, {
    key: "initEventData",
    value: function initEventData() {
      this.initSessionStore();
      var _this_metadata = this.metadata,
        subLob = _this_metadata.subLob,
        lob = _this_metadata.lob;
      _SearchLocationEventTracker.sessionStore.metadata = {
        subLob: subLob,
        lob: lob
      };
      if (!lob) {
        _SearchLocationEventTracker.sessionStore.metadata.lob = Utils.UNKNOWN;
      }
      this.initializeInputField();
    }
  }, {
    key: "initializeInputField",
    value: function initializeInputField() {
      var _SearchLocationEventTracker_sessionStore_input, _SearchLocationEventTracker_sessionStore_input1;
      _SearchLocationEventTracker.sessionStore.input = Utils.getDomElement();
      _SearchLocationEventTracker.sessionStore.fieldName = Utils.getInputElementId(_SearchLocationEventTracker.sessionStore.input);
      (_SearchLocationEventTracker_sessionStore_input = _SearchLocationEventTracker.sessionStore.input) === null || _SearchLocationEventTracker_sessionStore_input === void 0 ? void 0 : _SearchLocationEventTracker_sessionStore_input.removeEventListener("keydown", this.keyDown);
      (_SearchLocationEventTracker_sessionStore_input1 = _SearchLocationEventTracker.sessionStore.input) === null || _SearchLocationEventTracker_sessionStore_input1 === void 0 ? void 0 : _SearchLocationEventTracker_sessionStore_input1.addEventListener("keydown", this.keyDown);
    }
  }, {
    key: "initSessionStore",
    value: function initSessionStore() {
      _SearchLocationEventTracker.sessionStore = {
        metadata: {
          lob: Utils.UNKNOWN
        },
        noOfBackspaces: 0,
        query: ""
      };
    }
  }, {
    key: "resetResponse",
    value: function resetResponse() {
      this.prevResponse = void 0;
      this.response = void 0;
      this.shownResponse = void 0;
    }
  }]);
  return _SearchLocationEventTracker;
}();
__publicField(_SearchLocationEventTracker, "sessionStore");
var SearchLocationEventTracker = _SearchLocationEventTracker;
// ../internal/src/components/form/egds-search-form-location-field/location-field.tsx
import React38 from "react";
import { TypeaheadCustom, TypeaheadCustomWithoutCSS, TypeaheadLocationType } from "@egds/react-search-experience";
import { IntersectionTracker as IntersectionTracker2, useClickTracker as useClickTracker13, useEgClickstream } from "@shared-ui/clickstream-analytics-context";
import { useLocalization as useLocalization4 } from "@shared-ui/localization-context";
import { useLoggerEvents } from "@shared-ui/logger-context";
import { useSearchFormReflectionContext as useSearchFormReflectionContext3 } from "@shared-ui/retail-search-tools-reflection-provider";
import { useSignalSubscriber } from "@shared-ui/signal-events-context";
// ../internal/src/utils/logger-utils.ts
import { SystemEvent as SystemEvent3, SystemEventLevel as SystemEventLevel3 } from "@shared-ui/logger-context";
var LOGGER_EVENTS = {
  SEARCH_LOCATION_TYPEAHEAD_DURATION: new SystemEvent3(SystemEventLevel3.INFO, "SEARCH_LOCATION_TYPEAHEAD_DURATION")
};
var jsonStringifyWithFormatForLogging = function () {
  var obj = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return JSON.stringify(obj).replaceAll(":", "=").replaceAll('"', "");
};
// ../internal/src/utils/signal-subscribers.ts
var LOCATION_FIELD_UPDATE_SIGNAL_TYPE = "SEARCH_FORM_LOCATION_FIELD_UPDATE";
var locationFieldUpdateSubscriber = function (callback) {
  return {
    query: {
      type: LOCATION_FIELD_UPDATE_SIGNAL_TYPE
    },
    onSignal: function (param) {
      var tmp = param.payload,
        locationValue = (tmp === void 0 ? {} : tmp).locationValue;
      if (typeof locationValue !== "string") {
        return;
      }
      callback({
        term: locationValue,
        data: {}
      });
    }
  };
};
// ../internal/src/components/form/egds-search-form-location-field/location-field.tsx
var DISPLAY_NAME9 = "EGDSSearchFormLocationField";
var LOCATION_NAME_PREFIX = "".concat(DISPLAY_NAME9, "-Location");
var REGION_ID_NAME_PREFIX = "".concat(DISPLAY_NAME9, "-RegionId");
var AIRPORT_CODE_NAME_PREFIX = "".concat(DISPLAY_NAME9, "-AirportCode");
var LAT_NAME_PREFIX = "".concat(DISPLAY_NAME9, "-Lat");
var LONG_NAME_PREFIX = "".concat(DISPLAY_NAME9, "-Long");
var SELECTED_PREFIX = "".concat(DISPLAY_NAME9, "-Selected");
var AMENITIES_GROUP_PREFIX = "".concat(DISPLAY_NAME9, "-AmenitiesFacilitiesGroup");
var LOCATION_GROUP_PREFIX = "".concat(DISPLAY_NAME9, "-LocGroup");
var PROPERTIES_GOOD_FOR_GROUP_PREFIX = "".concat(DISPLAY_NAME9, "-PropertiesGoodForGroup");
var PROPERTY_TYPE_GROUP_PREFIX = "".concat(DISPLAY_NAME9, "-PropertyTypeGroup");
var DESTINATION_ID_NAME_PREFIX = "".concat(DISPLAY_NAME9, "-DestinationId");
var PROPERTY_ID_NAME_PREFIX = "".concat(DISPLAY_NAME9, "-PropertyId");
var PROPERTY_FILTER_NAME_PREFIX = "".concat(DISPLAY_NAME9, "-PropertyFilter");
var LocationField = function (props) {
  var _currentSelection_data_regionNames, _currentSelection_data, _currentSelection_data_listing, _currentSelection_data1, _currentSelection_data2;
  var egdsElementId = props.egdsElementId,
    essAdapter = props.essAdapter,
    label = props.label,
    placeholder = props.placeholder,
    icon = props.icon,
    value = props.value,
    accessibility = props.accessibility,
    errorText = props.errorText,
    required = props.required,
    emptyResultsPlaceholder = props.emptyResultsPlaceholder,
    setFieldRefByTypename = props.setFieldRefByTypename,
    __typename = props.__typename,
    analyticsLinkName = props.analyticsLinkName,
    analyticsReferrerId = props.analyticsReferrerId,
    closeAnalyticsLinkName = props.closeAnalyticsLinkName,
    changeAnalyticsLinkName = props.changeAnalyticsLinkName,
    changeAnalyticsReferrerId = props.changeAnalyticsReferrerId,
    closeAnalyticsReferrerId = props.closeAnalyticsReferrerId,
    categorize = props.categorize,
    allowExactMatch = props.allowExactMatch,
    listTitle = props.listTitle,
    handleResultSelection = props.handleResultSelection,
    onSelection = props.onSelection,
    selection = props.selection,
    index = props.index,
    initialRegionId = props.regionId,
    skipQuery = props.skipQuery,
    valueFromQueryParam = props.valueFromQueryParam,
    initialSelected = props.pinnedPropertyId,
    alternativeLocationLabel = props.alternativeLocationLabel,
    propertyRefinements = props.propertyRefinements,
    isDestination = props.isDestination,
    skipReflection = props.skipReflection,
    onOpenLocationField = props.onOpenLocationField,
    _props_debounceRate = props.debounceRate,
    debounceRate = _props_debounceRate === void 0 ? 200 : _props_debounceRate,
    allowToRemoveRecentSearches = props.allowToRemoveRecentSearches,
    withoutCustomStyling = props.withoutCustomStyling,
    onDismissLocation = props.onDismissLocation,
    showCurrentLocation = props.showCurrentLocation,
    searchLocationAnalytics = props.searchLocationAnalytics,
    _props_isPopularFiltersPlaybackEnabled = props.isPopularFiltersPlaybackEnabled,
    isPopularFiltersPlaybackEnabled = _props_isPopularFiltersPlaybackEnabled === void 0 ? false : _props_isPopularFiltersPlaybackEnabled,
    onType = props.onType,
    predictiveText = props.predictiveText,
    eventTracker2 = props.eventTracker;
  var _useSearchFormReflectionContext3 = useSearchFormReflectionContext3(),
    state = _useSearchFormReflectionContext3.state,
    dispatch = _useSearchFormReflectionContext3.dispatch;
  var reflectionDestination = state.destination,
    reflectionOrigin = state.origin;
  var localizationContext = useLocalization4();
  var formatDateString = localizationContext.formatDateString;
  var systemEvents = useLoggerEvents(LOGGER_EVENTS);
  var resultsRequestDurationTimeCallback = function (duration, hasSearchTerm) {
    systemEvents.SEARCH_LOCATION_TYPEAHEAD_DURATION.log(jsonStringifyWithFormatForLogging({
      withSearchTerm: hasSearchTerm,
      siteId: essAdapter.config.siteId,
      duration: duration.toFixed(0),
      lob: essAdapter.config.lob
    }));
  };
  var defaultSelection = React38.useMemo(function () {
    var _essAdapter_config_lastSearchLatLong, _essAdapter_config;
    if (!skipReflection && isDestination && reflectionDestination) {
      return reflectionDestination;
    }
    if (!skipReflection && !isDestination && reflectionOrigin) {
      return reflectionOrigin;
    }
    var _ref = _sliced_to_array((essAdapter === null || essAdapter === void 0 ? void 0 : (_essAdapter_config = essAdapter.config) === null || _essAdapter_config === void 0 ? void 0 : (_essAdapter_config_lastSearchLatLong = _essAdapter_config.lastSearchLatLong) === null || _essAdapter_config_lastSearchLatLong === void 0 ? void 0 : _essAdapter_config_lastSearchLatLong.split(",")) || ["", ""], 2),
      latitude = _ref[0],
      longitude = _ref[1];
    return {
      term: value,
      data: {
        type: void 0,
        regionId: initialRegionId,
        hierarchyInfo: {
          airport: {
            airportCode: "",
            airportId: ""
          }
        },
        location: {
          lat: latitude,
          long: longitude
        },
        selected: initialSelected !== null && initialSelected !== void 0 ? initialSelected : void 0,
        regionNames: {
          fullName: value
        },
        cityId: ""
      }
    };
  }, [value, initialRegionId, initialSelected, isDestination]);
  var _React38_useState = _sliced_to_array(React38.useState(defaultSelection), 2),
    currentSelection = _React38_useState[0],
    setCurrentSelection = _React38_useState[1];
  var _React38_useState1 = _sliced_to_array(React38.useState(currentSelection.term && alternativeLocationLabel ? alternativeLocationLabel : label), 2),
    displayLabel = _React38_useState1[0],
    setDisplayLabel = _React38_useState1[1];
  React38.useEffect(function () {
    if (defaultSelection.term != null && !skipQuery) {
      setCurrentSelection(defaultSelection);
    }
  }, [defaultSelection, skipQuery]);
  React38.useEffect(function () {
    if (!skipReflection && !isDestination && reflectionOrigin) {
      setCurrentSelection(reflectionOrigin);
    }
    if (!skipReflection && isDestination && reflectionDestination) {
      setCurrentSelection(reflectionDestination);
    }
  }, [skipReflection, reflectionOrigin, reflectionDestination]);
  React38.useEffect(function () {
    var _essAdapter_config = essAdapter.config,
      lob = _essAdapter_config.lob,
      subLob = _essAdapter_config.subLob;
    eventTracker2.initMetadata({
      lob: lob,
      subLob: subLob
    });
  }, [essAdapter.config]);
  var track = useClickTracker13();
  var trackClickstream = useEgClickstream();
  var _ref = searchLocationAnalytics !== null && searchLocationAnalytics !== void 0 ? searchLocationAnalytics : {},
    open = _ref.open,
    close = _ref.close,
    itemSelected = _ref.itemSelected,
    recommendationSelected = _ref.recommendationSelected,
    recommendationsPresented = _ref.recommendationsPresented;
  var handleClick = function (eventInfo) {
    if (onOpenLocationField) {
      var _essAdapter_config_subLob;
      onOpenLocationField({
        isDestination: isDestination,
        lineOfBusiness: essAdapter.config.lob,
        subLineOfBusiness: (_essAdapter_config_subLob = essAdapter.config.subLob) !== null && _essAdapter_config_subLob !== void 0 ? _essAdapter_config_subLob : ""
      });
    }
    if (analyticsReferrerId !== "" || analyticsLinkName !== "") {
      track(analyticsReferrerId, analyticsLinkName);
    }
    if (open) {
      setTimeout(function () {
        var openPayload = eventTracker2.getOpenEventPayload(eventInfo === null || eventInfo === void 0 ? void 0 : eventInfo.prefillText);
        trackClickstream({
          serverPayload: open,
          clientPayload: openPayload
        });
      });
    }
  };
  var handleMountCB = React38.useCallback(function (ref) {
    return setFieldRefByTypename(__typename, ref);
  }, [setFieldRefByTypename, __typename]);
  React38.useEffect(function () {
    if ((selection === null || selection === void 0 ? void 0 : selection.term) && selection.term !== currentSelection.term) {
      setCurrentSelection(selection);
    }
    if (valueFromQueryParam && valueFromQueryParam !== currentSelection.term) {
      setCurrentSelection(function (prevState) {
        return _object_spread_props(_object_spread({}, prevState), {
          term: valueFromQueryParam
        });
      });
      if (onSelection) {
        onSelection({
          data: currentSelection.data,
          term: valueFromQueryParam
        });
      }
    }
  }, [selection, valueFromQueryParam]);
  var _ref1 = currentSelection.data || defaultSelection.data,
    regionId = _ref1.regionId,
    location = _ref1.location,
    hierarchyInfo = _ref1.hierarchyInfo,
    _ref_selected = _ref1.selected,
    selected = _ref_selected === void 0 ? "" : _ref_selected,
    type = _ref1.type,
    cityId = _ref1.cityId;
  var _ref2 = location !== null && location !== void 0 ? location : {},
    _ref_lat = _ref2.lat,
    lat = _ref_lat === void 0 ? "" : _ref_lat,
    _ref_long = _ref2.long,
    long = _ref_long === void 0 ? "" : _ref_long;
  var airport = (hierarchyInfo !== null && hierarchyInfo !== void 0 ? hierarchyInfo : {}).airport;
  var _ref3 = airport || {},
    _ref_airportCode = _ref3.airportCode,
    airportCode = _ref_airportCode === void 0 ? "" : _ref_airportCode,
    _ref_airportId = _ref3.airportId,
    airportId = _ref_airportId === void 0 ? "" : _ref_airportId;
  var handleChange = function (eventInfo) {
    var _eventInfo_selection_data, _eventInfo_selection;
    var _eventInfo_selection_term;
    var term = (_eventInfo_selection_term = eventInfo.selection.term) !== null && _eventInfo_selection_term !== void 0 ? _eventInfo_selection_term : "";
    if (changeAnalyticsReferrerId && changeAnalyticsLinkName) {
      var _eventInfo_selection_data1;
      track("".concat(changeAnalyticsReferrerId, ".").concat(term), changeAnalyticsLinkName);
      var _eventInfo_selection_data_popularFilter;
      var popularFilters = (_eventInfo_selection_data_popularFilter = (_eventInfo_selection_data1 = eventInfo.selection.data) === null || _eventInfo_selection_data1 === void 0 ? void 0 : _eventInfo_selection_data1.popularFilter) !== null && _eventInfo_selection_data_popularFilter !== void 0 ? _eventInfo_selection_data_popularFilter : [];
      popularFilters.forEach(function (filter) {
        track("".concat(changeAnalyticsReferrerId, ".PopularFilter.Selected.").concat(term, "-").concat(filter === null || filter === void 0 ? void 0 : filter.externalId), "".concat(changeAnalyticsLinkName, " with popular filter"));
      });
    }
    setCurrentSelection(eventInfo.selection);
    setDisplayLabel(term && alternativeLocationLabel ? alternativeLocationLabel : label);
    if (onSelection) {
      onSelection(eventInfo.selection);
    }
    if (!skipReflection) {
      var _eventInfo_selection_data2;
      dispatch({
        type: isDestination ? "UPDATE_DESTINATION" : "UPDATE_ORIGIN",
        location: eventInfo.selection.data ? eventInfo.selection : _object_spread_props(_object_spread({}, eventInfo.selection), {
          data: {}
        })
      });
      if (essAdapter.config.historyDetail && ((_eventInfo_selection_data2 = eventInfo.selection.data) === null || _eventInfo_selection_data2 === void 0 ? void 0 : _eventInfo_selection_data2.searchDetail)) {
        var _eventInfo_selection_data_searchDetail;
        dispatch({
          type: "UPDATE_DATES_AND_TRAVELERS",
          travelers: (_eventInfo_selection_data_searchDetail = eventInfo.selection.data.searchDetail) !== null && _eventInfo_selection_data_searchDetail !== void 0 ? _eventInfo_selection_data_searchDetail : null
        });
      }
    }
    if (showCurrentLocation && (eventInfo === null || eventInfo === void 0 ? void 0 : (_eventInfo_selection = eventInfo.selection) === null || _eventInfo_selection === void 0 ? void 0 : (_eventInfo_selection_data = _eventInfo_selection.data) === null || _eventInfo_selection_data === void 0 ? void 0 : _eventInfo_selection_data.type) === TypeaheadLocationType.CURRENT_LOCATION) {
      var today2 = /* @__PURE__ */new Date();
      var startDate2 = formatDateString(new Date(today2.getFullYear(), today2.getMonth(), today2.getDate()), {
        raw: "yyyy-MM-dd"
      });
      var endDate2 = formatDateString(new Date(today2.getFullYear(), today2.getMonth(), today2.getDate() + 1), {
        raw: "yyyy-MM-dd"
      });
      dispatch({
        type: "UPDATE_DATES",
        start: startDate2,
        end: endDate2
      });
    }
    var _eventTracker2_getSelectEventPayloads;
    var _ref = (_eventTracker2_getSelectEventPayloads = eventTracker2.getSelectEventPayloads(eventInfo.selectionData)) !== null && _eventTracker2_getSelectEventPayloads !== void 0 ? _eventTracker2_getSelectEventPayloads : {},
      selectPayload = _ref.selectPayload,
      recommendationSelectPayload = _ref.recommendationSelectPayload;
    if (itemSelected && selectPayload) {
      trackClickstream({
        serverPayload: itemSelected,
        clientPayload: selectPayload
      });
    }
    if (recommendationSelected && recommendationSelectPayload) {
      trackClickstream({
        serverPayload: recommendationSelected,
        clientPayload: recommendationSelectPayload
      });
    }
  };
  var handleClear = function () {
    setCurrentSelection({
      term: "",
      data: {
        regionId: "",
        hierarchyInfo: {
          airport: {
            airportCode: "",
            airportId: ""
          }
        },
        location: {
          lat: "",
          long: ""
        },
        selected: void 0,
        regionNames: {},
        cityId: ""
      }
    });
    setDisplayLabel(label);
  };
  var handleOnDismiss = function () {
    if (onDismissLocation) {
      onDismissLocation(currentSelection);
    }
    var referrerId = closeAnalyticsReferrerId !== null && closeAnalyticsReferrerId !== void 0 ? closeAnalyticsReferrerId : "";
    var linkName = closeAnalyticsLinkName !== null && closeAnalyticsLinkName !== void 0 ? closeAnalyticsLinkName : "";
    if (referrerId && linkName) {
      track(referrerId, linkName);
    }
    if (close) {
      var closePayload = eventTracker2.getCloseEventPayload();
      trackClickstream({
        serverPayload: close,
        clientPayload: closePayload
      });
    }
  };
  var handleOnRecommendationImpression = function (term) {
    var recSeenPayload = eventTracker2.getRecommendationPresentedPayload(term);
    if (recommendationsPresented && recSeenPayload) {
      trackClickstream({
        serverPayload: recommendationsPresented,
        clientPayload: recSeenPayload
      });
    }
  };
  var handleLocationFieldUpdate = React38.useCallback(function (newSelection) {
    setCurrentSelection(function (prev) {
      var _prev_data_regionNames, _prev_data;
      if (((_prev_data = prev.data) === null || _prev_data === void 0 ? void 0 : (_prev_data_regionNames = _prev_data.regionNames) === null || _prev_data_regionNames === void 0 ? void 0 : _prev_data_regionNames.fullName) === newSelection.term) {
        return prev;
      }
      return newSelection;
    });
  }, []);
  useSignalSubscriber(locationFieldUpdateSubscriber(handleLocationFieldUpdate));
  var hiddenInputNameSuffix = "".concat(egdsElementId).concat(Number.isInteger(index) ? "-".concat(index) : "");
  var currentLocation = ((_currentSelection_data = currentSelection.data) === null || _currentSelection_data === void 0 ? void 0 : (_currentSelection_data_regionNames = _currentSelection_data.regionNames) === null || _currentSelection_data_regionNames === void 0 ? void 0 : _currentSelection_data_regionNames.fullName) && !valueFromQueryParam && type !== TypeaheadLocationType.CURRENT_LOCATION ? currentSelection.data.regionNames.fullName : currentSelection.term;
  var currentRegionId = currentSelection.data ? regionId || cityId || airportId : "";
  var hiddenLocationValue = essAdapter.config.showCurrentLocation && type === TypeaheadLocationType.CURRENT_LOCATION ? "" : currentLocation;
  var destinationId = currentSelection.data ? cityId || regionId : "";
  var _currentSelection_data_listing_expediaId;
  var propertyId = (_currentSelection_data_listing_expediaId = (_currentSelection_data1 = currentSelection.data) === null || _currentSelection_data1 === void 0 ? void 0 : (_currentSelection_data_listing = _currentSelection_data1.listing) === null || _currentSelection_data_listing === void 0 ? void 0 : _currentSelection_data_listing.expediaId) !== null && _currentSelection_data_listing_expediaId !== void 0 ? _currentSelection_data_listing_expediaId : null;
  var _currentSelection_data_popularFilter;
  var filters = (_currentSelection_data_popularFilter = (_currentSelection_data2 = currentSelection.data) === null || _currentSelection_data2 === void 0 ? void 0 : _currentSelection_data2.popularFilter) !== null && _currentSelection_data_popularFilter !== void 0 ? _currentSelection_data_popularFilter : [];
  var LocationResultItemImpressionTracker = React38.memo(function (param) {
    var children = param.children,
      linkNameSuffix = param.linkNameSuffix,
      referrerIdSuffix = param.referrerIdSuffix;
    return /* @__PURE__ */React38.createElement(IntersectionTracker2, {
      linkName: "Location result impression - ".concat(linkNameSuffix),
      referrerId: "".concat(analyticsReferrerId, ".").concat(referrerIdSuffix)
    }, children);
  });
  var Typeahead = withoutCustomStyling ? TypeaheadCustomWithoutCSS : TypeaheadCustom;
  return /* @__PURE__ */React38.createElement(React38.Fragment, null, /* @__PURE__ */React38.createElement("div", {
    "data-stid": "search-location"
  }, /* @__PURE__ */React38.createElement(Typeahead, {
    onType: onType,
    id: egdsElementId,
    name: egdsElementId,
    adapter: essAdapter,
    label: displayLabel,
    typeaheadPlaceholder: placeholder,
    icon: icon,
    value: currentLocation,
    onUpdate: handleChange,
    handleClear: handleClear,
    stid: egdsElementId,
    accessibilityLabel: accessibility,
    onClick: handleClick,
    onMountCB: handleMountCB,
    invalid: errorText,
    required: required,
    typeaheadEmptyResultPlaceholder: emptyResultsPlaceholder,
    onResultSelection: handleResultSelection,
    categorize: categorize,
    allowExactMatch: allowExactMatch,
    listTitle: listTitle,
    onDismiss: handleOnDismiss,
    debounceRate: debounceRate,
    allowToRemoveRecentSearches: allowToRemoveRecentSearches,
    resultItemImpressionTracker: LocationResultItemImpressionTracker,
    resultsRequestDurationTimeCallback: resultsRequestDurationTimeCallback,
    onResultItemImpression: handleOnRecommendationImpression,
    predictiveText: predictiveText
  })), /* @__PURE__ */React38.createElement("input", {
    type: "hidden",
    "data-stid": LOCATION_NAME_PREFIX,
    name: "".concat(LOCATION_NAME_PREFIX, "-").concat(hiddenInputNameSuffix),
    value: hiddenLocationValue
  }), currentRegionId && /* @__PURE__ */React38.createElement("input", {
    type: "hidden",
    "data-stid": REGION_ID_NAME_PREFIX,
    name: "".concat(REGION_ID_NAME_PREFIX, "-").concat(hiddenInputNameSuffix),
    value: currentRegionId
  }), /* @__PURE__ */React38.createElement("input", {
    type: "hidden",
    "data-stid": AIRPORT_CODE_NAME_PREFIX,
    name: "".concat(AIRPORT_CODE_NAME_PREFIX, "-").concat(hiddenInputNameSuffix),
    value: airportCode
  }), /* @__PURE__ */React38.createElement("input", {
    type: "hidden",
    "data-stid": LAT_NAME_PREFIX,
    name: "".concat(LAT_NAME_PREFIX, "-").concat(hiddenInputNameSuffix),
    value: lat
  }), /* @__PURE__ */React38.createElement("input", {
    type: "hidden",
    "data-stid": LONG_NAME_PREFIX,
    name: "".concat(LONG_NAME_PREFIX, "-").concat(hiddenInputNameSuffix),
    value: long
  }), propertyId && /* @__PURE__ */React38.createElement("input", {
    type: "hidden",
    "data-stid": PROPERTY_ID_NAME_PREFIX,
    name: "".concat(PROPERTY_ID_NAME_PREFIX, "-").concat(hiddenInputNameSuffix),
    value: propertyId
  }), /* @__PURE__ */React38.createElement("input", {
    type: "hidden",
    "data-stid": SELECTED_PREFIX,
    name: "".concat(SELECTED_PREFIX, "-").concat(hiddenInputNameSuffix),
    value: propertyId !== null && propertyId !== void 0 ? propertyId : selected
  }), essAdapter.config.popularFilter && !isPopularFiltersPlaybackEnabled && filters.map(function (filterItem) {
    var _filterItem_refinementGroupSet;
    var hasLegacyId = !!(filterItem === null || filterItem === void 0 ? void 0 : filterItem.legacyId) && !!(filterItem === null || filterItem === void 0 ? void 0 : filterItem.legacyValue);
    var keySuffix = hasLegacyId ? filterItem === null || filterItem === void 0 ? void 0 : filterItem.legacyId : filterItem === null || filterItem === void 0 ? void 0 : filterItem.externalId;
    var _filterItem_refinementGroupSet_;
    var nameSuffix = hasLegacyId ? filterItem === null || filterItem === void 0 ? void 0 : filterItem.legacyId : (_filterItem_refinementGroupSet_ = filterItem === null || filterItem === void 0 ? void 0 : (_filterItem_refinementGroupSet = filterItem.refinementGroupSet) === null || _filterItem_refinementGroupSet === void 0 ? void 0 : _filterItem_refinementGroupSet[1]) !== null && _filterItem_refinementGroupSet_ !== void 0 ? _filterItem_refinementGroupSet_ : "";
    var _filterItem_externalId;
    var filterValue = hasLegacyId ? filterItem === null || filterItem === void 0 ? void 0 : filterItem.legacyValue : (_filterItem_externalId = filterItem === null || filterItem === void 0 ? void 0 : filterItem.externalId) !== null && _filterItem_externalId !== void 0 ? _filterItem_externalId : "";
    return /* @__PURE__ */React38.createElement("input", {
      key: "search-location-popular-filter-".concat(keySuffix),
      type: "hidden",
      "data-stid": PROPERTY_FILTER_NAME_PREFIX,
      name: "".concat(PROPERTY_FILTER_NAME_PREFIX, "-").concat(nameSuffix),
      value: filterValue
    });
  }), (propertyRefinements === null || propertyRefinements === void 0 ? void 0 : propertyRefinements.amenitiesFacilitiesGroup) && /* @__PURE__ */React38.createElement("input", {
    type: "hidden",
    "data-stid": AMENITIES_GROUP_PREFIX,
    name: "".concat(AMENITIES_GROUP_PREFIX, "-").concat(hiddenInputNameSuffix),
    value: propertyRefinements === null || propertyRefinements === void 0 ? void 0 : propertyRefinements.amenitiesFacilitiesGroup
  }), (propertyRefinements === null || propertyRefinements === void 0 ? void 0 : propertyRefinements.locationGroup) && /* @__PURE__ */React38.createElement("input", {
    type: "hidden",
    "data-stid": LOCATION_GROUP_PREFIX,
    name: "".concat(LOCATION_GROUP_PREFIX, "-").concat(hiddenInputNameSuffix),
    value: propertyRefinements === null || propertyRefinements === void 0 ? void 0 : propertyRefinements.locationGroup
  }), (propertyRefinements === null || propertyRefinements === void 0 ? void 0 : propertyRefinements.propertiesGoodForGroup) && /* @__PURE__ */React38.createElement("input", {
    type: "hidden",
    "data-stid": PROPERTIES_GOOD_FOR_GROUP_PREFIX,
    name: "".concat(PROPERTIES_GOOD_FOR_GROUP_PREFIX, "-").concat(hiddenInputNameSuffix),
    value: propertyRefinements === null || propertyRefinements === void 0 ? void 0 : propertyRefinements.propertiesGoodForGroup
  }), (propertyRefinements === null || propertyRefinements === void 0 ? void 0 : propertyRefinements.propertyTypeGroup) && /* @__PURE__ */React38.createElement("input", {
    type: "hidden",
    "data-stid": PROPERTY_TYPE_GROUP_PREFIX,
    name: "".concat(PROPERTY_TYPE_GROUP_PREFIX, "-").concat(hiddenInputNameSuffix),
    value: propertyRefinements === null || propertyRefinements === void 0 ? void 0 : propertyRefinements.propertyTypeGroup
  }), destinationId && /* @__PURE__ */React38.createElement("input", {
    type: "hidden",
    "data-stid": DESTINATION_ID_NAME_PREFIX,
    name: "".concat(DESTINATION_ID_NAME_PREFIX, "-").concat(hiddenInputNameSuffix),
    value: destinationId
  }));
};
// ../internal/src/components/form/egds-search-form-location-field/multi-location-field.tsx
import React39 from "react";
import { TypeaheadCustom as TypeaheadCustom2 } from "@egds/react-search-experience";
import { useClickTracker as useClickTracker14, useEgClickstream as useEgClickstream2 } from "@shared-ui/clickstream-analytics-context";
var DISPLAY_NAME10 = "EGDSSearchFormLocationField";
var LOCATION_NAME_PREFIX2 = "".concat(DISPLAY_NAME10, "-Location");
var REGION_ID_NAME_PREFIX2 = "".concat(DISPLAY_NAME10, "-RegionId");
var AIRPORT_CODE_NAME_PREFIX2 = "".concat(DISPLAY_NAME10, "-AirportCode");
var LAT_NAME_PREFIX2 = "".concat(DISPLAY_NAME10, "-Lat");
var LONG_NAME_PREFIX2 = "".concat(DISPLAY_NAME10, "-Long");
var LOCATION_DEEP_LINK_PREFIX = "".concat(DISPLAY_NAME10, "-Values");
var getLocationFieldDataSelection = function (selection) {
  var defaultSelection = {
    data: {
      regionId: "",
      hierarchyInfo: {
        airport: {
          airportCode: ""
        }
      },
      location: {
        lat: "",
        long: ""
      },
      value: ""
    }
  };
  var selectionsData = selection.map(function (item) {
    return item.data || defaultSelection.data;
  });
  return {
    term: selection.map(function (item) {
      return item.term;
    }).join(","),
    regionId: selectionsData.map(function (data) {
      return data.regionId;
    }).join(","),
    lat: selectionsData.map(function (data) {
      var _data_location;
      return (_data_location = data.location) === null || _data_location === void 0 ? void 0 : _data_location.lat;
    }).join(","),
    long: selectionsData.map(function (data) {
      var _data_location;
      return (_data_location = data.location) === null || _data_location === void 0 ? void 0 : _data_location.long;
    }).join(","),
    airportCode: selectionsData.map(function (data) {
      var _data_hierarchyInfo_airport, _data_hierarchyInfo;
      return (_data_hierarchyInfo = data.hierarchyInfo) === null || _data_hierarchyInfo === void 0 ? void 0 : (_data_hierarchyInfo_airport = _data_hierarchyInfo.airport) === null || _data_hierarchyInfo_airport === void 0 ? void 0 : _data_hierarchyInfo_airport.airportCode;
    }).join(","),
    locationValues: selectionsData.map(function (data) {
      return data.value;
    }).join(",")
  };
};
var MultiLocationField = function (props) {
  var egdsElementId = props.egdsElementId,
    essAdapter = props.essAdapter,
    label = props.label,
    placeholder = props.placeholder,
    icon = props.icon,
    multiLocations = props.multiLocations,
    errorText = props.errorText,
    required = props.required,
    emptyResultsPlaceholder = props.emptyResultsPlaceholder,
    setFieldRefByTypename = props.setFieldRefByTypename,
    __typename = props.__typename,
    analyticsLinkName = props.analyticsLinkName,
    analyticsReferrerId = props.analyticsReferrerId,
    categorize = props.categorize,
    allowExactMatch = props.allowExactMatch,
    listTitle = props.listTitle,
    selectedItemHeading = props.selectedItemHeading,
    clearAllText = props.clearAllText,
    dismissButtonText = props.dismissButtonText,
    handleResultSelection = props.handleResultSelection,
    onMultiSelectItemRemove = props.onMultiSelectItemRemove,
    onMultiSelectClearAll = props.onMultiSelectClearAll,
    onMultiSelectClose = props.onMultiSelectClose,
    withoutCustomStyling = props.withoutCustomStyling,
    searchLocationAnalytics = props.searchLocationAnalytics,
    eventTracker2 = props.eventTracker;
  var defaultMultiSelection = multiLocations.map(function (item) {
    return {
      term: item.text,
      data: {
        regionId: "",
        hierarchyInfo: {
          airport: {
            airportCode: ""
          }
        },
        location: {
          lat: "",
          long: ""
        },
        value: item.value
      }
    };
  });
  var _React39_useState = _sliced_to_array(React39.useState(defaultMultiSelection), 2),
    selection = _React39_useState[0],
    setSelection = _React39_useState[1];
  var _React39_useState1 = _sliced_to_array(React39.useState(false), 2),
    shouldFireChangeEvent = _React39_useState1[0],
    setShouldFireChangeEvent = _React39_useState1[1];
  React39.useEffect(function () {
    if (shouldFireChangeEvent) {
      setShouldFireChangeEvent(false);
      triggerInputChangeEvent(selection.map(function (value) {
        return value.term;
      }).join(", "), handleResultSelection);
    }
  }, [shouldFireChangeEvent, selection, handleResultSelection]);
  var trackClick = useClickTracker14();
  var trackClickstream = useEgClickstream2();
  var _ref = searchLocationAnalytics !== null && searchLocationAnalytics !== void 0 ? searchLocationAnalytics : {},
    open = _ref.open,
    close = _ref.close,
    itemSelected = _ref.itemSelected,
    recommendationSelected = _ref.recommendationSelected,
    recommendationsPresented = _ref.recommendationsPresented;
  var handleClick = function (eventInfo) {
    trackClick(analyticsReferrerId, analyticsLinkName);
    eventTracker2.initMetadata({
      lob: essAdapter.config.lob,
      subLob: essAdapter.config.subLob
    });
    if (open) {
      setTimeout(function () {
        var openPayload = eventTracker2.getOpenEventPayload(eventInfo === null || eventInfo === void 0 ? void 0 : eventInfo.prefillText);
        trackClickstream({
          serverPayload: open,
          clientPayload: openPayload
        });
      });
    }
  };
  var handleMountCB = function (ref) {
    return setFieldRefByTypename(__typename, ref);
  };
  var _getLocationFieldDataSelection = getLocationFieldDataSelection(selection),
    term = _getLocationFieldDataSelection.term,
    regionId = _getLocationFieldDataSelection.regionId,
    lat = _getLocationFieldDataSelection.lat,
    long = _getLocationFieldDataSelection.long,
    airportCode = _getLocationFieldDataSelection.airportCode,
    locationValues = _getLocationFieldDataSelection.locationValues;
  var handleChange = function (eventInfo) {
    var isNewSelectionRepeated = selection.some(function (item) {
      return item === eventInfo.selection;
    });
    if (!isNewSelectionRepeated && eventInfo.selection.data) {
      setSelection(function (prevSelection) {
        return _to_consumable_array(prevSelection).concat([eventInfo.selection]);
      });
    }
    var _eventTracker2_getSelectEventPayloads;
    var _ref = (_eventTracker2_getSelectEventPayloads = eventTracker2.getSelectEventPayloads(eventInfo.selectionData)) !== null && _eventTracker2_getSelectEventPayloads !== void 0 ? _eventTracker2_getSelectEventPayloads : {},
      selectPayload = _ref.selectPayload,
      recommendationSelectPayload = _ref.recommendationSelectPayload;
    if (itemSelected && selectPayload) {
      trackClickstream({
        serverPayload: itemSelected,
        clientPayload: selectPayload
      });
    }
    if (recommendationSelected && recommendationSelectPayload) {
      trackClickstream({
        serverPayload: recommendationSelected,
        clientPayload: recommendationSelectPayload
      });
    }
  };
  var handleClear = function () {
    setSelection([]);
    onMultiSelectClearAll === null || onMultiSelectClearAll === void 0 ? void 0 : onMultiSelectClearAll(egdsElementId);
  };
  var handleRemove = function (selectedIndex) {
    if ((selection === null || selection === void 0 ? void 0 : selection.length) > 0) {
      setSelection(function (prevSelection) {
        return prevSelection.filter(function (_, index) {
          return index !== selectedIndex;
        });
      });
      onMultiSelectItemRemove === null || onMultiSelectItemRemove === void 0 ? void 0 : onMultiSelectItemRemove(selection[selectedIndex], egdsElementId);
    }
  };
  var handleDismiss = function (eventInfo) {
    if (eventInfo === null || eventInfo === void 0 ? void 0 : eventInfo.renderType) {
      onMultiSelectClose === null || onMultiSelectClose === void 0 ? void 0 : onMultiSelectClose(eventInfo === null || eventInfo === void 0 ? void 0 : eventInfo.renderType, egdsElementId);
      setShouldFireChangeEvent(true);
    }
    if (close) {
      var closePayload = eventTracker2.getCloseEventPayload();
      trackClickstream({
        serverPayload: close,
        clientPayload: closePayload
      });
    }
  };
  var handleOnRecommendationImpression = function (query) {
    var recSeenPayload = eventTracker2.getRecommendationPresentedPayload(query);
    if (recommendationsPresented && recSeenPayload) {
      trackClickstream({
        serverPayload: recommendationsPresented,
        clientPayload: recSeenPayload
      });
    }
  };
  var accessibilityLabel = label.concat(",").concat(term);
  return /* @__PURE__ */React39.createElement(React39.Fragment, null, /* @__PURE__ */React39.createElement("div", {
    "data-stid": "search-location"
  }, /* @__PURE__ */React39.createElement(TypeaheadCustom2, {
    id: egdsElementId,
    name: egdsElementId,
    adapter: essAdapter,
    label: label,
    typeaheadPlaceholder: placeholder,
    icon: icon,
    value: selection.map(function (item) {
      return item.term;
    }),
    onUpdate: handleChange,
    stid: egdsElementId,
    accessibilityLabel: accessibilityLabel,
    onClick: handleClick,
    onMountCB: handleMountCB,
    invalid: errorText,
    required: required,
    typeaheadEmptyResultPlaceholder: emptyResultsPlaceholder,
    handleClear: handleClear,
    onItemRemove: handleRemove,
    onDismiss: handleDismiss,
    categorize: categorize,
    allowExactMatch: allowExactMatch,
    listTitle: listTitle,
    selectedItemHeading: selectedItemHeading,
    clearAllText: clearAllText,
    dismissButtonText: dismissButtonText,
    isMulti: true,
    withoutCustomStyling: withoutCustomStyling,
    onResultItemImpression: handleOnRecommendationImpression
  })), /* @__PURE__ */React39.createElement("input", {
    type: "hidden",
    "data-stid": LOCATION_NAME_PREFIX2,
    name: "".concat(LOCATION_NAME_PREFIX2, "-").concat(egdsElementId),
    value: term
  }), /* @__PURE__ */React39.createElement("input", {
    type: "hidden",
    "data-stid": REGION_ID_NAME_PREFIX2,
    name: "".concat(REGION_ID_NAME_PREFIX2, "-").concat(egdsElementId),
    value: regionId
  }), /* @__PURE__ */React39.createElement("input", {
    type: "hidden",
    "data-stid": AIRPORT_CODE_NAME_PREFIX2,
    name: "".concat(AIRPORT_CODE_NAME_PREFIX2, "-").concat(egdsElementId),
    value: airportCode
  }), /* @__PURE__ */React39.createElement("input", {
    type: "hidden",
    "data-stid": LAT_NAME_PREFIX2,
    name: "".concat(LAT_NAME_PREFIX2, "-").concat(egdsElementId),
    value: lat
  }), /* @__PURE__ */React39.createElement("input", {
    type: "hidden",
    "data-stid": LONG_NAME_PREFIX2,
    name: "".concat(LONG_NAME_PREFIX2, "-").concat(egdsElementId),
    value: long
  }), /* @__PURE__ */React39.createElement("input", {
    type: "hidden",
    "data-stid": LOCATION_DEEP_LINK_PREFIX,
    name: "".concat(LOCATION_DEEP_LINK_PREFIX, "-").concat(egdsElementId),
    value: locationValues
  }));
};
// ../internal/src/components/form/egds-search-form-location-field/egds-search-form-location-field.tsx
var __Fragment25 = gql32(_templateObject31());
var DISPLAY_NAME11 = "EGDSSearchFormLocationField";
var eventTracker = new SearchLocationEventTracker();
var EGDSSearchFormLocationField = function (props) {
  var _fieldError_validations, _validations_find, _useGoogleMapsSdkVersion;
  var fieldError = props.fieldError,
    data = props.data,
    adapter = props.adapter,
    onMultiSelectClose = props.onMultiSelectClose,
    onMultiSelectItemRemove = props.onMultiSelectItemRemove,
    onMultiSelectClearAll = props.onMultiSelectClearAll,
    locationsErrorText = props.locationsErrorText,
    additionalAdapterFields = props.additionalAdapterFields,
    pinnedPropertyId = props.pinnedPropertyId,
    alternativeLocationLabel = props.alternativeLocationLabel,
    propertyRefinements = props.propertyRefinements,
    skipReflection = props.skipReflection,
    onLocationsSelection = props.onLocationsSelection,
    showCurrentLocation = props.showCurrentLocation,
    allowToRemoveRecentSearches = props.allowToRemoveRecentSearches,
    onDismissLocation = props.onDismissLocation,
    categorizeResults = props.categorizeResults,
    searchLocationAnalytics = props.searchLocationAnalytics,
    enablePredictiveText = props.enablePredictiveText,
    isHistoryDetailFormatVariant = props.isHistoryDetailFormatVariant;
  var context = useBexApi5().context;
  var identity = context.identity,
    locale = context.locale,
    siteId = context.siteId;
  var __typename = data.__typename,
    label = data.label,
    action = data.action,
    placeholder = data.placeholder,
    leftIcon = data.leftIcon,
    egdsElementId = data.egdsElementId,
    value = data.value,
    errorMessage = data.errorMessage,
    required = data.required,
    multiLocations = data.multiLocations,
    closeAnalytics = data.closeAnalytics,
    changeAnalytics = data.changeAnalytics,
    regionId = data.regionId,
    debounceRate = data.debounceRate,
    validations = data.validations;
  var sameInputErrorText = (fieldError === null || fieldError === void 0 ? void 0 : (_fieldError_validations = fieldError.validations) === null || _fieldError_validations === void 0 ? void 0 : _fieldError_validations.sameLocationSelected) && validations && egdsElementId === "origin_select" ? (_validations_find = validations.find(function (field) {
    return field.__typename === "EGDSSameValueInputValidation";
  })) === null || _validations_find === void 0 ? void 0 : _validations_find.errorMessage : null;
  var _ref, _ref1;
  var errorTextToDisplay = (_ref1 = (_ref = sameInputErrorText !== null && sameInputErrorText !== void 0 ? sameInputErrorText : locationsErrorText) !== null && _ref !== void 0 ? _ref : errorMessage) !== null && _ref1 !== void 0 ? _ref1 : "";
  var handleResultSelection = useFormCallback6(egdsElementId, function (event) {
    return event;
  });
  var googleApiVersion = (_useGoogleMapsSdkVersion = useGoogleMapsSdkVersion()) === null || _useGoogleMapsSdkVersion === void 0 ? void 0 : _useGoogleMapsSdkVersion.version;
  var _useExperiment2 = useExperiment2("TypeaheadCustom_without_specific_CSS" /* TypeaheadCustom_without_specific_CSS */),
    typeaheadCustomWithoutSpecificCSSExposure = _useExperiment2.exposure,
    logTypeaheadCustomWithoutSpecificCSS = _useExperiment2.logExperiment;
  React40.useEffect(function () {
    try {
      logTypeaheadCustomWithoutSpecificCSS(typeaheadCustomWithoutSpecificCSSExposure);
    } catch (e) {}
  });
  if ((action === null || action === void 0 ? void 0 : action.__typename) !== "OpenTypeaheadAction") {
    return null;
  }
  var logRequest = function (query) {
    eventTracker.recordRequest(query);
  };
  var logResponse = function (response) {
    eventTracker.recordResponse(response);
  };
  var finalAdditionalAdapterFields = _object_spread_props(_object_spread({}, additionalAdapterFields), {
    alternate: (additionalAdapterFields === null || additionalAdapterFields === void 0 ? void 0 : additionalAdapterFields.lastSearchLatLong) ? additionalAdapterFields === null || additionalAdapterFields === void 0 ? void 0 : additionalAdapterFields.alternate : false,
    googleApiVersion: googleApiVersion
  });
  var analytics = action.analytics,
    accessibility = action.accessibility,
    emptyResultsPlaceholder = action.emptyResultsPlaceholder,
    allowExactMatch = action.allowExactMatch,
    categorize = action.categorize,
    listTitle = action.listTitle,
    selectedItemHeading = action.selectedItemHeading,
    clearAllText = action.clearAllText,
    dismissButtonText = action.dismissButtonText;
  var _action_info = action.info,
    client = _action_info.client,
    drivable = _action_info.drivable,
    isDestination = _action_info.isDestination,
    lineOfBusiness = _action_info.lineOfBusiness,
    maxNumberOfResults = _action_info.maxNumberOfResults,
    packageType = _action_info.packageType,
    personalize = _action_info.personalize,
    regionType = _action_info.regionType,
    typeaheadFeatures = _action_info.typeaheadFeatures,
    isMultiLocation = _action_info.isMultiLocation,
    domain = _action_info.domain,
    typeaheadRegionId = _action_info.regionId,
    subLob = _action_info.subLob,
    expUserId = _action_info.expUserId,
    trending = _action_info.trending;
  var _ref2 = identity || {},
    guid = _ref2.duaid;
  var expuserid = Number(expUserId) || -1;
  var defaultMaxNumberOfResults = 10;
  var defaultRegionType = 2047;
  var defaultIcon = "place";
  var essAdapter = adapter !== null && adapter !== void 0 ? adapter : new ESSAdapter(_object_spread_props(_object_spread({
    client: client !== null && client !== void 0 ? client : "",
    drivable: drivable,
    trending: trending,
    dest: isDestination,
    domain: domain !== null && domain !== void 0 ? domain : "https://www.expedia.com/",
    expuserid: expuserid,
    features: typeaheadFeatures !== null && typeaheadFeatures !== void 0 ? typeaheadFeatures : "",
    guid: guid,
    lob: lineOfBusiness !== null && lineOfBusiness !== void 0 ? lineOfBusiness : "",
    locale: locale,
    maxResults: maxNumberOfResults !== null && maxNumberOfResults !== void 0 ? maxNumberOfResults : defaultMaxNumberOfResults,
    personalize: personalize,
    regionType: regionType !== null && regionType !== void 0 ? regionType : defaultRegionType,
    siteId: siteId,
    packageType: packageType !== null && packageType !== void 0 ? packageType : "",
    showCurrentLocation: showCurrentLocation !== null && showCurrentLocation !== void 0 ? showCurrentLocation : false,
    regionId: typeaheadRegionId !== null && typeaheadRegionId !== void 0 ? typeaheadRegionId : void 0,
    excludeRoomsLabelForRecentHistory: regionType === 10111
  }, finalAdditionalAdapterFields), {
    subLob: subLob !== null && subLob !== void 0 ? subLob : "",
    logRequest: logRequest,
    logResponse: logResponse,
    historyDetailFormatVariant: isHistoryDetailFormatVariant !== null && isHistoryDetailFormatVariant !== void 0 ? isHistoryDetailFormatVariant : false
  }));
  var _leftIcon_title;
  var commonProps = _object_spread_props(_object_spread({}, props), {
    egdsElementId: egdsElementId,
    essAdapter: essAdapter,
    predictiveText: enablePredictiveText,
    categorize: !!(categorize || categorizeResults),
    allowExactMatch: allowExactMatch,
    listTitle: listTitle,
    handleResultSelection: handleResultSelection,
    label: label !== null && label !== void 0 ? label : "",
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    icon: (_leftIcon_title = leftIcon === null || leftIcon === void 0 ? void 0 : leftIcon.title) !== null && _leftIcon_title !== void 0 ? _leftIcon_title : defaultIcon,
    accessibility: accessibility !== null && accessibility !== void 0 ? accessibility : "",
    errorText: fieldError ? errorTextToDisplay : "",
    required: required !== null && required !== void 0 ? required : false,
    emptyResultsPlaceholder: emptyResultsPlaceholder !== null && emptyResultsPlaceholder !== void 0 ? emptyResultsPlaceholder : "",
    analyticsLinkName: analytics.linkName,
    analyticsReferrerId: analytics.referrerId,
    closeAnalyticsLinkName: closeAnalytics === null || closeAnalytics === void 0 ? void 0 : closeAnalytics.linkName,
    closeAnalyticsReferrerId: closeAnalytics === null || closeAnalytics === void 0 ? void 0 : closeAnalytics.referrerId,
    changeAnalyticsLinkName: changeAnalytics === null || changeAnalytics === void 0 ? void 0 : changeAnalytics.linkName,
    changeAnalyticsReferrerId: changeAnalytics === null || changeAnalytics === void 0 ? void 0 : changeAnalytics.referrerId,
    selectedItemHeading: selectedItemHeading !== null && selectedItemHeading !== void 0 ? selectedItemHeading : "",
    dismissButtonText: dismissButtonText !== null && dismissButtonText !== void 0 ? dismissButtonText : "",
    __typename: __typename,
    regionId: regionId,
    isDestination: isDestination,
    debounceRate: debounceRate !== null && debounceRate !== void 0 ? debounceRate : void 0,
    showCurrentLocation: showCurrentLocation !== null && showCurrentLocation !== void 0 ? showCurrentLocation : false,
    withoutCustomStyling: typeaheadCustomWithoutSpecificCSSExposure.bucket === 1
  });
  if (isMultiLocation) {
    return /* @__PURE__ */React40.createElement(MultiLocationField, _object_spread_props(_object_spread({}, commonProps), {
      multiLocations: multiLocations !== null && multiLocations !== void 0 ? multiLocations : [],
      clearAllText: clearAllText !== null && clearAllText !== void 0 ? clearAllText : "",
      onMultiSelectClose: onMultiSelectClose,
      onMultiSelectItemRemove: onMultiSelectItemRemove,
      onMultiSelectClearAll: onMultiSelectClearAll,
      onLocationsSelection: onLocationsSelection,
      eventTracker: eventTracker
    }));
  }
  return /* @__PURE__ */React40.createElement(LocationField, _object_spread_props(_object_spread({}, commonProps), {
    value: value !== null && value !== void 0 ? value : "",
    pinnedPropertyId: pinnedPropertyId !== null && pinnedPropertyId !== void 0 ? pinnedPropertyId : "",
    alternativeLocationLabel: alternativeLocationLabel,
    propertyRefinements: propertyRefinements,
    skipReflection: skipReflection,
    allowToRemoveRecentSearches: allowToRemoveRecentSearches,
    onDismissLocation: onDismissLocation,
    eventTracker: eventTracker
  }));
};
EGDSSearchFormLocationField.displayName = DISPLAY_NAME11;
EGDSSearchFormLocationField.fragment = _object_spread_props(_object_spread({}, __Fragment25), {
  __typename: DISPLAY_NAME11
});
// ../internal/src/components/form/egds-search-form-locations-field/egds-search-form-locations-field.tsx
import React42 from "react";
import { gql as gql34 } from "@apollo/client";
import { useClickTracker as useClickTracker16 } from "@shared-ui/clickstream-analytics-context";
import { useSearchFormReflectionContext as useSearchFormReflectionContext4 } from "@shared-ui/retail-search-tools-reflection-provider";
import { ViewMedium as ViewMedium3, Viewport as Viewport5, ViewSmall as ViewSmall5 } from "@shared-ui/viewport-context";
import { UitkInputSwapper } from "uitk-react-input";
// ../internal/src/components/common/button/egds-secondary-button.tsx
import React41 from "react";
import { gql as gql33 } from "@apollo/client";
import { useClickTracker as useClickTracker15 } from "@shared-ui/clickstream-analytics-context";
import { UitkSecondaryButton } from "uitk-react-button";
var __Fragment26 = gql33(_templateObject32(), EGDSButtonFragment);
var EGDSSecondaryButton = function (param) {
  var onClick = param.onClick,
    data = param.data;
  var egdsElementId = data.egdsElementId,
    primary = data.primary,
    analytics = data.analytics;
  var id = egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "search_form_secondary_button";
  var track = useClickTracker15();
  var handleClick = React41.useCallback(function () {
    if (analytics) {
      var referrerId = analytics.referrerId,
        linkName = analytics.linkName;
      track(referrerId, linkName);
    }
    onClick();
  }, [analytics, onClick, track]);
  return /* @__PURE__ */React41.createElement(UitkSecondaryButton, {
    id: id,
    onClick: handleClick
  }, primary);
};
EGDSSecondaryButton.displayName = "EGDSSecondaryButton";
EGDSSecondaryButton.fragment = __Fragment26;
// ../internal/src/components/form/egds-search-form-locations-field/egds-search-form-locations-field.tsx
var __Fragment27 = gql34(_templateObject33(), EGDSSecondaryButton.fragment, EGDSSearchFormLocationField.fragment);
var DISPLAY_NAME12 = "EGDSSearchFormLocationsField";
var getAccessibilityInputSwapperLabel = function (data) {
  var _data_horizontalSwapper, _data_verticalSwapper;
  if (((_data_horizontalSwapper = data.horizontalSwapper) === null || _data_horizontalSwapper === void 0 ? void 0 : _data_horizontalSwapper.__typename) === "UISecondaryButton" && data.horizontalSwapper.accessibility) {
    return data.horizontalSwapper.accessibility;
  }
  if (((_data_verticalSwapper = data.verticalSwapper) === null || _data_verticalSwapper === void 0 ? void 0 : _data_verticalSwapper.__typename) === "UISecondaryButton" && data.verticalSwapper.accessibility) {
    return data.verticalSwapper.accessibility;
  }
};
var EGDSSearchFormLocationsField = function (props) {
  var _validations_find, _destinationFieldError_validations;
  var originRef = props.originRef,
    destinationRef = props.destinationRef,
    data = props.data,
    adapter = props.adapter,
    index = props.index,
    skipReflection = props.skipReflection,
    onOpenLocationField = props.onOpenLocationField,
    onLocationsSelection = props.onLocationsSelection,
    additionalAdapterFields = props.additionalAdapterFields,
    allowToRemoveRecentSearches = props.allowToRemoveRecentSearches,
    searchLocationAnalytics = props.searchLocationAnalytics;
  var trackClick = useClickTracker16();
  var _useSearchFormReflectionContext4 = useSearchFormReflectionContext4(),
    state = _useSearchFormReflectionContext4.state,
    dispatch = _useSearchFormReflectionContext4.dispatch;
  var origin = data.origin,
    destination = data.destination,
    validations = data.validations;
  var originFieldError = originRef.originFieldError,
    setFieldRefByTypenameOrigin = originRef.setFieldRefByTypename;
  var destinationFieldError = destinationRef.destinationFieldError,
    setFieldRefByTypenameDestination = destinationRef.setFieldRefByTypename;
  var reflectionDestination = state.destination,
    reflectionOrigin = state.origin;
  var _origin_value;
  var _React42_useState = _sliced_to_array(React42.useState(!skipReflection && reflectionOrigin ? reflectionOrigin : {
      term: (_origin_value = origin.value) !== null && _origin_value !== void 0 ? _origin_value : "",
      data: {
        regionId: "",
        regionNames: {
          shortName: ""
        },
        hierarchyInfo: {
          airport: {
            airportCode: ""
          }
        },
        location: {
          lat: "",
          long: ""
        }
      }
    }), 2),
    originSelection = _React42_useState[0],
    setOriginSelection = _React42_useState[1];
  var _destination_value;
  var _React42_useState1 = _sliced_to_array(React42.useState(!skipReflection && reflectionDestination ? reflectionDestination : {
      term: (_destination_value = destination.value) !== null && _destination_value !== void 0 ? _destination_value : "",
      data: {
        regionId: "",
        regionNames: {
          shortName: ""
        },
        hierarchyInfo: {
          airport: {
            airportCode: ""
          }
        },
        location: {
          lat: "",
          long: ""
        }
      }
    }), 2),
    destinationSelection = _React42_useState1[0],
    setDestinationSelection = _React42_useState1[1];
  var trackOnSwapClick = function (isHorizontalSwapper) {
    var _data_horizontalSwapper, _data_verticalSwapper;
    if (isHorizontalSwapper && (data === null || data === void 0 ? void 0 : (_data_horizontalSwapper = data.horizontalSwapper) === null || _data_horizontalSwapper === void 0 ? void 0 : _data_horizontalSwapper.__typename) === "UISecondaryButton" && data.horizontalSwapper.analytics) {
      trackClick(data.horizontalSwapper.analytics.referrerId, data.horizontalSwapper.analytics.linkName);
    } else if (!isHorizontalSwapper && (data === null || data === void 0 ? void 0 : (_data_verticalSwapper = data.verticalSwapper) === null || _data_verticalSwapper === void 0 ? void 0 : _data_verticalSwapper.__typename) === "UISecondaryButton" && data.verticalSwapper.analytics) {
      trackClick(data.verticalSwapper.analytics.referrerId, data.verticalSwapper.analytics.linkName);
    }
  };
  var onLocationSwap = function () {
    if (!skipReflection) {
      dispatch({
        type: "UPDATE_DESTINATION",
        location: originSelection.data ? originSelection : _object_spread_props(_object_spread({}, originSelection), {
          data: {}
        })
      });
      dispatch({
        type: "UPDATE_ORIGIN",
        location: destinationSelection.data ? destinationSelection : _object_spread_props(_object_spread({}, destinationSelection), {
          data: {}
        })
      });
    }
    setOriginSelection(_object_spread({}, destinationSelection));
    setDestinationSelection(_object_spread({}, originSelection));
  };
  var onLocationSwapHorizontal = function () {
    onLocationSwap();
    trackOnSwapClick(true);
  };
  var onLocationSwapVertical = function () {
    onLocationSwap();
    trackOnSwapClick(false);
  };
  var getOriginLocationValue = function (selection) {
    setOriginSelection(selection);
    if (onLocationsSelection) {
      onLocationsSelection({
        term: selection.term,
        data: _object_spread_props(_object_spread({}, selection.data), {
          origin: selection.data ? selection.data.regionNames.shortName : selection.term,
          destination: destinationSelection.term,
          index: index
        })
      });
    }
  };
  var getDestinationLocationValue = function (selection) {
    setDestinationSelection(selection);
    if (onLocationsSelection) {
      onLocationsSelection({
        term: selection.term,
        data: _object_spread_props(_object_spread({}, selection.data), {
          origin: originSelection.term,
          destination: selection.data ? selection.data.regionNames.shortName : selection.term,
          index: index
        })
      });
    }
  };
  var defaultLocationFieldProps = {
    adapter: adapter,
    index: index,
    onOpenLocationField: onOpenLocationField,
    additionalAdapterFields: additionalAdapterFields,
    skipReflection: skipReflection,
    allowToRemoveRecentSearches: allowToRemoveRecentSearches,
    searchLocationAnalytics: searchLocationAnalytics
  };
  var _validations_find_errorMessage;
  var errorMessageTest = (_validations_find_errorMessage = validations === null || validations === void 0 ? void 0 : (_validations_find = validations.find(function (validation) {
    return validation.__typename === "EGDSSameValueInputValidation";
  })) === null || _validations_find === void 0 ? void 0 : _validations_find.errorMessage) !== null && _validations_find_errorMessage !== void 0 ? _validations_find_errorMessage : "";
  var originLocation = /* @__PURE__ */React42.createElement(EGDSSearchFormLocationField, _object_spread_props(_object_spread({}, defaultLocationFieldProps), {
    additionalAdapterFields: _object_spread_props(_object_spread({}, additionalAdapterFields), {
      trending: false
    }),
    setFieldRefByTypename: setFieldRefByTypenameOrigin,
    fieldError: originFieldError,
    data: origin,
    onSelection: getOriginLocationValue,
    selection: originSelection,
    onLocationsSelection: getOriginLocationValue,
    searchLocationAnalytics: searchLocationAnalytics
  }));
  var locationsErrorText = (destinationFieldError === null || destinationFieldError === void 0 ? void 0 : (_destinationFieldError_validations = destinationFieldError.validations) === null || _destinationFieldError_validations === void 0 ? void 0 : _destinationFieldError_validations.sameLocationSelected) ? errorMessageTest : void 0;
  var destinationLocation = /* @__PURE__ */React42.createElement(EGDSSearchFormLocationField, _object_spread_props(_object_spread({}, defaultLocationFieldProps), {
    setFieldRefByTypename: setFieldRefByTypenameDestination,
    fieldError: destinationFieldError,
    locationsErrorText: locationsErrorText,
    data: destination,
    onSelection: getDestinationLocationValue,
    selection: destinationSelection,
    onLocationsSelection: getDestinationLocationValue,
    searchLocationAnalytics: searchLocationAnalytics
  }));
  var accessibilityLabel = getAccessibilityInputSwapperLabel(data);
  return /* @__PURE__ */React42.createElement(Viewport5, null, /* @__PURE__ */React42.createElement(ViewSmall5, null, /* @__PURE__ */React42.createElement(UitkInputSwapper, {
    startInput: originLocation,
    isHorizontalSwapper: false,
    onSwapButtonClick: onLocationSwapVertical,
    endInput: destinationLocation,
    a11ySwapButtonLabel: accessibilityLabel
  })), /* @__PURE__ */React42.createElement(ViewMedium3, null, /* @__PURE__ */React42.createElement(UitkInputSwapper, {
    startInput: originLocation,
    onSwapButtonClick: onLocationSwapHorizontal,
    endInput: destinationLocation,
    a11ySwapButtonLabel: accessibilityLabel
  })));
};
EGDSSearchFormLocationsField.displayName = DISPLAY_NAME12;
EGDSSearchFormLocationsField.fragment = _object_spread_props(_object_spread({}, __Fragment27), {
  __typename: DISPLAY_NAME12
});
// ../internal/src/components/form/egds-search-form-travelers-field/egds-search-form-travelers-field.tsx
import React60 from "react";
import { gql as gql48 } from "@apollo/client";
// ../internal/src/components/form/egds-search-form-travelers-field/egds-basic-traveler-selector.tsx
import React53 from "react";
import { gql as gql43 } from "@apollo/client";
import { ViewMedium as ViewMedium4, Viewport as Viewport6 } from "@shared-ui/viewport-context";
import { UitkButtonSize as UitkButtonSize3 } from "uitk-react-button";
import { UitkLayoutFlex as UitkLayoutFlex6, UitkLayoutFlexItem as UitkLayoutFlexItem6 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing11 } from "uitk-react-spacing";
// ../internal/src/components/common/button/egds-primary-button.tsx
import React43 from "react";
import { gql as gql35 } from "@apollo/client";
import { useClickTracker as useClickTracker17 } from "@shared-ui/clickstream-analytics-context";
import { UitkButtonSize as UitkButtonSize2, UitkFloatingFullWidthButton, UitkPrimaryButton as UitkPrimaryButton2 } from "uitk-react-button";
import { UitkScrim } from "uitk-react-scrim";
var __Fragment28 = gql35(_templateObject34(), EGDSButtonFragment);
var EGDSPrimaryButton = function (param) {
  var data = param.data,
    onClick = param.onClick,
    size = param.size,
    _param_isFullWidth = param.isFullWidth,
    isFullWidth = _param_isFullWidth === void 0 ? true : _param_isFullWidth,
    _param_floating = param.floating,
    floating = _param_floating === void 0 ? false : _param_floating;
  var egdsElementId = data.egdsElementId,
    primary = data.primary,
    analytics = data.analytics;
  var id = egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "search_form_primary_button";
  var track = useClickTracker17();
  var handleClick = React43.useCallback(function () {
    if (analytics) {
      var referrerId = analytics.referrerId,
        linkName = analytics.linkName;
      track(referrerId, linkName);
    }
    onClick();
  }, [analytics, onClick, track]);
  var primaryButtonProps = {
    onClick: handleClick,
    id: id,
    isFullWidth: isFullWidth,
    size: size || UitkButtonSize2.LARGE
  };
  return floating ? /* @__PURE__ */React43.createElement(UitkScrim, {
    type: "fade-button"
  }, /* @__PURE__ */React43.createElement(UitkFloatingFullWidthButton, _object_spread({}, primaryButtonProps), primary)) : /* @__PURE__ */React43.createElement(UitkPrimaryButton2, _object_spread({}, primaryButtonProps), primary);
};
EGDSPrimaryButton.displayName = "EGDSPrimaryButton";
EGDSPrimaryButton.fragment = __Fragment28;
// ../internal/src/components/common/button/egds-tertiary-button.tsx
import React44 from "react";
import { gql as gql36 } from "@apollo/client";
import { useClickTracker as useClickTracker18 } from "@shared-ui/clickstream-analytics-context";
import { UitkTertiaryButton } from "uitk-react-button";
import { UitkIcon as UitkIcon3 } from "uitk-react-icons";
var __Fragment29 = gql36(_templateObject35(), EGDSButtonFragment);
var EGDSTertiaryButton = function (param) {
  var onClick = param.onClick,
    isFullWidth = param.isFullWidth,
    size = param.size,
    data = param.data,
    isDisabled = param.isDisabled,
    domRef = param.domRef;
  var egdsElementId = data.egdsElementId,
    primary = data.primary,
    disabled = data.disabled,
    accessibility = data.accessibility,
    analytics = data.analytics,
    icon = data.icon;
  var id = egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "search_form_tertiary_button";
  var track = useClickTracker18();
  var disableState = isDisabled || disabled;
  var handleClick = React44.useCallback(function () {
    if (analytics) {
      var referrerId = analytics.referrerId,
        linkName = analytics.linkName;
      track(referrerId, linkName);
    }
    onClick();
  }, [analytics, onClick, track]);
  return /* @__PURE__ */React44.createElement(UitkTertiaryButton, {
    "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : "",
    id: id,
    "data-test-id": id,
    onClick: handleClick,
    disabled: disableState,
    isFullWidth: isFullWidth,
    size: size,
    domRef: domRef
  }, icon && /* @__PURE__ */React44.createElement(UitkIcon3, {
    name: icon.id
  }), primary);
};
EGDSTertiaryButton.displayName = "EGDSTertiaryButton";
EGDSTertiaryButton.fragment = __Fragment29;
// ../internal/src/components/form/egds-search-form-travelers-field/egds-travelers.tsx
import React52 from "react";
import { gql as gql42 } from "@apollo/client";
import { UitkSpacing as UitkSpacing10 } from "uitk-react-spacing";
// ../internal/src/components/form/egds-search-form-travelers-field/egds-travelers-children.tsx
import React50 from "react";
import { gql as gql41 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex5, UitkLayoutFlexItem as UitkLayoutFlexItem5 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing9 } from "uitk-react-spacing";
// ../internal/src/components/form/egds-search-form-travelers-field/egds-travelers-child-age-select.tsx
import React48 from "react";
import { gql as gql38 } from "@apollo/client";
import { useClickTracker as useClickTracker19 } from "@shared-ui/clickstream-analytics-context";
import { UitkSelect as UitkSelect2 } from "uitk-react-input";
// ../internal/src/components/common/egds-basic-option.tsx
import React45 from "react";
import { gql as gql37 } from "@apollo/client";
var __Fragment30 = gql37(_templateObject36());
var EGDSBasicOption = function (param) {
  var data = param.data;
  var label = data.label,
    value = data.value,
    egdsElementId = data.egdsElementId;
  var key = "".concat(egdsElementId, "-").concat(value);
  return /* @__PURE__ */React45.createElement("option", {
    key: key,
    value: value
  }, label);
};
EGDSBasicOption.displayName = "EGDSBasicOptionFragment";
EGDSBasicOption.fragment = __Fragment30;
// ../internal/src/components/form/egds-search-form-travelers-field/travelers-basic-provider.tsx
import React47 from "react";
// ../internal/src/components/form/egds-search-form-travelers-field/travelers-provider.tsx
import React46 from "react";
var noAgeSelected = function (infantOrChild) {
  return infantOrChild.__typename === "EGDSTravelerChildAgeSelect" && infantOrChild.value === null;
};
var getChildCountWithoutAge = function (rooms) {
  return rooms.reduce(function (count, room) {
    var _room_infants;
    var childrenAges = room.children.__typename === "EGDSTravelerChildren" ? room.children.ages : [];
    var infantAges = ((_room_infants = room.infants) === null || _room_infants === void 0 ? void 0 : _room_infants.__typename) === "EGDSTravelerInfant" ? room.infants.ages : [];
    var _infantAges_filter_length;
    return count + childrenAges.filter(noAgeSelected).length + ((_infantAges_filter_length = infantAges.filter(noAgeSelected).length) !== null && _infantAges_filter_length !== void 0 ? _infantAges_filter_length : 0);
  }, 0);
};
var getChildren = function (childCount, childAges, room) {
  if (room.children.__typename === "EGDSTravelerChildren") {
    var children = room.children;
    var newChildren = _object_spread_props(_object_spread({}, children), {
      count: _object_spread_props(_object_spread({}, children.count), {
        value: childCount
      }),
      ages: childAges.length ? childAges.map(function (childAge) {
        return _object_spread_props(_object_spread({}, children.ageTemplate), {
          value: childAge
        });
      }) : []
    });
    return _object_spread({}, newChildren);
  }
  return _object_spread({}, room.children);
};
var getTravelersError = function (currentError, rooms, validations, currentInfantSelection) {
  if (!validations) {
    return null;
  }
  var travelersCount = rooms.reduce(function (count, room) {
    var _room_infants;
    var _room_infants_count_value;
    return count + room.adults.value + room.children.count.value + ((_room_infants_count_value = (_room_infants = room.infants) === null || _room_infants === void 0 ? void 0 : _room_infants.count.value) !== null && _room_infants_count_value !== void 0 ? _room_infants_count_value : 0);
  }, 0);
  var infantsOnLap = currentInfantSelection === "lap" ? rooms.reduce(function (count, room) {
    var _room_infants;
    var _room_infants_count_value;
    return count + ((_room_infants_count_value = (_room_infants = room.infants) === null || _room_infants === void 0 ? void 0 : _room_infants.count.value) !== null && _room_infants_count_value !== void 0 ? _room_infants_count_value : 0);
  }, 0) : 0;
  var infantInSeat = currentInfantSelection === "seat" ? rooms.reduce(function (count, room) {
    var _room_infants;
    var _room_infants_count_value;
    return count + ((_room_infants_count_value = (_room_infants = room.infants) === null || _room_infants === void 0 ? void 0 : _room_infants.count.value) !== null && _room_infants_count_value !== void 0 ? _room_infants_count_value : 0);
  }, 0) : 0;
  var adultCount = rooms.reduce(function (count, room) {
    var _room_adults_value;
    return count + ((_room_adults_value = room.adults.value) !== null && _room_adults_value !== void 0 ? _room_adults_value : 0);
  }, 0);
  var olderChildren = rooms.reduce(function (count, room) {
    var ages = room.children.__typename === "EGDSTravelerChildren" ? room.children.ages : [];
    var _ages_filter_length;
    return count + ((_ages_filter_length = ages.filter(function (age) {
      return age.__typename === "EGDSTravelerChildAgeSelect" && age.value && age.value >= 12;
    }).length) !== null && _ages_filter_length !== void 0 ? _ages_filter_length : 0);
  }, 0);
  var childWithoutAgeCount = getChildCountWithoutAge(rooms);
  var checkInfantsOnLap = olderChildren + adultCount < infantsOnLap;
  var errors = validations.map(function (validation) {
    if (validation.__typename === "EGDSTravelersInputValidation") {
      var type = validation.type,
        message = validation.errorMessage,
        maxCount = validation.maxCount,
        errorSummary2 = validation.errorSummary,
        infantsInSeatPerAdult = validation.infantsInSeatPerAdult;
      var _obj;
      var validationErrors = (_obj = {}, _define_property(_obj, "MAX_TRAVELERS" /* MAX_TRAVELERS */, maxCount && travelersCount > maxCount ? {
        message: message,
        type: type,
        displayConfirmation: true,
        errorCount: 1,
        errorSummary: _object_spread_props(_object_spread({}, errorSummary2), {
          heading: message
        })
      } : null), _define_property(_obj, "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */, childWithoutAgeCount > 0 ? {
        message: message,
        type: type,
        displayConfirmation: false,
        errorCount: childWithoutAgeCount,
        errorSummary: errorSummary2
      } : null), _define_property(_obj, "MANY_INFANT_ON_LAP" /* MANY_INFANT_ON_LAP */, checkInfantsOnLap ? {
        message: message,
        type: type,
        displayConfirmation: true,
        errorCount: 1,
        errorSummary: errorSummary2
      } : null), _define_property(_obj, "MANY_INFANT_IN_SEAT" /* MANY_INFANT_IN_SEAT */, infantsInSeatPerAdult && olderChildren + adultCount < infantInSeat / infantsInSeatPerAdult ? {
        message: message,
        type: type,
        displayConfirmation: true,
        errorCount: 1,
        errorSummary: errorSummary2
      } : null), _obj);
      var _validationErrors_type;
      return (_validationErrors_type = validationErrors[type]) !== null && _validationErrors_type !== void 0 ? _validationErrors_type : null;
    }
    return null;
  }).filter(function (error) {
    return error !== null;
  });
  var sameErrorPresent = errors.find(function (error) {
    return currentError && currentError.type === error.type;
  });
  if (sameErrorPresent && (currentError === null || currentError === void 0 ? void 0 : currentError.displayConfirmation)) {
    return _object_spread_props(_object_spread({}, currentError), {
      errorCount: currentError.type === "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */ ? childWithoutAgeCount : 1
    });
  }
  var _errors_;
  return (_errors_ = errors[0]) !== null && _errors_ !== void 0 ? _errors_ : null;
};
var travelersReducer = function (state, action) {
  switch (action.type) {
    case "ADD_ROOM":
      {
        var _state_rooms_ = state.rooms[0],
          adults = _state_rooms_.adults,
          label = _state_rooms_.label,
          removeRoomButton = _state_rooms_.removeRoomButton,
          removeRoomAnnouncement = _state_rooms_.removeRoomAnnouncement,
          children = _state_rooms_.children,
          infants = _state_rooms_.infants;
        if (adults.__typename === "EGDSTravelerStepInput" && children.__typename === "EGDSTravelerChildren" && children.ages) {
          var _state_infantSeatSelection;
          var defaultChildrenCount = _object_spread_props(_object_spread({}, children.count), {
            value: 0
          });
          var defaultRoom = {
            __typename: "EGDSTravelerSelectorRoom",
            children: _object_spread_props(_object_spread({}, children), {
              count: defaultChildrenCount,
              ages: []
            }),
            adults: _object_spread_props(_object_spread({}, adults), {
              value: 1
            }),
            label: label,
            removeRoomButton: removeRoomButton,
            removeRoomAnnouncement: removeRoomAnnouncement,
            infants: (infants === null || infants === void 0 ? void 0 : infants.__typename) === "EGDSTravelerInfant" ? _object_spread_props(_object_spread({}, infants), {
              count: _object_spread_props(_object_spread({}, infants.count), {
                value: 0
              }),
              ages: []
            }) : null
          };
          var rooms = state.rooms.concat(defaultRoom);
          var _state_validations;
          var error = getTravelersError(state.error ? state.error : null, rooms, (_state_validations = state.validations) !== null && _state_validations !== void 0 ? _state_validations : [], (_state_infantSeatSelection = state.infantSeatSelection) === null || _state_infantSeatSelection === void 0 ? void 0 : _state_infantSeatSelection.value);
          return _object_spread_props(_object_spread({}, state), {
            rooms: rooms,
            error: error
          });
        }
        return _object_spread_props(_object_spread({}, state), {
          rooms: []
        });
      }
    case "REMOVE_ROOM":
      {
        var _state_infantSeatSelection1;
        var roomIndex = action.roomIndex;
        var rooms1 = state.rooms.filter(function (_, index) {
          return index !== roomIndex;
        });
        var _state_validations1;
        var error1 = getTravelersError(state.error ? state.error : null, rooms1, (_state_validations1 = state.validations) !== null && _state_validations1 !== void 0 ? _state_validations1 : [], (_state_infantSeatSelection1 = state.infantSeatSelection) === null || _state_infantSeatSelection1 === void 0 ? void 0 : _state_infantSeatSelection1.value);
        return _object_spread_props(_object_spread({}, state), {
          rooms: rooms1,
          error: error1
        });
      }
    case "RESET_STATE":
      {
        return action.state;
      }
    case "RESET_ROOMS":
      {
        return _object_spread_props(_object_spread({}, state), {
          rooms: action.state.rooms
        });
      }
    case "UPDATE_INFANT_SEAT_SELECTION":
      {
        var value = action.value;
        var _state_validations2;
        var error2 = getTravelersError(state.error ? state.error : null, state.rooms, (_state_validations2 = state.validations) !== null && _state_validations2 !== void 0 ? _state_validations2 : [], value);
        return _object_spread_props(_object_spread({}, state), {
          infantSeatSelection: {
            value: action.value
          },
          error: error2
        });
      }
    case "UPDATE_TRAVELERS_COUNT":
      {
        var _state_infantSeatSelection2;
        var roomIndex1 = action.roomIndex,
          count = action.count,
          travelersType = action.travelersType;
        var rooms2 = state.rooms.map(function (room, index) {
          if (index === roomIndex1) {
            switch (travelersType) {
              case "adults" /* ADULTS */:
                {
                  return _object_spread_props(_object_spread({}, room), {
                    adults: _object_spread_props(_object_spread({}, room.adults), {
                      value: count
                    })
                  });
                }
              case "children" /* CHILDREN */:
                {
                  if (room.children.__typename === "EGDSTravelerChildren") {
                    var _children_ages, _children_ages1;
                    var children = room.children;
                    var childrenAdded = count > children.count.value;
                    var ageTemplateWithoutDefaultAge = children.ageTemplate.__typename === "EGDSTravelerChildAgeSelect" ? _object_spread_props(_object_spread({}, children.ageTemplate), {
                      value: null
                    }) : null;
                    var ages = childrenAdded ? (_children_ages = children.ages) === null || _children_ages === void 0 ? void 0 : _children_ages.concat(ageTemplateWithoutDefaultAge !== null && ageTemplateWithoutDefaultAge !== void 0 ? ageTemplateWithoutDefaultAge : children.ageTemplate) : (_children_ages1 = children.ages) === null || _children_ages1 === void 0 ? void 0 : _children_ages1.slice(0, -1);
                    var newChildren = _object_spread_props(_object_spread({}, children), {
                      count: _object_spread_props(_object_spread({}, children.count), {
                        value: count
                      }),
                      ages: ages
                    });
                    return _object_spread_props(_object_spread({}, room), {
                      children: newChildren
                    });
                  }
                  return room;
                }
              case "infants" /* INFANTS */:
                {
                  var _room_infants;
                  if (((_room_infants = room.infants) === null || _room_infants === void 0 ? void 0 : _room_infants.__typename) === "EGDSTravelerInfant") {
                    var infants = room.infants;
                    var infantsAdded = count > infants.count.value;
                    var ages1 = infantsAdded ? infants.ages.concat(infants.ageTemplate) : infants.ages.slice(0, -1);
                    var newInfants = _object_spread_props(_object_spread({}, infants), {
                      count: _object_spread_props(_object_spread({}, infants.count), {
                        value: count
                      }),
                      ages: ages1
                    });
                    return _object_spread_props(_object_spread({}, room), {
                      infants: newInfants
                    });
                  }
                  return room;
                }
              default:
                return room;
            }
          }
          return room;
        });
        var _state_validations3;
        var error3 = getTravelersError(state.error ? state.error : null, rooms2, (_state_validations3 = state.validations) !== null && _state_validations3 !== void 0 ? _state_validations3 : [], (_state_infantSeatSelection2 = state.infantSeatSelection) === null || _state_infantSeatSelection2 === void 0 ? void 0 : _state_infantSeatSelection2.value);
        return _object_spread_props(_object_spread({}, state), {
          rooms: rooms2,
          error: error3
        });
      }
    case "UPDATE_CHILD_AGE":
      {
        var _state_infantSeatSelection3;
        var roomIndex2 = action.roomIndex,
          childIndex = action.childIndex,
          childAge = action.childAge,
          isInfant = action.isInfant;
        var rooms3 = state.rooms.map(function (room, index) {
          var _room_infants;
          if (index === roomIndex2 && room.children.__typename === "EGDSTravelerChildren" && !isInfant) {
            return _object_spread_props(_object_spread({}, room), {
              children: _object_spread_props(_object_spread({}, room.children), {
                ages: room.children.ages.map(function (child, ageIndex) {
                  return child.__typename === "EGDSTravelerChildAgeSelect" && childIndex === ageIndex ? _object_spread_props(_object_spread({}, child), {
                    value: childAge
                  }) : _object_spread({}, child);
                })
              })
            });
          }
          if (index === roomIndex2 && ((_room_infants = room.infants) === null || _room_infants === void 0 ? void 0 : _room_infants.__typename) === "EGDSTravelerInfant" && isInfant) {
            return _object_spread_props(_object_spread({}, room), {
              infants: _object_spread_props(_object_spread({}, room.infants), {
                ages: room.infants.ages.map(function (infant, ageIndex) {
                  return infant.__typename === "EGDSTravelerChildAgeSelect" && childIndex === ageIndex ? _object_spread_props(_object_spread({}, infant), {
                    value: childAge
                  }) : _object_spread({}, infant);
                })
              })
            });
          }
          return room;
        });
        var _state_validations4;
        var error4 = getTravelersError(state.error ? state.error : null, rooms3, (_state_validations4 = state.validations) !== null && _state_validations4 !== void 0 ? _state_validations4 : [], (_state_infantSeatSelection3 = state.infantSeatSelection) === null || _state_infantSeatSelection3 === void 0 ? void 0 : _state_infantSeatSelection3.value);
        return _object_spread_props(_object_spread({}, state), {
          rooms: rooms3,
          error: error4
        });
      }
    case "SHOW_ERROR":
      {
        if (state.error) {
          var _state_error = state.error,
            message = _state_error.message,
            type = _state_error.type,
            errorCount = _state_error.errorCount,
            errorSummary2 = _state_error.errorSummary;
          var newError = {
            message: message,
            type: type,
            displayConfirmation: true,
            errorCount: errorCount,
            errorSummary: errorSummary2
          };
          return _object_spread_props(_object_spread({}, state), {
            error: newError
          });
        }
        return _object_spread({}, state);
      }
    case "SET_VALIDATIONS":
      {
        return _object_spread_props(_object_spread({}, state), {
          validations: action.validations
        });
      }
    case "UPDATE_TRAVELERS_BULK":
      {
        var adultTravelerCounts = action.adultTravelerCounts,
          childTravelerCounts = action.childTravelerCounts,
          childrenAges = action.childrenAges;
        if (adultTravelerCounts === null || adultTravelerCounts === void 0 ? void 0 : adultTravelerCounts.length) {
          var newRooms = adultTravelerCounts.map(function (adultCount, roomIndex) {
            return _object_spread_props(_object_spread({}, state.rooms[roomIndex]), {
              adults: _object_spread_props(_object_spread({}, state.rooms[roomIndex].adults), {
                value: adultCount
              }),
              children: (childrenAges === null || childrenAges === void 0 ? void 0 : childrenAges.length) ? getChildren((childTravelerCounts === null || childTravelerCounts === void 0 ? void 0 : childTravelerCounts.length) ? childTravelerCounts[roomIndex] : 0, childrenAges[roomIndex], state.rooms[roomIndex]) : _object_spread_props(_object_spread({}, state.rooms[roomIndex].children), {
                count: _object_spread_props(_object_spread({}, state.rooms[roomIndex].children.count), {
                  value: 0
                }),
                ages: []
              })
            });
          });
          return _object_spread_props(_object_spread({}, state), {
            rooms: newRooms
          });
        }
        return _object_spread({}, state);
      }
    default:
      return state;
  }
};
var TravelersContext = React46.createContext({
  state: {}
});
var TravelersProvider = function (param) {
  var children = param.children,
    rooms = param.rooms,
    validations = param.validations,
    skipQuery = param.skipQuery,
    infantSeatSelection = param.infantSeatSelection;
  var _React46_useReducer = _sliced_to_array(React46.useReducer(travelersReducer, {
      rooms: rooms,
      validations: validations,
      infantSeatSelection: infantSeatSelection ? {
        value: infantSeatSelection.selected
      } : null
    }), 2),
    state = _React46_useReducer[0],
    dispatch = _React46_useReducer[1];
  var _React46_useState = _sliced_to_array(React46.useState(state), 2),
    currentState = _React46_useState[0],
    setCurrentState = _React46_useState[1];
  React46.useEffect(function () {
    if (!skipQuery) {
      dispatch({
        type: "RESET_STATE",
        state: {
          rooms: rooms,
          validations: validations,
          infantSeatSelection: infantSeatSelection ? {
            value: infantSeatSelection.selected
          } : null
        }
      });
    }
  }, [skipQuery, infantSeatSelection, rooms]);
  React46.useEffect(function () {
    if (state !== currentState) {
      setCurrentState(state);
    }
  }, [state, currentState]);
  React46.useEffect(function () {
    dispatch({
      type: "SET_VALIDATIONS",
      validations: validations
    });
  }, [validations]);
  var travelersContext = {
    state: currentState,
    dispatch: dispatch
  };
  return /* @__PURE__ */React46.createElement(TravelersContext.Provider, {
    value: travelersContext
  }, children);
};
var useTravelersContext = function () {
  return React46.useContext(TravelersContext);
};
// ../internal/src/components/form/egds-search-form-travelers-field/travelers-basic-provider.tsx
var noAgeSelected2 = function (childrenAge) {
  return childrenAge.__typename === "EGDSTravelerChildAgeSelect" && childrenAge.value === null;
};
var noInfantsInSeatAgeSelected = function (infantsInSeatAge) {
  return infantsInSeatAge.__typename === "EGDSTravelerChildAgeSelect" && infantsInSeatAge.value === null;
};
var noInfantsOnLapAgeSelected = function (infantsOnLap) {
  return infantsOnLap.__typename === "EGDSTravelerChildAgeSelect" && infantsOnLap.value === null;
};
var getChildCountWithoutAge2 = function (children) {
  return (children === null || children === void 0 ? void 0 : children.__typename) === "EGDSTravelerChildren" ? children.ages.filter(noAgeSelected2).length : 0;
};
var getInfantsInSeatCountWithoutAge = function (infantInSeat) {
  return (infantInSeat === null || infantInSeat === void 0 ? void 0 : infantInSeat.__typename) === "EGDSTravelerInfant" ? infantInSeat === null || infantInSeat === void 0 ? void 0 : infantInSeat.ages.filter(noInfantsInSeatAgeSelected).length : 0;
};
var getInfantsOnLapCountWithoutAge = function (infantOnLap) {
  return (infantOnLap === null || infantOnLap === void 0 ? void 0 : infantOnLap.__typename) === "EGDSTravelerInfant" ? infantOnLap === null || infantOnLap === void 0 ? void 0 : infantOnLap.ages.filter(noInfantsOnLapAgeSelected).length : 0;
};
var getTravelersError2 = function (currentError, travelers, validations) {
  var _travelers_children, _travelers_infantsInSeat, _travelers_infantsOnLap, _travelers_children1, _travelers_children2;
  if (!validations) {
    return null;
  }
  var _travelers_children_count_value;
  var childrenCount = (_travelers_children_count_value = (_travelers_children = travelers.children) === null || _travelers_children === void 0 ? void 0 : _travelers_children.count.value) !== null && _travelers_children_count_value !== void 0 ? _travelers_children_count_value : 0;
  var _travelers_infantsInSeat_count_value;
  var infantInSeat = (_travelers_infantsInSeat_count_value = (_travelers_infantsInSeat = travelers.infantsInSeat) === null || _travelers_infantsInSeat === void 0 ? void 0 : _travelers_infantsInSeat.count.value) !== null && _travelers_infantsInSeat_count_value !== void 0 ? _travelers_infantsInSeat_count_value : 0;
  var _travelers_infantsOnLap_count_value;
  var infantsOnLap = (_travelers_infantsOnLap_count_value = (_travelers_infantsOnLap = travelers.infantsOnLap) === null || _travelers_infantsOnLap === void 0 ? void 0 : _travelers_infantsOnLap.count.value) !== null && _travelers_infantsOnLap_count_value !== void 0 ? _travelers_infantsOnLap_count_value : 0;
  var _travelers_adults_value;
  var adultCount = (_travelers_adults_value = travelers.adults.value) !== null && _travelers_adults_value !== void 0 ? _travelers_adults_value : 0;
  var travelersCount = adultCount + childrenCount + infantInSeat + infantsOnLap;
  var childWithoutAgeCount = getChildCountWithoutAge2(travelers.children);
  var infantInSeatWithoutAgeCount = getInfantsInSeatCountWithoutAge(travelers.infantsInSeat);
  var infantsOnLapWithoutAgeCount = getInfantsOnLapCountWithoutAge(travelers.infantsOnLap);
  var kidsWithoutAgeCount = childWithoutAgeCount + infantInSeatWithoutAgeCount + infantsOnLapWithoutAgeCount;
  var olderChildren = ((_travelers_children1 = travelers.children) === null || _travelers_children1 === void 0 ? void 0 : _travelers_children1.__typename) === "EGDSTravelerChildren" ? (_travelers_children2 = travelers.children) === null || _travelers_children2 === void 0 ? void 0 : _travelers_children2.ages.filter(function (age) {
    return age.__typename === "EGDSTravelerChildAgeSelect" && age.value && age.value >= 12;
  }).length : 0;
  var checkInfantsOnLap = olderChildren + adultCount < infantsOnLap;
  var errors = validations.map(function (validation) {
    if (validation.__typename === "EGDSTravelersInputValidation") {
      var type = validation.type,
        message = validation.errorMessage,
        maxCount = validation.maxCount,
        errorSummary2 = validation.errorSummary,
        infantsInSeatPerAdult = validation.infantsInSeatPerAdult;
      var _obj;
      var validationErrors = (_obj = {}, _define_property(_obj, "MAX_TRAVELERS" /* MAX_TRAVELERS */, maxCount ? travelersCount > maxCount && {
        message: message,
        type: type,
        displayConfirmation: true,
        errorCount: 1,
        errorSummary: errorSummary2
      } : null), _define_property(_obj, "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */, kidsWithoutAgeCount > 0 ? {
        message: message,
        type: type,
        displayConfirmation: false,
        errorCount: kidsWithoutAgeCount,
        errorSummary: errorSummary2
      } : null), _define_property(_obj, "MANY_INFANT_ON_LAP" /* MANY_INFANT_ON_LAP */, checkInfantsOnLap ? {
        message: message,
        type: type,
        displayConfirmation: true,
        errorCount: 1,
        errorSummary: errorSummary2
      } : null), _define_property(_obj, "MANY_INFANT_IN_SEAT" /* MANY_INFANT_IN_SEAT */, infantsInSeatPerAdult && olderChildren + adultCount < infantInSeat / infantsInSeatPerAdult ? {
        message: message,
        type: type,
        displayConfirmation: true,
        errorCount: 1,
        errorSummary: errorSummary2
      } : null), _obj);
      return validationErrors[type];
    }
    return null;
  }).filter(function (error) {
    return !!error;
  });
  var sameErrorPresent = errors.find(function (error) {
    return currentError && currentError.type === (error === null || error === void 0 ? void 0 : error.type);
  });
  if (sameErrorPresent && (currentError === null || currentError === void 0 ? void 0 : currentError.displayConfirmation)) {
    return _object_spread_props(_object_spread({}, currentError), {
      errorCount: currentError.type === "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */ ? kidsWithoutAgeCount : 1
    });
  }
  return errors ? errors[0] : null;
};
var getTravelersWithPets = function (travelers, petCount) {
  var _travelers_pets;
  if (((_travelers_pets = travelers.pets) === null || _travelers_pets === void 0 ? void 0 : _travelers_pets.__typename) === "EGDSBasicCheckBox") {
    var state = petCount > 0 ? "CHECKED" /* CHECKED */ : "UNCHECKED" /* UNCHECKED */;
    return _object_spread_props(_object_spread({}, travelers), {
      pets: _object_spread_props(_object_spread({}, travelers.pets), {
        state: state
      })
    });
  }
  return travelers;
};
var getUpdatedTravelersBulk = function (adultCount, childCount, childrenAges, travelers) {
  var _travelers_children;
  if (((_travelers_children = travelers.children) === null || _travelers_children === void 0 ? void 0 : _travelers_children.__typename) === "EGDSTravelerChildren") {
    var children = travelers.children;
    return _object_spread_props(_object_spread({}, travelers), {
      adults: _object_spread_props(_object_spread({}, travelers.adults), {
        value: adultCount
      }),
      children: _object_spread_props(_object_spread({}, travelers.children), {
        count: _object_spread_props(_object_spread({}, travelers.children.count), {
          value: childCount
        }),
        ages: childrenAges.length ? childrenAges.map(function (childAge) {
          return _object_spread_props(_object_spread({}, children === null || children === void 0 ? void 0 : children.ageTemplate), {
            value: childAge
          });
        }) : []
      })
    });
  }
  return travelers;
};
var getUpdatedTravelersCount = function (travelers, action) {
  switch (action.travelersType) {
    case "adults" /* ADULTS */:
      {
        return _object_spread_props(_object_spread({}, travelers), {
          adults: _object_spread_props(_object_spread({}, travelers.adults), {
            value: action.count
          })
        });
      }
    case "children" /* CHILDREN */:
      {
        var _travelers_children, _travelers_children1;
        if (((_travelers_children = travelers.children) === null || _travelers_children === void 0 ? void 0 : _travelers_children.__typename) === "EGDSTravelerChildren") {
          var _children_ages, _children_ages1;
          var children = travelers.children;
          var childrenAdded = action.count > children.count.value;
          var ageTemplateWithoutDefaultAge = children.ageTemplate.__typename === "EGDSTravelerChildAgeSelect" ? _object_spread_props(_object_spread({}, children.ageTemplate), {
            value: null
          }) : null;
          var ages = childrenAdded ? (_children_ages = children.ages) === null || _children_ages === void 0 ? void 0 : _children_ages.concat(ageTemplateWithoutDefaultAge !== null && ageTemplateWithoutDefaultAge !== void 0 ? ageTemplateWithoutDefaultAge : children.ageTemplate) : (_children_ages1 = children.ages) === null || _children_ages1 === void 0 ? void 0 : _children_ages1.slice(0, -1);
          var newChildren = _object_spread_props(_object_spread({}, children), {
            count: _object_spread_props(_object_spread({}, children.count), {
              value: action.count
            }),
            ages: ages
          });
          return _object_spread_props(_object_spread({}, travelers), {
            children: newChildren
          });
        }
        if (((_travelers_children1 = travelers.children) === null || _travelers_children1 === void 0 ? void 0 : _travelers_children1.__typename) === "EGDSBasicTraveler") {
          var children1 = travelers.children;
          return _object_spread_props(_object_spread({}, travelers), {
            children: _object_spread_props(_object_spread({}, children1), {
              count: _object_spread_props(_object_spread({}, children1.count), {
                value: action.count
              })
            })
          });
        }
        return travelers;
      }
    case "infants_in_seat" /* INFANTS_IN_SEAT */:
      {
        var _travelers_infantsInSeat, _travelers_infantsOnLap, _travelers_infantsInSeat1;
        if (((_travelers_infantsInSeat = travelers.infantsInSeat) === null || _travelers_infantsInSeat === void 0 ? void 0 : _travelers_infantsInSeat.__typename) === "EGDSTravelerInfant" && ((_travelers_infantsOnLap = travelers.infantsOnLap) === null || _travelers_infantsOnLap === void 0 ? void 0 : _travelers_infantsOnLap.__typename) === "EGDSTravelerInfant") {
          var _infantsInSeat_ages, _infantsInSeat_ages1;
          var infantsInSeat = travelers.infantsInSeat,
            infantsOnLap = travelers.infantsOnLap;
          var infantsInSeatAdded = action.count > infantsInSeat.count.value;
          var ages1 = infantsInSeatAdded ? (_infantsInSeat_ages = infantsInSeat.ages) === null || _infantsInSeat_ages === void 0 ? void 0 : _infantsInSeat_ages.concat(infantsInSeat.ageTemplate) : (_infantsInSeat_ages1 = infantsInSeat.ages) === null || _infantsInSeat_ages1 === void 0 ? void 0 : _infantsInSeat_ages1.slice(0, -1);
          var newInfantsInSeat = _object_spread_props(_object_spread({}, infantsInSeat), {
            count: _object_spread_props(_object_spread({}, infantsInSeat.count), {
              value: action.count
            }),
            ages: ages1
          });
          var maxAllowedInfantsOnLap = newInfantsInSeat.count.value > 0 ? 0 : newInfantsInSeat.count.max;
          var newinfantsOnLap = _object_spread_props(_object_spread({}, infantsOnLap), {
            count: _object_spread_props(_object_spread({}, infantsOnLap === null || infantsOnLap === void 0 ? void 0 : infantsOnLap.count), {
              max: maxAllowedInfantsOnLap
            })
          });
          return _object_spread_props(_object_spread({}, travelers), {
            infantsInSeat: newInfantsInSeat,
            infantsOnLap: newinfantsOnLap
          });
        }
        if (((_travelers_infantsInSeat1 = travelers.infantsInSeat) === null || _travelers_infantsInSeat1 === void 0 ? void 0 : _travelers_infantsInSeat1.__typename) === "EGDSBasicTraveler") {
          var infantsInSeat1 = travelers.infantsInSeat;
          return _object_spread_props(_object_spread({}, travelers), {
            infantsInSeat: _object_spread_props(_object_spread({}, infantsInSeat1), {
              count: _object_spread_props(_object_spread({}, infantsInSeat1.count), {
                value: action.count
              })
            })
          });
        }
        return travelers;
      }
    case "infants_on_lap" /* INFANTS_ON_LAP */:
      {
        var _travelers_infantsOnLap1, _travelers_infantsInSeat2, _travelers_infantsOnLap2;
        if (((_travelers_infantsOnLap1 = travelers.infantsOnLap) === null || _travelers_infantsOnLap1 === void 0 ? void 0 : _travelers_infantsOnLap1.__typename) === "EGDSTravelerInfant" && ((_travelers_infantsInSeat2 = travelers.infantsInSeat) === null || _travelers_infantsInSeat2 === void 0 ? void 0 : _travelers_infantsInSeat2.__typename) === "EGDSTravelerInfant") {
          var _infantsOnLap_ages, _infantsOnLap_ages1;
          var infantsOnLap1 = travelers.infantsOnLap,
            infantsInSeat2 = travelers.infantsInSeat;
          var infantsOnLapAdded = action.count > infantsOnLap1.count.value;
          var ages2 = infantsOnLapAdded ? (_infantsOnLap_ages = infantsOnLap1.ages) === null || _infantsOnLap_ages === void 0 ? void 0 : _infantsOnLap_ages.concat(infantsOnLap1.ageTemplate) : (_infantsOnLap_ages1 = infantsOnLap1.ages) === null || _infantsOnLap_ages1 === void 0 ? void 0 : _infantsOnLap_ages1.slice(0, -1);
          var newInfantsOnLap = _object_spread_props(_object_spread({}, infantsOnLap1), {
            count: _object_spread_props(_object_spread({}, infantsOnLap1.count), {
              value: action.count
            }),
            ages: ages2
          });
          var maxAllowedInfantsInSeat = newInfantsOnLap.count.value > 0 ? 0 : newInfantsOnLap.count.max;
          var newinfantsInSeat = _object_spread_props(_object_spread({}, infantsInSeat2), {
            count: _object_spread_props(_object_spread({}, infantsInSeat2 === null || infantsInSeat2 === void 0 ? void 0 : infantsInSeat2.count), {
              max: maxAllowedInfantsInSeat
            })
          });
          return _object_spread_props(_object_spread({}, travelers), {
            infantsOnLap: newInfantsOnLap,
            infantsInSeat: newinfantsInSeat
          });
        }
        if (((_travelers_infantsOnLap2 = travelers.infantsOnLap) === null || _travelers_infantsOnLap2 === void 0 ? void 0 : _travelers_infantsOnLap2.__typename) === "EGDSBasicTraveler") {
          var infantsOnLap2 = travelers.infantsOnLap;
          return _object_spread_props(_object_spread({}, travelers), {
            infantsOnLap: _object_spread_props(_object_spread({}, infantsOnLap2), {
              count: _object_spread_props(_object_spread({}, infantsOnLap2.count), {
                value: action.count
              })
            })
          });
        }
        return travelers;
      }
    default:
      return travelers;
  }
};
var getUpdatedChildAge = function (travelers, action) {
  var _travelers_children, _travelers_infantsInSeat, _travelers_infantsOnLap;
  if (((_travelers_children = travelers.children) === null || _travelers_children === void 0 ? void 0 : _travelers_children.__typename) === "EGDSTravelerChildren" && action.infantType === "") {
    return _object_spread_props(_object_spread({}, travelers), {
      children: _object_spread_props(_object_spread({}, travelers.children), {
        ages: travelers.children.ages.map(function (child, ageIndex) {
          return child.__typename === "EGDSTravelerChildAgeSelect" && action.childIndex === ageIndex ? _object_spread_props(_object_spread({}, child), {
            value: action.childAge
          }) : _object_spread({}, child);
        })
      })
    });
  }
  if (((_travelers_infantsInSeat = travelers.infantsInSeat) === null || _travelers_infantsInSeat === void 0 ? void 0 : _travelers_infantsInSeat.__typename) === "EGDSTravelerInfant" && action.infantType === "infants_in_seat" /* INFANTS_IN_SEAT */) {
    return _object_spread_props(_object_spread({}, travelers), {
      infantsInSeat: _object_spread_props(_object_spread({}, travelers.infantsInSeat), {
        ages: travelers.infantsInSeat.ages.map(function (infantInSeat, ageIndex) {
          return infantInSeat.__typename === "EGDSTravelerChildAgeSelect" && action.childIndex === ageIndex ? _object_spread_props(_object_spread({}, infantInSeat), {
            value: action.childAge
          }) : _object_spread({}, infantInSeat);
        })
      })
    });
  }
  if (((_travelers_infantsOnLap = travelers.infantsOnLap) === null || _travelers_infantsOnLap === void 0 ? void 0 : _travelers_infantsOnLap.__typename) === "EGDSTravelerInfant" && action.infantType === "infants_on_lap" /* INFANTS_ON_LAP */) {
    return _object_spread_props(_object_spread({}, travelers), {
      infantsOnLap: _object_spread_props(_object_spread({}, travelers.infantsOnLap), {
        ages: travelers.infantsOnLap.ages.map(function (infantsOnLap, ageIndex) {
          return infantsOnLap.__typename === "EGDSTravelerChildAgeSelect" && action.childIndex === ageIndex ? _object_spread_props(_object_spread({}, infantsOnLap), {
            value: action.childAge
          }) : _object_spread({}, infantsOnLap);
        })
      })
    });
  }
  return travelers;
};
var getUpdatedPetsFilter = function (travelers, action) {
  var _travelers_pets;
  if (((_travelers_pets = travelers.pets) === null || _travelers_pets === void 0 ? void 0 : _travelers_pets.__typename) === "EGDSBasicCheckBox") {
    var state = action.checked ? "CHECKED" /* CHECKED */ : "UNCHECKED" /* UNCHECKED */;
    return _object_spread_props(_object_spread({}, travelers), {
      pets: _object_spread_props(_object_spread({}, travelers.pets), {
        state: state
      })
    });
  }
  return travelers;
};
var travelersReducer2 = function (state, action) {
  switch (action.type) {
    case "RESET_STATE":
      {
        return action.state;
      }
    case "UPDATE_TRAVELERS_COUNT":
      {
        var travelers = getUpdatedTravelersCount(state.travelers, action);
        var _state_validations;
        var error = getTravelersError2(state.error ? state.error : null, travelers, (_state_validations = state.validations) !== null && _state_validations !== void 0 ? _state_validations : []);
        return _object_spread_props(_object_spread({}, state), {
          travelers: travelers,
          error: error
        });
      }
    case "UPDATE_CHILD_AGE":
      {
        var travelers1 = getUpdatedChildAge(state.travelers, action);
        var _state_validations1;
        var error1 = getTravelersError2(state.error ? state.error : null, travelers1, (_state_validations1 = state.validations) !== null && _state_validations1 !== void 0 ? _state_validations1 : []);
        return _object_spread_props(_object_spread({}, state), {
          travelers: travelers1,
          error: error1
        });
      }
    case "UPDATE_PETS_FILTER":
      {
        var travelers2 = getUpdatedPetsFilter(state.travelers, action);
        var _state_validations2;
        var error2 = getTravelersError2(state.error ? state.error : null, travelers2, (_state_validations2 = state.validations) !== null && _state_validations2 !== void 0 ? _state_validations2 : []);
        return _object_spread_props(_object_spread({}, state), {
          travelers: travelers2,
          error: error2
        });
      }
    case "SHOW_ERROR":
      {
        if (state.error) {
          var _state_error = state.error,
            message = _state_error.message,
            type = _state_error.type,
            errorCount = _state_error.errorCount,
            errorSummary2 = _state_error.errorSummary;
          var newError = {
            message: message,
            type: type,
            displayConfirmation: true,
            errorCount: errorCount,
            errorSummary: errorSummary2
          };
          return _object_spread_props(_object_spread({}, state), {
            error: newError
          });
        }
        return _object_spread({}, state);
      }
    case "UPDATE_TRAVELERS_BULK":
      {
        var adultTravelerCounts = action.adultTravelerCounts,
          childTravelerCounts = action.childTravelerCounts,
          childrenAges = action.childrenAges,
          petCounts = action.petCounts;
        var travelers3 = getUpdatedTravelersBulk(adultTravelerCounts, childTravelerCounts, childrenAges, state.travelers);
        var travelersWithPets = getTravelersWithPets(travelers3, petCounts);
        var _state_validations3;
        var error3 = getTravelersError2(state.error ? state.error : null, travelers3, (_state_validations3 = state.validations) !== null && _state_validations3 !== void 0 ? _state_validations3 : []);
        return _object_spread_props(_object_spread({}, state), {
          travelers: travelersWithPets,
          error: error3
        });
      }
    default:
      return state;
  }
};
var TravelersContext2 = React47.createContext({
  state: {}
});
var BasicTravelersProvider = function (param) {
  var children = param.children,
    travelers = param.travelers,
    validations = param.validations,
    skipQuery = param.skipQuery;
  var _React47_useReducer = _sliced_to_array(React47.useReducer(travelersReducer2, {
      travelers: travelers,
      validations: validations
    }), 2),
    state = _React47_useReducer[0],
    dispatch = _React47_useReducer[1];
  React47.useEffect(function () {
    if (!skipQuery) {
      dispatch({
        type: "RESET_STATE",
        state: {
          travelers: travelers,
          validations: validations
        }
      });
    }
  }, [skipQuery]);
  var travelersContext = React47.useMemo(function () {
    return {
      state: state,
      dispatch: dispatch
    };
  }, [state, dispatch]);
  return /* @__PURE__ */React47.createElement(TravelersContext2.Provider, {
    value: travelersContext
  }, children);
};
var useBasicTravelersContext = function () {
  return React47.useContext(TravelersContext2);
};
// ../internal/src/components/form/egds-search-form-travelers-field/egds-travelers-child-age-select.tsx
var __Fragment31 = gql38(_templateObject37(), EGDSBasicOption.fragment);
var EGDSTravelerChildAgeSelect = function (param) {
  var childIndex = param.childIndex,
    roomIndex = param.roomIndex,
    isInfant = param.isInfant,
    infantType = param.infantType,
    childAgeRef = param.childAgeRef,
    data = param.data;
  var travelersContext = useTravelersContext();
  var basicTravelersContext = useBasicTravelersContext();
  var hasRooms = roomIndex !== void 0;
  var labelTemplate = data.labelTemplate,
    options = data.options,
    egdsElementId = data.egdsElementId,
    value = data.value;
  var track = useClickTracker19();
  var onChange = function (event) {
    var age = parseInt(event.target.value, 10);
    var currentOption = options.find(function (option) {
      return option.__typename === "EGDSBasicOption" && option.value === event.target.value;
    });
    if (currentOption && (currentOption === null || currentOption === void 0 ? void 0 : currentOption.__typename) === "EGDSBasicOption" && (currentOption === null || currentOption === void 0 ? void 0 : currentOption.changeAnalytics)) {
      var _currentOption_changeAnalytics = currentOption.changeAnalytics,
        referrerId = _currentOption_changeAnalytics.referrerId,
        linkName = _currentOption_changeAnalytics.linkName;
      track(referrerId, linkName);
    }
    if (!Number.isNaN(age)) {
      if (hasRooms) {
        travelersContext.dispatch({
          type: "UPDATE_CHILD_AGE",
          roomIndex: roomIndex,
          childIndex: childIndex,
          childAge: age,
          isInfant: isInfant,
          infantType: infantType
        });
      } else {
        basicTravelersContext.dispatch({
          type: "UPDATE_CHILD_AGE",
          childIndex: childIndex,
          childAge: age,
          infantType: infantType
        });
      }
    }
  };
  var elementName = "child-".concat(egdsElementId).concat(hasRooms ? "-".concat(roomIndex) : "", "-").concat(childIndex);
  var elementId = "age-".concat(egdsElementId).concat(hasRooms ? "-".concat(roomIndex) : "", "-").concat(childIndex);
  var childNumber = childIndex + 1;
  var childAge = value !== null && value !== void 0 ? value : "";
  var hasValidChildAge = Number.isInteger(childAge);
  var error = (hasRooms ? travelersContext.state : basicTravelersContext.state).error;
  var hasError = (error === null || error === void 0 ? void 0 : error.type) === "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */ && error.displayConfirmation;
  var errorMessage = error && error.type === "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */ && !hasValidChildAge && hasError ? error.message : "";
  var label = labelTemplate.__typename === "EGDSBasicLocalizedText" && labelTemplate.models.length === 1 ? formatLocalizedTokenString(labelTemplate.template, labelTemplate.models[0].key, childNumber.toString()) : "";
  return /* @__PURE__ */React48.createElement(UitkSelect2, {
    domRef: childAgeRef,
    invalid: errorMessage,
    label: label,
    id: elementId,
    name: elementName,
    onChange: onChange,
    value: childAge,
    emptyState: typeof childAge === "string",
    required: true
  }, options.map(function (option) {
    return option.__typename === "EGDSBasicOption" && /* @__PURE__ */React48.createElement(EGDSBasicOption, {
      key: "".concat(elementName, "-").concat(option.value),
      data: option
    });
  }));
};
EGDSTravelerChildAgeSelect.displayName = "EGDSTravelerChildAgeSelectFragment";
EGDSTravelerChildAgeSelect.fragment = _object_spread_props(_object_spread({}, __Fragment31), {
  __typename: "EGDSTravelerChildAgeSelect"
});
// ../internal/src/components/form/egds-search-form-travelers-field/egds-travelers-step-input.tsx
import React49 from "react";
import { gql as gql40 } from "@apollo/client";
import { useClickTracker as useClickTracker20 } from "@shared-ui/clickstream-analytics-context";
import { UitkStepInput } from "uitk-react-step-input";
// ../internal/src/components/common/egds-text/egds-localized-text-fragments.ts
import { gql as gql39 } from "@apollo/client";
var TemplateModelFragment = gql39(_templateObject38());
var EGDSBasicLocalizedTextFragment = gql39(_templateObject39(), TemplateModelFragment);
var EGDSCardinalLocalizedTextFragment = gql39(_templateObject40(), TemplateModelFragment);
var EGDSCompositeLocalizedTextFragment = gql39(_templateObject41(), TemplateModelFragment);
var EGDSLocalizedTextFragment = gql39(_templateObject42(), EGDSBasicLocalizedTextFragment, EGDSCardinalLocalizedTextFragment, EGDSCompositeLocalizedTextFragment);
// ../internal/src/components/form/egds-search-form-travelers-field/egds-travelers-step-input.tsx
var __Fragment32 = gql40(_templateObject43(), EGDSBasicLocalizedTextFragment);
var getStepInputText = function (textTemplate, roomIndex) {
  if ((textTemplate === null || textTemplate === void 0 ? void 0 : textTemplate.__typename) === "EGDSBasicLocalizedText") {
    var roomNumber = (roomIndex + 1).toString();
    return formatLocalizedTokenString(textTemplate.template, textTemplate.models[0].key, roomNumber);
  }
  return "";
};
var EGDSTravelersStepInput = function (param) {
  var roomIndex = param.roomIndex,
    travelersType = param.travelersType,
    data = param.data;
  var label = data.label,
    max = data.max,
    min = data.min,
    subLabel = data.subLabel,
    value = data.value;
  var travelersContext = useTravelersContext();
  var basicTravelersContext = useBasicTravelersContext();
  var clickTracker = useClickTracker20();
  var hasRooms = roomIndex !== void 0;
  var stepInputTexts = data.__typename === "EGDSTravelerStepInput" && (hasRooms ? {
    incrementText: getStepInputText(data.increaseTextTemplate, roomIndex),
    decrementText: getStepInputText(data.decreaseTextTemplate, roomIndex)
  } : {
    incrementText: data.increaseText || "",
    decrementText: data.decreaseText || ""
  });
  var onChange = function (event) {
    var count = parseInt(event.target.value, 10);
    if (data.__typename === "EGDSTravelerStepInput") {
      var increaseAnalytics = data.increaseAnalytics,
        decreaseAnalytics = data.decreaseAnalytics;
      if (count > value && increaseAnalytics.referrerId && increaseAnalytics.linkName) {
        clickTracker(increaseAnalytics.referrerId, data.increaseAnalytics.linkName);
      } else if (decreaseAnalytics.referrerId && decreaseAnalytics.linkName) {
        clickTracker(decreaseAnalytics.referrerId, data.decreaseAnalytics.linkName);
      }
    }
    if (!Number.isNaN(count)) {
      if (hasRooms) {
        travelersContext.dispatch({
          type: "UPDATE_TRAVELERS_COUNT",
          travelersType: travelersType,
          roomIndex: roomIndex,
          count: count
        });
      } else {
        basicTravelersContext.dispatch({
          type: "UPDATE_TRAVELERS_COUNT",
          travelersType: travelersType,
          count: count
        });
      }
    }
  };
  var travelerId = data.__typename === "EGDSTravelerStepInput" ? "".concat(data.egdsElementId).concat(hasRooms ? "-".concat(roomIndex) : "") : "";
  return /* @__PURE__ */React49.createElement(UitkStepInput, _object_spread_props(_object_spread({}, stepInputTexts), {
    label: label,
    incrementId: "".concat(travelerId, "-increase"),
    decrementId: "".concat(travelerId, "-decrease"),
    min: min !== null && min !== void 0 ? min : 0,
    max: max !== null && max !== void 0 ? max : 0,
    onChange: onChange,
    value: value,
    description: subLabel !== null && subLabel !== void 0 ? subLabel : "",
    id: travelerId
  }));
};
EGDSTravelersStepInput.displayName = "EGDSTravelerStepInputFragment";
EGDSTravelersStepInput.fragment = _object_spread_props(_object_spread({}, __Fragment32), {
  __typename: "EGDSTravelerStepInput"
});
// ../internal/src/components/form/egds-search-form-travelers-field/egds-travelers-children.tsx
var __Fragment33 = gql41(_templateObject44(), EGDSTravelersStepInput.fragment, EGDSTravelerChildAgeSelect.fragment);
var EGDSTravelersChildren = function (param) {
  var data = param.data,
    childAgeRef = param.childAgeRef,
    roomIndex = param.roomIndex,
    travelersType = param.travelersType;
  var _data_ages;
  var count = data.count,
    __typename = data.__typename;
  var isInfant = travelersType === "infants" /* INFANTS */ || travelersType === "infants_on_lap" /* INFANTS_ON_LAP */ || travelersType === "infants_in_seat" /* INFANTS_IN_SEAT */;
  var firstChildIndexWithNoAgeValue = ((data.__typename === "EGDSTravelerInfant" || data.__typename === "EGDSTravelerChildren") && data.ages ? data.ages : []).findIndex(function (age) {
    return age.__typename === "EGDSTravelerChildAgeSelect" && age.value === null;
  });
  return /* @__PURE__ */React50.createElement(React50.Fragment, null, count && count.__typename === "EGDSTravelerStepInput" && /* @__PURE__ */React50.createElement(EGDSTravelersStepInput, {
    travelersType: travelersType,
    roomIndex: roomIndex,
    data: count
  }), (__typename === "EGDSTravelerChildren" || __typename === "EGDSTravelerInfant") && /* @__PURE__ */React50.createElement(UitkLayoutFlex5, {
    wrap: "wrap"
  }, (_data_ages = data.ages) === null || _data_ages === void 0 ? void 0 : _data_ages.map(function (age, childIndex) {
    return age.__typename === "EGDSTravelerChildAgeSelect" && /* @__PURE__ */React50.createElement(React50.Fragment, {
      key: childIndex
    }, /* @__PURE__ */React50.createElement(UitkSpacing9, {
      padding: {
        blockstart: "two",
        inlineend: "two"
      }
    }, /* @__PURE__ */React50.createElement(UitkLayoutFlexItem5, {
      minWidth: "full_width"
    }, /* @__PURE__ */React50.createElement("div", null, /* @__PURE__ */React50.createElement(EGDSTravelerChildAgeSelect, {
      key: childIndex,
      childIndex: childIndex,
      roomIndex: roomIndex,
      isInfant: isInfant,
      infantType: isInfant ? travelersType : "",
      data: age,
      childAgeRef: firstChildIndexWithNoAgeValue === childIndex ? childAgeRef : void 0
    })))));
  })));
};
EGDSTravelersChildren.displayName = "EGDSTravelersChildren";
EGDSTravelersChildren.fragment = _object_spread_props(_object_spread({}, __Fragment33), {
  __typename: "EGDSTravelerChildren"
});
// ../internal/src/components/form/egds-search-form-travelers-field/travelers-pets.tsx
import React51 from "react";
var TravelersPets = function (param) {
  var data = param.data;
  var _useBasicTravelersContext = useBasicTravelersContext(),
    state = _useBasicTravelersContext.state,
    dispatch = _useBasicTravelersContext.dispatch;
  var pets = state.travelers.pets;
  if ((pets === null || pets === void 0 ? void 0 : pets.__typename) !== "EGDSBasicCheckBox") {
    return null;
  }
  var checked = pets.state === "CHECKED" /* CHECKED */;
  var handleOnChange = function (event) {
    dispatch({
      type: "UPDATE_PETS_FILTER",
      checked: event.currentTarget.checked
    });
  };
  return /* @__PURE__ */React51.createElement(EGDSBasicCheckBox, {
    data: data,
    checked: checked,
    onChange: handleOnChange
  });
};
// ../internal/src/components/form/egds-search-form-travelers-field/egds-travelers.tsx
var __Fragment34 = gql42(_templateObject45(), EGDSBasicCheckBox.fragment, EGDSTravelersChildren.fragment, EGDSTravelersStepInput.fragment);
var EGDSTravelers = function (param) {
  var childAgeRef = param.childAgeRef,
    infantsOnLapRef = param.infantsOnLapRef,
    infantsInSeatRef = param.infantsInSeatRef,
    isTravelersExpanded = param.isTravelersExpanded,
    data = param.data;
  var adults = data.adults,
    children = data.children,
    pets = data.pets,
    infantsInSeat = data.infantsInSeat,
    infantsOnLap = data.infantsOnLap;
  var adultsLabelSpanRef = React52.useRef(null);
  React52.useEffect(function () {
    if (isTravelersExpanded) {
      var _adultsLabelSpanRef_current;
      (_adultsLabelSpanRef_current = adultsLabelSpanRef.current) === null || _adultsLabelSpanRef_current === void 0 ? void 0 : _adultsLabelSpanRef_current.focus();
    }
  }, [isTravelersExpanded]);
  return /* @__PURE__ */React52.createElement(React52.Fragment, null, adults.__typename === "EGDSTravelerStepInput" && /* @__PURE__ */React52.createElement(UitkSpacing10, {
    padding: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React52.createElement("div", null, /* @__PURE__ */React52.createElement("span", {
    className: "is-visually-hidden",
    tabIndex: -1,
    ref: adultsLabelSpanRef
  }, adults.label), /* @__PURE__ */React52.createElement(EGDSTravelersStepInput, {
    travelersType: "adults" /* ADULTS */,
    data: adults
  }))), ((children === null || children === void 0 ? void 0 : children.__typename) === "EGDSTravelerChildren" || (children === null || children === void 0 ? void 0 : children.__typename) === "EGDSBasicTraveler") && /* @__PURE__ */React52.createElement(UitkSpacing10, {
    padding: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React52.createElement("div", null, /* @__PURE__ */React52.createElement(EGDSTravelersChildren, {
    travelersType: "children" /* CHILDREN */,
    childAgeRef: childAgeRef,
    data: children
  }))), ((infantsOnLap === null || infantsOnLap === void 0 ? void 0 : infantsOnLap.__typename) === "EGDSTravelerInfant" || (infantsOnLap === null || infantsOnLap === void 0 ? void 0 : infantsOnLap.__typename) === "EGDSBasicTraveler") && /* @__PURE__ */React52.createElement(UitkSpacing10, {
    padding: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React52.createElement("div", null, /* @__PURE__ */React52.createElement(EGDSTravelersChildren, {
    travelersType: "infants_on_lap" /* INFANTS_ON_LAP */,
    childAgeRef: infantsOnLapRef,
    data: infantsOnLap
  }))), ((infantsInSeat === null || infantsInSeat === void 0 ? void 0 : infantsInSeat.__typename) === "EGDSTravelerInfant" || (infantsInSeat === null || infantsInSeat === void 0 ? void 0 : infantsInSeat.__typename) === "EGDSBasicTraveler") && /* @__PURE__ */React52.createElement(UitkSpacing10, {
    padding: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React52.createElement("div", null, /* @__PURE__ */React52.createElement(EGDSTravelersChildren, {
    travelersType: "infants_in_seat" /* INFANTS_IN_SEAT */,
    childAgeRef: infantsInSeatRef,
    data: infantsInSeat
  }))), (pets === null || pets === void 0 ? void 0 : pets.__typename) === "EGDSBasicCheckBox" && /* @__PURE__ */React52.createElement(UitkSpacing10, {
    padding: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React52.createElement("div", null, /* @__PURE__ */React52.createElement(TravelersPets, {
    data: pets
  }))));
};
EGDSTravelers.displayName = "EGDSTravelersFragment";
EGDSTravelers.fragment = _object_spread_props(_object_spread({}, __Fragment34), {
  __typename: "EGDSTravelers"
});
// ../internal/src/components/form/egds-search-form-travelers-field/egds-basic-traveler-selector.tsx
var __Fragment35 = gql43(_templateObject46(), EGDSErrorSummary.fragment, EGDSPrimaryButton.fragment, EGDSTertiaryButton.fragment, EGDSTravelers.fragment);
var EGDSBasicTravelerSelector = function (param) {
  var data = param.data,
    onSubmit = param.onSubmit,
    isTravelersExpanded = param.isTravelersExpanded;
  var doneButton = data.doneButton;
  var state = useBasicTravelersContext().state;
  var childAgeRef = React53.useRef(null);
  var infantsOnLap = React53.useRef(null);
  var infantsInSeat = React53.useRef(null);
  var travelers = state.travelers,
    error = state.error;
  var getChildrenRef = function () {
    if (childAgeRef.current) {
      return childAgeRef;
    }
    if (infantsOnLap.current) {
      return infantsOnLap;
    }
    return infantsInSeat;
  };
  var inputErrorRef = getChildrenRef();
  var handleSubmit = function () {
    if (onSubmit) {
      onSubmit("menu");
    }
  };
  return /* @__PURE__ */React53.createElement(UitkLayoutFlex6, {
    direction: "column"
  }, (error === null || error === void 0 ? void 0 : error.displayConfirmation) && /* @__PURE__ */React53.createElement(UitkSpacing11, {
    padding: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React53.createElement("div", null, /* @__PURE__ */React53.createElement(EGDSErrorSummary, {
    data: error.errorSummary,
    inputErrorRef: inputErrorRef,
    errorCount: error.errorCount
  }))), /* @__PURE__ */React53.createElement("section", null, /* @__PURE__ */React53.createElement(EGDSTravelers, {
    data: travelers,
    childAgeRef: childAgeRef,
    infantsOnLapRef: infantsOnLap,
    infantsInSeatRef: infantsInSeat,
    isTravelersExpanded: isTravelersExpanded
  })), doneButton.__typename === "UIPrimaryButton" && /* @__PURE__ */React53.createElement(Viewport6, null, /* @__PURE__ */React53.createElement(ViewMedium4, null, /* @__PURE__ */React53.createElement(UitkSpacing11, {
    padding: {
      blockstart: "four",
      blockend: "three"
    }
  }, /* @__PURE__ */React53.createElement(UitkLayoutFlex6, {
    justifyContent: "end"
  }, /* @__PURE__ */React53.createElement(UitkLayoutFlexItem6, null, /* @__PURE__ */React53.createElement(EGDSPrimaryButton, {
    isFullWidth: false,
    onClick: handleSubmit,
    data: doneButton,
    size: UitkButtonSize3.MEDIUM
  })))))));
};
EGDSBasicTravelerSelector.displayName = "EGDSBasicTravelerSelectorFragment";
EGDSBasicTravelerSelector.fragment = _object_spread_props(_object_spread({}, __Fragment35), {
  __typename: "EGDSBasicTravelerSelector"
});
// ../internal/src/components/form/egds-search-form-travelers-field/egds-rooms-traveler-selector.tsx
import React57 from "react";
import { gql as gql47 } from "@apollo/client";
import { ViewMedium as ViewMedium5, Viewport as Viewport7 } from "@shared-ui/viewport-context";
import { UitkButtonSize as UitkButtonSize4 } from "uitk-react-button";
import { UitkLayoutFlex as UitkLayoutFlex9, UitkLayoutFlexItem as UitkLayoutFlexItem9 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing14 } from "uitk-react-spacing";
// ../internal/src/components/form/egds-search-form-travelers-field/egds-traveler-infant-seat-select.tsx
import React55 from "react";
import { gql as gql45 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex7, UitkLayoutFlexItem as UitkLayoutFlexItem7 } from "uitk-react-layout-flex";
import { UitkRadioButton, UitkRadioButtonGroup } from "uitk-react-radio-button";
import { UitkSpacing as UitkSpacing12 } from "uitk-react-spacing";
import { UitkText as UitkText4 } from "uitk-react-text";
// ../internal/src/components/common/link/egds-standard-link.tsx
import React54 from "react";
import { gql as gql44 } from "@apollo/client";
import { useClickTracker as useClickTracker21 } from "@shared-ui/clickstream-analytics-context";
import { UitkIcon as UitkIcon4 } from "uitk-react-icons";
import { UitkLink } from "uitk-react-link";
import { UitkText as UitkText3 } from "uitk-react-text";
var fragment4 = gql44(_templateObject47());
var _obj2;
var UILinkTargetMap = (_obj2 = {}, _define_property(_obj2, "EXTERNAL" /* EXTERNAL */, "_blank" /* EXTERNAL */), _define_property(_obj2, "INTERNAL" /* INTERNAL */, "_self" /* INTERNAL */), _obj2);
var EGDSStandardLink = function (param) {
  var _param_data = param.data,
    _param_data_action = _param_data.action,
    analytics = _param_data_action.analytics,
    resource = _param_data_action.resource,
    target = _param_data_action.target,
    accessibility = _param_data_action.accessibility,
    text = _param_data.text,
    icon = _param_data.icon,
    iconPosition = _param_data.iconPosition;
  var clickTracker = useClickTracker21();
  var onClick = React54.useCallback(function () {
    clickTracker(analytics.referrerId, analytics.linkName);
  }, [clickTracker, analytics]);
  return /* @__PURE__ */React54.createElement(UitkLink, {
    onClickCapture: onClick,
    inline: true
  }, /* @__PURE__ */React54.createElement("a", {
    target: UILinkTargetMap[target],
    href: resource.value
  }, icon && iconPosition !== "TRAILING" /* TRAILING */ && /* @__PURE__ */React54.createElement(UitkIcon4, {
    name: icon.id
  }), text, icon && iconPosition === "TRAILING" /* TRAILING */ && /* @__PURE__ */React54.createElement(UitkIcon4, {
    name: icon.id
  }), accessibility && /* @__PURE__ */React54.createElement(UitkText3, {
    className: "is-visually-hidden"
  }, accessibility)));
};
EGDSStandardLink.fragment = fragment4;
EGDSStandardLink.displayName = "EGDSStandardLink";
// ../internal/src/components/form/egds-search-form-travelers-field/egds-traveler-infant-seat-select.tsx
var __Fragment36 = gql45(_templateObject48(), EGDSStandardLink.fragment);
var EGDSTravelerInfantSeatSelect = function (param) {
  var data = param.data;
  var _state_infantSeatSelection;
  var _useTravelersContext = useTravelersContext(),
    state = _useTravelersContext.state,
    dispatch = _useTravelersContext.dispatch;
  var numberOfInfants = state.rooms.reduce(function (infants, room) {
    var _room_infants_count, _room_infants;
    var _room_infants_count_value;
    return infants + ((_room_infants_count_value = (_room_infants = room.infants) === null || _room_infants === void 0 ? void 0 : (_room_infants_count = _room_infants.count) === null || _room_infants_count === void 0 ? void 0 : _room_infants_count.value) !== null && _room_infants_count_value !== void 0 ? _room_infants_count_value : 0);
  }, 0);
  var infantSeatSelection = (_state_infantSeatSelection = state.infantSeatSelection) === null || _state_infantSeatSelection === void 0 ? void 0 : _state_infantSeatSelection.value;
  if (data.labelTemplate.__typename !== "EGDSCardinalLocalizedText" || numberOfInfants === 0 || !infantSeatSelection) {
    return null;
  }
  var labelTemplate = data.labelTemplate,
    options = data.options,
    airlineAgeRule = data.airlineAgeRule,
    groupName = data.groupName;
  var infantsSeatingText = numberOfInfants === 1 ? labelTemplate.text : labelTemplate.templates[1].template;
  var handleOnChange = function (event) {
    dispatch({
      type: "UPDATE_INFANT_SEAT_SELECTION",
      value: event.currentTarget.value
    });
  };
  return /* @__PURE__ */React55.createElement(UitkLayoutFlex7, {
    direction: "column"
  }, /* @__PURE__ */React55.createElement(UitkLayoutFlexItem7, null, /* @__PURE__ */React55.createElement(UitkText4, null, infantsSeatingText)), /* @__PURE__ */React55.createElement(UitkLayoutFlexItem7, null, /* @__PURE__ */React55.createElement(UitkRadioButtonGroup, {
    group: groupName,
    selected: infantSeatSelection,
    onChange: handleOnChange,
    defaultChecked: true
  }, options.map(function (option, index) {
    return /* @__PURE__ */React55.createElement(UitkSpacing12, {
      key: "radioInfant".concat(index + 1),
      margin: index === 0 ? {
        blockstart: "three"
      } : void 0
    }, /* @__PURE__ */React55.createElement("div", null, /* @__PURE__ */React55.createElement(UitkRadioButton, {
      id: option.value,
      value: option.value
    }, option.label)));
  }))), /* @__PURE__ */React55.createElement(UitkLayoutFlexItem7, null, /* @__PURE__ */React55.createElement(UitkSpacing12, {
    padding: {
      blockstart: "two",
      blockend: "six"
    }
  }, /* @__PURE__ */React55.createElement("div", null, /* @__PURE__ */React55.createElement(EGDSStandardLink, {
    data: airlineAgeRule
  })))));
};
EGDSTravelerInfantSeatSelect.displayName = "EGDSTravelerInfantSeatSelect";
EGDSTravelerInfantSeatSelect.fragment = _object_spread_props(_object_spread({}, __Fragment36), {
  __typename: "EGDSTravelerInfantSeatSelection"
});
// ../internal/src/components/form/egds-search-form-travelers-field/egds-travelers-selector-room.tsx
import React56 from "react";
import { gql as gql46 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex8, UitkLayoutFlexItem as UitkLayoutFlexItem8 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing13 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading3 } from "uitk-react-text";
import { Level as Level3, liveAnnounce as liveAnnounce3 } from "uitk-react-utils";
var __Fragment37 = gql46(_templateObject49(), EGDSTravelersStepInput.fragment, EGDSTravelersChildren.fragment, EGDSTertiaryButton.fragment);
var EGDSTravelerSelectorRoom = function (param) {
  var roomIndex = param.roomIndex,
    childAgeRef = param.childAgeRef,
    data = param.data,
    isTravelersExpanded = param.isTravelersExpanded,
    focusAddRoomButton = param.focusAddRoomButton;
  var _children_ages;
  var adults = data.adults,
    children = data.children,
    infants = data.infants,
    label = data.label,
    removeRoomButton = data.removeRoomButton,
    removeRoomAnnouncement = data.removeRoomAnnouncement;
  var _useTravelersContext = useTravelersContext(),
    state = _useTravelersContext.state,
    dispatch = _useTravelersContext.dispatch;
  var roomLabelRef = React56.useRef();
  var roomsLenght = React56.useRef(state.rooms.length);
  React56.useEffect(function () {
    if (isTravelersExpanded && roomIndex === 0) {
      var _roomLabelRef_current;
      (_roomLabelRef_current = roomLabelRef.current) === null || _roomLabelRef_current === void 0 ? void 0 : _roomLabelRef_current.focus();
    }
  }, [isTravelersExpanded]);
  React56.useEffect(function () {
    if (isTravelersExpanded && state.rooms.length >= roomsLenght.current && roomIndex === state.rooms.length - 1) {
      var _roomLabelRef_current;
      (_roomLabelRef_current = roomLabelRef.current) === null || _roomLabelRef_current === void 0 ? void 0 : _roomLabelRef_current.focus();
    }
    roomsLenght.current = state.rooms.length;
  }, [state.rooms.length]);
  var onRemoveRoom = function () {
    if (removeRoomAnnouncement) {
      liveAnnounce3(removeRoomAnnouncement, Level3.ASSERTIVE);
    }
    if (focusAddRoomButton) {
      focusAddRoomButton();
    }
    dispatch({
      type: "REMOVE_ROOM",
      roomIndex: roomIndex
    });
  };
  var hasChildWithNoAge = children.__typename === "EGDSTravelerChildren" && ((_children_ages = children.ages) === null || _children_ages === void 0 ? void 0 : _children_ages.some(function (child) {
    return child.__typename === "EGDSTravelerChildAgeSelect" && child.value === null;
  }));
  var roomNumber = roomIndex + 1;
  return /* @__PURE__ */React56.createElement(React56.Fragment, null, label.__typename === "EGDSBasicLocalizedText" && label.models.length === 1 && /* @__PURE__ */React56.createElement(UitkHeading3, {
    size: 7,
    domRef: roomLabelRef,
    tabIndex: -1
  }, formatLocalizedTokenString(label.template, label.models[0].key, roomNumber.toString())), adults.__typename === "EGDSTravelerStepInput" && /* @__PURE__ */React56.createElement(UitkSpacing13, {
    padding: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React56.createElement("div", null, /* @__PURE__ */React56.createElement(EGDSTravelersStepInput, {
    travelersType: "adults" /* ADULTS */,
    roomIndex: roomIndex,
    data: adults
  }))), children.__typename === "EGDSTravelerChildren" && /* @__PURE__ */React56.createElement(UitkSpacing13, {
    padding: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React56.createElement("div", null, /* @__PURE__ */React56.createElement(EGDSTravelersChildren, {
    travelersType: "children" /* CHILDREN */,
    roomIndex: roomIndex,
    childAgeRef: childAgeRef,
    data: children
  }))), (infants === null || infants === void 0 ? void 0 : infants.__typename) === "EGDSTravelerInfant" && /* @__PURE__ */React56.createElement(UitkSpacing13, {
    padding: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React56.createElement("div", null, /* @__PURE__ */React56.createElement(EGDSTravelersChildren, {
    travelersType: "infants" /* INFANTS */,
    roomIndex: roomIndex,
    childAgeRef: hasChildWithNoAge ? void 0 : childAgeRef,
    data: infants
  }))), state.rooms.length > 1 && removeRoomButton && removeRoomButton.__typename === "UITertiaryButton" && /* @__PURE__ */React56.createElement(UitkSpacing13, {
    padding: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React56.createElement(UitkLayoutFlex8, {
    justifyContent: "end"
  }, /* @__PURE__ */React56.createElement(UitkLayoutFlexItem8, null, /* @__PURE__ */React56.createElement(EGDSTertiaryButton, {
    onClick: onRemoveRoom,
    data: removeRoomButton
  })))));
};
EGDSTravelerSelectorRoom.displayName = "EGDSTravelerSelectorRoomFragment";
EGDSTravelerSelectorRoom.fragment = _object_spread_props(_object_spread({}, __Fragment37), {
  __typename: "EGDSTravelerSelectorRoom"
});
// ../internal/src/components/form/egds-search-form-travelers-field/egds-rooms-traveler-selector.tsx
var __Fragment38 = gql47(_templateObject50(), EGDSErrorSummary.fragment, EGDSPrimaryButton.fragment, EGDSTertiaryButton.fragment, EGDSTravelerSelectorRoom.fragment, EGDSTravelerInfantSeatSelect.fragment);
var EGDSRoomsTravelerSelector = function (param) {
  var data = param.data,
    onSubmit = param.onSubmit,
    isTravelersExpanded = param.isTravelersExpanded;
  var addAnotherRoomButton = data.addAnotherRoomButton,
    doneButton = data.doneButton,
    maxRoomCount = data.maxRoomCount,
    infantSeatSelection = data.infantSeatSelection;
  var _useTravelersContext = useTravelersContext(),
    state = _useTravelersContext.state,
    dispatch = _useTravelersContext.dispatch;
  var childAgeRef = React57.useRef(null);
  var addRoomRef = React57.useRef(null);
  var rooms = state.rooms,
    error = state.error;
  var _React57_useState = _sliced_to_array(React57.useState(rooms), 2),
    setRoom = _React57_useState[1];
  React57.useEffect(function () {
    setRoom(rooms);
  }, [rooms]);
  if (rooms.length < 1) {
    return null;
  }
  var onAddRoom = function () {
    dispatch({
      type: "ADD_ROOM"
    });
  };
  var handleSubmit = function () {
    if (onSubmit) {
      onSubmit("menu");
    }
  };
  var focusAddRoomButton = function () {
    var _addRoomRef_current;
    (_addRoomRef_current = addRoomRef.current) === null || _addRoomRef_current === void 0 ? void 0 : _addRoomRef_current.focus();
  };
  var addNewRoomButton = _object_spread_props(_object_spread({}, addAnotherRoomButton), {
    disabled: maxRoomCount ? rooms.length >= maxRoomCount : false
  });
  var firstRoomIndexWithNoChildAgeValue = rooms.findIndex(function (room) {
    var _room_children, _room_children1, _room_infants, _room_infants1;
    var _ref;
    return room.children.__typename === "EGDSTravelerChildren" && ((_room_children = room.children) === null || _room_children === void 0 ? void 0 : _room_children.ages) && ((_room_children1 = room.children) === null || _room_children1 === void 0 ? void 0 : _room_children1.ages.some(function (child) {
      return child.__typename === "EGDSTravelerChildAgeSelect" && child.value === null;
    })) || ((_ref = ((_room_infants = room.infants) === null || _room_infants === void 0 ? void 0 : _room_infants.__typename) === "EGDSTravelerInfant" && ((_room_infants1 = room.infants) === null || _room_infants1 === void 0 ? void 0 : _room_infants1.ages.some(function (infant) {
      return infant.__typename === "EGDSTravelerChildAgeSelect" && infant.value === null;
    }))) !== null && _ref !== void 0 ? _ref : false);
  });
  var actionButton = doneButton.__typename === "UIPrimaryButton" && /* @__PURE__ */React57.createElement(UitkSpacing14, {
    padding: {
      blockstart: "four",
      blockend: "three"
    }
  }, /* @__PURE__ */React57.createElement(UitkLayoutFlex9, {
    justifyContent: "end"
  }, /* @__PURE__ */React57.createElement(UitkLayoutFlexItem9, null, /* @__PURE__ */React57.createElement(EGDSPrimaryButton, {
    isFullWidth: false,
    onClick: handleSubmit,
    data: doneButton,
    size: UitkButtonSize4.MEDIUM
  }))));
  return /* @__PURE__ */React57.createElement(UitkLayoutFlex9, {
    direction: "column"
  }, (error === null || error === void 0 ? void 0 : error.displayConfirmation) && /* @__PURE__ */React57.createElement(EGDSErrorSummary, {
    data: error.errorSummary,
    inputErrorRef: childAgeRef,
    errorCount: error.errorCount
  }), /* @__PURE__ */React57.createElement("section", null, rooms.map(function (room, roomIndex) {
    return /* @__PURE__ */React57.createElement(UitkSpacing14, {
      padding: {
        blockstart: (error === null || error === void 0 ? void 0 : error.displayConfirmation) ? "two" : "unset"
      },
      key: roomIndex
    }, /* @__PURE__ */React57.createElement("div", null, /* @__PURE__ */React57.createElement(EGDSTravelerSelectorRoom, {
      roomIndex: roomIndex,
      data: room,
      childAgeRef: firstRoomIndexWithNoChildAgeValue === roomIndex ? childAgeRef : void 0,
      isTravelersExpanded: isTravelersExpanded,
      focusAddRoomButton: focusAddRoomButton
    })));
  }), addNewRoomButton.__typename === "UITertiaryButton" && /* @__PURE__ */React57.createElement(UitkSpacing14, {
    padding: {
      small: {
        blockstart: "two",
        blockend: "sixteen"
      },
      medium: {
        blockend: "unset"
      }
    }
  }, /* @__PURE__ */React57.createElement(UitkLayoutFlex9, {
    justifyContent: "end"
  }, /* @__PURE__ */React57.createElement(UitkLayoutFlexItem9, null, /* @__PURE__ */React57.createElement(EGDSTertiaryButton, {
    onClick: onAddRoom,
    data: addNewRoomButton,
    domRef: addRoomRef
  })))), infantSeatSelection && /* @__PURE__ */React57.createElement(UitkSpacing14, {
    padding: {
      blockstart: "twelve"
    }
  }, /* @__PURE__ */React57.createElement("div", null, /* @__PURE__ */React57.createElement(EGDSTravelerInfantSeatSelect, {
    data: infantSeatSelection
  })))), /* @__PURE__ */React57.createElement(Viewport7, null, /* @__PURE__ */React57.createElement(ViewMedium5, null, /* @__PURE__ */React57.createElement("div", null, actionButton))));
};
EGDSRoomsTravelerSelector.displayName = "EGDSTravelerSelectorFragment";
EGDSRoomsTravelerSelector.fragment = _object_spread_props(_object_spread({}, __Fragment38), {
  __typename: "EGDSRoomsTravelerSelector"
});
// ../internal/src/components/form/egds-search-form-travelers-field/travelers-basic-field-triggers.tsx
import React58 from "react";
import { useClickTracker as useClickTracker22 } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
import { useSearchFormReflectionContext as useSearchFormReflectionContext5 } from "@shared-ui/retail-search-tools-reflection-provider";
import { ViewLarge as ViewLarge3, ViewMedium as ViewMedium6, Viewport as Viewport8, ViewSizes, ViewSmall as ViewSmall6 } from "@shared-ui/viewport-context";
import { UitkForm as UitkForm2, useFormCallback as useFormCallback7 } from "uitk-react-form";
import { UitkFakeInput } from "uitk-react-input";
import { PositionType as PositionType2, UitkMenu as UitkMenu2, UitkMenuContainer as UitkMenuContainer2, UitkMenuTrigger as UitkMenuTrigger2 } from "uitk-react-menu";
import { UitkSheet, UitkSheetContent, UitkSheetTransition } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing15 } from "uitk-react-spacing";
import { UitkToolbar as UitkToolbar2 } from "uitk-react-toolbar";
// ../internal/src/helper/object-comparator.ts
var isEqual = function (obj1, obj2) {
  var getType = function getType(obj) {
    return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
  };
  var areArraysEqual = function areArraysEqual() {
    if (obj1.length !== obj2.length) {
      return false;
    }
    for (var i = 0; i < obj1.length; i += 1) {
      if (!isEqual(obj1[i], obj2[i])) {
        return false;
      }
    }
    return true;
  };
  var areObjectsEqual = function areObjectsEqual() {
    var obj1Keys = Object.keys(obj1);
    if (obj1Keys.length !== Object.keys(obj2).length) {
      return false;
    }
    for (var i = 0; i < obj1Keys.length; i += 1) {
      var key = obj1Keys[i];
      if (Object.prototype.hasOwnProperty.call(obj1, key)) {
        if (!isEqual(obj1[key], obj2[key])) {
          return false;
        }
      }
    }
    return true;
  };
  var areFunctionsEqual = function areFunctionsEqual() {
    return obj1.toString() === obj2.toString();
  };
  var arePrimativesEqual = function arePrimativesEqual() {
    return obj1 === obj2;
  };
  var type = getType(obj1);
  if (type !== getType(obj2)) {
    return false;
  }
  if (type === "array") {
    return areArraysEqual();
  }
  if (type === "object") {
    return areObjectsEqual();
  }
  if (type === "function") {
    return areFunctionsEqual();
  }
  return arePrimativesEqual();
};
// ../internal/src/components/form/egds-search-form-travelers-field/travelers-summary.ts
var formatCardinalText2 = function (cardinalText, value) {
  var useSecondaryTemplates = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  var templateKey = useSecondaryTemplates ? "secondaryTemplates" : "templates";
  var cardinalTemplate = cardinalText[templateKey].find(function (template) {
    return template.category === getPluralCategory(value);
  });
  if (!cardinalTemplate) {
    return "";
  }
  return formatLocalizedTokenString(cardinalTemplate.template, cardinalText.models[0].key, value.toString());
};
var formatCompositeText = function (compositeText) {
  for (var _len = arguments.length, keysToReplace = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keysToReplace[_key - 1] = arguments[_key];
  }
  var models = compositeText.models,
    template = compositeText.template;
  var formattedTexts = models.map(function (model, index) {
    return model.models.__typename === "EGDSCardinalLocalizedText" ? formatCardinalText2(model.models, keysToReplace[index]) : "";
  });
  return models.reduce(function (prev, model, index) {
    return formatLocalizedTokenString(prev, model.key, formattedTexts[index]);
  }, template);
};
// ../internal/src/components/form/egds-search-form-travelers-field/travelers-basic-field-triggers.tsx
var BASE_TRAVELERS_FIELD_PREFIX = "EGDSSearchFormTravelersField-";
var ADULT_COUNT_NAME_PREFIX = "".concat(BASE_TRAVELERS_FIELD_PREFIX, "Adult");
var CHILDREN_NAME_PREFIX = "".concat(BASE_TRAVELERS_FIELD_PREFIX, "ChildrenAge");
var INFANT_IN_SEAT_NAME_PREFIX = "".concat(BASE_TRAVELERS_FIELD_PREFIX, "InfantInSeatAge");
var INFANT_ON_LAP_NAME_PREFIX = "".concat(BASE_TRAVELERS_FIELD_PREFIX, "InfantOnLapAge");
var PETS_STATE_NAME_PREFIX = "".concat(BASE_TRAVELERS_FIELD_PREFIX, "Pets");
var ChildrenHiddenInputs = function (param) {
  var ages = param.ages,
    prefix = param.prefix;
  return /* @__PURE__ */React58.createElement(React58.Fragment, null, ages.map(function (age, index) {
    if (age.__typename === "EGDSTravelerChildAgeSelect") {
      var childNumber = index + 1;
      var name = "".concat(prefix, "-").concat(childNumber);
      var _age_value;
      return /* @__PURE__ */React58.createElement("input", {
        key: index,
        type: "hidden",
        "data-stid": name,
        name: name,
        value: (_age_value = age.value) !== null && _age_value !== void 0 ? _age_value : ""
      });
    }
    return null;
  }));
};
var BasicTravelersFieldTriggers = function (param) {
  var label = param.label,
    leftIcon = param.leftIcon,
    action = param.action,
    labelTemplate = param.labelTemplate,
    readOnly = param.readOnly,
    isAnyPetAllowed = param.isAnyPetAllowed,
    retainTravelerOnDialogDismiss = param.retainTravelerOnDialogDismiss,
    onOpenTravelerField = param.onOpenTravelerField,
    onCloseTravelerField = param.onCloseTravelerField;
  var analytics = action.analytics,
    travelerSelector = action.travelerSelector;
  var doneButton = travelerSelector.doneButton;
  var track = useClickTracker22();
  var _useBasicTravelersContext = useBasicTravelersContext(),
    dispatch = _useBasicTravelersContext.dispatch,
    state = _useBasicTravelersContext.state;
  var _useSearchFormReflectionContext5 = useSearchFormReflectionContext5(),
    reflectionState = _useSearchFormReflectionContext5.state;
  var _useDialog = _sliced_to_array(useDialog("travelerSelectorDialog"), 3),
    isOpen = _useDialog[0],
    dialogActions = _useDialog[1],
    TravelerSelectorDialogWrapper = _useDialog[2];
  var triggerRef = React58.useRef(null);
  var _React58_useState = _sliced_to_array(React58.useState(false), 2),
    showMenu = _React58_useState[0],
    setShowMenu = _React58_useState[1];
  var _React58_useState1 = _sliced_to_array(React58.useState(state), 2),
    initialState = _React58_useState1[0],
    setInitialState = _React58_useState1[1];
  var _labelTemplate_text;
  var _React58_useState2 = _sliced_to_array(React58.useState((_labelTemplate_text = labelTemplate === null || labelTemplate === void 0 ? void 0 : labelTemplate.text) !== null && _labelTemplate_text !== void 0 ? _labelTemplate_text : ""), 2),
    travelersSummary = _React58_useState2[0],
    setTravelersSummary = _React58_useState2[1];
  var error = state.error;
  var handleChange = useFormCallback7(travelerSelector.__typename, function (event) {
    return event;
  });
  var formatTravelerSummary = function (travelers) {
    var _travelers_adults, _travelers_children_count, _travelers_children, _travelers_infantsInSeat_count, _travelers_infantsInSeat, _travelers_infantsOnLap_count, _travelers_infantsOnLap, _travelers_pets;
    var _travelers_adults_value;
    var adultCount = (_travelers_adults_value = (_travelers_adults = travelers.adults) === null || _travelers_adults === void 0 ? void 0 : _travelers_adults.value) !== null && _travelers_adults_value !== void 0 ? _travelers_adults_value : 0;
    var _travelers_children_count_value;
    var childrenCount = (_travelers_children_count_value = (_travelers_children = travelers.children) === null || _travelers_children === void 0 ? void 0 : (_travelers_children_count = _travelers_children.count) === null || _travelers_children_count === void 0 ? void 0 : _travelers_children_count.value) !== null && _travelers_children_count_value !== void 0 ? _travelers_children_count_value : 0;
    var _travelers_infantsInSeat_count_value;
    var infantsInSeatCount = (_travelers_infantsInSeat_count_value = (_travelers_infantsInSeat = travelers.infantsInSeat) === null || _travelers_infantsInSeat === void 0 ? void 0 : (_travelers_infantsInSeat_count = _travelers_infantsInSeat.count) === null || _travelers_infantsInSeat_count === void 0 ? void 0 : _travelers_infantsInSeat_count.value) !== null && _travelers_infantsInSeat_count_value !== void 0 ? _travelers_infantsInSeat_count_value : 0;
    var _travelers_infantsOnLap_count_value;
    var infantsOnLapCount = (_travelers_infantsOnLap_count_value = (_travelers_infantsOnLap = travelers.infantsOnLap) === null || _travelers_infantsOnLap === void 0 ? void 0 : (_travelers_infantsOnLap_count = _travelers_infantsOnLap.count) === null || _travelers_infantsOnLap_count === void 0 ? void 0 : _travelers_infantsOnLap_count.value) !== null && _travelers_infantsOnLap_count_value !== void 0 ? _travelers_infantsOnLap_count_value : 0;
    var travelersCount = adultCount + childrenCount + infantsInSeatCount + infantsOnLapCount;
    var isPetsChecked = (travelers === null || travelers === void 0 ? void 0 : (_travelers_pets = travelers.pets) === null || _travelers_pets === void 0 ? void 0 : _travelers_pets.__typename) === "EGDSBasicCheckBox" && travelers.pets.state === "CHECKED" /* CHECKED */;
    return formatCardinalText2(labelTemplate, travelersCount, isPetsChecked);
  };
  React58.useEffect(function () {
    var _initialState_travelers_pets;
    if (isAnyPetAllowed !== void 0) {
      dispatch({
        type: "UPDATE_PETS_FILTER",
        checked: isAnyPetAllowed
      });
    }
    if (((_initialState_travelers_pets = initialState.travelers.pets) === null || _initialState_travelers_pets === void 0 ? void 0 : _initialState_travelers_pets.__typename) === "EGDSBasicCheckBox") {
      var dataTravelersPetsState = isAnyPetAllowed ? "CHECKED" /* CHECKED */ : "UNCHECKED" /* UNCHECKED */;
      var newState = _object_spread_props(_object_spread({}, initialState), {
        travelers: _object_spread_props(_object_spread({}, initialState.travelers), {
          pets: _object_spread_props(_object_spread({}, initialState.travelers.pets), {
            state: dataTravelersPetsState
          })
        })
      });
      setInitialState(newState);
    }
  }, [isAnyPetAllowed]);
  React58.useEffect(function () {
    setTravelersSummary(formatTravelerSummary(state.travelers));
  }, [state.travelers]);
  React58.useEffect(function () {
    var _reflectionState_travelers_adultTravelerCounts, _reflectionState_travelers;
    if ((_reflectionState_travelers = reflectionState.travelers) === null || _reflectionState_travelers === void 0 ? void 0 : (_reflectionState_travelers_adultTravelerCounts = _reflectionState_travelers.adultTravelerCounts) === null || _reflectionState_travelers_adultTravelerCounts === void 0 ? void 0 : _reflectionState_travelers_adultTravelerCounts.length) {
      var _reflectionState_travelers_adultTravelerCounts1, _reflectionState_travelers1, _reflectionState_travelers2, _reflectionState_travelers_childTravelerCounts, _reflectionState_travelers3, _reflectionState_travelers4, _reflectionState_travelers_childrenAges, _reflectionState_travelers5, _reflectionState_travelers6, _reflectionState_travelers7, _reflectionState_travelers_petCounts, _reflectionState_travelers8, _reflectionState_travelers9;
      dispatch({
        type: "UPDATE_TRAVELERS_BULK",
        adultTravelerCounts: ((_reflectionState_travelers1 = reflectionState.travelers) === null || _reflectionState_travelers1 === void 0 ? void 0 : (_reflectionState_travelers_adultTravelerCounts1 = _reflectionState_travelers1.adultTravelerCounts) === null || _reflectionState_travelers_adultTravelerCounts1 === void 0 ? void 0 : _reflectionState_travelers_adultTravelerCounts1.length) ? (_reflectionState_travelers2 = reflectionState.travelers) === null || _reflectionState_travelers2 === void 0 ? void 0 : _reflectionState_travelers2.adultTravelerCounts[0] : 0,
        childTravelerCounts: ((_reflectionState_travelers3 = reflectionState.travelers) === null || _reflectionState_travelers3 === void 0 ? void 0 : (_reflectionState_travelers_childTravelerCounts = _reflectionState_travelers3.childTravelerCounts) === null || _reflectionState_travelers_childTravelerCounts === void 0 ? void 0 : _reflectionState_travelers_childTravelerCounts.length) ? (_reflectionState_travelers4 = reflectionState.travelers) === null || _reflectionState_travelers4 === void 0 ? void 0 : _reflectionState_travelers4.childTravelerCounts[0] : 0,
        childrenAges: ((_reflectionState_travelers5 = reflectionState.travelers) === null || _reflectionState_travelers5 === void 0 ? void 0 : (_reflectionState_travelers_childrenAges = _reflectionState_travelers5.childrenAges) === null || _reflectionState_travelers_childrenAges === void 0 ? void 0 : _reflectionState_travelers_childrenAges.length) && ((_reflectionState_travelers6 = reflectionState.travelers) === null || _reflectionState_travelers6 === void 0 ? void 0 : _reflectionState_travelers6.childrenAges[0].length) ? (_reflectionState_travelers7 = reflectionState.travelers) === null || _reflectionState_travelers7 === void 0 ? void 0 : _reflectionState_travelers7.childrenAges[0] : [],
        petCounts: ((_reflectionState_travelers8 = reflectionState.travelers) === null || _reflectionState_travelers8 === void 0 ? void 0 : (_reflectionState_travelers_petCounts = _reflectionState_travelers8.petCounts) === null || _reflectionState_travelers_petCounts === void 0 ? void 0 : _reflectionState_travelers_petCounts.length) ? (_reflectionState_travelers9 = reflectionState.travelers) === null || _reflectionState_travelers9 === void 0 ? void 0 : _reflectionState_travelers9.petCounts[0] : 0
      });
    }
  }, [reflectionState.travelers]);
  if (travelerSelector.__typename !== "EGDSBasicTravelerSelector") {
    return null;
  }
  var onTriggerClick = function () {
    if (onOpenTravelerField) {
      onOpenTravelerField();
    }
    setShowMenu(function (prevState) {
      return !prevState;
    });
    if (analytics.referrerId && analytics.linkName) {
      track(analytics.referrerId, analytics.linkName);
    }
  };
  var onDismissMenu = function () {
    var _ref = _async_to_generator(function () {
      return _ts_generator(this, function (_state) {
        switch (_state.label) {
          case 0:
            if (!state.error) return [3, 2];
            return [4, dispatch({
              type: "SHOW_ERROR"
            })];
          case 1:
            _state.sent();
            setShowMenu(true);
            _state.label = 2;
          case 2:
            if (!state.error && !isEqual(initialState, state)) {
              setInitialState(state);
              triggerInputChangeEvent("submit", handleChange);
            }
            return [2];
        }
      });
    });
    return function onDismissMenu() {
      return _ref.apply(this, arguments);
    };
  }();
  var onClick = function () {
    if (onOpenTravelerField) {
      onOpenTravelerField();
    }
    dialogActions.openDialog();
    if (analytics.referrerId && analytics.linkName) {
      track(analytics.referrerId, analytics.linkName);
    }
  };
  var onDismissDialog = function () {
    if (onCloseTravelerField) {
      onCloseTravelerField(ViewSizes.SMALL);
    }
    if ((travelerSelector.closeButton.__typename === "UIPrimaryButton" || travelerSelector.closeButton.__typename === "UITertiaryButton") && travelerSelector.closeButton.analytics) {
      var _travelerSelector_closeButton_analytics = travelerSelector.closeButton.analytics,
        referrerId = _travelerSelector_closeButton_analytics.referrerId,
        linkName = _travelerSelector_closeButton_analytics.linkName;
      track(referrerId, retainTravelerOnDialogDismiss && !error ? "Travelers results updated" : linkName);
    }
    if (retainTravelerOnDialogDismiss && error && error.type === "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */) {
      var _error_errorSummary;
      dispatch({
        type: "SHOW_ERROR"
      });
      if ((_error_errorSummary = error.errorSummary) === null || _error_errorSummary === void 0 ? void 0 : _error_errorSummary.impressionAnalytics) {
        var referrerId1 = "".concat(error.errorSummary.impressionAnalytics.referrerId, ".For.NoChildAgeSubmit");
        var linkName1 = error.errorSummary.impressionAnalytics.linkName || "";
        track(referrerId1, linkName1);
      }
    } else if (retainTravelerOnDialogDismiss && !error) {
      onSaveDialog(state);
    } else {
      dispatch({
        type: "RESET_STATE",
        state: initialState
      });
      dialogActions.closeDialog();
    }
  };
  var updateTravelerSummary = function (travelers) {
    var travelersValue = formatTravelerSummary(travelers);
    triggerInputChangeEvent(travelersValue, handleChange);
    setTravelersSummary(travelersValue);
  };
  var onSaveMenu = function (newState) {
    var _triggerRef_current;
    if (!isEqual(initialState, newState)) {
      updateTravelerSummary(newState.travelers);
      setInitialState(newState);
    }
    setShowMenu(function (prevState) {
      return !prevState;
    });
    (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.focus();
  };
  var onSaveDialog = function (newState) {
    var _triggerRef_current;
    if (!isEqual(initialState, newState)) {
      updateTravelerSummary(newState.travelers);
      setInitialState(newState);
    }
    (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.focus();
    dialogActions.closeDialog();
  };
  var handleSubmit = function (triggerType) {
    if (error && error.type === "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */) {
      var _error_errorSummary;
      dispatch({
        type: "SHOW_ERROR"
      });
      if ((_error_errorSummary = error.errorSummary) === null || _error_errorSummary === void 0 ? void 0 : _error_errorSummary.impressionAnalytics) {
        var referrerId = "".concat(error.errorSummary.impressionAnalytics.referrerId, ".For.NoChildAgeSubmit");
        var linkName = error.errorSummary.impressionAnalytics.linkName || "";
        track(referrerId, linkName);
      }
    }
    if (!error) {
      if (triggerType === "menu") {
        onSaveMenu(state);
      } else {
        onSaveDialog(state);
      }
    }
  };
  var _state_travelers = state.travelers,
    adults = _state_travelers.adults,
    children = _state_travelers.children,
    pets = _state_travelers.pets,
    infantsInSeat = _state_travelers.infantsInSeat,
    infantsOnLap = _state_travelers.infantsOnLap;
  var _travelerSelector_closeButton_accessibility;
  return /* @__PURE__ */React58.createElement(React58.Fragment, null, /* @__PURE__ */React58.createElement(Viewport8, null, /* @__PURE__ */React58.createElement(ViewLarge3, null, /* @__PURE__ */React58.createElement(UitkMenu2, {
    isOpen: showMenu,
    onTriggerClick: onTriggerClick,
    onDismiss: onDismissMenu
  }, /* @__PURE__ */React58.createElement(UitkMenuTrigger2, null, /* @__PURE__ */React58.createElement(UitkFakeInput, {
    label: label,
    value: travelersSummary,
    icon: leftIcon,
    "data-stid": "open-room-picker",
    disabled: readOnly,
    domRef: triggerRef
  })), /* @__PURE__ */React58.createElement(UitkMenuContainer2, {
    autoPosition: true,
    position: PositionType2.RIGHT,
    width: 375
  }, /* @__PURE__ */React58.createElement(UitkSpacing15, {
    padding: {
      inline: "six"
    }
  }, /* @__PURE__ */React58.createElement("div", null, /* @__PURE__ */React58.createElement(EGDSBasicTravelerSelector, {
    onSubmit: handleSubmit,
    data: travelerSelector,
    isTravelersExpanded: showMenu
  })))))), /* @__PURE__ */React58.createElement(ViewMedium6, null, /* @__PURE__ */React58.createElement(UitkMenu2, {
    isOpen: showMenu,
    onTriggerClick: onTriggerClick,
    onDismiss: onDismissMenu
  }, /* @__PURE__ */React58.createElement(UitkMenuTrigger2, null, /* @__PURE__ */React58.createElement(UitkFakeInput, {
    label: label,
    value: travelersSummary,
    icon: leftIcon,
    "data-stid": "open-room-picker",
    disabled: readOnly,
    domRef: triggerRef
  })), /* @__PURE__ */React58.createElement(UitkMenuContainer2, {
    autoPosition: true,
    position: PositionType2.LEFT,
    width: 375
  }, /* @__PURE__ */React58.createElement(UitkSpacing15, {
    padding: {
      inline: "six"
    }
  }, /* @__PURE__ */React58.createElement("div", null, /* @__PURE__ */React58.createElement(EGDSBasicTravelerSelector, {
    onSubmit: handleSubmit,
    data: travelerSelector,
    isTravelersExpanded: showMenu
  })))))), /* @__PURE__ */React58.createElement(ViewSmall6, null, /* @__PURE__ */React58.createElement(React58.Fragment, null, /* @__PURE__ */React58.createElement(UitkFakeInput, {
    label: label,
    value: travelersSummary,
    onClick: onClick,
    icon: leftIcon,
    "data-stid": "open-room-picker",
    disabled: readOnly,
    domRef: triggerRef
  }), /* @__PURE__ */React58.createElement(UitkSheetTransition, {
    isVisible: isOpen
  }, /* @__PURE__ */React58.createElement(TravelerSelectorDialogWrapper, null, /* @__PURE__ */React58.createElement(UitkSheet, {
    type: "full",
    triggerRef: triggerRef,
    isVisible: isOpen,
    returnFocusOnClose: true
  }, /* @__PURE__ */React58.createElement(UitkToolbar2, {
    toolbarTitle: travelerSelector.title,
    navigationContent: {
      navType: "close",
      navIconLabel: travelerSelector.closeButton.__typename === "UIPrimaryButton" || travelerSelector.closeButton.__typename === "UITertiaryButton" ? (_travelerSelector_closeButton_accessibility = travelerSelector.closeButton.accessibility) !== null && _travelerSelector_closeButton_accessibility !== void 0 ? _travelerSelector_closeButton_accessibility : "" : "",
      onClick: onDismissDialog
    }
  }), /* @__PURE__ */React58.createElement(UitkSheetContent, {
    padded: false
  }, /* @__PURE__ */React58.createElement(UitkSpacing15, {
    padding: {
      blockstart: "four",
      blockend: "sixteen",
      inline: "six"
    }
  }, /* @__PURE__ */React58.createElement("div", null, /* @__PURE__ */React58.createElement(UitkForm2, {
    hasRequiredFieldIndicator: true
  }, /* @__PURE__ */React58.createElement(EGDSBasicTravelerSelector, {
    data: travelerSelector,
    isTravelersExpanded: isOpen
  }))))), doneButton.__typename === "UIPrimaryButton" && /* @__PURE__ */React58.createElement(EGDSPrimaryButton, {
    floating: true,
    onClick: handleSubmit,
    data: doneButton
  }))))))), /* @__PURE__ */React58.createElement(React58.Fragment, null, /* @__PURE__ */React58.createElement("input", {
    type: "hidden",
    "data-stid": "".concat(ADULT_COUNT_NAME_PREFIX),
    name: "".concat(ADULT_COUNT_NAME_PREFIX),
    value: adults.value
  }), (children === null || children === void 0 ? void 0 : children.__typename) === "EGDSTravelerChildren" && children.ages && /* @__PURE__ */React58.createElement(ChildrenHiddenInputs, {
    ages: children.ages,
    prefix: CHILDREN_NAME_PREFIX
  }), (children === null || children === void 0 ? void 0 : children.__typename) === "EGDSBasicTraveler" && /* @__PURE__ */React58.createElement("input", {
    type: "hidden",
    "data-stid": "".concat(CHILDREN_NAME_PREFIX),
    name: "".concat(CHILDREN_NAME_PREFIX),
    value: children.count.value
  }), (infantsInSeat === null || infantsInSeat === void 0 ? void 0 : infantsInSeat.__typename) === "EGDSTravelerInfant" && infantsInSeat.ages && /* @__PURE__ */React58.createElement(ChildrenHiddenInputs, {
    ages: infantsInSeat.ages,
    prefix: INFANT_IN_SEAT_NAME_PREFIX
  }), (infantsInSeat === null || infantsInSeat === void 0 ? void 0 : infantsInSeat.__typename) === "EGDSBasicTraveler" && /* @__PURE__ */React58.createElement("input", {
    type: "hidden",
    "data-stid": "".concat(INFANT_IN_SEAT_NAME_PREFIX),
    name: "".concat(INFANT_IN_SEAT_NAME_PREFIX),
    value: infantsInSeat.count.value
  }), (infantsOnLap === null || infantsOnLap === void 0 ? void 0 : infantsOnLap.__typename) === "EGDSTravelerInfant" && infantsOnLap.ages && /* @__PURE__ */React58.createElement(ChildrenHiddenInputs, {
    ages: infantsOnLap.ages,
    prefix: INFANT_ON_LAP_NAME_PREFIX
  }), (infantsOnLap === null || infantsOnLap === void 0 ? void 0 : infantsOnLap.__typename) === "EGDSBasicTraveler" && /* @__PURE__ */React58.createElement("input", {
    type: "hidden",
    "data-stid": "".concat(INFANT_ON_LAP_NAME_PREFIX),
    name: "".concat(INFANT_ON_LAP_NAME_PREFIX),
    value: infantsOnLap.count.value
  }), (pets === null || pets === void 0 ? void 0 : pets.__typename) === "EGDSBasicCheckBox" && /* @__PURE__ */React58.createElement("input", {
    type: "hidden",
    name: "".concat(PETS_STATE_NAME_PREFIX),
    value: pets.state
  })));
};
// ../internal/src/components/form/egds-search-form-travelers-field/travelers-field-triggers.tsx
import React59 from "react";
import { useClickTracker as useClickTracker23 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
import { useSearchFormReflectionContext as useSearchFormReflectionContext6 } from "@shared-ui/retail-search-tools-reflection-provider";
import { ViewLarge as ViewLarge4, ViewMedium as ViewMedium7, Viewport as Viewport9, ViewSizes as ViewSizes2, ViewSmall as ViewSmall7 } from "@shared-ui/viewport-context";
import { UitkForm as UitkForm3, useFormCallback as useFormCallback8 } from "uitk-react-form";
import { UitkFakeInput as UitkFakeInput2 } from "uitk-react-input";
import { PositionType as PositionType3, UitkMenu as UitkMenu3, UitkMenuContainer as UitkMenuContainer3, UitkMenuTrigger as UitkMenuTrigger3 } from "uitk-react-menu";
import { UitkSheet as UitkSheet2, UitkSheetContent as UitkSheetContent2, UitkSheetTransition as UitkSheetTransition2 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing16 } from "uitk-react-spacing";
import { UitkToolbar as UitkToolbar3 } from "uitk-react-toolbar";
var BASE_TRAVELERS_FIELD_PREFIX2 = "EGDSSearchFormTravelersField";
var ADULT_COUNT_NAME_PREFIX2 = "".concat(BASE_TRAVELERS_FIELD_PREFIX2, "-Adult");
var CHILDREN_NAME_PREFIX2 = "".concat(BASE_TRAVELERS_FIELD_PREFIX2, "-ChildrenAge");
var INFANT_IN_SEAT_NAME_PREFIX2 = "".concat(BASE_TRAVELERS_FIELD_PREFIX2, "-InfantInSeatAge");
var INFANT_ON_LAP_NAME_PREFIX2 = "".concat(BASE_TRAVELERS_FIELD_PREFIX2, "-InfantOnLapAge");
var TravelersFieldTriggers = function (param) {
  var label = param.label,
    leftIcon = param.leftIcon,
    action = param.action,
    labelTemplate = param.labelTemplate,
    readOnly = param.readOnly,
    onOpenTravelerField = param.onOpenTravelerField;
  var accessibility = action.accessibility,
    analytics = action.analytics,
    travelerSelector = action.travelerSelector;
  var doneButton = travelerSelector.doneButton;
  var allyLabelDescritption = accessibility !== null && accessibility !== void 0 ? accessibility : "";
  var track = useClickTracker23();
  var _useTravelersContext = useTravelersContext(),
    dispatch = _useTravelersContext.dispatch,
    state = _useTravelersContext.state;
  var _useSearchFormReflectionContext6 = useSearchFormReflectionContext6(),
    reflectionState = _useSearchFormReflectionContext6.state;
  var error = state.error;
  var _useDialog2 = _sliced_to_array(useDialog2("travelerSelectorDialog"), 3),
    isOpen = _useDialog2[0],
    dialogActions = _useDialog2[1],
    TravelerSelectorDialogWrapper = _useDialog2[2];
  var triggerRef = React59.useRef(null);
  var _React59_useState = _sliced_to_array(React59.useState(false), 2),
    showMenu = _React59_useState[0],
    setShowMenu = _React59_useState[1];
  var _React59_useState1 = _sliced_to_array(React59.useState(state), 2),
    initialState = _React59_useState1[0],
    setInitialState = _React59_useState1[1];
  var _labelTemplate_text;
  var _React59_useState2 = _sliced_to_array(React59.useState((_labelTemplate_text = labelTemplate === null || labelTemplate === void 0 ? void 0 : labelTemplate.text) !== null && _labelTemplate_text !== void 0 ? _labelTemplate_text : ""), 2),
    travelersSummary = _React59_useState2[0],
    setTravelersSummary = _React59_useState2[1];
  var handleChange = useFormCallback8(travelerSelector.__typename, function (event) {
    return event;
  });
  var formatTravelerSummary = function (rooms) {
    var travelersCount = rooms.reduce(function (count, room) {
      var _room_adults, _room_children_count, _room_children, _room_infants_count, _room_infants;
      var _room_adults_value;
      var adultsCount = (_room_adults_value = (_room_adults = room.adults) === null || _room_adults === void 0 ? void 0 : _room_adults.value) !== null && _room_adults_value !== void 0 ? _room_adults_value : 0;
      var _room_children_count_value;
      var childrenCount = (_room_children_count_value = (_room_children = room.children) === null || _room_children === void 0 ? void 0 : (_room_children_count = _room_children.count) === null || _room_children_count === void 0 ? void 0 : _room_children_count.value) !== null && _room_children_count_value !== void 0 ? _room_children_count_value : 0;
      var _room_infants_count_value;
      var infantsCount = (_room_infants_count_value = (_room_infants = room.infants) === null || _room_infants === void 0 ? void 0 : (_room_infants_count = _room_infants.count) === null || _room_infants_count === void 0 ? void 0 : _room_infants_count.value) !== null && _room_infants_count_value !== void 0 ? _room_infants_count_value : 0;
      return count + adultsCount + childrenCount + infantsCount;
    }, 0);
    return formatCompositeText(labelTemplate, rooms.length, travelersCount);
  };
  React59.useEffect(function () {
    setTravelersSummary(formatTravelerSummary(state.rooms));
    if (action.travelerSelector.__typename === "EGDSRoomsTravelerSelector") {
      if (action.travelerSelector.rooms[0].infants !== initialState.rooms[0].infants) {
        dispatch({
          type: "RESET_ROOMS",
          state: _object_spread_props(_object_spread({}, state), {
            rooms: _to_consumable_array(action.travelerSelector.rooms)
          })
        });
        setInitialState(_object_spread_props(_object_spread({}, state), {
          rooms: _to_consumable_array(action.travelerSelector.rooms)
        }));
        setTravelersSummary(formatTravelerSummary(_to_consumable_array(action.travelerSelector.rooms)));
      }
    }
  }, [action.travelerSelector]);
  React59.useEffect(function () {
    setTravelersSummary(formatTravelerSummary(state.rooms));
  }, [state.rooms]);
  React59.useEffect(function () {
    var _reflectionState_travelers_adultTravelerCounts, _reflectionState_travelers;
    if ((action === null || action === void 0 ? void 0 : action.__typename) === "EGDSOpenTravelerSelectorAction" && (action === null || action === void 0 ? void 0 : action.travelerSelector.__typename) === "EGDSRoomsTravelerSelector" && (reflectionState === null || reflectionState === void 0 ? void 0 : (_reflectionState_travelers = reflectionState.travelers) === null || _reflectionState_travelers === void 0 ? void 0 : (_reflectionState_travelers_adultTravelerCounts = _reflectionState_travelers.adultTravelerCounts) === null || _reflectionState_travelers_adultTravelerCounts === void 0 ? void 0 : _reflectionState_travelers_adultTravelerCounts.length)) {
      var _reflectionState_travelers1, _reflectionState_travelers2, _reflectionState_travelers3;
      var _reflectionState_travelers_adultTravelerCounts1, _reflectionState_travelers_childTravelerCounts, _reflectionState_travelers_childrenAges;
      dispatch({
        type: "UPDATE_TRAVELERS_BULK",
        state: initialState,
        adultTravelerCounts: (_reflectionState_travelers_adultTravelerCounts1 = reflectionState === null || reflectionState === void 0 ? void 0 : (_reflectionState_travelers1 = reflectionState.travelers) === null || _reflectionState_travelers1 === void 0 ? void 0 : _reflectionState_travelers1.adultTravelerCounts) !== null && _reflectionState_travelers_adultTravelerCounts1 !== void 0 ? _reflectionState_travelers_adultTravelerCounts1 : [0],
        childTravelerCounts: (_reflectionState_travelers_childTravelerCounts = reflectionState === null || reflectionState === void 0 ? void 0 : (_reflectionState_travelers2 = reflectionState.travelers) === null || _reflectionState_travelers2 === void 0 ? void 0 : _reflectionState_travelers2.childTravelerCounts) !== null && _reflectionState_travelers_childTravelerCounts !== void 0 ? _reflectionState_travelers_childTravelerCounts : [0],
        childrenAges: (_reflectionState_travelers_childrenAges = reflectionState === null || reflectionState === void 0 ? void 0 : (_reflectionState_travelers3 = reflectionState.travelers) === null || _reflectionState_travelers3 === void 0 ? void 0 : _reflectionState_travelers3.childrenAges) !== null && _reflectionState_travelers_childrenAges !== void 0 ? _reflectionState_travelers_childrenAges : [[]]
      });
    }
  }, [reflectionState.travelers]);
  if (travelerSelector.__typename !== "EGDSRoomsTravelerSelector") {
    return null;
  }
  var onTriggerClick = function () {
    setShowMenu(function (prevState) {
      return !prevState;
    });
    if (onOpenTravelerField) {
      onOpenTravelerField();
    }
    track(analytics.referrerId, analytics.linkName);
  };
  var onDismissMenu = function () {
    var _ref = _async_to_generator(function () {
      return _ts_generator(this, function (_state) {
        switch (_state.label) {
          case 0:
            if (!state.error) return [3, 2];
            return [4, dispatch({
              type: "SHOW_ERROR"
            })];
          case 1:
            _state.sent();
            setShowMenu(true);
            _state.label = 2;
          case 2:
            if (!state.error && !isEqual(initialState, state)) {
              setInitialState(state);
              triggerInputChangeEvent("submit", handleChange);
            }
            setTravelersSummary(formatTravelerSummary(state.rooms));
            return [2];
        }
      });
    });
    return function onDismissMenu() {
      return _ref.apply(this, arguments);
    };
  }();
  var onClick = function () {
    dialogActions.openDialog();
    track(analytics.referrerId, analytics.linkName);
    if (onOpenTravelerField) {
      onOpenTravelerField(ViewSizes2.SMALL);
    }
  };
  var updateTravelerSummary = function (rooms) {
    var travelersValue = formatTravelerSummary(rooms);
    triggerInputChangeEvent(travelersValue, handleChange);
    setTravelersSummary(travelersValue);
  };
  var onSaveMenu = function (newState) {
    var _triggerRef_current;
    if (!isEqual(initialState, newState)) {
      updateTravelerSummary(newState.rooms);
      setInitialState(newState);
    }
    setShowMenu(function (prevState) {
      return !prevState;
    });
    (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.focus();
  };
  var onSaveDialog = function (newState) {
    var _triggerRef_current;
    if (!isEqual(initialState, newState)) {
      updateTravelerSummary(newState.rooms);
      setInitialState(newState);
    }
    (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.focus();
    dialogActions.closeDialog();
  };
  var validateSelector = function (event) {
    if (error && error.type === "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */) {
      if (event) {
        event.preventDefault();
      }
      dispatch({
        type: "SHOW_ERROR"
      });
    }
  };
  var onDismissDialog = function () {
    if ((travelerSelector.closeButton.__typename === "UIPrimaryButton" || travelerSelector.closeButton.__typename === "UITertiaryButton") && travelerSelector.closeButton.analytics) {
      var _travelerSelector_closeButton_analytics = travelerSelector.closeButton.analytics,
        referrerId = _travelerSelector_closeButton_analytics.referrerId,
        linkName = _travelerSelector_closeButton_analytics.linkName;
      if (!error) {
        track(referrerId, linkName);
      }
    }
    validateSelector();
    if (!error) {
      onSaveDialog(state);
    }
  };
  var handleSubmit = function (triggerType) {
    validateSelector();
    if (!error) {
      if (triggerType === "menu") {
        onSaveMenu(state);
      } else {
        onSaveDialog(state);
      }
    }
  };
  var getActionButton = function (isFloating) {
    return doneButton.__typename === "UIPrimaryButton" && /* @__PURE__ */React59.createElement(EGDSPrimaryButton, {
      onClick: handleSubmit,
      data: doneButton,
      floating: isFloating
    });
  };
  var _travelerSelector_closeButton_accessibility;
  return /* @__PURE__ */React59.createElement(React59.Fragment, null, /* @__PURE__ */React59.createElement(Viewport9, null, /* @__PURE__ */React59.createElement(ViewLarge4, null, /* @__PURE__ */React59.createElement(UitkMenu3, {
    isOpen: showMenu,
    onTriggerClick: onTriggerClick,
    onDismiss: onDismissMenu
  }, /* @__PURE__ */React59.createElement(UitkMenuTrigger3, null, /* @__PURE__ */React59.createElement(UitkFakeInput2, {
    label: label,
    "aria-roledescription": allyLabelDescritption,
    value: travelersSummary,
    icon: leftIcon,
    "data-stid": "open-room-picker",
    disabled: readOnly,
    domRef: triggerRef,
    className: "open-room-picker-observer-root"
  })), /* @__PURE__ */React59.createElement(UitkMenuContainer3, {
    maxHeight: 4e3,
    autoPosition: true,
    position: PositionType3.RIGHT,
    width: 375,
    intersectionObserverRoot: ".open-room-picker-observer-root"
  }, /* @__PURE__ */React59.createElement(UitkSpacing16, {
    padding: {
      inline: "six",
      blockstart: "two"
    }
  }, /* @__PURE__ */React59.createElement("div", {
    "data-stid": "rooms-traveler-selector-menu-container"
  }, /* @__PURE__ */React59.createElement(EGDSRoomsTravelerSelector, {
    onSubmit: handleSubmit,
    data: travelerSelector,
    isTravelersExpanded: showMenu
  })))))), /* @__PURE__ */React59.createElement(ViewMedium7, null, /* @__PURE__ */React59.createElement(UitkMenu3, {
    isOpen: showMenu,
    onTriggerClick: onTriggerClick,
    onDismiss: onDismissMenu
  }, /* @__PURE__ */React59.createElement(UitkMenuTrigger3, null, /* @__PURE__ */React59.createElement(UitkFakeInput2, {
    label: label,
    "aria-roledescription": allyLabelDescritption,
    value: travelersSummary,
    icon: leftIcon,
    "data-stid": "open-room-picker",
    disabled: readOnly,
    domRef: triggerRef,
    className: "open-room-picker-observer-root"
  })), /* @__PURE__ */React59.createElement(UitkMenuContainer3, {
    maxHeight: 4e3,
    autoPosition: true,
    position: PositionType3.RIGHT,
    width: 375,
    intersectionObserverRoot: ".open-room-picker-observer-root"
  }, /* @__PURE__ */React59.createElement(UitkSpacing16, {
    padding: {
      inline: "six",
      blockstart: "two"
    }
  }, /* @__PURE__ */React59.createElement("div", {
    "data-stid": "rooms-traveler-selector-menu-container"
  }, /* @__PURE__ */React59.createElement(EGDSRoomsTravelerSelector, {
    onSubmit: handleSubmit,
    data: travelerSelector,
    isTravelersExpanded: showMenu
  })))))), /* @__PURE__ */React59.createElement(ViewSmall7, null, /* @__PURE__ */React59.createElement(React59.Fragment, null, /* @__PURE__ */React59.createElement(UitkFakeInput2, {
    label: label,
    "aria-roledescription": allyLabelDescritption,
    value: travelersSummary,
    onClick: onClick,
    icon: leftIcon,
    "data-stid": "open-room-picker",
    disabled: readOnly,
    domRef: triggerRef
  }), /* @__PURE__ */React59.createElement(UitkSheetTransition2, {
    isVisible: isOpen
  }, /* @__PURE__ */React59.createElement(TravelerSelectorDialogWrapper, null, /* @__PURE__ */React59.createElement(UitkSheet2, {
    isVisible: isOpen,
    returnFocusOnClose: true,
    type: "full",
    triggerRef: triggerRef
  }, /* @__PURE__ */React59.createElement(UitkToolbar3, {
    toolbarTitle: travelerSelector.title,
    navigationContent: {
      navType: "close",
      navIconLabel: travelerSelector.closeButton.__typename === "UIPrimaryButton" || travelerSelector.closeButton.__typename === "UITertiaryButton" ? (_travelerSelector_closeButton_accessibility = travelerSelector.closeButton.accessibility) !== null && _travelerSelector_closeButton_accessibility !== void 0 ? _travelerSelector_closeButton_accessibility : "" : "",
      onClick: onDismissDialog
    }
  }), /* @__PURE__ */React59.createElement(UitkSheetContent2, null, /* @__PURE__ */React59.createElement(UitkForm3, {
    hasRequiredFieldIndicator: true
  }, /* @__PURE__ */React59.createElement(EGDSRoomsTravelerSelector, {
    data: travelerSelector,
    isTravelersExpanded: isOpen
  }))), getActionButton(true))))))), state.rooms.map(function (room, roomIndex) {
    var _children_ages, _infants_ages;
    var adults = room.adults,
      children = room.children,
      infants = room.infants;
    var roomNumber = roomIndex + 1;
    return /* @__PURE__ */React59.createElement(React59.Fragment, {
      key: roomIndex
    }, /* @__PURE__ */React59.createElement("input", {
      type: "hidden",
      "data-stid": "".concat(ADULT_COUNT_NAME_PREFIX2, "-").concat(roomNumber),
      name: "".concat(ADULT_COUNT_NAME_PREFIX2, "-Room").concat(roomNumber),
      value: adults.value
    }), children.__typename === "EGDSTravelerChildren" && ((_children_ages = children.ages) === null || _children_ages === void 0 ? void 0 : _children_ages.map(function (age, childIndex) {
      if (age.__typename === "EGDSTravelerChildAgeSelect") {
        var childNumber = childIndex + 1;
        var childName = "".concat(CHILDREN_NAME_PREFIX2, "-Room").concat(roomNumber, "-Child").concat(childNumber);
        var _age_value;
        return /* @__PURE__ */React59.createElement("input", {
          key: childIndex,
          type: "hidden",
          "data-stid": childName,
          name: childName,
          value: (_age_value = age.value) !== null && _age_value !== void 0 ? _age_value : ""
        });
      }
      return null;
    })), (infants === null || infants === void 0 ? void 0 : infants.__typename) === "EGDSTravelerInfant" && ((_infants_ages = infants.ages) === null || _infants_ages === void 0 ? void 0 : _infants_ages.map(function (age, infantIndex) {
      if (age.__typename === "EGDSTravelerChildAgeSelect") {
        var _state_infantSeatSelection;
        var infantNumber = infantIndex + 1;
        var infantType = ((_state_infantSeatSelection = state.infantSeatSelection) === null || _state_infantSeatSelection === void 0 ? void 0 : _state_infantSeatSelection.value) === "seat" ? INFANT_IN_SEAT_NAME_PREFIX2 : INFANT_ON_LAP_NAME_PREFIX2;
        var infantName = "".concat(infantType, "-Room").concat(roomNumber, "-Infant").concat(infantNumber);
        var _age_value;
        return /* @__PURE__ */React59.createElement("input", {
          key: infantIndex,
          type: "hidden",
          "data-stid": infantName,
          name: infantName,
          value: (_age_value = age.value) !== null && _age_value !== void 0 ? _age_value : ""
        });
      }
      return null;
    })));
  }));
};
// ../internal/src/components/form/egds-search-form-travelers-field/egds-search-form-travelers-field.tsx
var __Fragment39 = gql48(_templateObject51(), EGDSBasicTravelerSelector.fragment, EGDSRoomsTravelerSelector.fragment);
var getTravelersData = function (travelers, isAnyPetAllowed) {
  if ((travelers === null || travelers === void 0 ? void 0 : travelers.pets) && travelers.pets.__typename === "EGDSBasicCheckBox") {
    return _object_spread_props(_object_spread({}, travelers), {
      pets: _object_spread_props(_object_spread({}, travelers.pets), {
        state: isAnyPetAllowed ? "CHECKED" /* CHECKED */ : "UNCHECKED" /* UNCHECKED */
      })
    });
  }
  return travelers;
};
var EGDSSearchFormTravelersField = function (param) {
  var data = param.data,
    skipQuery = param.skipQuery,
    isAnyPetAllowed = param.isAnyPetAllowed,
    retainTravelerOnDialogDismiss = param.retainTravelerOnDialogDismiss,
    onOpenTravelerField = param.onOpenTravelerField,
    onCloseTravelerField = param.onCloseTravelerField,
    maxBookableTravelers = param.maxBookableTravelers,
    maxTravelersErrorMessage = param.maxTravelersErrorMessage;
  var _React60_useState = _sliced_to_array(React60.useState(data), 2),
    state = _React60_useState[0],
    setState = _React60_useState[1];
  React60.useEffect(function () {
    var _data_action;
    if (((_data_action = data.action) === null || _data_action === void 0 ? void 0 : _data_action.__typename) === "EGDSOpenTravelerSelectorAction") {
      var _data_action_travelerSelector_validations;
      var _data_action_travelerSelector_validations_map;
      var validations = (_data_action_travelerSelector_validations_map = (_data_action_travelerSelector_validations = data.action.travelerSelector.validations) === null || _data_action_travelerSelector_validations === void 0 ? void 0 : _data_action_travelerSelector_validations.map(function (validation) {
        var isTravelerValidation = validation.__typename === "EGDSTravelersInputValidation" && validation.type === "MAX_TRAVELERS";
        var overrideTravelerMaxCount = isTravelerValidation && maxBookableTravelers;
        if (overrideTravelerMaxCount) {
          return _object_spread_props(_object_spread({}, validation), {
            maxCount: maxBookableTravelers,
            errorMessage: maxTravelersErrorMessage !== null && maxTravelersErrorMessage !== void 0 ? maxTravelersErrorMessage : ""
          });
        }
        return validation;
      })) !== null && _data_action_travelerSelector_validations_map !== void 0 ? _data_action_travelerSelector_validations_map : null;
      setState(_object_spread_props(_object_spread({}, data), {
        action: _object_spread_props(_object_spread({}, data.action), {
          travelerSelector: _object_spread_props(_object_spread({}, data.action.travelerSelector), {
            validations: validations
          })
        })
      }));
      return;
    }
    setState(data);
  }, [data, maxBookableTravelers, maxTravelersErrorMessage]);
  var action = state.action,
    label = state.label,
    labelTemplate = state.labelTemplate,
    leftIcon = state.leftIcon,
    readOnly = state.readOnly;
  if ((action === null || action === void 0 ? void 0 : action.__typename) !== "EGDSOpenTravelerSelectorAction") {
    return null;
  }
  switch (action.travelerSelector.__typename) {
    case "EGDSBasicTravelerSelector":
      {
        var _action_travelerSelector = action.travelerSelector,
          travelers = _action_travelerSelector.travelers,
          validations = _action_travelerSelector.validations;
        var initialTravelers = getTravelersData(travelers, isAnyPetAllowed !== null && isAnyPetAllowed !== void 0 ? isAnyPetAllowed : false);
        if (!!initialTravelers && (labelTemplate === null || labelTemplate === void 0 ? void 0 : labelTemplate.__typename) === "EGDSCardinalLocalizedText") {
          return /* @__PURE__ */React60.createElement(BasicTravelersProvider, _object_spread_props(_object_spread({}, {
            travelers: initialTravelers,
            validations: validations
          }), {
            skipQuery: skipQuery
          }), /* @__PURE__ */React60.createElement(BasicTravelersFieldTriggers, {
            label: label !== null && label !== void 0 ? label : "",
            leftIcon: leftIcon === null || leftIcon === void 0 ? void 0 : leftIcon.id,
            action: action,
            labelTemplate: labelTemplate,
            readOnly: readOnly,
            isAnyPetAllowed: isAnyPetAllowed,
            onOpenTravelerField: onOpenTravelerField,
            onCloseTravelerField: onCloseTravelerField,
            retainTravelerOnDialogDismiss: retainTravelerOnDialogDismiss
          }));
        }
        return null;
      }
    case "EGDSRoomsTravelerSelector":
      {
        if ((labelTemplate === null || labelTemplate === void 0 ? void 0 : labelTemplate.__typename) === "EGDSCompositeLocalizedText") {
          return /* @__PURE__ */React60.createElement(TravelersProvider, _object_spread_props(_object_spread({}, action.travelerSelector), {
            infantSeatSelection: action.travelerSelector.infantSeatSelection,
            rooms: action.travelerSelector.rooms,
            validations: action.travelerSelector.validations,
            skipQuery: skipQuery
          }), /* @__PURE__ */React60.createElement(TravelersFieldTriggers, {
            label: label !== null && label !== void 0 ? label : "",
            leftIcon: leftIcon === null || leftIcon === void 0 ? void 0 : leftIcon.id,
            action: action,
            labelTemplate: labelTemplate,
            readOnly: readOnly,
            onOpenTravelerField: onOpenTravelerField
          }));
        }
        return null;
      }
    default:
      return null;
  }
};
EGDSSearchFormTravelersField.displayName = "EGDSSearchFormTravelersField";
EGDSSearchFormTravelersField.fragment = __Fragment39;
// ../internal/src/components/form/egds-search-playback.tsx
import React61 from "react";
import { gql as gql49 } from "@apollo/client";
import { useClickTracker as useClickTracker24 } from "@shared-ui/clickstream-analytics-context";
import { UitkButtonSize as UitkButtonSize5 } from "uitk-react-button";
import { UitkCard, UitkCardLink } from "uitk-react-cards";
import { UitkIcon as UitkIcon5, UitkIconSize as UitkIconSize2 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex10 } from "uitk-react-layout-flex";
import { MinMax, Repeat, UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkHeading as UitkHeading4, UitkText as UitkText5 } from "uitk-react-text";
var __Fragment40 = gql49(_templateObject52(), EGDSTertiaryButton.fragment);
var StickyWrapper = function (param) {
  var isSticky = param.isSticky,
    children = param.children;
  return isSticky ? /* @__PURE__ */React61.createElement(StickySearchForm, null, children) : /* @__PURE__ */React61.createElement("div", null, children);
};
var EGDSSearchPlayback = function (param) {
  var data = param.data,
    children = param.children,
    stickyPlayback = param.stickyPlayback,
    display = param.display,
    onDisplayToggle = param.onDisplayToggle;
  var primary = data.primary,
    secondaries = data.secondaries,
    showAction = data.showAction,
    hideButton = data.hideButton;
  var track = useClickTracker24();
  if (showAction.__typename !== "EGDSShowSearchFormAction" || hideButton.__typename !== "UITertiaryButton") {
    return null;
  }
  var accessibility = showAction.accessibility,
    analytics = showAction.analytics,
    icon = showAction.icon;
  var _icon_size;
  var iconSize = UitkIconSize2[(_icon_size = icon.size) !== null && _icon_size !== void 0 ? _icon_size : "SMALL"];
  var onPlaybackClick = function () {
    onDisplayToggle(false);
    track(analytics.referrerId, analytics.linkName);
  };
  var onCloseButtonClick = function () {
    onDisplayToggle(true);
    if (hideButton.analytics) {
      var _hideButton_analytics = hideButton.analytics,
        referrerId = _hideButton_analytics.referrerId,
        linkName = _hideButton_analytics.linkName;
      track(referrerId, linkName);
    }
  };
  return /* @__PURE__ */React61.createElement(StickyWrapper, {
    isSticky: stickyPlayback
  }, display && /* @__PURE__ */React61.createElement(UitkCard, {
    border: true,
    padded: true
  }, /* @__PURE__ */React61.createElement(UitkLayoutGrid, {
    space: "three",
    columns: [MinMax("0x", "1fr"), "min-content"],
    alignItems: "center"
  }, /* @__PURE__ */React61.createElement(UitkLayoutGridItem, null, /* @__PURE__ */React61.createElement("div", null, /* @__PURE__ */React61.createElement(UitkHeading4, {
    size: 6,
    tag: "h2",
    overflow: "truncate"
  }, primary.text), /* @__PURE__ */React61.createElement(UitkLayoutGrid, {
    columns: [Repeat(secondaries.length, "max-content")],
    space: "six"
  }, secondaries.map(function (secondary, index) {
    return secondary && secondary.__typename === "EGDSBasicLocalizedText" || secondary && secondary.__typename === "EGDSCardinalLocalizedText" ? /* @__PURE__ */React61.createElement(UitkLayoutGridItem, {
      key: "secondary-".concat(index)
    }, /* @__PURE__ */React61.createElement(UitkText5, {
      size: 200,
      overflow: "truncate",
      "aria-label": secondary.__typename === "EGDSBasicLocalizedText" ? secondary.accessibilityTemplate : secondary.accessibilityText
    }, /* @__PURE__ */React61.createElement("span", {
      "aria-hidden": "true"
    }, secondary.text))) : /* @__PURE__ */React61.createElement(UitkLayoutGridItem, {
      key: "secondary-".concat(index)
    }, /* @__PURE__ */React61.createElement(UitkText5, {
      size: 200,
      overflow: "truncate"
    }, secondary && secondary.__typename === "EGDSPlainText" ? secondary.text : ""));
  })))), /* @__PURE__ */React61.createElement(UitkLayoutGridItem, null, /* @__PURE__ */React61.createElement(UitkIcon5, {
    id: icon.id,
    name: icon.id,
    size: iconSize
  }))), /* @__PURE__ */React61.createElement(UitkCardLink, null, /* @__PURE__ */React61.createElement("button", {
    type: "button",
    onClick: onPlaybackClick,
    "aria-label": accessibility
  }))), /* @__PURE__ */React61.createElement(UitkLayoutFlex10, {
    space: "three",
    direction: "column",
    "aria-hidden": display,
    className: display ? "is-visually-hidden is-hidden" : ""
  }, children, /* @__PURE__ */React61.createElement(EGDSTertiaryButton, {
    onClick: onCloseButtonClick,
    isFullWidth: true,
    size: UitkButtonSize5.MEDIUM,
    data: hideButton
  })));
};
EGDSSearchPlayback.fragment = __Fragment40;
EGDSSearchPlayback.displayName = "EGDSSearchPlayback";
// ../internal/src/components/form/search-form-messaging/search-form-messaging.tsx
import React65 from "react";
import { gql as gql52 } from "@apollo/client";
import { EGDSParagraph } from "@egds/react-core/text";
import { ViewMedium as ViewMedium9, Viewport as Viewport11, ViewSizes as ViewSizes3, ViewSmall as ViewSmall9 } from "@shared-ui/viewport-context";
// ../internal/src/components/form/search-form-messaging/components/search-form-messaging-card.tsx
import React64 from "react";
import { EGDSCard } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText4 } from "@egds/react-core/text";
// ../internal/src/components/form/search-form-messaging/layout-field-config.ts
var FLEX_ITEM_FIELDS = {
  LEFT_ICON: "LeftIconFlexItem",
  DEFAULT: "default"
};
var flexItemLayoutProps = {
  SMALL: {
    LeftIconFlexItem: {
      alignSelf: void 0
    },
    default: {
      alignSelf: "center"
    }
  },
  MEDIUM: {
    LeftIconFlexItem: {
      alignSelf: "center"
    },
    default: {}
  },
  LARGE: {
    default: {}
  },
  EXTRA_LARGE: {
    default: {}
  }
};
var getFlexItemPropsByFieldName = function (fieldName, viewportSize) {
  var componentPropsMappingByViewport = flexItemLayoutProps[viewportSize];
  var _componentPropsMappingByViewport_fieldName;
  return (_componentPropsMappingByViewport_fieldName = componentPropsMappingByViewport[fieldName]) !== null && _componentPropsMappingByViewport_fieldName !== void 0 ? _componentPropsMappingByViewport_fieldName : componentPropsMappingByViewport.default;
};
var flexLayoutProps = {
  SMALL: {
    space: "one",
    justifyContent: "center",
    alignItems: "center"
  },
  MEDIUM: {
    alignItems: void 0
  },
  LARGE: {},
  EXTRA_LARGE: {}
};
var getFlexLayoutProps = function (viewportSize) {
  return flexLayoutProps[viewportSize];
};
// ../internal/src/components/form/search-form-messaging/components/search-form-messaging-info-trigger.tsx
import React63 from "react";
import { gql as gql51 } from "@apollo/client";
import { EGDSMoreInfoTrigger } from "@egds/react-core/more-info-trigger";
import { EGDSText as EGDSText3 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker26 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/form/search-form-messaging/components/search-form-messaging-sheet.tsx
import React62 from "react";
import { gql as gql50 } from "@apollo/client";
import { EGDSTertiaryButton as EGDSTertiaryButton2 } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon3 } from "@egds/react-core/icons";
import { EGDSSheet, EGDSSheetCloseButton, EGDSSheetContent, EGDSSheetTransition } from "@egds/react-core/sheet";
import { useClickTracker as useClickTracker25 } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium as ViewMedium8, Viewport as Viewport10, ViewSmall as ViewSmall8 } from "@shared-ui/viewport-context";
var _fragment = gql50(_templateObject53());
var EGDSSheetType = {
  POPOVER: "popover" /* POPOVER */,
  BOTTOM: "bottom" /* BOTTOM */,
  CENTERED: "centered" /* CENTERED */,
  FULL: "full" /* FULL */,
  SIDE: "side" /* SIDE */
};
var SearchFormMessagingSheet = function (props) {
  var _sheetTypes_find_sheetType, _sheetTypes_find, _sheetTypes_find_sheetType1, _sheetTypes_find1;
  var toggleVisibility = props.toggleVisibility,
    children = props.children,
    isVisible = props.isVisible,
    data = props.data;
  var track = useClickTracker25();
  var closeAccessibility = data.closeAccessibility,
    sheetTypes = data.sheetTypes,
    closeAnalytics = data.closeAnalytics;
  var _sheetTypes_find_sheetType_toString;
  var mobileSheetType = EGDSSheetType[(_sheetTypes_find_sheetType_toString = sheetTypes === null || sheetTypes === void 0 ? void 0 : (_sheetTypes_find = sheetTypes.find(function (sheet) {
    return sheet.viewSize === "SMALL" /* SMALL */;
  })) === null || _sheetTypes_find === void 0 ? void 0 : (_sheetTypes_find_sheetType = _sheetTypes_find.sheetType) === null || _sheetTypes_find_sheetType === void 0 ? void 0 : _sheetTypes_find_sheetType.toString()) !== null && _sheetTypes_find_sheetType_toString !== void 0 ? _sheetTypes_find_sheetType_toString : "BOTTOM"];
  var _sheetTypes_find_sheetType_toString1;
  var desktopSheetType = EGDSSheetType[(_sheetTypes_find_sheetType_toString1 = sheetTypes === null || sheetTypes === void 0 ? void 0 : (_sheetTypes_find1 = sheetTypes.find(function (sheet) {
    return sheet.viewSize === "LARGE" /* LARGE */;
  })) === null || _sheetTypes_find1 === void 0 ? void 0 : (_sheetTypes_find_sheetType1 = _sheetTypes_find1.sheetType) === null || _sheetTypes_find_sheetType1 === void 0 ? void 0 : _sheetTypes_find_sheetType1.toString()) !== null && _sheetTypes_find_sheetType_toString1 !== void 0 ? _sheetTypes_find_sheetType_toString1 : "POPOVER"];
  var handleOnDismiss = function () {
    var linkName = closeAnalytics.linkName,
      referrerId = closeAnalytics.referrerId;
    track(referrerId, linkName);
    if (toggleVisibility) {
      toggleVisibility();
    }
  };
  var closeButton = /* @__PURE__ */React62.createElement(EGDSSheetCloseButton, null, /* @__PURE__ */React62.createElement(EGDSTertiaryButton2, {
    type: "button",
    onClick: handleOnDismiss
  }, /* @__PURE__ */React62.createElement(EGDSIcon3, {
    name: "close",
    title: closeAccessibility !== null && closeAccessibility !== void 0 ? closeAccessibility : "",
    id: "sheet-close-button"
  })));
  var commonSheetContent = /* @__PURE__ */React62.createElement(EGDSSheetContent, {
    padded: true
  }, children);
  return /* @__PURE__ */React62.createElement(EGDSSheetTransition, {
    isVisible: isVisible
  }, /* @__PURE__ */React62.createElement(Viewport10, null, /* @__PURE__ */React62.createElement(ViewSmall8, null, /* @__PURE__ */React62.createElement(EGDSSheet, {
    isVisible: isVisible,
    type: mobileSheetType,
    triggerRef: null,
    onDismiss: handleOnDismiss
  }, closeButton, commonSheetContent)), /* @__PURE__ */React62.createElement(ViewMedium8, null, /* @__PURE__ */React62.createElement(EGDSSheet, {
    position: {
      inline: "leading",
      block: "trailing"
    },
    isVisible: isVisible,
    type: desktopSheetType,
    triggerRef: null,
    onDismiss: handleOnDismiss,
    width: 360,
    applyBlockStartMargin: true
  }, closeButton, commonSheetContent))));
};
SearchFormMessagingSheet.fragment = _fragment;
SearchFormMessagingSheet.displayName = "SearchFormMessagingSheet";
// ../internal/src/components/form/search-form-messaging/components/search-form-messaging-info-trigger.tsx
var _fragment2 = gql51(_templateObject54(), Icon.fragment, SearchFormMessagingSheet.fragment);
var MoreInfoTrigger = React63.forwardRef(function (param, ref) {
  var data = param.data,
    children = param.children,
    onHandleClick = param.onHandleClick;
  var icon = data.icon,
    text = data.text,
    analytics = data.triggerAction.analytics;
  var track = useClickTracker26();
  var triggerIcon = _object_spread_props(_object_spread({}, icon), {
    size: "SMALL" /* SMALL */,
    description: ""
  });
  var handleOnClick = function () {
    if (analytics) {
      var referrerId = analytics.referrerId,
        linkName = analytics.linkName;
      track(referrerId, linkName);
    }
    if (onHandleClick) {
      onHandleClick();
    }
  };
  return /* @__PURE__ */React63.createElement(EGDSMoreInfoTrigger, {
    theme: "default"
  }, /* @__PURE__ */React63.createElement("button", {
    type: "button",
    onClick: handleOnClick,
    ref: ref
  }, children !== null && children !== void 0 ? children : /* @__PURE__ */React63.createElement(EGDSText3, null, text), /* @__PURE__ */React63.createElement(Icon, {
    data: triggerIcon
  })));
});
MoreInfoTrigger.fragment = _fragment2;
MoreInfoTrigger.displayName = "EGDSMoreInfoTrigger";
// ../internal/src/components/form/search-form-messaging/components/search-form-messaging-card.tsx
var MessagingCardText = function (param) {
  var mainText = param.mainText,
    replacementTexts = param.replacementTexts;
  var priceText = mainText.split(/\${|\}/g);
  var children = priceText.map(function (text, index) {
    var price = replacementTexts[text];
    if (price) {
      return /* @__PURE__ */React64.createElement(EGDSText4, {
        key: index,
        inline: "strong"
      }, price);
    }
    return /* @__PURE__ */React64.createElement(React64.Fragment, null, text);
  });
  return /* @__PURE__ */React64.createElement(EGDSText4, null, children);
};
var SearchFormMessagingCard = function (param) {
  var viewSize = param.viewSize,
    toggleVisibility = param.toggleVisibility,
    triggerRef = param.triggerRef,
    data = param.data;
  var icon = data.icon,
    moreInfoTrigger = data.moreInfoTrigger,
    text = data.text;
  var _text_template, _text_replacementTexts;
  return /* @__PURE__ */React64.createElement(EGDSCard, {
    padded: true,
    backgroundTheme: "secondary"
  }, /* @__PURE__ */React64.createElement(EGDSLayoutFlex2, _object_spread({}, getFlexLayoutProps(viewSize)), icon && /* @__PURE__ */React64.createElement(EGDSLayoutFlexItem2, _object_spread({}, getFlexItemPropsByFieldName(FLEX_ITEM_FIELDS.LEFT_ICON, viewSize)), /* @__PURE__ */React64.createElement(Icon, {
    data: _object_spread_props(_object_spread({}, icon), {
      size: "SMALL" /* SMALL */
    })
  })), moreInfoTrigger && /* @__PURE__ */React64.createElement(EGDSLayoutFlexItem2, _object_spread({}, getFlexItemPropsByFieldName(FLEX_ITEM_FIELDS.DEFAULT, viewSize)), /* @__PURE__ */React64.createElement(EGDSSpacing4, {
    margin: {
      inlinestart: "two"
    }
  }, /* @__PURE__ */React64.createElement("div", null, /* @__PURE__ */React64.createElement(MoreInfoTrigger, {
    data: moreInfoTrigger,
    onHandleClick: toggleVisibility,
    ref: triggerRef
  }, /* @__PURE__ */React64.createElement(MessagingCardText, {
    mainText: (_text_template = text === null || text === void 0 ? void 0 : text.template) !== null && _text_template !== void 0 ? _text_template : "",
    replacementTexts: (_text_replacementTexts = text === null || text === void 0 ? void 0 : text.replacementTexts) !== null && _text_replacementTexts !== void 0 ? _text_replacementTexts : []
  })))))));
};
// ../internal/src/components/form/search-form-messaging/search-form-messaging.tsx
var _fragment3 = gql52(_templateObject55(), Icon.fragment, MoreInfoTrigger.fragment);
var SearchFormMessaging = function (props) {
  var data = props.data;
  var moreInfoTrigger = data.moreInfoTrigger;
  var _React65_useState = _sliced_to_array(React65.useState(false), 2),
    isSheetVisible = _React65_useState[0],
    setSheetVisibility = _React65_useState[1];
  var triggerRef = React65.useRef(null);
  var toggleVisibility = function () {
    setSheetVisibility(function (prevState) {
      if (prevState) {
        var _triggerRef_current;
        (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.focus();
      }
      return !prevState;
    });
  };
  var searchFormMessagingCardProps = {
    data: data,
    toggleVisibility: toggleVisibility,
    triggerRef: triggerRef,
    viewSize: ViewSizes3.SMALL
  };
  return /* @__PURE__ */React65.createElement(React65.Fragment, null, /* @__PURE__ */React65.createElement(Viewport11, null, /* @__PURE__ */React65.createElement(ViewSmall9, null, /* @__PURE__ */React65.createElement(SearchFormMessagingCard, _object_spread({}, searchFormMessagingCardProps))), /* @__PURE__ */React65.createElement(ViewMedium9, null, /* @__PURE__ */React65.createElement(SearchFormMessagingCard, _object_spread_props(_object_spread({}, searchFormMessagingCardProps), {
    viewSize: ViewSizes3.MEDIUM
  })))), moreInfoTrigger && /* @__PURE__ */React65.createElement(SearchFormMessagingSheet, {
    isVisible: isSheetVisible,
    data: moreInfoTrigger.triggerAction.sheet,
    toggleVisibility: toggleVisibility
  }, /* @__PURE__ */React65.createElement(EGDSParagraph, {
    size: 2
  }, moreInfoTrigger.triggerAction.text)));
};
SearchFormMessaging.fragment = _fragment3;
SearchFormMessaging.displayName = "SearchFormMessaging";
// ../internal/src/components/form/search-form-partial-stay.tsx
import React67 from "react";
import { gql as gql53 } from "@apollo/client";
// ../internal/src/components/form/additional-field-with-layout.tsx
import React66 from "react";
import { UitkLayoutGrid as UitkLayoutGrid2, UitkLayoutGridItem as UitkLayoutGridItem2 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing17 } from "uitk-react-spacing";
var AddtionalFieldWithLayout = function (param) {
  var children = param.children;
  return /* @__PURE__ */React66.createElement(UitkLayoutGrid2, {
    columns: {
      small: 2,
      medium: 12
    }
  }, /* @__PURE__ */React66.createElement(UitkLayoutGridItem2, {
    colSpan: {
      small: 2,
      medium: 4
    }
  }, /* @__PURE__ */React66.createElement("div", null, /* @__PURE__ */React66.createElement(UitkSpacing17, {
    padding: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React66.createElement("div", null, children)))));
};
// ../internal/src/components/form/search-form-partial-stay.tsx
var __Fragment41 = gql53(_templateObject56(), EGDSSearchFormDatePickerField.fragment, EGDSSearchFormDatePickerField.fragment);
var SearchFormPartialStay = function (param) {
  var data = param.data,
    setFieldRefByTypename = param.setFieldRefByTypename,
    fieldError = param.fieldError;
  var addPartialStay = data.addPartialStay,
    dates = data.dates,
    errorMessage = data.errorMessage;
  var _addPartialStay_state;
  var _React67_useState = _sliced_to_array(React67.useState((_addPartialStay_state = addPartialStay === null || addPartialStay === void 0 ? void 0 : addPartialStay.state) !== null && _addPartialStay_state !== void 0 ? _addPartialStay_state : "UNCHECKED" /* UNCHECKED */), 2),
    checked = _React67_useState[0],
    setChecked = _React67_useState[1];
  var handleCheckboxChange = function (event) {
    setChecked(event.target.checked ? "CHECKED" /* CHECKED */ : "UNCHECKED" /* UNCHECKED */);
  };
  var handleFieldRef = function (typename, ref, refIndex) {
    setFieldRefByTypename("".concat(typename, "PartialStay"), ref, refIndex);
  };
  var datesField = dates && /* @__PURE__ */React67.createElement("div", {
    "data-stid": "partial-stay-date-field"
  }, /* @__PURE__ */React67.createElement(AddtionalFieldWithLayout, null, /* @__PURE__ */React67.createElement(EGDSSearchFormDatePickerField, {
    skipReflection: true,
    data: dates,
    fieldError: fieldError,
    setFieldRefByTypename: handleFieldRef,
    overrideErrorMessage: errorMessage
  })));
  return /* @__PURE__ */React67.createElement(React67.Fragment, null, addPartialStay && /* @__PURE__ */React67.createElement(EGDSCheckBox, {
    onChange: handleCheckboxChange,
    data: addPartialStay
  }), checked === "CHECKED" /* CHECKED */ && datesField);
};
SearchFormPartialStay.displayName = "SearchFormPartialStay";
SearchFormPartialStay.fragment = __Fragment41;
// ../internal/src/components/form/search-location/search-location.tsx
import { gql as gql54 } from "@apollo/client";
var SearchLocationFragment = gql54(_templateObject57());
// ../internal/src/utils/error-validation.ts
var getDate = function (date) {
  var days = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return typeof date === "string" && date.includes("-") ? /* @__PURE__ */new Date("".concat(date, "T00:00:00")) : new Date(new Date(date).setDate(new Date(date).getDate() + days));
};
var getFieldError = function (errorState, componentTypeName) {
  return errorState.fieldsWithErrors.find(function (field) {
    return field.__typename === componentTypeName;
  });
};
var getRefTypename = function (typename) {
  var id = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  var typenames = {
    "origin_select-input": "".concat(typename, "Origin"),
    "destination_select-input": "".concat(typename, "Destination"),
    "pick_up_location-input": "".concat(typename, "PickUp"),
    "drop_off_location-input": "".concat(typename, "DropOff"),
    "airport_location-input": "".concat(typename, "Airport"),
    "hotel_location-input": "".concat(typename, "Hotel"),
    "partial_date-input": "".concat(typename, "PartialStay")
  };
  var _typenames_id;
  return (_typenames_id = typenames[id]) !== null && _typenames_id !== void 0 ? _typenames_id : typename;
};
var validateAgeInputField = function (age) {
  var _ref = age || {},
    ageInput = _ref.ageInput,
    config = _ref.config;
  var _ageInput_value;
  var ageinputValue = (_ageInput_value = ageInput.value) !== null && _ageInput_value !== void 0 ? _ageInput_value : "";
  var isAgeinputValueEmpty = ageinputValue === "";
  var ageNumber = parseInt(ageinputValue, 10);
  var isAgeRangeValid = ageNumber && (config === null || config === void 0 ? void 0 : config.min) && (config === null || config === void 0 ? void 0 : config.max) ? ageNumber >= (config === null || config === void 0 ? void 0 : config.min) && ageNumber <= (config === null || config === void 0 ? void 0 : config.max) : true;
  var isAgeInputnValid = !isAgeinputValueEmpty && isAgeRangeValid;
  return {
    __typename: getRefTypename("EGDSNumberInputField", ageInput === null || ageInput === void 0 ? void 0 : ageInput.id),
    isValid: isAgeInputnValid,
    validations: {
      ageRange: isAgeinputValueEmpty ? false : !isAgeRangeValid
    }
  };
};
var validateDestinationLocationField = function (originLocation, destinationLocation) {
  var isSoftPackage = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  var _destinationLocation_value;
  var destinationValue = (_destinationLocation_value = destinationLocation.value) !== null && _destinationLocation_value !== void 0 ? _destinationLocation_value : "";
  var isDestinationEmpty = destinationValue === "";
  var isLocationValid = !isDestinationEmpty;
  var hasSameValueAsOrigin = false;
  if (!isSoftPackage) {
    hasSameValueAsOrigin = originLocation ? !isDestinationEmpty && originLocation.value === destinationValue : false;
    isLocationValid = !isDestinationEmpty && !hasSameValueAsOrigin;
  }
  return {
    __typename: getRefTypename("EGDSSearchFormLocationField", destinationLocation === null || destinationLocation === void 0 ? void 0 : destinationLocation.id),
    isValid: isLocationValid,
    validations: {
      sameLocationSelected: hasSameValueAsOrigin
    }
  };
};
var validateOriginLocationField = function (origin, softPackageDestination) {
  var _origin_value;
  var originValue = (_origin_value = origin.value) !== null && _origin_value !== void 0 ? _origin_value : "";
  var isOriginEmpty = originValue === "";
  if (softPackageDestination && !isOriginEmpty) {
    var hasSameValueAsDestination = softPackageDestination.value === originValue;
    return {
      __typename: getRefTypename("EGDSSearchFormLocationField", origin === null || origin === void 0 ? void 0 : origin.id),
      isValid: !hasSameValueAsDestination,
      validations: {
        sameLocationSelected: hasSameValueAsDestination
      }
    };
  }
  return {
    __typename: getRefTypename("EGDSSearchFormLocationField", origin === null || origin === void 0 ? void 0 : origin.id),
    isValid: !isOriginEmpty
  };
};
var validateDateOutsideTripRange = function (dateField, compareToDateField) {
  var _dateField_startDate, _dateField_endDate, _compareToDateField_startDate, _compareToDateField_endDate;
  var _dateField_startDate_value;
  var dateFieldStartDate = getDate((_dateField_startDate_value = (_dateField_startDate = dateField.startDate) === null || _dateField_startDate === void 0 ? void 0 : _dateField_startDate.value) !== null && _dateField_startDate_value !== void 0 ? _dateField_startDate_value : "");
  var _dateField_endDate_value;
  var dateFieldEndDate = getDate((_dateField_endDate_value = (_dateField_endDate = dateField.endDate) === null || _dateField_endDate === void 0 ? void 0 : _dateField_endDate.value) !== null && _dateField_endDate_value !== void 0 ? _dateField_endDate_value : "");
  var _compareToDateField_startDate_value;
  var compareToDateFieldStartDate = getDate((_compareToDateField_startDate_value = (_compareToDateField_startDate = compareToDateField.startDate) === null || _compareToDateField_startDate === void 0 ? void 0 : _compareToDateField_startDate.value) !== null && _compareToDateField_startDate_value !== void 0 ? _compareToDateField_startDate_value : "");
  var _compareToDateField_endDate_value;
  var compareToDateFieldEndDate = getDate((_compareToDateField_endDate_value = (_compareToDateField_endDate = compareToDateField.endDate) === null || _compareToDateField_endDate === void 0 ? void 0 : _compareToDateField_endDate.value) !== null && _compareToDateField_endDate_value !== void 0 ? _compareToDateField_endDate_value : "");
  return dateFieldStartDate < compareToDateFieldStartDate || dateFieldEndDate > compareToDateFieldEndDate;
};
var validateDatePickerField = function (startDate2, endDate2, config, fieldId) {
  var _startDate2_value;
  var formattedStartDate = getDate((_startDate2_value = startDate2 === null || startDate2 === void 0 ? void 0 : startDate2.value) !== null && _startDate2_value !== void 0 ? _startDate2_value : "");
  var _endDate2_value;
  var formattedEndDate = getDate((_endDate2_value = endDate2 === null || endDate2 === void 0 ? void 0 : endDate2.value) !== null && _endDate2_value !== void 0 ? _endDate2_value : "");
  var overpassesMaxRange = config.maxNumberOfDaysSelected !== 0 ? formattedEndDate >= getDate(formattedStartDate, config.maxNumberOfDaysSelected) : false;
  var isSameDate = formattedStartDate === formattedEndDate;
  var endDateBeforeStartDate = formattedEndDate < formattedStartDate;
  var isDateValid = !overpassesMaxRange && !isSameDate && !endDateBeforeStartDate;
  return {
    __typename: getRefTypename("EGDSSearchFormDatePickerField", fieldId !== null && fieldId !== void 0 ? fieldId : startDate2 === null || startDate2 === void 0 ? void 0 : startDate2.id),
    isValid: isDateValid,
    validations: {
      maxDate: overpassesMaxRange,
      sameDate: isSameDate,
      endDateBeforeStartDate: endDateBeforeStartDate
    }
  };
};
var getParsedTimeValues = function (time) {
  var hours = parseInt(time.substr(0, 2), 10);
  var minutes = parseInt(time.substr(2, 2), 10);
  if (time.includes("PM") && hours !== 12) {
    hours += 12;
  }
  if (time.includes("AM") && hours === 12) {
    hours -= 12;
  }
  return {
    hours: hours,
    minutes: minutes
  };
};
var validatePickupTimeField = function (startTimeValue, startDate2) {
  var today2 = /* @__PURE__ */new Date();
  if (today2.getDate() === startDate2.getDate() && today2.getMonth() === startDate2.getMonth() && today2.getFullYear() === startDate2.getFullYear()) {
    var parsedTime = getParsedTimeValues(startTimeValue);
    var startTimeFormat = /* @__PURE__ */new Date();
    startTimeFormat.setHours(parsedTime.hours, parsedTime.minutes);
    var isValid = today2 < startTimeFormat;
    return {
      __typename: "EGDSBasicSelectPickUp",
      isValid: isValid
    };
  }
  return {
    __typename: "EGDSBasicSelectPickUp",
    isValid: true
  };
};
var validateDropoffTimeField = function (startTime, endTime, dates) {
  var startDateInput = dates.startDateInput,
    endDateInput = dates.endDateInput;
  var _startDateInput_value;
  var startDate2 = getDate((_startDateInput_value = startDateInput === null || startDateInput === void 0 ? void 0 : startDateInput.value) !== null && _startDateInput_value !== void 0 ? _startDateInput_value : "");
  var _endDateInput_value;
  var endDate2 = getDate((_endDateInput_value = endDateInput === null || endDateInput === void 0 ? void 0 : endDateInput.value) !== null && _endDateInput_value !== void 0 ? _endDateInput_value : "");
  var startTimeValue = startTime === null || startTime === void 0 ? void 0 : startTime.value;
  var endTimeValue = endTime === null || endTime === void 0 ? void 0 : endTime.value;
  if (!startTimeValue || !endTimeValue) {
    return {
      __typename: "EGDSBasicSelectDropOff",
      isValid: true
    };
  }
  var startParsedTime = getParsedTimeValues(startTimeValue);
  startDate2.setHours(startParsedTime.hours, startParsedTime.minutes);
  var endParsedTime = getParsedTimeValues(endTimeValue);
  endDate2.setHours(endParsedTime.hours, endParsedTime.minutes);
  var isEndTimeAfterStartTime = endDate2 > startDate2;
  startDate2.setTime(startDate2.getTime() + 2 * 60 * 60 * 1e3);
  var isTwoHoursDifference = endDate2 >= startDate2;
  var isValid = isEndTimeAfterStartTime && isTwoHoursDifference;
  return {
    __typename: "EGDSBasicSelectDropOff",
    isValid: isValid
  };
};
var getFormElementsWithErrors = function (formElements) {
  var softPackages = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var location = formElements.location,
    dates = formElements.dates,
    age = formElements.age,
    time = formElements.time;
  var startDateInput = dates.startDateInput,
    endDateInput = dates.endDateInput,
    partialStayStartDateInput = dates.partialStayStartDateInput,
    partialStayEndDateInput = dates.partialStayEndDateInput,
    config = dates.config;
  var _location_destination;
  var validations = location.origin ? [validateOriginLocationField(location.origin, softPackages ? (_location_destination = location.destination) !== null && _location_destination !== void 0 ? _location_destination : null : null), validateDatePickerField(startDateInput, endDateInput, config)] : [validateDatePickerField(startDateInput, endDateInput, config)];
  if (location.destination) {
    validations.push(validateDestinationLocationField(location.origin, location.destination, softPackages));
  }
  if (age) {
    validations.push(validateAgeInputField(age));
  }
  if (time) {
    var _time_pickup;
    var _dates_startDateInput_value;
    var startDate2 = getDate((_dates_startDateInput_value = dates.startDateInput.value) !== null && _dates_startDateInput_value !== void 0 ? _dates_startDateInput_value : "");
    var startTimeValue = time === null || time === void 0 ? void 0 : (_time_pickup = time.pickup) === null || _time_pickup === void 0 ? void 0 : _time_pickup.value;
    validations.push(validatePickupTimeField(startTimeValue, startDate2), validateDropoffTimeField(time.pickup, time.dropOff, dates));
  }
  if (partialStayEndDateInput && partialStayStartDateInput) {
    var fieldDatesPartialId = "partial_date-input";
    var dateFieldGeneralValidation = validateDatePickerField(partialStayStartDateInput, partialStayEndDateInput, config, fieldDatesPartialId);
    var validateRange = validateDateOutsideTripRange({
      startDate: partialStayStartDateInput,
      endDate: partialStayEndDateInput
    }, {
      startDate: startDateInput,
      endDate: endDateInput
    });
    validations.push(_object_spread_props(_object_spread({}, dateFieldGeneralValidation), {
      isValid: dateFieldGeneralValidation.isValid && !validateRange,
      validations: _object_spread_props(_object_spread({}, dateFieldGeneralValidation.validations), {
        dateOutsideTripRange: validateRange
      })
    }));
  }
  return validations.filter(function (element) {
    return !element.isValid;
  });
};
var findFieldByNameAttribute = function (name) {
  return function (element) {
    return element.getAttribute("name") === name;
  };
};
// src/components/packages-search-form/forms/multi-packages-search-form.tsx
import { ViewLarge as ViewLarge5, ViewMedium as ViewMedium10, Viewport as Viewport12, ViewSizes as ViewSizes5, ViewSmall as ViewSmall10 } from "@shared-ui/viewport-context";
import { UitkForm as UitkForm4 } from "uitk-react-form";
import { UitkLayoutFlex as UitkLayoutFlex11, UitkLayoutFlexItem as UitkLayoutFlexItem10 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing18 } from "uitk-react-spacing";
// src/util/fields-map.ts
var FieldNameMap = /* @__PURE__ */function (FieldNameMap2) {
  FieldNameMap2["ORIGIN"] = "origin_select";
  FieldNameMap2["DESTINATION"] = "destination_select";
  FieldNameMap2["TRAVEL_DATES"] = "EGDSDateRangePicker";
  FieldNameMap2["TRAVELER_SELECTOR"] = "EGDSRoomsTravelerSelector";
  FieldNameMap2["CABIN_CLASS"] = "EGDSSearchFormInputFieldWithSelection-cabin_class";
  return FieldNameMap2;
}(FieldNameMap || {});
// src/util/layout-field-config.ts
import { ViewSizes as ViewSizes4 } from "@shared-ui/viewport-context";
var FLIGHT_LAYOUT = {
  SMALL: {
    default: {}
  },
  MEDIUM: {
    default: {
      grow: 1
    },
    EGDSSearchFormLocationsField: {
      minWidth: "full_width"
    },
    EGDSSearchFormButton: {}
  },
  LARGE: {
    default: {
      grow: 1
    },
    EGDSSearchFormLocationsField: {
      minWidth: 500,
      grow: 1
    },
    EGDSSearchFormButton: {}
  },
  EXTRA_LARGE: {
    default: {}
  }
};
var _obj3;
var layoutFieldConfigViewportMapping = {
  prebundles: (_obj3 = {}, _define_property(_obj3, ViewSizes4.SMALL, {
    default: {}
  }), _define_property(_obj3, ViewSizes4.MEDIUM, {
    EGDSSearchFormLocationField: {
      minWidth: "full_width"
    },
    EGDSSearchFormButton: {},
    default: {
      grow: 1
    }
  }), _define_property(_obj3, ViewSizes4.LARGE, {
    EGDSSearchFormButton: {},
    EGDSSearchFormTravelersField: {
      maxWidth: 400,
      grow: 1
    },
    EGDSSearchFormDatePickerField: {
      maxWidth: 400,
      grow: 1
    },
    default: {
      minWidth: "third_width",
      grow: 1
    }
  }), _define_property(_obj3, ViewSizes4.EXTRA_LARGE, {
    default: {}
  }), _obj3),
  FLIGHT_CAR: FLIGHT_LAYOUT,
  FLIGHT_HOTEL: FLIGHT_LAYOUT,
  FLIGHT_HOTEL_CAR: FLIGHT_LAYOUT,
  HOTEL_CAR: {
    SMALL: {
      default: {}
    },
    MEDIUM: {
      default: {
        grow: 1,
        minWidth: 400
      },
      EGDSSearchFormTravelersField: {
        minWidth: 500,
        grow: 1
      },
      EGDSSearchFormButton: {}
    },
    LARGE: {
      EGDSSearchFormButton: {},
      EGDSSearchFormTravelersField: {
        maxWidth: 300,
        grow: 1
      },
      EGDSSearchFormDatePickerField: {
        maxWidth: 300,
        grow: 1
      },
      default: {
        grow: 1
      }
    },
    EXTRA_LARGE: {
      default: {}
    }
  }
};
var getFlexItemPropsByFieldType = function (typename, viewportSize) {
  var packageType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "prebundles";
  var componentPropsMappingByViewport = layoutFieldConfigViewportMapping[packageType][viewportSize];
  var _componentPropsMappingByViewport_typename;
  return (_componentPropsMappingByViewport_typename = componentPropsMappingByViewport[typename]) !== null && _componentPropsMappingByViewport_typename !== void 0 ? _componentPropsMappingByViewport_typename : componentPropsMappingByViewport.default;
};
var _obj4;
// src/util/query-params.ts
var packageTypeMap = (_obj4 = {}, _define_property(_obj4, "FLIGHT_CAR" /* FLIGHT_CAR */, "fc"), _define_property(_obj4, "FLIGHT_HOTEL" /* FLIGHT_HOTEL */, "fh"), _define_property(_obj4, "HOTEL_CAR" /* HOTEL_CAR */, "hc"), _define_property(_obj4, "FLIGHT_HOTEL_CAR" /* FLIGHT_HOTEL_CAR */, "fhc"), _define_property(_obj4, "HOTEL_ACTIVITY" /* HOTEL_ACTIVITY */, "ha"), _obj4);
var cabinClassTypeMap = {
  BUSINESS: "b",
  FIRST: "f",
  PREMIUM_ECONOMY: "p",
  COACH: "e"
};
var getQueryParamDateVariant = function (key, date) {
  var day = date.day,
    month = date.month,
    year = date.year;
  return "&".concat(key, "=").concat(year, "-").concat(month, "-").concat(day);
};
var getURLQueryParamsFromCriteria = function (criteria, packageType, directFlightsOnlySwitch) {
  var _criteria_secondary_selections, _criteria_secondary;
  var _criteria_primary = criteria.primary,
    cabinClass = _criteria_primary.cabinClass,
    dateRange = _criteria_primary.dateRange,
    destination = _criteria_primary.destination,
    origin = _criteria_primary.origin,
    travelerOccupancyGroups = _criteria_primary.travelerOccupancyGroups,
    partialStayDateRange = _criteria_primary.partialStayDateRange;
  var numberOfRomms = travelerOccupancyGroups === null || travelerOccupancyGroups === void 0 ? void 0 : travelerOccupancyGroups.map(function (travelers) {
    return travelers.travelers;
  }).length;
  var numberOfRommsQueryString = "&numberOfRooms=".concat(numberOfRomms);
  var _travelerOccupancyGroups_map;
  var infantInSeat = (_travelerOccupancyGroups_map = travelerOccupancyGroups === null || travelerOccupancyGroups === void 0 ? void 0 : travelerOccupancyGroups.map(function (travelersRoom) {
    return travelersRoom.travelers.filter(function (traveler) {
      return traveler.type === "INFANT_IN_SEAT";
    });
  })) !== null && _travelerOccupancyGroups_map !== void 0 ? _travelerOccupancyGroups_map : [];
  var checkInfantsInRoom = infantInSeat.filter(function (infants) {
    return infants.length > 0;
  });
  var infantInSeatQueryString = "&infantsInSeats=".concat(checkInfantsInRoom.length > 0 ? 1 : 0);
  var _travelerOccupancyGroups_map1;
  var infantOnLap = (_travelerOccupancyGroups_map1 = travelerOccupancyGroups === null || travelerOccupancyGroups === void 0 ? void 0 : travelerOccupancyGroups.map(function (travelersRoom) {
    return travelersRoom.travelers.filter(function (traveler) {
      return traveler.type === "INFANT_IN_LAP";
    });
  })) !== null && _travelerOccupancyGroups_map1 !== void 0 ? _travelerOccupancyGroups_map1 : [];
  var checkInfantsOnLap = infantOnLap.filter(function (infants) {
    return infants.length > 0;
  });
  var infantOnLapQueryString = "&infantsOnLap=".concat(checkInfantsOnLap.length > 0 ? 1 : 0);
  var _travelerOccupancyGroups_map2;
  var children = (_travelerOccupancyGroups_map2 = travelerOccupancyGroups === null || travelerOccupancyGroups === void 0 ? void 0 : travelerOccupancyGroups.map(function (travelersRoom) {
    return travelersRoom.travelers.filter(function (traveler) {
      return traveler.type === "CHILD" || traveler.type === "INFANT_IN_LAP" || traveler.type === "INFANT_IN_SEAT";
    });
  })) !== null && _travelerOccupancyGroups_map2 !== void 0 ? _travelerOccupancyGroups_map2 : [];
  var childAgesQueryString = children.length > 0 ? children.map(function (childrenRoom, roomIndex) {
    return childrenRoom.map(function (child, childIndex) {
      return "&childAges[".concat(roomIndex + 1, "][").concat(childIndex, "]=").concat(child.age);
    }).join("");
  }).join("") : "";
  var childrenPerRoomQueryString = children.length > 0 ? "".concat(children.map(function (childrenRoom, childIndex) {
    return "&childrenPerRoom[".concat(childIndex + 1, "]=").concat(childrenRoom.length);
  }).join("")) : "";
  var _travelerOccupancyGroups_map3;
  var adults = (_travelerOccupancyGroups_map3 = travelerOccupancyGroups === null || travelerOccupancyGroups === void 0 ? void 0 : travelerOccupancyGroups.map(function (travelersRoom) {
    return travelersRoom.travelers.filter(function (traveler) {
      return traveler.type === "ADULT";
    });
  })) !== null && _travelerOccupancyGroups_map3 !== void 0 ? _travelerOccupancyGroups_map3 : [];
  var adultsPerRoomQueryString = adults.length > 0 ? adults.map(function (adultRoom, index) {
    return "&adultsPerRoom[".concat(index + 1, "]=").concat(adultRoom.length);
  }).join("") : "";
  var hasInfantsOnLap = infantOnLap.length > 0;
  var hasInfantsInSeat = infantInSeat.length > 0;
  var infantsType = hasInfantsOnLap ? "lap" : "seat";
  var infantsTypeQueryString = hasInfantsOnLap || hasInfantsInSeat ? "&InfantSeating=".concat(infantsType) : "";
  var travelersQueryString = "".concat(numberOfRommsQueryString).concat(adultsPerRoomQueryString).concat(childAgesQueryString).concat(childrenPerRoomQueryString).concat(infantOnLapQueryString).concat(infantInSeatQueryString).concat(infantsTypeQueryString);
  var originQueryString = packageType !== "HOTEL_CAR" /* HOTEL_CAR */ ? "origin=".concat(origin === null || origin === void 0 ? void 0 : origin.regionName) : "";
  var destinationQueryString = "&destination=".concat(destination === null || destination === void 0 ? void 0 : destination.regionName);
  var destinationIdQueryString = (destination === null || destination === void 0 ? void 0 : destination.regionId) ? "&destinationId=".concat(destination === null || destination === void 0 ? void 0 : destination.regionId) : "";
  var destinationTtlaQueryString = (destination === null || destination === void 0 ? void 0 : destination.airportCode) ? "&ttla=".concat(destination === null || destination === void 0 ? void 0 : destination.airportCode) : "";
  var locationQueryString = "".concat(originQueryString).concat(destinationQueryString).concat(destinationIdQueryString).concat(destinationTtlaQueryString);
  var datesQueryString = dateRange ? "".concat(getQueryParamDateVariant("fromDate", dateRange.start)).concat(dateRange.end ? getQueryParamDateVariant("toDate", dateRange.end) : "").concat(getQueryParamDateVariant("d1", dateRange.start)).concat(dateRange.end ? getQueryParamDateVariant("d2", dateRange.end) : "") : "";
  var isPartialStayProduct = packageType === "FLIGHT_HOTEL_CAR" /* FLIGHT_HOTEL_CAR */ || packageType === "FLIGHT_HOTEL" /* FLIGHT_HOTEL */ || packageType === "HOTEL_CAR" /* HOTEL_CAR */;
  var partialStayDatesQueryString = partialStayDateRange ? "".concat(getQueryParamDateVariant("checkInDate", partialStayDateRange.start)).concat(getQueryParamDateVariant("checkOutDate", partialStayDateRange.end), "&isPartialStay=1\n  &partialStayCheckbox=true") : "&isPartialStay=0";
  var finalPartialStayDatesQueryString = isPartialStayProduct ? partialStayDatesQueryString : "";
  var packageTypeQueryString = "&packageType=".concat(packageTypeMap[packageType]);
  var cabinClassQueryString = packageType !== "HOTEL_CAR" /* HOTEL_CAR */ && cabinClass ? "&cabinClass=".concat(cabinClassTypeMap[cabinClass]) : "";
  var originIdQueryString = packageType !== "HOTEL_CAR" /* HOTEL_CAR */ && (origin === null || origin === void 0 ? void 0 : origin.regionId) ? "&originId=".concat(origin.regionId) : "";
  var ftlaQueryString = packageType !== "HOTEL_CAR" /* HOTEL_CAR */ && (origin === null || origin === void 0 ? void 0 : origin.airportCode) ? "&ftla=".concat(origin.airportCode) : "";
  var tripTypeQueryString = packageType === "FLIGHT_HOTEL" /* FLIGHT_HOTEL */ ? "&tripType=ROUND_TRIP" : "";
  var hotelIdSelection = packageType !== "FLIGHT_CAR" /* FLIGHT_CAR */ ? (_criteria_secondary = criteria.secondary) === null || _criteria_secondary === void 0 ? void 0 : (_criteria_secondary_selections = _criteria_secondary.selections) === null || _criteria_secondary_selections === void 0 ? void 0 : _criteria_secondary_selections.find(function (selection) {
    return selection.id === "hotelId";
  }) : void 0;
  var hotelIdQueryString = (hotelIdSelection === null || hotelIdSelection === void 0 ? void 0 : hotelIdSelection.value) ? "&hotelId=".concat(hotelIdSelection.value) : "";
  var directFlightsEnabled = directFlightsOnlySwitch && packageType !== "HOTEL_CAR" /* HOTEL_CAR */ ? "&isDirectFlight=true" : "";
  return "?".concat(locationQueryString).concat(travelersQueryString).concat(datesQueryString).concat(packageTypeQueryString).concat(cabinClassQueryString).concat(originIdQueryString).concat(ftlaQueryString).concat(tripTypeQueryString).concat(finalPartialStayDatesQueryString).concat(hotelIdQueryString).concat(directFlightsEnabled);
};
// src/util/search-criteria.ts
var EGDS_PREFIX = "EGDS";
var _obj5;
var TravelersTypeMap = (_obj5 = {}, _define_property(_obj5, ADULT_COUNT_NAME_PREFIX, "ADULT" /* ADULT */), _define_property(_obj5, CHILDREN_NAME_PREFIX, "CHILD" /* CHILD */), _define_property(_obj5, INFANT_ON_LAP_NAME_PREFIX, "INFANT_IN_LAP" /* INFANT_IN_LAP */), _define_property(_obj5, INFANT_IN_SEAT_NAME_PREFIX, "INFANT_IN_SEAT" /* INFANT_IN_SEAT */), _obj5);
var CabinClassMap = {
  COACH: "COACH" /* COACH */,
  ECONOMY_PREMIUM: "PREMIUM_ECONOMY" /* PREMIUM_ECONOMY */,
  BUSINESS: "BUSINESS" /* BUSINESS */,
  FIRST_CLASS: "FIRST" /* FIRST */
};
var packagesCriteriaReducer = function (criteria, param) {
  var name = param.name,
    value = param.value;
  if (name.startsWith("".concat(INPUT_FIELD__WITH_SELECTION_PREFIX))) {
    var primary = _object_spread_props(_object_spread({}, criteria.primary), {
      cabinClass: CabinClassMap[value]
    });
    return _object_spread_props(_object_spread({}, criteria), {
      primary: primary
    });
  }
  if (name.startsWith(BASE_TRAVELERS_FIELD_PREFIX)) {
    var isAdult = name.startsWith(ADULT_COUNT_NAME_PREFIX);
    var childKeys = name.split("-");
    var key = isAdult ? ADULT_COUNT_NAME_PREFIX : childKeys.slice(0, 2).join("-");
    var numericValue = Number.parseInt(value, 10);
    var travelers = isAdult ? Array.from(Array(numericValue).keys()).map(function () {
      return {
        type: TravelersTypeMap[key],
        age: null
      };
    }) : [{
      type: TravelersTypeMap[key],
      age: value ? numericValue : null
    }];
    var defaultRoomNumber = 1;
    var _name_split_;
    var roomString = (_name_split_ = name.split("".concat(key, "-Room"))[1]) !== null && _name_split_ !== void 0 ? _name_split_ : "1";
    var _parseInt;
    var roomNumber = (_parseInt = parseInt(roomString, 10)) !== null && _parseInt !== void 0 ? _parseInt : defaultRoomNumber;
    var _criteria_primary_travelerOccupancyGroups;
    var travelerOccupancyGroups = _to_consumable_array((_criteria_primary_travelerOccupancyGroups = criteria.primary.travelerOccupancyGroups) !== null && _criteria_primary_travelerOccupancyGroups !== void 0 ? _criteria_primary_travelerOccupancyGroups : []);
    travelerOccupancyGroups[roomNumber - 1] = {
      travelers: _to_consumable_array(travelerOccupancyGroups[roomNumber - 1] ? travelerOccupancyGroups[roomNumber - 1].travelers : []).concat(_to_consumable_array(travelers))
    };
    return _object_spread_props(_object_spread({}, criteria), {
      primary: _object_spread_props(_object_spread({}, criteria.primary), {
        travelerOccupancyGroups: travelerOccupancyGroups
      })
    });
  }
  if (name.startsWith("".concat(LOCATION_NAME_PREFIX, "-origin"))) {
    return _object_spread_props(_object_spread({}, criteria), {
      primary: _object_spread_props(_object_spread({}, criteria.primary), {
        origin: {
          airportCode: "",
          regionName: value
        }
      })
    });
  }
  if (name.startsWith("".concat(LOCATION_NAME_PREFIX, "-destination"))) {
    return _object_spread_props(_object_spread({}, criteria), {
      primary: _object_spread_props(_object_spread({}, criteria.primary), {
        destination: {
          airportCode: "",
          regionName: value
        }
      })
    });
  }
  var isStartDate = name.startsWith(START_DATE_NAME_PREFIX);
  var isEndDate = name.startsWith(END_DATE_NAME_PREFIX);
  if (isStartDate || isEndDate) {
    var _criteria_primary_dateRange, _criteria_primary_dateRange1;
    var _value_split_map = _sliced_to_array(value.split("-").map(function (partialDate) {
        return Number(partialDate);
      }), 3),
      year = _value_split_map[0],
      month = _value_split_map[1],
      day = _value_split_map[2];
    var defaultDate = {
      day: 0,
      month: 0,
      year: 0
    };
    var newDate = {
      day: day,
      month: month,
      year: year
    };
    return _object_spread_props(_object_spread({}, criteria), {
      primary: _object_spread_props(_object_spread({}, criteria.primary), {
        dateRange: {
          start: isStartDate ? newDate : ((_criteria_primary_dateRange = criteria.primary.dateRange) === null || _criteria_primary_dateRange === void 0 ? void 0 : _criteria_primary_dateRange.start) || defaultDate,
          end: isEndDate ? newDate : ((_criteria_primary_dateRange1 = criteria.primary.dateRange) === null || _criteria_primary_dateRange1 === void 0 ? void 0 : _criteria_primary_dateRange1.end) || defaultDate
        }
      })
    });
  }
  if (name.startsWith("".concat(AIRPORT_CODE_NAME_PREFIX, "-origin"))) {
    return _object_spread_props(_object_spread({}, criteria), {
      primary: _object_spread_props(_object_spread({}, criteria.primary), {
        origin: _object_spread_props(_object_spread({}, criteria.primary.origin), {
          airportCode: value
        })
      })
    });
  }
  if (name.startsWith("".concat(AIRPORT_CODE_NAME_PREFIX, "-destination"))) {
    return _object_spread_props(_object_spread({}, criteria), {
      primary: _object_spread_props(_object_spread({}, criteria.primary), {
        destination: _object_spread_props(_object_spread({}, criteria.primary.destination), {
          airportCode: value
        })
      })
    });
  }
  if (name.startsWith("".concat(DESTINATION_ID_NAME_PREFIX, "-destination"))) {
    var _criteria_primary_destination;
    var _criteria_primary_destination_airportCode;
    return _object_spread_props(_object_spread({}, criteria), {
      primary: _object_spread_props(_object_spread({}, criteria.primary), {
        destination: _object_spread_props(_object_spread({}, criteria.primary.destination), {
          airportCode: (_criteria_primary_destination_airportCode = (_criteria_primary_destination = criteria.primary.destination) === null || _criteria_primary_destination === void 0 ? void 0 : _criteria_primary_destination.airportCode) !== null && _criteria_primary_destination_airportCode !== void 0 ? _criteria_primary_destination_airportCode : "",
          regionId: value
        })
      })
    });
  }
  if (name.startsWith("".concat(REGION_ID_NAME_PREFIX, "-origin"))) {
    var _criteria_primary_destination1;
    var _criteria_primary_destination_airportCode1;
    return _object_spread_props(_object_spread({}, criteria), {
      primary: _object_spread_props(_object_spread({}, criteria.primary), {
        origin: _object_spread_props(_object_spread({}, criteria.primary.origin), {
          airportCode: (_criteria_primary_destination_airportCode1 = (_criteria_primary_destination1 = criteria.primary.destination) === null || _criteria_primary_destination1 === void 0 ? void 0 : _criteria_primary_destination1.airportCode) !== null && _criteria_primary_destination_airportCode1 !== void 0 ? _criteria_primary_destination_airportCode1 : "",
          regionId: value
        })
      })
    });
  }
  if (name.startsWith("".concat(SELECTED_PREFIX, "-destination")) && value) {
    var selectedDestinationId = "hotelId";
    return _object_spread_props(_object_spread({}, criteria), {
      primary: _object_spread({}, criteria.primary),
      secondary: {
        selections: [{
          id: selectedDestinationId,
          value: value
        }]
      }
    });
  }
  var isPartialStayStartDate = name.startsWith(PARTIAL_STAY_START_DATE_NAME_PREFIX);
  var isPartialStayEndDate = name.startsWith(PARTIAL_STAY_END_DATE_NAME_PREFIX);
  if (isPartialStayStartDate || isPartialStayEndDate) {
    var _criteria_primary_partialStayDateRange, _criteria_primary_partialStayDateRange1;
    var _value_split_map1 = _sliced_to_array(value.split("-").map(function (partialDate) {
        return Number(partialDate);
      }), 3),
      year1 = _value_split_map1[0],
      month1 = _value_split_map1[1],
      day1 = _value_split_map1[2];
    var partialDefaultDate = {
      day: 0,
      month: 0,
      year: 0
    };
    var partialNewDate = {
      day: day1,
      month: month1,
      year: year1
    };
    return _object_spread_props(_object_spread({}, criteria), {
      primary: _object_spread_props(_object_spread({}, criteria.primary), {
        partialStayDateRange: {
          start: isPartialStayStartDate ? partialNewDate : ((_criteria_primary_partialStayDateRange = criteria.primary.partialStayDateRange) === null || _criteria_primary_partialStayDateRange === void 0 ? void 0 : _criteria_primary_partialStayDateRange.start) || partialDefaultDate,
          end: isPartialStayEndDate ? partialNewDate : ((_criteria_primary_partialStayDateRange1 = criteria.primary.partialStayDateRange) === null || _criteria_primary_partialStayDateRange1 === void 0 ? void 0 : _criteria_primary_partialStayDateRange1.end) || partialDefaultDate
        }
      })
    });
  }
  return _object_spread({}, criteria);
};
var getSearchCriteriaFromHiddenInputs = function (elements) {
  var inputs = elements.filter(function (element) {
    return element.name.startsWith(EGDS_PREFIX);
  });
  var criteria = {
    primary: {},
    secondary: {}
  };
  return inputs.reduce(packagesCriteriaReducer, criteria);
};
var getPackageShoppingCriteriaFromHiddenInputs = function (elements) {
  return {
    primarySearchCriteria: {
      car: null,
      flight: null,
      property: null
    }
  };
};
// src/components/packages-search-form/forms/multi-packages-search-form.tsx
var fieldComponents = [EGDSSearchFormLocationField, EGDSSearchFormLocationsField, EGDSSearchFormDatePickerField, EGDSSearchFormTravelersField, EGDSSearchFormInputField, SearchFormPartialStay, SearchFormMessaging, EGDSSearchFormButton];
var __Fragment42 = gql55(_templateObject58(), EGDSErrorSummary.fragment, EGDSSearchFormButton.fragment, EGDSSearchFormLocationField.fragment, EGDSSearchFormLocationsField.fragment, EGDSSearchFormDatePickerField.fragment, EGDSSearchFormTravelersField.fragment, EGDSSearchFormInputField.fragment, EGDSSearchPlayback.fragment, SearchFormMessaging.fragment, SearchFormPartialStay.fragment, EGDSPill.fragment, SearchLocationFragment);
var FormFields = function (props) {
  var viewportSize = props.viewportSize,
    packageType = props.packageType,
    defaultValidationProps = props.defaultValidationProps,
    renderableElements = props.renderableElements,
    errorState = props.errorState,
    autoOpenCalendar = props.autoOpenCalendar,
    includeCabinClassField = props.includeCabinClassField,
    additionalAdapterFields = props.additionalAdapterFields,
    allowToRemoveRecentSearches = props.allowToRemoveRecentSearches,
    onOpenLocationField = props.onOpenLocationField,
    searchLocationAnalytics = props.searchLocationAnalytics;
  return /* @__PURE__ */React68.createElement(React68.Fragment, null, renderableElements.map(function (element, index) {
    var __typename = element.__typename;
    var FieldComponent = __typename === "EGDSSearchFormInputField" && includeCabinClassField && fieldComponents.find(function (param) {
      var displayName = param.displayName;
      return displayName === __typename;
    }) || fieldComponents.find(function (param) {
      var displayName = param.displayName;
      return displayName === __typename && __typename !== "EGDSSearchFormInputField";
    });
    if (!FieldComponent) {
      return null;
    }
    var flexItemProps = getFlexItemPropsByFieldType(__typename, viewportSize, packageType);
    var propsByField = _object_spread(_object_spread_props(_object_spread({}, defaultValidationProps), {
      fieldError: getFieldError(errorState, __typename === "SearchFormPartialStay" ? "EGDSSearchFormDatePickerFieldPartialStay" : __typename)
    }), __typename === "EGDSSearchFormLocationsField" && {
      originFieldError: getFieldError(errorState, "".concat(element.origin.__typename, "Origin")),
      destinationFieldError: getFieldError(errorState, "".concat(element.destination.__typename, "Destination")),
      additionalAdapterFields: additionalAdapterFields,
      allowToRemoveRecentSearches: allowToRemoveRecentSearches,
      onOpenLocationField: onOpenLocationField,
      searchLocationAnalytics: searchLocationAnalytics
    }, __typename === "EGDSSearchFormLocationField" && {
      additionalAdapterFields: additionalAdapterFields,
      allowToRemoveRecentSearches: allowToRemoveRecentSearches,
      onOpenLocationField: onOpenLocationField,
      searchLocationAnalytics: searchLocationAnalytics
    }, __typename === "EGDSSearchFormInputField" && {
      triggerType: "selector" /* SELECTOR */
    }, __typename === "EGDSSearchFormDatePickerField" && {
      autoOpen: autoOpenCalendar
    });
    var propsByLocationFieldType = {
      originRef: __typename === "EGDSSearchFormLocationsField" ? propsByField : null,
      destinationRef: __typename === "EGDSSearchFormLocationsField" ? propsByField : null
    };
    return /* @__PURE__ */React68.createElement(UitkLayoutFlexItem10, _object_spread({
      key: "field_".concat(__typename, "_").concat(index)
    }, flexItemProps), /* @__PURE__ */React68.createElement("div", null, /* @__PURE__ */React68.createElement(FieldComponent, _object_spread_props(_object_spread({}, propsByField, propsByLocationFieldType), {
      data: element
    }))));
  }));
};
var ValuePropMessage = function (param) {
  var data = param.data;
  return /* @__PURE__ */React68.createElement(UitkLayoutFlex11, null, /* @__PURE__ */React68.createElement(UitkLayoutFlexItem10, null, /* @__PURE__ */React68.createElement(UitkSpacing18, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React68.createElement("div", null, /* @__PURE__ */React68.createElement(SearchFormMessaging, {
    data: data
  })))));
};
var MultiPackagesSearchForm = function (props) {
  var _datePickerField_action;
  var data = props.data,
    onSubmit = props.onSubmit,
    onFieldChange = props.onFieldChange,
    autoOpenCalendar = props.autoOpenCalendar,
    packageType = props.packageType,
    cabinClass = props.cabinClass,
    redirectToSearchResultOnSubmit = props.redirectToSearchResultOnSubmit,
    autoOpenPlayback = props.autoOpenPlayback,
    stickyPlayback = props.stickyPlayback,
    additionalAdapterFields = props.additionalAdapterFields,
    directFlightsOnlySwitch = props.directFlightsOnlySwitch,
    onOpenLocationField = props.onOpenLocationField,
    handleDirectFlightsOnlySwitch = props.handleDirectFlightsOnlySwitch,
    showDirectFlightsOnly = props.showDirectFlightsOnly;
  var localizationContext = useLocalization5();
  var _React68_useState = _sliced_to_array(React68.useState({
      EGDSSearchFormLocationFieldOrigin: null,
      EGDSSearchFormLocationFieldDestination: null,
      EGDSSearchFormDatePickerField: null,
      EGDSSearchFormInputField: null,
      EGDSSearchFormDatePickerFieldPartialStay: null
    }), 2),
    fieldsRefs = _React68_useState[0],
    setFieldsRefs = _React68_useState[1];
  var initialErrorState = {
    displayErrorSummary: false,
    errorCount: 0,
    errorLinkReference: null,
    fieldsWithErrors: []
  };
  var _React68_useState1 = _sliced_to_array(React68.useState(initialErrorState), 2),
    errorState = _React68_useState1[0],
    setErrorState = _React68_useState1[1];
  var _React68_useState2 = _sliced_to_array(React68.useState(!autoOpenPlayback), 2),
    displayToggle = _React68_useState2[0],
    setDisplayToggle = _React68_useState2[1];
  var _useExperiment3 = useExperiment3("Web_Ability_to_Delete_Recent_Searches_in_Typeahead_NonLodging" /* Web_Ability_to_Delete_Recent_Searches_in_Typeahead_NonLodging */),
    allowToRemoveRecentSearchesExposure = _useExperiment3.exposure,
    allowToRemoveRecentSearchesLogger = _useExperiment3.logExperiment;
  var allowToRemoveRecentSearches = allowToRemoveRecentSearchesExposure.bucket === 1;
  React68.useEffect(function () {
    try {
      allowToRemoveRecentSearchesLogger(allowToRemoveRecentSearchesExposure);
    } catch (e) {}
  }, [allowToRemoveRecentSearchesExposure, allowToRemoveRecentSearchesLogger]);
  var setFieldRefByTypename = React68.useCallback(function (typename, ref) {
    var _ref_current;
    var typenameRef = getRefTypename(typename, (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.id);
    setFieldsRefs(function (prevState) {
      return _object_spread_props(_object_spread({}, prevState), _define_property({}, typenameRef, ref));
    });
  }, []);
  var elements = data.elements,
    errorSummary2 = data.errorSummary,
    search2 = data.search,
    actionURL = data.actionURL,
    initialPlayback = data.playback,
    valuePropMessage = data.valuePropMessage,
    searchLocation = data.searchLocation,
    partialStay = data.partialStay,
    directFlightsOnly = data.directFlightsOnly;
  var _React68_useState3 = _sliced_to_array(React68.useState(initialPlayback), 2),
    playback = _React68_useState3[0],
    setPlayback = _React68_useState3[1];
  var displayErrorSummary = errorState.displayErrorSummary,
    errorCount = errorState.errorCount,
    errorLinkReference = errorState.errorLinkReference;
  var handlePlaybackToggle = function (open) {
    setDisplayToggle(open);
  };
  if (!search2) {
    return null;
  }
  var defaultElements2 = _to_consumable_array(elements).concat([search2]);
  var renderableElements = _to_consumable_array(elements).concat([partialStay, valuePropMessage, search2]).filter(Boolean);
  var datePickerField = elements.find(function (element) {
    return element.__typename === "EGDSSearchFormDatePickerField";
  });
  var _datePickerField_action_datePicker_maxNumberOfDaysSelected;
  var maxNumberOfDaysSelected = (datePickerField === null || datePickerField === void 0 ? void 0 : datePickerField.__typename) === "EGDSSearchFormDatePickerField" && ((_datePickerField_action = datePickerField.action) === null || _datePickerField_action === void 0 ? void 0 : _datePickerField_action.__typename) === "EGDSOpenDatePickerAction" && datePickerField.action.datePicker.__typename === "EGDSDateRangePicker" && packageType !== "FLIGHT_CAR" /* FLIGHT_CAR */ ? (_datePickerField_action_datePicker_maxNumberOfDaysSelected = datePickerField.action.datePicker.maxNumberOfDaysSelected) !== null && _datePickerField_action_datePicker_maxNumberOfDaysSelected !== void 0 ? _datePickerField_action_datePicker_maxNumberOfDaysSelected : 0 : 0;
  var defaultValidationProps = {
    setFieldRefByTypename: setFieldRefByTypename
  };
  var defaultLayoutFlexProps2 = {
    space: "three",
    direction: "row"
  };
  var formFieldsProps = {
    packageType: packageType,
    viewportSize: ViewSizes5.SMALL,
    renderableElements: renderableElements,
    defaultValidationProps: defaultValidationProps,
    errorState: errorState,
    autoOpenCalendar: autoOpenCalendar,
    additionalAdapterFields: additionalAdapterFields,
    allowToRemoveRecentSearches: allowToRemoveRecentSearches,
    onOpenLocationField: onOpenLocationField,
    searchLocationAnalytics: searchLocation === null || searchLocation === void 0 ? void 0 : searchLocation.analytics
  };
  var formFieldsPropsDesktop = _object_spread_props(_object_spread({}, formFieldsProps), {
    renderableElements: defaultElements2
  });
  var handleFieldChange = function (field, event) {
    onFieldChange === null || onFieldChange === void 0 ? void 0 : onFieldChange(field, event);
    setPlayback(function (playbackPrev) {
      if (!playbackPrev) {
        return null;
      }
      var DESTINATION = FieldNameMap.DESTINATION,
        TRAVELER_SELECTOR = FieldNameMap.TRAVELER_SELECTOR,
        TRAVEL_DATES = FieldNameMap.TRAVEL_DATES;
      var primary = playbackPrev.primary,
        secondaries = playbackPrev.secondaries;
      var text = field.value;
      var newPrimary = field.name === DESTINATION ? _object_spread_props(_object_spread({}, primary), {
        text: text
      }) : primary;
      var _secondaries = _sliced_to_array(secondaries, 2),
        dates = _secondaries[0],
        travelers = _secondaries[1];
      var isDateRangePicker = field.name === TRAVEL_DATES;
      var secondaryDates = isDateRangePicker && dates.__typename === "EGDSPlainText" ? _object_spread_props(_object_spread({}, dates), {
        text: getFormattedDates(text, localizationContext)
      }) : dates;
      var secondaryTravelers = field.name === TRAVELER_SELECTOR ? _object_spread_props(_object_spread({}, travelers), {
        text: text
      }) : travelers;
      return _object_spread_props(_object_spread({}, playbackPrev), {
        primary: newPrimary,
        secondaries: [secondaryDates, secondaryTravelers]
      });
    });
  };
  var handleSubmit = function (event) {
    setErrorState(initialErrorState);
    var formElements = Array.from(event.currentTarget.elements);
    var formElementsToValidate = {
      location: {
        origin: formElements.find(findFieldByNameAttribute("origin_select")),
        destination: formElements.find(findFieldByNameAttribute("destination_select")),
        config: {
          sameLocationSelected: true
        }
      },
      dates: {
        startDateInput: formElements.find(findFieldByNameAttribute("EGDSDateRangePicker-StartDate-date-range-select")),
        endDateInput: formElements.find(findFieldByNameAttribute("EGDSDateRangePicker-EndDate-date-range-select")),
        partialStayStartDateInput: formElements.find(findFieldByNameAttribute("EGDSDateRangePartialStay-StartDate-partial-stay-date-range-select")),
        partialStayEndDateInput: formElements.find(findFieldByNameAttribute("EGDSDateRangePartialStay-EndDate-partial-stay-date-range-select")),
        config: {
          maxNumberOfDaysSelected: maxNumberOfDaysSelected
        }
      }
    };
    var fieldsWithErrors = getFormElementsWithErrors(formElementsToValidate);
    var isFormValid = fieldsWithErrors.length === 0;
    if (!isFormValid) {
      var _fieldsWithErrors_;
      setErrorState({
        fieldsWithErrors: fieldsWithErrors,
        errorCount: fieldsWithErrors.length,
        displayErrorSummary: true,
        errorLinkReference: fieldsRefs[(_fieldsWithErrors_ = fieldsWithErrors[0]) === null || _fieldsWithErrors_ === void 0 ? void 0 : _fieldsWithErrors_.__typename]
      });
      event.preventDefault();
      return;
    }
    if (onSubmit || redirectToSearchResultOnSubmit) {
      var elementsOnSubmit = Array.from(event.currentTarget.elements);
      var packageSearchCriteria = getSearchCriteriaFromHiddenInputs(elementsOnSubmit);
      var packageShoppingCriteria = getPackageShoppingCriteriaFromHiddenInputs(elementsOnSubmit);
      if (onSubmit) {
        onSubmit(event, {
          packageSearchCriteria: packageSearchCriteria,
          packageType: packageType,
          packageShoppingCriteria: packageShoppingCriteria
        });
      }
      if (redirectToSearchResultOnSubmit) {
        event.preventDefault();
        var action = event.currentTarget.action;
        var queryParams = getURLQueryParamsFromCriteria(packageSearchCriteria, packageType, directFlightsOnlySwitch);
        window.location.href = "".concat(action).concat(queryParams);
      }
    }
  };
  var hiddenCabinClassFieldElement = packageType !== "HOTEL_CAR" /* HOTEL_CAR */ ? /* @__PURE__ */React68.createElement("input", {
    type: "hidden",
    name: cabinClass === null || cabinClass === void 0 ? void 0 : cabinClass.name,
    value: cabinClass === null || cabinClass === void 0 ? void 0 : cabinClass.value
  }) : null;
  var isHotelPackage = packageType !== "FLIGHT_CAR" /* FLIGHT_CAR */;
  var onChangeDirectFlightsPill = function (event) {
    handleDirectFlightsOnlySwitch === null || handleDirectFlightsOnlySwitch === void 0 ? void 0 : handleDirectFlightsOnlySwitch(event.target.checked);
  };
  var directFlightsOnlyPill = directFlightsOnly && /* @__PURE__ */React68.createElement(UitkLayoutFlexItem10, null, /* @__PURE__ */React68.createElement("div", null, /* @__PURE__ */React68.createElement(EGDSPill, {
    data: directFlightsOnly,
    onChange: onChangeDirectFlightsPill
  })));
  return /* @__PURE__ */React68.createElement(UitkForm4, {
    id: "package-search-form",
    name: "packages-search-form-".concat(packageType),
    action: actionURL,
    onSubmit: handleSubmit,
    onFieldChange: handleFieldChange,
    hasRequiredFieldIndicator: true
  }, displayErrorSummary && errorSummary2 && /* @__PURE__ */React68.createElement(UitkSpacing18, {
    margin: {
      blockend: "two"
    }
  }, /* @__PURE__ */React68.createElement("div", null, /* @__PURE__ */React68.createElement(EGDSErrorSummary, {
    data: errorSummary2,
    errorCount: errorCount,
    inputErrorRef: errorLinkReference
  }))), /* @__PURE__ */React68.createElement(Viewport12, null, /* @__PURE__ */React68.createElement(ViewSmall10, null, /* @__PURE__ */React68.createElement(React68.Fragment, null, playback ? /* @__PURE__ */React68.createElement(EGDSSearchPlayback, {
    data: playback,
    stickyPlayback: stickyPlayback,
    display: displayToggle,
    onDisplayToggle: handlePlaybackToggle
  }, /* @__PURE__ */React68.createElement(UitkLayoutFlex11, _object_spread_props(_object_spread({}, defaultLayoutFlexProps2), {
    direction: "column"
  }), showDirectFlightsOnly && directFlightsOnlyPill, /* @__PURE__ */React68.createElement(FormFields, _object_spread_props(_object_spread({}, formFieldsProps), {
    viewportSize: ViewSizes5.SMALL,
    includeCabinClassField: true
  })))) : /* @__PURE__ */React68.createElement(UitkLayoutFlex11, _object_spread_props(_object_spread({}, defaultLayoutFlexProps2), {
    direction: "column"
  }), /* @__PURE__ */React68.createElement(FormFields, _object_spread_props(_object_spread({}, formFieldsProps), {
    viewportSize: ViewSizes5.SMALL
  })), hiddenCabinClassFieldElement))), /* @__PURE__ */React68.createElement(ViewMedium10, null, /* @__PURE__ */React68.createElement(React68.Fragment, null, /* @__PURE__ */React68.createElement(UitkLayoutFlex11, _object_spread_props(_object_spread({}, defaultLayoutFlexProps2), {
    wrap: "wrap"
  }), /* @__PURE__ */React68.createElement(FormFields, _object_spread_props(_object_spread({}, formFieldsPropsDesktop), {
    viewportSize: ViewSizes5.MEDIUM
  })), hiddenCabinClassFieldElement), isHotelPackage && partialStay && /* @__PURE__ */React68.createElement(UitkSpacing18, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React68.createElement("div", null, /* @__PURE__ */React68.createElement(SearchFormPartialStay, {
    data: partialStay,
    setFieldRefByTypename: setFieldRefByTypename,
    fieldError: errorState.fieldsWithErrors.find(function (field) {
      return field.__typename === "EGDSSearchFormDatePickerFieldPartialStay";
    })
  }))), valuePropMessage && /* @__PURE__ */React68.createElement(ValuePropMessage, {
    data: valuePropMessage
  }))), /* @__PURE__ */React68.createElement(ViewLarge5, null, /* @__PURE__ */React68.createElement(React68.Fragment, null, /* @__PURE__ */React68.createElement(UitkLayoutFlex11, _object_spread_props(_object_spread({}, defaultLayoutFlexProps2), {
    wrap: "wrap"
  }), /* @__PURE__ */React68.createElement(FormFields, _object_spread_props(_object_spread({}, formFieldsPropsDesktop), {
    viewportSize: ViewSizes5.LARGE
  })), hiddenCabinClassFieldElement), isHotelPackage && partialStay && /* @__PURE__ */React68.createElement(UitkSpacing18, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React68.createElement("div", null, /* @__PURE__ */React68.createElement(SearchFormPartialStay, {
    data: partialStay,
    setFieldRefByTypename: setFieldRefByTypename,
    fieldError: errorState.fieldsWithErrors.find(function (field) {
      return field.__typename === "EGDSSearchFormDatePickerFieldPartialStay";
    })
  }))), valuePropMessage && /* @__PURE__ */React68.createElement(ValuePropMessage, {
    data: valuePropMessage
  })))));
};
MultiPackagesSearchForm.fragment = __Fragment42;
MultiPackagesSearchForm.displayName = "MultiPackagesSearchForm";
// src/components/packages-search-form/forms/prebundles-search-form.tsx
import React69 from "react";
import { gql as gql56 } from "@apollo/client";
import { ViewLarge as ViewLarge6, ViewMedium as ViewMedium11, Viewport as Viewport13, ViewSizes as ViewSizes6, ViewSmall as ViewSmall11 } from "@shared-ui/viewport-context";
import { UitkForm as UitkForm5 } from "uitk-react-form";
import { UitkLayoutFlex as UitkLayoutFlex12, UitkLayoutFlexItem as UitkLayoutFlexItem11 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing19 } from "uitk-react-spacing";
var fieldComponents2 = [EGDSSearchFormLocationField, EGDSSearchFormDatePickerField, EGDSSearchFormTravelersField, EGDSSearchFormButton];
var __Fragment43 = gql56(_templateObject59(), EGDSErrorSummary.fragment, EGDSSearchPlayback.fragment, EGDSSearchFormButton.fragment, EGDSSearchFormLocationField.fragment, EGDSSearchFormDatePickerField.fragment, EGDSSearchFormTravelersField.fragment);
var defaultLayoutFlexProps = {
  space: "three",
  direction: "row"
};
var PrebundlesSearchForm = function (param) {
  var data = param.data,
    onFieldChange = param.onFieldChange,
    onSubmit = param.onSubmit;
  var _datePickerField_action;
  var _React69_useState = _sliced_to_array(React69.useState({
      EGDSSearchFormLocationField: null,
      EGDSSearchFormDatePickerField: null
    }), 2),
    fieldsRefs = _React69_useState[0],
    setFieldsRefs = _React69_useState[1];
  var _React69_useState1 = _sliced_to_array(React69.useState({
      displayErrorSummary: false,
      errorCount: 0,
      errorLinkReference: null,
      fieldsWithErrors: []
    }), 2),
    errorState = _React69_useState1[0],
    setErrorState = _React69_useState1[1];
  var _React69_useState2 = _sliced_to_array(React69.useState(true), 2),
    displayToggle = _React69_useState2[0],
    setDisplayToggle = _React69_useState2[1];
  var handlePlaybackToggle = function (open) {
    setDisplayToggle(open);
  };
  var setFieldRefByTypename = React69.useCallback(function (typename, ref) {
    setFieldsRefs(function (prevState) {
      return _object_spread_props(_object_spread({}, prevState), _define_property({}, typename, ref));
    });
  }, []);
  var elements = data.elements,
    errorSummary2 = data.errorSummary,
    playback = data.playback,
    search2 = data.search;
  var displayErrorSummary = errorState.displayErrorSummary,
    errorCount = errorState.errorCount,
    errorLinkReference = errorState.errorLinkReference;
  if (!search2) {
    return null;
  }
  var renderableElements = _to_consumable_array(elements).concat([search2]);
  var defaultValidationProps = {
    setFieldRefByTypename: setFieldRefByTypename
  };
  var datePickerField = elements.find(function (element) {
    return element.__typename === "EGDSSearchFormDatePickerField";
  });
  var _datePickerField_action_datePicker_maxNumberOfDaysSelected;
  var maxNumberOfDaysSelected = (datePickerField === null || datePickerField === void 0 ? void 0 : datePickerField.__typename) === "EGDSSearchFormDatePickerField" && ((_datePickerField_action = datePickerField.action) === null || _datePickerField_action === void 0 ? void 0 : _datePickerField_action.__typename) === "EGDSOpenDatePickerAction" && datePickerField.action.datePicker.__typename === "EGDSDateRangePicker" ? (_datePickerField_action_datePicker_maxNumberOfDaysSelected = datePickerField.action.datePicker.maxNumberOfDaysSelected) !== null && _datePickerField_action_datePicker_maxNumberOfDaysSelected !== void 0 ? _datePickerField_action_datePicker_maxNumberOfDaysSelected : 0 : 0;
  var handleFieldChange = function (field, event) {
    onFieldChange === null || onFieldChange === void 0 ? void 0 : onFieldChange(field, event);
  };
  var handleSubmit = function (event) {
    event.preventDefault();
    var formElements = Array.from(event.currentTarget.elements);
    var formElementsToValidate = {
      location: {
        origin: formElements.find(findFieldByNameAttribute("origin-select"))
      },
      dates: {
        startDateInput: formElements.find(findFieldByNameAttribute("EGDSDateRangePicker-StartDate-date-range-select")),
        endDateInput: formElements.find(findFieldByNameAttribute("EGDSDateRangePicker-EndDate-date-range-select")),
        config: {
          maxNumberOfDaysSelected: maxNumberOfDaysSelected
        }
      }
    };
    var fieldsWithErrors = getFormElementsWithErrors(formElementsToValidate);
    var isFormValid = fieldsWithErrors.length === 0;
    if (!isFormValid) {
      var _fieldsWithErrors_;
      setErrorState({
        fieldsWithErrors: fieldsWithErrors,
        errorCount: fieldsWithErrors.length,
        displayErrorSummary: true,
        errorLinkReference: fieldsRefs[(_fieldsWithErrors_ = fieldsWithErrors[0]) === null || _fieldsWithErrors_ === void 0 ? void 0 : _fieldsWithErrors_.__typename]
      });
    } else {
      onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(event);
    }
  };
  var searchFormElements = function (viewportSize) {
    return renderableElements.map(function (element, index) {
      var __typename = element.__typename;
      var FieldComponent = fieldComponents2.find(function (param) {
        var displayName = param.displayName;
        return displayName === __typename;
      });
      if (!FieldComponent) {
        return null;
      }
      var flexItemProps = getFlexItemPropsByFieldType(__typename, viewportSize);
      var fieldError = errorState.fieldsWithErrors.find(function (field) {
        return field.__typename === __typename;
      });
      var validationProps = _object_spread_props(_object_spread({}, defaultValidationProps), {
        fieldError: fieldError
      });
      return /* @__PURE__ */React69.createElement(UitkLayoutFlexItem11, _object_spread({
        key: "field_".concat(__typename, "_").concat(index)
      }, flexItemProps), /* @__PURE__ */React69.createElement("div", null, /* @__PURE__ */React69.createElement(FieldComponent, _object_spread({
        data: element
      }, validationProps))));
    });
  };
  return /* @__PURE__ */React69.createElement(UitkForm5, {
    id: "package-search-form",
    name: "package-search-form",
    onFieldChange: handleFieldChange,
    onSubmit: handleSubmit,
    hasRequiredFieldIndicator: true
  }, displayErrorSummary && errorSummary2 && /* @__PURE__ */React69.createElement(UitkSpacing19, {
    margin: {
      blockend: "two"
    }
  }, /* @__PURE__ */React69.createElement("div", null, /* @__PURE__ */React69.createElement(EGDSErrorSummary, {
    data: errorSummary2,
    errorCount: errorCount,
    inputErrorRef: errorLinkReference
  }))), /* @__PURE__ */React69.createElement(Viewport13, null, /* @__PURE__ */React69.createElement(ViewSmall11, null, playback ? /* @__PURE__ */React69.createElement(EGDSSearchPlayback, {
    data: playback,
    display: displayToggle,
    onDisplayToggle: handlePlaybackToggle
  }, /* @__PURE__ */React69.createElement(UitkLayoutFlex12, _object_spread_props(_object_spread({}, defaultLayoutFlexProps), {
    direction: "column"
  }), searchFormElements(ViewSizes6.SMALL))) : /* @__PURE__ */React69.createElement(UitkLayoutFlex12, _object_spread_props(_object_spread({}, defaultLayoutFlexProps), {
    direction: "column"
  }), searchFormElements(ViewSizes6.SMALL))), /* @__PURE__ */React69.createElement(ViewMedium11, null, /* @__PURE__ */React69.createElement(UitkLayoutFlex12, _object_spread_props(_object_spread({}, defaultLayoutFlexProps), {
    wrap: "wrap"
  }), searchFormElements(ViewSizes6.MEDIUM))), /* @__PURE__ */React69.createElement(ViewLarge6, null, /* @__PURE__ */React69.createElement(UitkLayoutFlex12, _object_spread_props(_object_spread({}, defaultLayoutFlexProps), {
    wrap: "wrap"
  }), searchFormElements(ViewSizes6.LARGE)))));
};
PrebundlesSearchForm.fragment = __Fragment43;
PrebundlesSearchForm.displayName = "PrebundlesSearchForm";
// src/components/packages-search-form/packages-search-form.tsx
var __Query2 = gql57(_templateObject60(), PrebundlesSearchForm.fragment, MultiPackagesSearchForm.fragment, NoSelectionMessage.fragment);
var smallViewportFormSkeletonProps = {
  rows: [{
    type: "primary"
  }, {
    type: "primary"
  }, {
    type: "primary"
  }]
};
var mediumViewportFormSkeletonProps = {
  rows: [{
    type: "primary"
  }]
};
var PackagesSearchForm = function (props) {
  var _data_searchForm, _data_searchForm1, _data_searchForm_packages_packageSelection;
  var inputs = props.inputs,
    skipSsr = props.skipSsr,
    includePlayback = props.includePlayback,
    batchKey = props.batchKey,
    _props_skipQuery = props.skipQuery,
    skipQuery = _props_skipQuery === void 0 ? false : _props_skipQuery;
  var packageType = inputs.packageType;
  var context = useBexApi6().context;
  var systemEvents = useLoggerEvents2(CLIENT_EVENTS);
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context,
    includePlayback: Boolean(includePlayback)
  });
  var _useQuery2 = useQuery2(__Query2, {
      context: {
        batchKey: batchKey
      },
      variables: variables,
      ssr: !skipSsr,
      skip: skipQuery
    }),
    currentData = _useQuery2.data,
    error = _useQuery2.error,
    loading = _useQuery2.loading,
    previousData = _useQuery2.previousData;
  var data = currentData || previousData;
  if (loading) {
    return /* @__PURE__ */React70.createElement(Viewport14, null, /* @__PURE__ */React70.createElement(ViewSmall12, null, /* @__PURE__ */React70.createElement(FormSkeleton, _object_spread({}, smallViewportFormSkeletonProps))), /* @__PURE__ */React70.createElement(ViewMedium12, null, /* @__PURE__ */React70.createElement(FormSkeleton, _object_spread({}, mediumViewportFormSkeletonProps))));
  }
  if (error || !data || !(data === null || data === void 0 ? void 0 : (_data_searchForm = data.searchForm) === null || _data_searchForm === void 0 ? void 0 : _data_searchForm.packages)) {
    var _fallback_searchForm, _fallback_searchForm_packages_packageSelection;
    systemEvents.SEARCH_TOOLS_PACKAGES_SEARCH_FORM_QUERY_FAILURE.log({
      name: error === null || error === void 0 ? void 0 : error.name,
      error: new Error(error === null || error === void 0 ? void 0 : error.message)
    });
    var fallback = getFallbackData(packageType);
    if (!(fallback === null || fallback === void 0 ? void 0 : (_fallback_searchForm = fallback.searchForm) === null || _fallback_searchForm === void 0 ? void 0 : _fallback_searchForm.packages) || fallback.searchForm.packages.__typename !== "PackagesSearchForm" || ((_fallback_searchForm_packages_packageSelection = fallback.searchForm.packages.packageSelection) === null || _fallback_searchForm_packages_packageSelection === void 0 ? void 0 : _fallback_searchForm_packages_packageSelection.__typename) !== "PackagesSearchFormSelection") {
      return null;
    }
    if (packageType === null) {
      return /* @__PURE__ */React70.createElement(FallbackIndicatorWrapper, null, /* @__PURE__ */React70.createElement(NoSelectionMessage, {
        data: fallback.searchForm.packages.packageSelection.noSelectionMessage
      }));
    }
    return /* @__PURE__ */React70.createElement(FallbackIndicatorWrapper, null, /* @__PURE__ */React70.createElement(IntersectionTracker3, _object_spread({}, CLIENT_TRACKING_EVENTS.SEARCH_TOOLS_PACKAGES_SEARCH_FORM_FALLBACK_IMPRESSION), packageType ? /* @__PURE__ */React70.createElement(MultiPackagesSearchForm, _object_spread_props(_object_spread({}, props), {
      packageType: packageType,
      data: fallback.searchForm.packages,
      includeCabinClassField: Boolean(includePlayback)
    })) : /* @__PURE__ */React70.createElement(PrebundlesSearchForm, _object_spread_props(_object_spread({}, props), {
      data: fallback.searchForm.packages
    }))));
  }
  if (!(data === null || data === void 0 ? void 0 : (_data_searchForm1 = data.searchForm) === null || _data_searchForm1 === void 0 ? void 0 : _data_searchForm1.packages) || data.searchForm.packages.__typename !== "PackagesSearchForm" || ((_data_searchForm_packages_packageSelection = data.searchForm.packages.packageSelection) === null || _data_searchForm_packages_packageSelection === void 0 ? void 0 : _data_searchForm_packages_packageSelection.__typename) !== "PackagesSearchFormSelection") {
    return null;
  }
  if (packageType === null) {
    return /* @__PURE__ */React70.createElement(NoSelectionMessage, {
      data: data.searchForm.packages.packageSelection.noSelectionMessage
    });
  }
  return /* @__PURE__ */React70.createElement(IntersectionTracker3, _object_spread({}, CLIENT_TRACKING_EVENTS.SEARCH_TOOLS_PACKAGES_SEARCH_FORM_IMPRESSION), packageType ? /* @__PURE__ */React70.createElement(MultiPackagesSearchForm, _object_spread_props(_object_spread({}, props), {
    packageType: packageType,
    data: data.searchForm.packages,
    includeCabinClassField: Boolean(includePlayback)
  })) : /* @__PURE__ */React70.createElement(PrebundlesSearchForm, _object_spread_props(_object_spread({}, props), {
    data: data.searchForm.packages
  })));
};
PackagesSearchForm.displayName = "sharedui-PackagesSearchForm";
// src/components/packages-search-form/search-form.tsx
var SearchForm = function (props) {
  var inputs = props.inputs,
    onPackageTypeChange = props.onPackageTypeChange,
    includePlayback = props.includePlayback,
    enableReflection = props.enableReflection,
    isSticky = props.sticky;
  var _React71_useState = _sliced_to_array(React71.useState(inputs.packageType), 2),
    packageType = _React71_useState[0],
    setPackageType = _React71_useState[1];
  var _React71_useState1 = _sliced_to_array(React71.useState({
      name: "",
      value: ""
    }), 2),
    cabinClass = _React71_useState1[0],
    setCabinClass = _React71_useState1[1];
  var _React71_useState2 = _sliced_to_array(React71.useState(true), 2),
    showCabinClass = _React71_useState2[0],
    setShowCabinClass = _React71_useState2[1];
  var _React71_useState3 = _sliced_to_array(React71.useState(true), 2),
    showDirectFlightsOnlyPill = _React71_useState3[0],
    setShowDirectFlightsOnlyPill = _React71_useState3[1];
  var _React71_useState4 = _sliced_to_array(React71.useState(false), 2),
    skipPackagesOptionsQuery = _React71_useState4[0],
    setSkipPackagesOptionsQuery = _React71_useState4[1];
  var _React71_useState5 = _sliced_to_array(React71.useState(false), 2),
    directFlightsOnlySwitch = _React71_useState5[0],
    setDirectFlightsOnlySwitch = _React71_useState5[1];
  var ContentContainer = isSticky ? StickySearchForm : React71.Fragment;
  var handlePackageTypeSelect = React71.useCallback(function (selectedPackageType) {
    setPackageType(selectedPackageType);
    onPackageTypeChange === null || onPackageTypeChange === void 0 ? void 0 : onPackageTypeChange(selectedPackageType);
    var isHotelCarCombination = selectedPackageType === "HOTEL_CAR" /* HOTEL_CAR */;
    setShowCabinClass(!isHotelCarCombination && selectedPackageType !== null);
    setShowDirectFlightsOnlyPill(!isHotelCarCombination && selectedPackageType !== null);
  }, [setPackageType, onPackageTypeChange]);
  var handleCabinClassSelect = React71.useCallback(function (field) {
    setCabinClass(field);
    setSkipPackagesOptionsQuery(true);
  }, [setCabinClass]);
  var handleDirectFlightsOnlySwitch = React71.useCallback(function (selected) {
    setDirectFlightsOnlySwitch(selected);
  }, [setDirectFlightsOnlySwitch]);
  var packagesOptions = /* @__PURE__ */React71.createElement(PackagesOptions, _object_spread_props(_object_spread({}, props), {
    onPackageTypeChange: handlePackageTypeSelect,
    onCabinClassSelect: handleCabinClassSelect,
    inputs: _object_spread({}, inputs),
    showCabinClass: showCabinClass,
    showDirectFlightsOnly: showDirectFlightsOnlyPill,
    skipQuery: skipPackagesOptionsQuery,
    handleDirectFlightsOnlySwitch: handleDirectFlightsOnlySwitch
  }));
  var packagesSearchForm = /* @__PURE__ */React71.createElement(PackagesSearchForm, _object_spread_props(_object_spread({}, props), {
    inputs: _object_spread_props(_object_spread({}, inputs), {
      packageType: packageType
    }),
    cabinClass: cabinClass,
    directFlightsOnlySwitch: directFlightsOnlySwitch,
    showDirectFlightsOnly: showDirectFlightsOnlyPill,
    handleDirectFlightsOnlySwitch: handleDirectFlightsOnlySwitch
  }));
  var content = /* @__PURE__ */React71.createElement(Viewport15, null, /* @__PURE__ */React71.createElement(ViewSmall13, null, /* @__PURE__ */React71.createElement(React71.Fragment, null, !includePlayback && packagesOptions, packagesSearchForm)), /* @__PURE__ */React71.createElement(ViewMedium13, null, /* @__PURE__ */React71.createElement(ContentContainer, null, packagesOptions, packagesSearchForm)));
  if (enableReflection) {
    return /* @__PURE__ */React71.createElement(SearchFormReflectionProvider, null, /* @__PURE__ */React71.createElement("div", {
      "data-stid": "search-form-with-reflection"
    }, content));
  }
  return content;
};
export { PackageType, SearchForm }; /* istanbul ignore file -- @preserve */ /* istanbul ignore next -- @preserve */ /* istanbul ignore if -- @preserve */